module.exports = [
  {
    "id": "1",
    "ndex": "1",
    "species": "Bulbasaur",
    "forme": "Bulbasaur",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Chlorophyll",
    "hp": "45",
    "attack": "49",
    "defense": "49",
    "spattack": "65",
    "spdefense": "65",
    "speed": "45",
    "total": "318",
    "weight": "15.2 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Seed Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "2",
    "ndex": "2",
    "species": "Ivysaur",
    "forme": "Ivysaur",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Chlorophyll",
    "hp": "60",
    "attack": "62",
    "defense": "63",
    "spattack": "80",
    "spdefense": "80",
    "speed": "60",
    "total": "405",
    "weight": "28.7 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Seed Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Bulbasaur",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "3",
    "ndex": "3",
    "species": "Venusaur",
    "forme": "Venusaur",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Chlorophyll",
    "hp": "80",
    "attack": "82",
    "defense": "83",
    "spattack": "100",
    "spdefense": "100",
    "speed": "80",
    "total": "525",
    "weight": "220.5 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Seed Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Ivysaur",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "4",
    "ndex": "4",
    "species": "Charmander",
    "forme": "Charmander",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Solar Power",
    "hp": "39",
    "attack": "52",
    "defense": "43",
    "spattack": "60",
    "spdefense": "50",
    "speed": "65",
    "total": "309",
    "weight": "18.7 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Lizard Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "5",
    "ndex": "5",
    "species": "Charmeleon",
    "forme": "Charmeleon",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Solar Power",
    "hp": "58",
    "attack": "64",
    "defense": "58",
    "spattack": "80",
    "spdefense": "65",
    "speed": "80",
    "total": "405",
    "weight": "41.9 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Flame Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Charmander",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "6",
    "ndex": "6",
    "species": "Charizard",
    "forme": "Charizard",
    "type1": "Fire",
    "type2": "Flying",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Solar Power",
    "hp": "78",
    "attack": "84",
    "defense": "78",
    "spattack": "109",
    "spdefense": "85",
    "speed": "100",
    "total": "534",
    "weight": "199.5 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Flame Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Charmeleon",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "7",
    "ndex": "7",
    "species": "Squirtle",
    "forme": "Squirtle",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Rain Dish",
    "hp": "44",
    "attack": "48",
    "defense": "65",
    "spattack": "50",
    "spdefense": "64",
    "speed": "43",
    "total": "314",
    "weight": "19.8 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Tiny Turtle Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "8",
    "ndex": "8",
    "species": "Wartortle",
    "forme": "Wartortle",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Rain Dish",
    "hp": "59",
    "attack": "63",
    "defense": "80",
    "spattack": "65",
    "spdefense": "80",
    "speed": "58",
    "total": "405",
    "weight": "49.6 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Turtle Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Squirtle",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "9",
    "ndex": "9",
    "species": "Blastoise",
    "forme": "Blastoise",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Rain Dish",
    "hp": "79",
    "attack": "83",
    "defense": "100",
    "spattack": "85",
    "spdefense": "105",
    "speed": "78",
    "total": "530",
    "weight": "188.5 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Shellfish Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Wartortle",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "10",
    "ndex": "10",
    "species": "Caterpie",
    "forme": "Caterpie",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shield Dust",
    "ability2": "",
    "abilityH": "Run Away",
    "hp": "45",
    "attack": "30",
    "defense": "35",
    "spattack": "20",
    "spdefense": "20",
    "speed": "45",
    "total": "195",
    "weight": "6.4 lbs.",
    "height": "1'00\"",
    "dex1": "When attacked by bird Pokémon, it resists by releasing a terrifically strong odor from its antennae, but it often becomes their prey.",
    "dex2": "It’s easy to catch, and it grows quickly, making it one of the top recommendations for novice Pokémon Trainers.",
    "class": "Worm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "11",
    "ndex": "11",
    "species": "Metapod",
    "forme": "Metapod",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "20",
    "defense": "55",
    "spattack": "25",
    "spdefense": "25",
    "speed": "30",
    "total": "205",
    "weight": "21.8 lbs.",
    "height": "2'04\"",
    "dex1": "Its shell is filled with its soft innards. It doesn’t move much because of the risk it might carelessly spill its innards out.",
    "dex2": "Its shell is hard, but it’s still just a bug shell. It’s been known to break, so intense battles with it should be avoided.",
    "class": "Cocoon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Caterpie",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "12",
    "ndex": "12",
    "species": "Butterfree",
    "forme": "Butterfree",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Compound Eyes",
    "ability2": "",
    "abilityH": "Tinted Lens",
    "hp": "60",
    "attack": "45",
    "defense": "50",
    "spattack": "90",
    "spdefense": "80",
    "speed": "70",
    "total": "395",
    "weight": "70.5 lbs.",
    "height": "3'07\"",
    "dex1": "Close examination of its large eyes reveals that each eye is composed of a myriad of tiny eyes.",
    "dex2": "When attacked by other Pokémon, it defends itself by scattering its poisonous scales and fluttering its wings.",
    "class": "Butterfly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Metapod",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "13",
    "ndex": "13",
    "species": "Weedle",
    "forme": "Weedle",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Shield Dust",
    "ability2": "",
    "abilityH": "Run Away",
    "hp": "40",
    "attack": "35",
    "defense": "30",
    "spattack": "20",
    "spdefense": "20",
    "speed": "50",
    "total": "195",
    "weight": "7.1 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Hairy Bug Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "14",
    "ndex": "14",
    "species": "Kakuna",
    "forme": "Kakuna",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Shed Skin",
    "ability2": "Shed Skin",
    "abilityH": "",
    "hp": "45",
    "attack": "25",
    "defense": "50",
    "spattack": "25",
    "spdefense": "25",
    "speed": "35",
    "total": "205",
    "weight": "22.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Cocoon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Weedle",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "15",
    "ndex": "15",
    "species": "Beedrill",
    "forme": "Beedrill",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Swarm",
    "ability2": "Swarm",
    "abilityH": "Sniper",
    "hp": "65",
    "attack": "90",
    "defense": "40",
    "spattack": "45",
    "spdefense": "80",
    "speed": "75",
    "total": "395",
    "weight": "65.0 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Bee Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Kakuna",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "16",
    "ndex": "16",
    "species": "Pidgey",
    "forme": "Pidgey",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Tangled Feet",
    "abilityH": "Big Pecks",
    "hp": "40",
    "attack": "45",
    "defense": "40",
    "spattack": "35",
    "spdefense": "35",
    "speed": "56",
    "total": "251",
    "weight": "4.0 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Tiny Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "17",
    "ndex": "17",
    "species": "Pidgeotto",
    "forme": "Pidgeotto",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Tangled Feet",
    "abilityH": "Big Pecks",
    "hp": "63",
    "attack": "60",
    "defense": "55",
    "spattack": "50",
    "spdefense": "50",
    "speed": "71",
    "total": "349",
    "weight": "66.1 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pidgey",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "18",
    "ndex": "18",
    "species": "Pidgeot",
    "forme": "Pidgeot",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Tangled Feet",
    "abilityH": "Big Pecks",
    "hp": "83",
    "attack": "80",
    "defense": "75",
    "spattack": "70",
    "spdefense": "70",
    "speed": "101",
    "total": "479",
    "weight": "87.1 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pidgeotto",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "19",
    "ndex": "19",
    "species": "Rattata",
    "forme": "Rattata",
    "type1": "Normal",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Guts",
    "abilityH": "Hustle",
    "hp": "30",
    "attack": "56",
    "defense": "35",
    "spattack": "25",
    "spdefense": "35",
    "speed": "72",
    "total": "253",
    "weight": "7.7 lbs.",
    "height": "1'00\"",
    "dex1": "Its incisors continue growing until its death. If its Trainer doesn’t offer it a file to gnaw on, it will gnaw on door frames, table legs, and so on.",
    "dex2": "With their strong capacity for survival, they can live in dirty places without concern. Left unchecked, their numbers multiply rapidly.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "20",
    "ndex": "20",
    "species": "Raticate",
    "forme": "Raticate",
    "type1": "Normal",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Guts",
    "abilityH": "Hustle",
    "hp": "55",
    "attack": "81",
    "defense": "60",
    "spattack": "50",
    "spdefense": "70",
    "speed": "97",
    "total": "413",
    "weight": "40.8 lbs.",
    "height": "2'04\"",
    "dex1": "Its hind feet are webbed, so it’s a strong swimmer. It can cross rivers and sometimes even oceans.",
    "dex2": "Its disposition is far more violent than its looks would suggest. Don’t let your hand get too close to its face, as it could bite your hand clean off.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Rattata",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "21",
    "ndex": "21",
    "species": "Spearow",
    "forme": "Spearow",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Keen Eye",
    "abilityH": "Sniper",
    "hp": "40",
    "attack": "60",
    "defense": "30",
    "spattack": "31",
    "spdefense": "31",
    "speed": "70",
    "total": "262",
    "weight": "4.4 lbs.",
    "height": "1'00\"",
    "dex1": "Its short wings make it inept at flying. It moves about hurriedly and pecks at Bug-type Pokémon in the tall grass.",
    "dex2": "Farmers whose fields are troubled by bug Pokémon appreciate Spearow for its vigorous appetite and look after it.",
    "class": "Tiny Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "22",
    "ndex": "22",
    "species": "Fearow",
    "forme": "Fearow",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Keen Eye",
    "abilityH": "Sniper",
    "hp": "65",
    "attack": "90",
    "defense": "65",
    "spattack": "61",
    "spdefense": "61",
    "speed": "100",
    "total": "442",
    "weight": "83.8 lbs.",
    "height": "3'11\"",
    "dex1": "It’s tough and has excellent stamina. It has no problem flying continuously for a whole day carrying a heavy load.",
    "dex2": "Drawings of a Pokémon resembling Fearow can be seen in murals from deep in ancient history.",
    "class": "Beak Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spearow",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "23",
    "ndex": "23",
    "species": "Ekans",
    "forme": "Ekans",
    "type1": "Poison",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Shed Skin",
    "abilityH": "Unnerve",
    "hp": "35",
    "attack": "60",
    "defense": "44",
    "spattack": "40",
    "spdefense": "54",
    "speed": "55",
    "total": "288",
    "weight": "15.2 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Snake Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Dragon"
  },
  {
    "id": "24",
    "ndex": "24",
    "species": "Arbok",
    "forme": "Arbok",
    "type1": "Poison",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Shed Skin",
    "abilityH": "Unnerve",
    "hp": "60",
    "attack": "95",
    "defense": "69",
    "spattack": "65",
    "spdefense": "79",
    "speed": "80",
    "total": "448",
    "weight": "143.3 lbs.",
    "height": "11'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Cobra Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Ekans",
    "egg-group1": "Field",
    "egg-group2": "Dragon"
  },
  {
    "id": "25",
    "ndex": "25",
    "species": "Pikachu",
    "forme": "Pikachu",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Static",
    "abilityH": "Lightning Rod",
    "hp": "35",
    "attack": "55",
    "defense": "40",
    "spattack": "50",
    "spdefense": "50",
    "speed": "90",
    "total": "320",
    "weight": "13.2 lbs.",
    "height": "1'04\"",
    "dex1": "A plan was recently announced to gather many Pikachu and make an electric power plant.",
    "dex2": "It’s in its nature to store electricity. It feels stressed now and then if it’s unable to fully discharge the electricity.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pichu",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "26",
    "ndex": "26",
    "species": "Raichu",
    "forme": "Raichu",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Static",
    "abilityH": "Lightning Rod",
    "hp": "60",
    "attack": "90",
    "defense": "55",
    "spattack": "90",
    "spdefense": "80",
    "speed": "110",
    "total": "485",
    "weight": "66.1 lbs.",
    "height": "2'07\"",
    "dex1": "It unleashes electric shocks that can reach 100,000 volts. When agitated, it can knock out even an Indian elephant.",
    "dex2": "It becomes aggressive when it has electricity stored up. At such times, even its Trainer has to take care to avoid being attacked.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pikachu",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "27",
    "ndex": "27",
    "species": "Sandshrew",
    "forme": "Sandshrew",
    "type1": "Ground",
    "type2": "",
    "ability1": "Sand Veil",
    "ability2": "",
    "abilityH": "Sand Rush",
    "hp": "50",
    "attack": "75",
    "defense": "85",
    "spattack": "20",
    "spdefense": "30",
    "speed": "40",
    "total": "300",
    "weight": "26.5 lbs.",
    "height": "2'00\"",
    "dex1": "It can roll its body into a ball. It moves through the desert by rolling at high speeds.",
    "dex2": "It usually makes its home in deserts and arid zones, where rain does not fall. It digs holes to catch Bug-type Pokémon.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "28",
    "ndex": "28",
    "species": "Sandslash",
    "forme": "Sandslash",
    "type1": "Ground",
    "type2": "",
    "ability1": "Sand Veil",
    "ability2": "",
    "abilityH": "Sand Rush",
    "hp": "75",
    "attack": "100",
    "defense": "110",
    "spattack": "45",
    "spdefense": "55",
    "speed": "65",
    "total": "450",
    "weight": "65.0 lbs.",
    "height": "3'03\"",
    "dex1": "Although they are sharp, its claws and spikes often break off. They grow back the next day, so it is not bothered by the temporary loss.",
    "dex2": "It uses its claws to climb trees and then curls its body into a spiny ball, ready to drop onto any prey that appears.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sandshrew",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "29",
    "ndex": "29",
    "species": "Nidoran♀",
    "forme": "Nidoran♀",
    "type1": "Poison",
    "type2": "",
    "ability1": "Poison Point",
    "ability2": "Rivalry",
    "abilityH": "Hustle",
    "hp": "55",
    "attack": "47",
    "defense": "52",
    "spattack": "40",
    "spdefense": "40",
    "speed": "41",
    "total": "275",
    "weight": "15.4 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Pin Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "30",
    "ndex": "30",
    "species": "Nidorina",
    "forme": "Nidorina",
    "type1": "Poison",
    "type2": "",
    "ability1": "Poison Point",
    "ability2": "Rivalry",
    "abilityH": "Hustle",
    "hp": "70",
    "attack": "62",
    "defense": "67",
    "spattack": "55",
    "spdefense": "55",
    "speed": "56",
    "total": "365",
    "weight": "44.1 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Pin Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Nidoran♀",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "31",
    "ndex": "31",
    "species": "Nidoqueen",
    "forme": "Nidoqueen",
    "type1": "Poison",
    "type2": "Ground",
    "ability1": "Poison Point",
    "ability2": "Rivalry",
    "abilityH": "Sheer Force",
    "hp": "90",
    "attack": "92",
    "defense": "87",
    "spattack": "75",
    "spdefense": "85",
    "speed": "76",
    "total": "505",
    "weight": "132.3 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Drill Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Nidorina",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "32",
    "ndex": "32",
    "species": "Nidoran♂",
    "forme": "Nidoran♂",
    "type1": "Poison",
    "type2": "",
    "ability1": "Poison Point",
    "ability2": "Rivalry",
    "abilityH": "Hustle",
    "hp": "46",
    "attack": "57",
    "defense": "40",
    "spattack": "40",
    "spdefense": "40",
    "speed": "50",
    "total": "273",
    "weight": "19.8 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Pin Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "33",
    "ndex": "33",
    "species": "Nidorino",
    "forme": "Nidorino",
    "type1": "Poison",
    "type2": "",
    "ability1": "Poison Point",
    "ability2": "Rivalry",
    "abilityH": "Hustle",
    "hp": "61",
    "attack": "72",
    "defense": "57",
    "spattack": "55",
    "spdefense": "55",
    "speed": "65",
    "total": "365",
    "weight": "43.0 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Pin Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Nidoran♂",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "34",
    "ndex": "34",
    "species": "Nidoking",
    "forme": "Nidoking",
    "type1": "Poison",
    "type2": "Ground",
    "ability1": "Poison Point",
    "ability2": "Rivalry",
    "abilityH": "Sheer Force",
    "hp": "81",
    "attack": "102",
    "defense": "77",
    "spattack": "85",
    "spdefense": "75",
    "speed": "85",
    "total": "505",
    "weight": "136.7 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Drill Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Nidorino",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "35",
    "ndex": "35",
    "species": "Clefairy",
    "forme": "Clefairy",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Cute Charm",
    "ability2": "Magic Guard",
    "abilityH": "Friend Guard",
    "hp": "70",
    "attack": "45",
    "defense": "48",
    "spattack": "60",
    "spdefense": "65",
    "speed": "35",
    "total": "323",
    "weight": "16.5 lbs.",
    "height": "2'00\"",
    "dex1": "Its adorable behavior and appearance make it popular with men and women, young and old. Its numbers are few, however.",
    "dex2": "On nights with a full moon, they gather together and dance. The surrounding area is enveloped in an abnormal magnetic field.",
    "class": "Fairy Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "Cleffa",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "36",
    "ndex": "36",
    "species": "Clefable",
    "forme": "Clefable",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Cute Charm",
    "ability2": "Magic Guard",
    "abilityH": "Unaware",
    "hp": "95",
    "attack": "70",
    "defense": "73",
    "spattack": "95",
    "spdefense": "90",
    "speed": "60",
    "total": "483",
    "weight": "88.2 lbs.",
    "height": "4'03\"",
    "dex1": "They don’t like to reveal themselves in front of people. They live quietly in packs deep in the mountains.",
    "dex2": "According to tradition, people who see a pair of Clefable skipping by can look forward to a happy marriage.",
    "class": "Fairy Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "Clefairy",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "37",
    "ndex": "37",
    "species": "Vulpix",
    "forme": "Vulpix",
    "type1": "Fire",
    "type2": "",
    "ability1": "Flash Fire",
    "ability2": "",
    "abilityH": "Drought",
    "hp": "38",
    "attack": "41",
    "defense": "40",
    "spattack": "50",
    "spdefense": "65",
    "speed": "65",
    "total": "299",
    "weight": "21.8 lbs.",
    "height": "2'00\"",
    "dex1": "Its beautiful fur and tails have made it very popular. As it grows, its tails split to form more tails.",
    "dex2": "From its mouth spew flames that seem to resemble the spirits of the deceased. Some people mistakenly think this fire is a ghost.",
    "class": "Fox Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "38",
    "ndex": "38",
    "species": "Ninetales",
    "forme": "Ninetales",
    "type1": "Fire",
    "type2": "",
    "ability1": "Flash Fire",
    "ability2": "",
    "abilityH": "Drought",
    "hp": "73",
    "attack": "76",
    "defense": "75",
    "spattack": "81",
    "spdefense": "100",
    "speed": "100",
    "total": "505",
    "weight": "43.9 lbs.",
    "height": "3'07\"",
    "dex1": "Legend has it that this mystical Pokémon was formed when nine saints coalesced into one.",
    "dex2": "Said to live for a thousand years, this Pokémon uses its supernatural abilities to manipulate fire. It can burn its prey to a crisp as it pleases.",
    "class": "Fox Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "Vulpix",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "39",
    "ndex": "39",
    "species": "Jigglypuff",
    "forme": "Jigglypuff",
    "type1": "Normal",
    "type2": "Fairy",
    "ability1": "Cute Charm",
    "ability2": "Competitive",
    "abilityH": "Friend Guard",
    "hp": "115",
    "attack": "45",
    "defense": "20",
    "spattack": "45",
    "spdefense": "25",
    "speed": "20",
    "total": "270",
    "weight": "12.1 lbs.",
    "height": "1'08\"",
    "dex1": "It hugely inflates its stomach and sings a mysterious melody. If you hear this melody, you’ll become sleepy right away.",
    "dex2": "Jigglypuff possess a vocal range that exceeds 12 octaves, but each individual’s singing skill depends on its own effort.",
    "class": "Balloon Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "Igglybuff",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "40",
    "ndex": "40",
    "species": "Wigglytuff",
    "forme": "Wigglytuff",
    "type1": "Normal",
    "type2": "Fairy",
    "ability1": "Cute Charm",
    "ability2": "Competitive",
    "abilityH": "Frisk",
    "hp": "140",
    "attack": "70",
    "defense": "45",
    "spattack": "85",
    "spdefense": "50",
    "speed": "45",
    "total": "435",
    "weight": "26.5 lbs.",
    "height": "3'03\"",
    "dex1": "It sheds its fine fur when the seasons change. The fur is gathered and spun into a luxurious yarn.",
    "dex2": "As it inhales, it expands...and expands...and expands. Wigglytuff compete to see which one can inflate itself the most.",
    "class": "Balloon Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "Jigglypuff",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "41",
    "ndex": "41",
    "species": "Zubat",
    "forme": "Zubat",
    "type1": "Poison",
    "type2": "Flying",
    "ability1": "Inner Focus",
    "ability2": "",
    "abilityH": "Infiltrator",
    "hp": "40",
    "attack": "45",
    "defense": "35",
    "spattack": "30",
    "spdefense": "40",
    "speed": "55",
    "total": "245",
    "weight": "16.5 lbs.",
    "height": "2'07\"",
    "dex1": "It sleeps in caves during the day. It has no eyes, so to check its surroundings while flying, it emits ultrasonic waves.",
    "dex2": "When exposed to sunlight, they suffer burns. The frequency of their ultrasonic waves can differ slightly from colony to colony.",
    "class": "Bat Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "42",
    "ndex": "42",
    "species": "Golbat",
    "forme": "Golbat",
    "type1": "Poison",
    "type2": "Flying",
    "ability1": "Inner Focus",
    "ability2": "",
    "abilityH": "Infiltrator",
    "hp": "75",
    "attack": "80",
    "defense": "70",
    "spattack": "65",
    "spdefense": "75",
    "speed": "90",
    "total": "455",
    "weight": "121.3 lbs.",
    "height": "5'03\"",
    "dex1": "Its thick fangs are hollow like straws, making them unexpectedly fragile. These fangs are specialized for sucking blood.",
    "dex2": "Sometimes they drink so much blood, they can’t fly anymore. Then they fall to the ground and become food for other Pokémon.",
    "class": "Bat Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Zubat",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "43",
    "ndex": "43",
    "species": "Oddish",
    "forme": "Oddish",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "Run Away",
    "hp": "45",
    "attack": "50",
    "defense": "55",
    "spattack": "75",
    "spdefense": "65",
    "speed": "30",
    "total": "320",
    "weight": "11.9 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Weed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "44",
    "ndex": "44",
    "species": "Gloom",
    "forme": "Gloom",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "Stench",
    "hp": "60",
    "attack": "65",
    "defense": "70",
    "spattack": "85",
    "spdefense": "75",
    "speed": "40",
    "total": "395",
    "weight": "19.0 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Weed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Oddish",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "45",
    "ndex": "45",
    "species": "Vileplume",
    "forme": "Vileplume",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "Effect Spore",
    "hp": "75",
    "attack": "80",
    "defense": "85",
    "spattack": "110",
    "spdefense": "90",
    "speed": "50",
    "total": "490",
    "weight": "41.0 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Flower Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gloom",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "46",
    "ndex": "46",
    "species": "Paras",
    "forme": "Paras",
    "type1": "Bug",
    "type2": "Grass",
    "ability1": "Effect Spore",
    "ability2": "Dry Skin",
    "abilityH": "Damp",
    "hp": "35",
    "attack": "70",
    "defense": "55",
    "spattack": "45",
    "spdefense": "55",
    "speed": "25",
    "total": "285",
    "weight": "11.9 lbs.",
    "height": "1'00\"",
    "dex1": "No matter how much it eats, the mushrooms growing on its back steal away most of the nutrients it consumes.",
    "dex2": "Mushrooms called tochukaso sprout from its back. They can be dried and powdered to make a medicine used to extend life.",
    "class": "Mushroom Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": "Grass"
  },
  {
    "id": "47",
    "ndex": "47",
    "species": "Parasect",
    "forme": "Parasect",
    "type1": "Bug",
    "type2": "Grass",
    "ability1": "Effect Spore",
    "ability2": "Dry Skin",
    "abilityH": "Damp",
    "hp": "60",
    "attack": "95",
    "defense": "80",
    "spattack": "60",
    "spdefense": "80",
    "speed": "30",
    "total": "405",
    "weight": "65.0 lbs.",
    "height": "3'03\"",
    "dex1": "The large mushroom on its back controls it. It often fights over territory with Shiinotic.",
    "dex2": "It scatters toxic spores from its mushroom cap. Once harvested, these spores can be steeped and boiled down to prepare herbal medicines.",
    "class": "Mushroom Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Paras",
    "egg-group1": "Bug",
    "egg-group2": "Grass"
  },
  {
    "id": "48",
    "ndex": "48",
    "species": "Venonat",
    "forme": "Venonat",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Compound Eyes",
    "ability2": "Tinted Lens",
    "abilityH": "Run Away",
    "hp": "60",
    "attack": "55",
    "defense": "50",
    "spattack": "40",
    "spdefense": "55",
    "speed": "45",
    "total": "305",
    "weight": "66.1 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Insect Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "49",
    "ndex": "49",
    "species": "Venomoth",
    "forme": "Venomoth",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Shield Dust",
    "ability2": "Tinted Lens",
    "abilityH": "Wonder Skin",
    "hp": "70",
    "attack": "65",
    "defense": "60",
    "spattack": "90",
    "spdefense": "75",
    "speed": "90",
    "total": "450",
    "weight": "27.6 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Moth Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Venonat",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "50",
    "ndex": "50",
    "species": "Diglett",
    "forme": "Diglett",
    "type1": "Ground",
    "type2": "",
    "ability1": "Sand Veil",
    "ability2": "Arena Trap",
    "abilityH": "Sand Force",
    "hp": "10",
    "attack": "55",
    "defense": "25",
    "spattack": "35",
    "spdefense": "45",
    "speed": "95",
    "total": "265",
    "weight": "1.8 lbs.",
    "height": "0'08\"",
    "dex1": "It chews on plant roots underground. Farmers whose vegetables are vulnerable find it can be quite a pest.",
    "dex2": "Many farmers cherish and nurture Diglett because its droppings enrich the soil it lives in.",
    "class": "Mole Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "51",
    "ndex": "51",
    "species": "Dugtrio",
    "forme": "Dugtrio",
    "type1": "Ground",
    "type2": "",
    "ability1": "Sand Veil",
    "ability2": "Arena Trap",
    "abilityH": "Sand Force",
    "hp": "35",
    "attack": "100",
    "defense": "50",
    "spattack": "50",
    "spdefense": "70",
    "speed": "120",
    "total": "425",
    "weight": "73.4 lbs.",
    "height": "2'04\"",
    "dex1": "This set of triplets moves cooperatively. It’s the power of teamwork that enables this Pokémon to dig to a depth of 60 miles.",
    "dex2": "Despite the closeness between this Pokémon and farmers and other people, no one has ever seen the parts of it concealed underground.",
    "class": "Mole Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Diglett",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "52",
    "ndex": "52",
    "species": "Meowth",
    "forme": "Meowth",
    "type1": "Normal",
    "type2": "",
    "ability1": "Pickup",
    "ability2": "Technician",
    "abilityH": "Unnerve",
    "hp": "40",
    "attack": "45",
    "defense": "35",
    "spattack": "40",
    "spdefense": "40",
    "speed": "90",
    "total": "290",
    "weight": "9.3 lbs.",
    "height": "1'04\"",
    "dex1": "It lies around all day, becoming active near dusk. At night, it wanders the city in search of loose change.",
    "dex2": "It loves shiny things. It often fights with Murkrow over prey they’re both trying to catch.",
    "class": "Scratch Cat Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "53",
    "ndex": "53",
    "species": "Persian",
    "forme": "Persian",
    "type1": "Normal",
    "type2": "",
    "ability1": "Limber",
    "ability2": "Technician",
    "abilityH": "Unnerve",
    "hp": "65",
    "attack": "70",
    "defense": "60",
    "spattack": "65",
    "spdefense": "65",
    "speed": "115",
    "total": "440",
    "weight": "70.5 lbs.",
    "height": "3'03\"",
    "dex1": "It has a violent temperament. It will attack anything that looks it in the eye. Its sharp claws inflict deep wounds.",
    "dex2": "It has a high opinion of itself, although not to the same extent as the Alolan Persian. It’s quite difficult to make friends with this Pokémon.",
    "class": "Classy Cat Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Meowth",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "54",
    "ndex": "54",
    "species": "Psyduck",
    "forme": "Psyduck",
    "type1": "Water",
    "type2": "",
    "ability1": "Damp",
    "ability2": "Cloud Nine",
    "abilityH": "Swift Swim",
    "hp": "50",
    "attack": "52",
    "defense": "48",
    "spattack": "65",
    "spdefense": "50",
    "speed": "55",
    "total": "320",
    "weight": "43.2 lbs.",
    "height": "2'07\"",
    "dex1": "As a result of headaches so fierce they cause it to cry, it sometimes uses psychokinesis without meaning to.",
    "dex2": "This Pokémon is troubled by constant headaches. The more pain it’s in, the more powerful its psychokinesis becomes.",
    "class": "Duck Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "55",
    "ndex": "55",
    "species": "Golduck",
    "forme": "Golduck",
    "type1": "Water",
    "type2": "",
    "ability1": "Damp",
    "ability2": "Cloud Nine",
    "abilityH": "Swift Swim",
    "hp": "80",
    "attack": "82",
    "defense": "78",
    "spattack": "95",
    "spdefense": "80",
    "speed": "85",
    "total": "500",
    "weight": "168.9 lbs.",
    "height": "5'07\"",
    "dex1": "It is said that the red part of its forehead grants supernatural powers to those who possess one, so it was over-hunted in the past.",
    "dex2": "It swims along the banks of lakes and catches fish Pokémon. It takes them to the shore and quietly eats them up.",
    "class": "Duck Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Psyduck",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "56",
    "ndex": "56",
    "species": "Mankey",
    "forme": "Mankey",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Vital Spirit",
    "ability2": "Anger Point",
    "abilityH": "Defiant",
    "hp": "40",
    "attack": "80",
    "defense": "35",
    "spattack": "35",
    "spdefense": "45",
    "speed": "70",
    "total": "305",
    "weight": "61.7 lbs.",
    "height": "1'08\"",
    "dex1": "It can spontaneously become enraged. Everyone near it clears out as it rampages, and the resulting loneliness makes it angrier still.",
    "dex2": "Its raging tires it out and causes it to fall asleep, but the anger resonating in its dreams causes it to wake up—which infuriates it all over again.",
    "class": "Pig Monkey Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "57",
    "ndex": "57",
    "species": "Primeape",
    "forme": "Primeape",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Vital Spirit",
    "ability2": "Anger Point",
    "abilityH": "Defiant",
    "hp": "65",
    "attack": "105",
    "defense": "60",
    "spattack": "60",
    "spdefense": "70",
    "speed": "95",
    "total": "455",
    "weight": "70.5 lbs.",
    "height": "3'03\"",
    "dex1": "It has been known to become so angry that it dies as a result. Its face looks peaceful in death, however.",
    "dex2": "Some researchers theorize that Primeape remains angry even when inside a Poké Ball.",
    "class": "Pig Monkey Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Mankey",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "58",
    "ndex": "58",
    "species": "Growlithe",
    "forme": "Growlithe",
    "type1": "Fire",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Flash Fire",
    "abilityH": "Justified",
    "hp": "55",
    "attack": "70",
    "defense": "45",
    "spattack": "70",
    "spdefense": "50",
    "speed": "60",
    "total": "350",
    "weight": "41.9 lbs.",
    "height": "2'04\"",
    "dex1": "It’s both clever and loyal, but if a stranger tries to invade its territory, it barks threateningly.",
    "dex2": "It looks cute, but when you approach another Trainer’s Growlithe, it will bark at you and bite.",
    "class": "Puppy Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "59",
    "ndex": "59",
    "species": "Arcanine",
    "forme": "Arcanine",
    "type1": "Fire",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Flash Fire",
    "abilityH": "Justified",
    "hp": "90",
    "attack": "110",
    "defense": "80",
    "spattack": "100",
    "spdefense": "80",
    "speed": "95",
    "total": "555",
    "weight": "341.7 lbs.",
    "height": "6'03\"",
    "dex1": "Overflowing with beauty and majesty, this strong Pokémon appears in ancient Eastern folklore.",
    "dex2": "The fire burning inside its body serves as the energy to fuel it as it runs great distances. It appears in many legends.",
    "class": "Legendary Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Growlithe",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "60",
    "ndex": "60",
    "species": "Poliwag",
    "forme": "Poliwag",
    "type1": "Water",
    "type2": "",
    "ability1": "Water Absorb",
    "ability2": "Damp",
    "abilityH": "Swift Swim",
    "hp": "40",
    "attack": "50",
    "defense": "40",
    "spattack": "40",
    "spdefense": "40",
    "speed": "90",
    "total": "300",
    "weight": "27.3 lbs.",
    "height": "2'00\"",
    "dex1": "The swirl on its belly is its internal organs showing through. If the swirl is tinged white, that means it’s affected by some disease.",
    "dex2": "It’s still not very good at walking. Its Trainers should train this Pokémon to walk every day.",
    "class": "Tadpole Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "61",
    "ndex": "61",
    "species": "Poliwhirl",
    "forme": "Poliwhirl",
    "type1": "Water",
    "type2": "",
    "ability1": "Water Absorb",
    "ability2": "Damp",
    "abilityH": "Swift Swim",
    "hp": "65",
    "attack": "65",
    "defense": "65",
    "spattack": "50",
    "spdefense": "50",
    "speed": "90",
    "total": "385",
    "weight": "44.1 lbs.",
    "height": "3'03\"",
    "dex1": "Although it can live on land, it prefers to stay in the water, where it has fewer natural enemies.",
    "dex2": "It marches over the land in search of bug Pokémon to eat. Then it takes them underwater so it can dine on them where it’s safe.",
    "class": "Tadpole Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Poliwag",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "62",
    "ndex": "62",
    "species": "Poliwrath",
    "forme": "Poliwrath",
    "type1": "Water",
    "type2": "Fighting",
    "ability1": "Water Absorb",
    "ability2": "Damp",
    "abilityH": "Swift Swim",
    "hp": "90",
    "attack": "95",
    "defense": "95",
    "spattack": "70",
    "spdefense": "90",
    "speed": "70",
    "total": "510",
    "weight": "119.0 lbs.",
    "height": "4'03\"",
    "dex1": "Poliwrath in the Alola region are strong swimmers that use the breaststroke. Many children learn to swim by imitating Poliwrath.",
    "dex2": "Its percentage of body fat is nearly zero. Its body is entirely muscle, which makes it heavy and forces its swimming prowess to develop.",
    "class": "Tadpole Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Poliwhirl",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "63",
    "ndex": "63",
    "species": "Abra",
    "forme": "Abra",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Synchronize",
    "ability2": "Inner Focus",
    "abilityH": "Magic Guard",
    "hp": "25",
    "attack": "20",
    "defense": "15",
    "spattack": "105",
    "spdefense": "55",
    "speed": "90",
    "total": "310",
    "weight": "43.0 lbs.",
    "height": "2'11\"",
    "dex1": "It sleeps 18 hours a day. Even while sleeping, it will teleport itself to treetops and pick and eat berries there.",
    "dex2": "It can teleport itself to safety while it’s asleep, but when it wakes, it doesn’t know where it is, so it panics.",
    "class": "Psi Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "64",
    "ndex": "64",
    "species": "Kadabra",
    "forme": "Kadabra",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Synchronize",
    "ability2": "Inner Focus",
    "abilityH": "Magic Guard",
    "hp": "40",
    "attack": "35",
    "defense": "30",
    "spattack": "120",
    "spdefense": "70",
    "speed": "105",
    "total": "400",
    "weight": "124.6 lbs.",
    "height": "4'03\"",
    "dex1": "A theory exists that this Pokémon was a young boy who couldn’t control his psychic powers and ended up transformed into this Pokémon.",
    "dex2": "Kadabra’s presence infests televisions and monitors with creepy shadows that bring bad luck.",
    "class": "Psi Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Abra",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "65",
    "ndex": "65",
    "species": "Alakazam",
    "forme": "Alakazam",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Synchronize",
    "ability2": "Inner Focus",
    "abilityH": "Magic Guard",
    "hp": "55",
    "attack": "50",
    "defense": "45",
    "spattack": "135",
    "spdefense": "95",
    "speed": "120",
    "total": "500",
    "weight": "105.8 lbs.",
    "height": "4'11\"",
    "dex1": "It is said to have an IQ of approximately 5,000. Its overflowing psychokinetic powers cause headaches to anyone nearby.",
    "dex2": "Its brain cells continue to increase in number until its death. The older the Alakazam, the larger its head.",
    "class": "Psi Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Kadabra",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "66",
    "ndex": "66",
    "species": "Machop",
    "forme": "Machop",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Guts",
    "ability2": "No Guard",
    "abilityH": "Steadfast",
    "hp": "70",
    "attack": "80",
    "defense": "50",
    "spattack": "35",
    "spdefense": "35",
    "speed": "35",
    "total": "305",
    "weight": "43.0 lbs.",
    "height": "2'07\"",
    "dex1": "It loves working out. As it gazes at its muscles, which continue to swell day by day, it becomes more and more dedicated to its training.",
    "dex2": "With its superhuman strength, it’s able to throw a hundred people all at the same time. Its strength comes from lifting Graveler every day.",
    "class": "Superpower Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "67",
    "ndex": "67",
    "species": "Machoke",
    "forme": "Machoke",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Guts",
    "ability2": "No Guard",
    "abilityH": "Steadfast",
    "hp": "80",
    "attack": "100",
    "defense": "70",
    "spattack": "50",
    "spdefense": "60",
    "speed": "45",
    "total": "405",
    "weight": "155.4 lbs.",
    "height": "4'11\"",
    "dex1": "As a result of its continual workouts, it has developed tremendous power. It uses that power to help people with their work.",
    "dex2": "It willingly assists with hard labor because it knows the work is good training for its muscles.",
    "class": "Superpower Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Machop",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "68",
    "ndex": "68",
    "species": "Machamp",
    "forme": "Machamp",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Guts",
    "ability2": "No Guard",
    "abilityH": "Steadfast",
    "hp": "90",
    "attack": "130",
    "defense": "80",
    "spattack": "65",
    "spdefense": "85",
    "speed": "55",
    "total": "505",
    "weight": "286.6 lbs.",
    "height": "5'03\"",
    "dex1": "It unleashes megaton-level punches that send opponents flying clear over the horizon.",
    "dex2": "It can lift heavy loads with the greatest of ease. It can even heft dump trucks. But its clumsy fingers prevent it from doing any precision work.",
    "class": "Superpower Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Machoke",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "69",
    "ndex": "69",
    "species": "Bellsprout",
    "forme": "Bellsprout",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "Gluttony",
    "hp": "50",
    "attack": "75",
    "defense": "35",
    "spattack": "70",
    "spdefense": "30",
    "speed": "40",
    "total": "300",
    "weight": "8.8 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Flower Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "70",
    "ndex": "70",
    "species": "Weepinbell",
    "forme": "Weepinbell",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "Gluttony",
    "hp": "65",
    "attack": "90",
    "defense": "50",
    "spattack": "85",
    "spdefense": "45",
    "speed": "55",
    "total": "390",
    "weight": "14.1 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Flycatcher Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Bellsprout",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "71",
    "ndex": "71",
    "species": "Victreebel",
    "forme": "Victreebel",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "Gluttony",
    "hp": "80",
    "attack": "105",
    "defense": "65",
    "spattack": "100",
    "spdefense": "70",
    "speed": "70",
    "total": "490",
    "weight": "34.2 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Flycatcher Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Weepinbell",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "72",
    "ndex": "72",
    "species": "Tentacool",
    "forme": "Tentacool",
    "type1": "Water",
    "type2": "Poison",
    "ability1": "Clear Body",
    "ability2": "Liquid Ooze",
    "abilityH": "Rain Dish",
    "hp": "40",
    "attack": "40",
    "defense": "35",
    "spattack": "50",
    "spdefense": "100",
    "speed": "70",
    "total": "335",
    "weight": "100.3 lbs.",
    "height": "2'11\"",
    "dex1": "They can be found lying dehydrated on beaches, but they are often still alive. When soaked in water, they will revive.",
    "dex2": "It drifts in shallow seas, such as the areas near beaches. If you get bitten or stabbed by its toxic tentacles, rush to the hospital.",
    "class": "Jellyfish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "73",
    "ndex": "73",
    "species": "Tentacruel",
    "forme": "Tentacruel",
    "type1": "Water",
    "type2": "Poison",
    "ability1": "Clear Body",
    "ability2": "Liquid Ooze",
    "abilityH": "Rain Dish",
    "hp": "80",
    "attack": "70",
    "defense": "65",
    "spattack": "80",
    "spdefense": "120",
    "speed": "100",
    "total": "515",
    "weight": "121.3 lbs.",
    "height": "5'03\"",
    "dex1": "Normally, it has 80 poisonous tentacles. The longer one has been alive, the fewer tentacles it will have.",
    "dex2": "Although these Pokémon are rare, when a large outbreak of them occurs, all fish Pokémon disappear from the surrounding sea.",
    "class": "Jellyfish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Tentacool",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "74",
    "ndex": "74",
    "species": "Geodude",
    "forme": "Geodude",
    "type1": "Rock",
    "type2": "Ground",
    "ability1": "Rock Head",
    "ability2": "Sturdy",
    "abilityH": "Sand Veil",
    "hp": "40",
    "attack": "80",
    "defense": "100",
    "spattack": "30",
    "spdefense": "30",
    "speed": "20",
    "total": "300",
    "weight": "44.1 lbs.",
    "height": "1'04\"",
    "dex1": "Its round body makes it easy to pick up, but it is hard and heavy. It’s dangerous to play with them as if they were snowballs.",
    "dex2": "There are plenty of them to be found along any road. A scholar with too much free time once counted a hundred of them along a single route.",
    "class": "Rock Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "75",
    "ndex": "75",
    "species": "Graveler",
    "forme": "Graveler",
    "type1": "Rock",
    "type2": "Ground",
    "ability1": "Rock Head",
    "ability2": "Sturdy",
    "abilityH": "Sand Veil",
    "hp": "55",
    "attack": "95",
    "defense": "115",
    "spattack": "45",
    "spdefense": "45",
    "speed": "35",
    "total": "390",
    "weight": "231.5 lbs.",
    "height": "3'03\"",
    "dex1": "Mossy rocks are its favorite food. It can devour a ton a day while crunching loudly.",
    "dex2": "This slow-footed Pokémon moves by curling up and rolling instead of walking. With enough momentum, its speed can exceed 60 mph.",
    "class": "Rock Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Geodude",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "76",
    "ndex": "76",
    "species": "Golem",
    "forme": "Golem",
    "type1": "Rock",
    "type2": "Ground",
    "ability1": "Rock Head",
    "ability2": "Sturdy",
    "abilityH": "Sand Veil",
    "hp": "80",
    "attack": "120",
    "defense": "130",
    "spattack": "55",
    "spdefense": "65",
    "speed": "45",
    "total": "495",
    "weight": "661.4 lbs.",
    "height": "4'07\"",
    "dex1": "Its body can survive dynamite blasts without a single scratch, but it hates rain and humidity.",
    "dex2": "Once a year, this Pokémon molts, and its shed shell returns to the soil. This process creates enriched soil, so farmers collect the shells.",
    "class": "Megaton Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Graveler",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "77",
    "ndex": "77",
    "species": "Ponyta",
    "forme": "Ponyta",
    "type1": "Fire",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Flash Fire",
    "abilityH": "Flame Body",
    "hp": "50",
    "attack": "85",
    "defense": "55",
    "spattack": "65",
    "spdefense": "65",
    "speed": "90",
    "total": "410",
    "weight": "66.1 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Fire Horse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "78",
    "ndex": "78",
    "species": "Rapidash",
    "forme": "Rapidash",
    "type1": "Fire",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Flash Fire",
    "abilityH": "Flame Body",
    "hp": "65",
    "attack": "100",
    "defense": "70",
    "spattack": "80",
    "spdefense": "80",
    "speed": "105",
    "total": "500",
    "weight": "209.4 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Fire Horse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Ponyta",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "79",
    "ndex": "79",
    "species": "Slowpoke",
    "forme": "Slowpoke",
    "type1": "Water",
    "type2": "Psychic",
    "ability1": "Oblivious",
    "ability2": "Own Tempo",
    "abilityH": "Regenerator",
    "hp": "90",
    "attack": "65",
    "defense": "65",
    "spattack": "40",
    "spdefense": "40",
    "speed": "15",
    "total": "315",
    "weight": "79.4 lbs.",
    "height": "3'11\"",
    "dex1": "Its long tail often breaks off. It doesn’t really feel any pain, though, and the tail grows back, so Slowpoke isn’t particularly bothered.",
    "dex2": "Alolan home cooking involves drying Slowpoke tails and then simmering them into a salty stew.",
    "class": "Dopey Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "80",
    "ndex": "80",
    "species": "Slowbro",
    "forme": "Slowbro",
    "type1": "Water",
    "type2": "Psychic",
    "ability1": "Oblivious",
    "ability2": "Own Tempo",
    "abilityH": "Regenerator",
    "hp": "95",
    "attack": "75",
    "defense": "110",
    "spattack": "100",
    "spdefense": "80",
    "speed": "30",
    "total": "490",
    "weight": "173.1 lbs.",
    "height": "5'03\"",
    "dex1": "It spaces out while gazing at the sea. With Shellder’s poison flowing through its body, it becomes even spacier.",
    "dex2": "Whenever Shellder bites down hard on its tail, it gives Slowbro a flash of inspiration...which it forgets a moment later.",
    "class": "Hermit Crab Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Slowpoke",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "81",
    "ndex": "81",
    "species": "Magnemite",
    "forme": "Magnemite",
    "type1": "Electric",
    "type2": "Steel",
    "ability1": "Magnet Pull",
    "ability2": "Sturdy",
    "abilityH": "Analytic",
    "hp": "25",
    "attack": "35",
    "defense": "70",
    "spattack": "95",
    "spdefense": "55",
    "speed": "45",
    "total": "325",
    "weight": "13.2 lbs.",
    "height": "1'00\"",
    "dex1": "They gather in places where electricity is available. They can be found clinging to the steel towers used to support power lines.",
    "dex2": "It sends out electromagnetic waves, which let it float through the air. Touching it while it’s eating electricity will give you a full-body shock.",
    "class": "Magnet Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "82",
    "ndex": "82",
    "species": "Magneton",
    "forme": "Magneton",
    "type1": "Electric",
    "type2": "Steel",
    "ability1": "Magnet Pull",
    "ability2": "Sturdy",
    "abilityH": "Analytic",
    "hp": "50",
    "attack": "60",
    "defense": "95",
    "spattack": "120",
    "spdefense": "70",
    "speed": "70",
    "total": "465",
    "weight": "132.3 lbs.",
    "height": "3'03\"",
    "dex1": "When three Magnemite link together, their brains also become one. They do not become three times more intelligent.",
    "dex2": "It has about three times the electrical power of Magnemite. For some reason, outbreaks of this Pokémon happen when lots of sunspots appear.",
    "class": "Magnet Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Magnemite",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "83",
    "ndex": "83",
    "species": "Farfetch’d",
    "forme": "Farfetch’d",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Inner Focus",
    "abilityH": "Defiant",
    "hp": "52",
    "attack": "90",
    "defense": "55",
    "spattack": "58",
    "spdefense": "62",
    "speed": "60",
    "total": "377",
    "weight": "33.1 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Wild Duck Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": "Field"
  },
  {
    "id": "84",
    "ndex": "84",
    "species": "Doduo",
    "forme": "Doduo",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Run Away",
    "ability2": "Early Bird",
    "abilityH": "Tangled Feet",
    "hp": "35",
    "attack": "85",
    "defense": "45",
    "spattack": "35",
    "spdefense": "35",
    "speed": "75",
    "total": "310",
    "weight": "86.4 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Twin Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "85",
    "ndex": "85",
    "species": "Dodrio",
    "forme": "Dodrio",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Run Away",
    "ability2": "Early Bird",
    "abilityH": "Tangled Feet",
    "hp": "60",
    "attack": "110",
    "defense": "70",
    "spattack": "60",
    "spdefense": "60",
    "speed": "100",
    "total": "460",
    "weight": "187.8 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Triple Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Doduo",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "86",
    "ndex": "86",
    "species": "Seel",
    "forme": "Seel",
    "type1": "Water",
    "type2": "",
    "ability1": "Thick Fat",
    "ability2": "Hydration",
    "abilityH": "Ice Body",
    "hp": "65",
    "attack": "45",
    "defense": "55",
    "spattack": "45",
    "spdefense": "70",
    "speed": "45",
    "total": "325",
    "weight": "198.4 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Sea Lion Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "87",
    "ndex": "87",
    "species": "Dewgong",
    "forme": "Dewgong",
    "type1": "Water",
    "type2": "Ice",
    "ability1": "Thick Fat",
    "ability2": "Hydration",
    "abilityH": "Ice Body",
    "hp": "90",
    "attack": "70",
    "defense": "80",
    "spattack": "70",
    "spdefense": "95",
    "speed": "70",
    "total": "475",
    "weight": "264.6 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Sea Lion Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Seel",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "88",
    "ndex": "88",
    "species": "Grimer",
    "forme": "Grimer",
    "type1": "Poison",
    "type2": "",
    "ability1": "Stench",
    "ability2": "Sticky Hold",
    "abilityH": "Poison Touch",
    "hp": "80",
    "attack": "80",
    "defense": "50",
    "spattack": "40",
    "spdefense": "50",
    "speed": "25",
    "total": "325",
    "weight": "66.1 lbs.",
    "height": "2'11\"",
    "dex1": "Its main source of food is the slimy industrial waste of factories. This Pokémon’s numbers have been decreasing in recent years.",
    "dex2": "It was born from sludge transformed by exposure to X-rays from the moon. When its internal load of germs decreases, it dies.",
    "class": "Sludge Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "89",
    "ndex": "89",
    "species": "Muk",
    "forme": "Muk",
    "type1": "Poison",
    "type2": "",
    "ability1": "Stench",
    "ability2": "Sticky Hold",
    "abilityH": "Poison Touch",
    "hp": "105",
    "attack": "105",
    "defense": "75",
    "spattack": "65",
    "spdefense": "100",
    "speed": "50",
    "total": "500",
    "weight": "66.1 lbs.",
    "height": "3'11\"",
    "dex1": "The stench it gives off will make your nose scrunch up. Still, there are Muk fans who think that’s a good thing.",
    "dex2": "After recent environmental improvements, this Pokémon is now hardly seen at all. People speculate that it may go extinct at some point.",
    "class": "Sludge Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Grimer",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "90",
    "ndex": "90",
    "species": "Shellder",
    "forme": "Shellder",
    "type1": "Water",
    "type2": "",
    "ability1": "Shell Armor",
    "ability2": "Skill Link",
    "abilityH": "Overcoat",
    "hp": "30",
    "attack": "65",
    "defense": "100",
    "spattack": "45",
    "spdefense": "25",
    "speed": "40",
    "total": "305",
    "weight": "8.8 lbs.",
    "height": "1'00\"",
    "dex1": "The hardness of its shell surpasses the hardness of a diamond. In days gone by, people used the shells to make shields.",
    "dex2": "This Pokémon’s tongue is always hanging out. It uses its tongue with great dexterity to dig up sand from the seabed in its search for food.",
    "class": "Bivalve Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "91",
    "ndex": "91",
    "species": "Cloyster",
    "forme": "Cloyster",
    "type1": "Water",
    "type2": "Ice",
    "ability1": "Shell Armor",
    "ability2": "Skill Link",
    "abilityH": "Overcoat",
    "hp": "50",
    "attack": "95",
    "defense": "180",
    "spattack": "85",
    "spdefense": "45",
    "speed": "70",
    "total": "525",
    "weight": "292.1 lbs.",
    "height": "4'11\"",
    "dex1": "Its hard shell cannot be shattered—not even by a bomb. The contents of the shell remain unknown.",
    "dex2": "Excavation of the tombs of ancient hunting tribes has turned up many spears tipped with spikes that had fallen off this Pokémon’s shell.",
    "class": "Bivalve Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shellder",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "92",
    "ndex": "92",
    "species": "Gastly",
    "forme": "Gastly",
    "type1": "Ghost",
    "type2": "Poison",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "30",
    "attack": "35",
    "defense": "30",
    "spattack": "100",
    "spdefense": "35",
    "speed": "80",
    "total": "310",
    "weight": "0.2 lbs.",
    "height": "4'03\"",
    "dex1": "Should a strange light be seen flickering in an abandoned building, Gastly is lurking there.",
    "dex2": "Although Gastly is barely visible, when it’s near, a faint sweet smell lingers.",
    "class": "Gas Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "93",
    "ndex": "93",
    "species": "Haunter",
    "forme": "Haunter",
    "type1": "Ghost",
    "type2": "Poison",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "45",
    "attack": "50",
    "defense": "45",
    "spattack": "115",
    "spdefense": "55",
    "speed": "95",
    "total": "405",
    "weight": "0.2 lbs.",
    "height": "5'03\"",
    "dex1": "It strikes at humans from total darkness. Those licked by its cold tongue grow weaker with each passing day until they die.",
    "dex2": "It fears the light and revels in the dark. It may be on the verge of extinction in cities that stay brightly lit at night.",
    "class": "Gas Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gastly",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "94",
    "ndex": "94",
    "species": "Gengar",
    "forme": "Gengar",
    "type1": "Ghost",
    "type2": "Poison",
    "ability1": "Cursed Body",
    "ability2": "Cursed Body",
    "abilityH": "Cursed Body",
    "hp": "60",
    "attack": "65",
    "defense": "60",
    "spattack": "130",
    "spdefense": "75",
    "speed": "110",
    "total": "500",
    "weight": "89.3 lbs.",
    "height": "4'11\"",
    "dex1": "Should you feel yourself attacked by a sudden chill, it is evidence of an approaching Gengar. There is no escaping it. Give up.",
    "dex2": "It apparently wishes for a traveling companion. Since it was once human itself, it tries to create one by taking the lives of other humans.",
    "class": "Shadow Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Haunter",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "95",
    "ndex": "95",
    "species": "Onix",
    "forme": "Onix",
    "type1": "Rock",
    "type2": "Ground",
    "ability1": "Rock Head",
    "ability2": "Sturdy",
    "abilityH": "Weak Armor",
    "hp": "35",
    "attack": "45",
    "defense": "160",
    "spattack": "30",
    "spdefense": "45",
    "speed": "70",
    "total": "385",
    "weight": "463.0 lbs.",
    "height": "28'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Rock Snake Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "96",
    "ndex": "96",
    "species": "Drowzee",
    "forme": "Drowzee",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Insomnia",
    "ability2": "Forewarn",
    "abilityH": "Inner Focus",
    "hp": "60",
    "attack": "48",
    "defense": "45",
    "spattack": "43",
    "spdefense": "90",
    "speed": "42",
    "total": "328",
    "weight": "71.4 lbs.",
    "height": "3'03\"",
    "dex1": "A Pokémon that nourishes itself by eating dreams, it is thought to share common ancestry with Munna and Musharna.",
    "dex2": "It finds really fun dreams tasty. When it makes friends with people, it may show them the most delicious dreams it’s ever eaten.",
    "class": "Hypnosis Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "97",
    "ndex": "97",
    "species": "Hypno",
    "forme": "Hypno",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Insomnia",
    "ability2": "Forewarn",
    "abilityH": "Inner Focus",
    "hp": "85",
    "attack": "73",
    "defense": "70",
    "spattack": "73",
    "spdefense": "115",
    "speed": "67",
    "total": "483",
    "weight": "166.7 lbs.",
    "height": "5'03\"",
    "dex1": "While it is an extremely dangerous Pokémon, people who are in need of a good, sound sleep call it their savior.",
    "dex2": "As a matter of course, it makes anyone it meets fall asleep and has a taste of their dreams. Anyone having a good dream, it carries off.",
    "class": "Hypnosis Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Drowzee",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "98",
    "ndex": "98",
    "species": "Krabby",
    "forme": "Krabby",
    "type1": "Water",
    "type2": "",
    "ability1": "Hyper Cutter",
    "ability2": "Shell Armor",
    "abilityH": "Sheer Force",
    "hp": "30",
    "attack": "105",
    "defense": "90",
    "spattack": "25",
    "spdefense": "25",
    "speed": "50",
    "total": "325",
    "weight": "14.3 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "River Crab Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "99",
    "ndex": "99",
    "species": "Kingler",
    "forme": "Kingler",
    "type1": "Water",
    "type2": "",
    "ability1": "Hyper Cutter",
    "ability2": "Shell Armor",
    "abilityH": "Sheer Force",
    "hp": "55",
    "attack": "130",
    "defense": "115",
    "spattack": "50",
    "spdefense": "50",
    "speed": "75",
    "total": "475",
    "weight": "132.3 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Pincer Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Krabby",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "100",
    "ndex": "100",
    "species": "Voltorb",
    "forme": "Voltorb",
    "type1": "Electric",
    "type2": "",
    "ability1": "Soundproof",
    "ability2": "Static",
    "abilityH": "Aftermath",
    "hp": "40",
    "attack": "30",
    "defense": "50",
    "spattack": "55",
    "spdefense": "55",
    "speed": "100",
    "total": "330",
    "weight": "22.9 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Ball Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "101",
    "ndex": "101",
    "species": "Electrode",
    "forme": "Electrode",
    "type1": "Electric",
    "type2": "",
    "ability1": "Soundproof",
    "ability2": "Static",
    "abilityH": "Aftermath",
    "hp": "60",
    "attack": "50",
    "defense": "70",
    "spattack": "80",
    "spdefense": "80",
    "speed": "150",
    "total": "490",
    "weight": "146.8 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Ball Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Voltorb",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "102",
    "ndex": "102",
    "species": "Exeggcute",
    "forme": "Exeggcute",
    "type1": "Grass",
    "type2": "Psychic",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "Harvest",
    "hp": "60",
    "attack": "40",
    "defense": "80",
    "spattack": "60",
    "spdefense": "45",
    "speed": "40",
    "total": "325",
    "weight": "5.5 lbs.",
    "height": "1'04\"",
    "dex1": "Its six eggs use telepathy to communicate among themselves. It is believed to carry plant genes and the genes of other species.",
    "dex2": "Six of them together form a full-fledged Pokémon. It’s often hunted by Crabrawler, but uses psychokinesis to drive it off.",
    "class": "Egg Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "103",
    "ndex": "103",
    "species": "Exeggutor",
    "forme": "Exeggutor",
    "type1": "Grass",
    "type2": "Psychic",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "Harvest",
    "hp": "95",
    "attack": "95",
    "defense": "85",
    "spattack": "125",
    "spdefense": "75",
    "speed": "55",
    "total": "530",
    "weight": "264.6 lbs.",
    "height": "6'07\"",
    "dex1": "Each of its heads has its own will. They use telepathy to discuss their plans before coming to a joint decision.",
    "dex2": "When the time comes, one of its three heads falls off. Before long, the fallen head grows into an Exeggcute.",
    "class": "Coconut Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Exeggcute",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "104",
    "ndex": "104",
    "species": "Cubone",
    "forme": "Cubone",
    "type1": "Ground",
    "type2": "",
    "ability1": "Rock Head",
    "ability2": "Lightning Rod",
    "abilityH": "Battle Armor",
    "hp": "50",
    "attack": "50",
    "defense": "95",
    "spattack": "40",
    "spdefense": "50",
    "speed": "35",
    "total": "320",
    "weight": "14.3 lbs.",
    "height": "1'04\"",
    "dex1": "When it thinks of its deceased mother, it weeps loudly. Mandibuzz that hear its cries will attack it from the air.",
    "dex2": "The skull it wears on its head is that of its dead mother. According to some, it will evolve when it comes to terms with the pain of her death.",
    "class": "Lonely Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "105",
    "ndex": "105",
    "species": "Marowak",
    "forme": "Marowak",
    "type1": "Ground",
    "type2": "",
    "ability1": "Rock Head",
    "ability2": "Lightning Rod",
    "abilityH": "Battle Armor",
    "hp": "60",
    "attack": "80",
    "defense": "110",
    "spattack": "50",
    "spdefense": "80",
    "speed": "45",
    "total": "425",
    "weight": "99.2 lbs.",
    "height": "3'03\"",
    "dex1": "Originally, it was weak and timid. After evolution, its temperament becomes violent, and it begins to wield bones as weapons.",
    "dex2": "This Pokémon is out for vengeance on its natural enemy, Mandibuzz. It throws bones like boomerangs to try to take it down.",
    "class": "Bone Keeper Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Cubone",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "106",
    "ndex": "106",
    "species": "Hitmonlee",
    "forme": "Hitmonlee",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Limber",
    "ability2": "Reckless",
    "abilityH": "Unburden",
    "hp": "50",
    "attack": "120",
    "defense": "53",
    "spattack": "35",
    "spdefense": "110",
    "speed": "87",
    "total": "455",
    "weight": "109.8 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Kicking Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Tyrogue",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "107",
    "ndex": "107",
    "species": "Hitmonchan",
    "forme": "Hitmonchan",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Keen Eye",
    "ability2": "Iron Fist",
    "abilityH": "Inner Focus",
    "hp": "50",
    "attack": "105",
    "defense": "79",
    "spattack": "35",
    "spdefense": "110",
    "speed": "76",
    "total": "455",
    "weight": "110.7 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Punching Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Tyrogue",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "108",
    "ndex": "108",
    "species": "Lickitung",
    "forme": "Lickitung",
    "type1": "Normal",
    "type2": "",
    "ability1": "Own Tempo",
    "ability2": "Oblivious",
    "abilityH": "Cloud Nine",
    "hp": "90",
    "attack": "55",
    "defense": "75",
    "spattack": "60",
    "spdefense": "75",
    "speed": "30",
    "total": "385",
    "weight": "144.4 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Licking Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "109",
    "ndex": "109",
    "species": "Koffing",
    "forme": "Koffing",
    "type1": "Poison",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "40",
    "attack": "65",
    "defense": "95",
    "spattack": "60",
    "spdefense": "45",
    "speed": "35",
    "total": "340",
    "weight": "2.2 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Gas Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "110",
    "ndex": "110",
    "species": "Weezing",
    "forme": "Weezing",
    "type1": "Poison",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "65",
    "attack": "90",
    "defense": "120",
    "spattack": "85",
    "spdefense": "70",
    "speed": "60",
    "total": "490",
    "weight": "20.9 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Gas Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Koffing",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "111",
    "ndex": "111",
    "species": "Rhyhorn",
    "forme": "Rhyhorn",
    "type1": "Ground",
    "type2": "Rock",
    "ability1": "Lightning Rod",
    "ability2": "Rock Head",
    "abilityH": "Reckless",
    "hp": "80",
    "attack": "85",
    "defense": "95",
    "spattack": "30",
    "spdefense": "30",
    "speed": "25",
    "total": "345",
    "weight": "253.5 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Spikes Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "112",
    "ndex": "112",
    "species": "Rhydon",
    "forme": "Rhydon",
    "type1": "Ground",
    "type2": "Rock",
    "ability1": "Lightning Rod",
    "ability2": "Rock Head",
    "abilityH": "Reckless",
    "hp": "105",
    "attack": "130",
    "defense": "120",
    "spattack": "45",
    "spdefense": "45",
    "speed": "40",
    "total": "485",
    "weight": "264.6 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Drill Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Rhyhorn",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "113",
    "ndex": "113",
    "species": "Chansey",
    "forme": "Chansey",
    "type1": "Normal",
    "type2": "",
    "ability1": "Natural Cure",
    "ability2": "Serene Grace",
    "abilityH": "Healer",
    "hp": "250",
    "attack": "5",
    "defense": "5",
    "spattack": "35",
    "spdefense": "105",
    "speed": "50",
    "total": "450",
    "weight": "76.3 lbs.",
    "height": "3'07\"",
    "dex1": "The eggs laid by Chansey are rich in nutrients and a favorite food of many Pokémon.",
    "dex2": "Not only are these Pokémon fast runners, they’re also few in number, so anyone who finds one must be lucky indeed.",
    "class": "Egg Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Happiny",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "114",
    "ndex": "114",
    "species": "Tangela",
    "forme": "Tangela",
    "type1": "Grass",
    "type2": "",
    "ability1": "Chlorophyll",
    "ability2": "Leaf Guard",
    "abilityH": "Regenerator",
    "hp": "65",
    "attack": "55",
    "defense": "115",
    "spattack": "100",
    "spdefense": "40",
    "speed": "60",
    "total": "435",
    "weight": "77.2 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Vine Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "115",
    "ndex": "115",
    "species": "Kangaskhan",
    "forme": "Kangaskhan",
    "type1": "Normal",
    "type2": "",
    "ability1": "Early Bird",
    "ability2": "Scrappy",
    "abilityH": "Inner Focus",
    "hp": "105",
    "attack": "95",
    "defense": "80",
    "spattack": "40",
    "spdefense": "80",
    "speed": "90",
    "total": "490",
    "weight": "176.4 lbs.",
    "height": "7'03\"",
    "dex1": "Kangaskhan’s maternal love is so deep that it will brave death to protect its offspring.",
    "dex2": "The child in its pouch leaves home after roughly three years. That is the only time the mother is heard to cry wildly.",
    "class": "Parent Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "116",
    "ndex": "116",
    "species": "Horsea",
    "forme": "Horsea",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "Sniper",
    "abilityH": "Damp",
    "hp": "30",
    "attack": "40",
    "defense": "70",
    "spattack": "70",
    "spdefense": "25",
    "speed": "60",
    "total": "295",
    "weight": "17.6 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Dragon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "117",
    "ndex": "117",
    "species": "Seadra",
    "forme": "Seadra",
    "type1": "Water",
    "type2": "",
    "ability1": "Poison Point",
    "ability2": "Sniper",
    "abilityH": "Damp",
    "hp": "55",
    "attack": "65",
    "defense": "95",
    "spattack": "95",
    "spdefense": "45",
    "speed": "85",
    "total": "440",
    "weight": "55.1 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Dragon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Horsea",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "118",
    "ndex": "118",
    "species": "Goldeen",
    "forme": "Goldeen",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "Sniper",
    "abilityH": "Damp",
    "hp": "45",
    "attack": "67",
    "defense": "60",
    "spattack": "35",
    "spdefense": "50",
    "speed": "63",
    "total": "320",
    "weight": "33.1 lbs.",
    "height": "2'00\"",
    "dex1": "When the weather grows warm, they form groups and swim upriver. This sight serves as a poetic reminder that spring has arrived.",
    "dex2": "Spellbound by the length of its horn and the beauty of its fins, many strange Trainers raise Goldeen and nothing but Goldeen.",
    "class": "Goldfish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "119",
    "ndex": "119",
    "species": "Seaking",
    "forme": "Seaking",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "Water Veil",
    "abilityH": "Lightning Rod",
    "hp": "80",
    "attack": "92",
    "defense": "65",
    "spattack": "65",
    "spdefense": "80",
    "speed": "68",
    "total": "450",
    "weight": "86.0 lbs.",
    "height": "4'03\"",
    "dex1": "When the weather grows cold, its whole body flushes a deep red. This sight serves as a poetic reminder that autumn has arrived.",
    "dex2": "Trainers who are crazy for Seaking are divided into horn enthusiasts and fin enthusiasts. The two groups do not get along well.",
    "class": "Goldfish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Goldeen",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "120",
    "ndex": "120",
    "species": "Staryu",
    "forme": "Staryu",
    "type1": "Water",
    "type2": "",
    "ability1": "Illuminate",
    "ability2": "Natural Cure",
    "abilityH": "Analytic",
    "hp": "30",
    "attack": "45",
    "defense": "55",
    "spattack": "70",
    "spdefense": "55",
    "speed": "85",
    "total": "340",
    "weight": "76.1 lbs.",
    "height": "2'07\"",
    "dex1": "Large numbers of these Pokémon make their home at the seaside. At night, a strange red glow radiates from the center of their bodies.",
    "dex2": "This Pokémon gets nibbled on by Lumineon and others. Thanks to its red core, it regenerates fast, so it’s unconcerned by their snack attacks.",
    "class": "Star Shape Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "121",
    "ndex": "121",
    "species": "Starmie",
    "forme": "Starmie",
    "type1": "Water",
    "type2": "Psychic",
    "ability1": "Illuminate",
    "ability2": "Natural Cure",
    "abilityH": "Analytic",
    "hp": "60",
    "attack": "75",
    "defense": "85",
    "spattack": "100",
    "spdefense": "85",
    "speed": "115",
    "total": "520",
    "weight": "176.4 lbs.",
    "height": "3'07\"",
    "dex1": "Its shining core is thought to receive and transmit enigmatic signals. It has been known to cause headaches in those who approach it.",
    "dex2": "Its unusual body shape, reminiscent of abstract art, led local people to spread rumors that this Pokémon may be an invader from outer space.",
    "class": "Mysterious Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Staryu",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "122",
    "ndex": "122",
    "species": "Mr. Mime",
    "forme": "Mr. Mime",
    "type1": "Psychic",
    "type2": "Fairy",
    "ability1": "Soundproof",
    "ability2": "Filter",
    "abilityH": "Technician",
    "hp": "40",
    "attack": "45",
    "defense": "65",
    "spattack": "100",
    "spdefense": "120",
    "speed": "90",
    "total": "460",
    "weight": "120.1 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Barrier Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Mime Jr.",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "123",
    "ndex": "123",
    "species": "Scyther",
    "forme": "Scyther",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Swarm",
    "ability2": "Technician",
    "abilityH": "Steadfast",
    "hp": "70",
    "attack": "110",
    "defense": "80",
    "spattack": "55",
    "spdefense": "80",
    "speed": "105",
    "total": "500",
    "weight": "123.5 lbs.",
    "height": "4'11\"",
    "dex1": "It confuses its prey with its quick, ninja-like movements. Then, in an instant, it cleaves them with its scythes.",
    "dex2": "While young, they live together deep in the mountains, training themselves in how to fight with their scythes and move at high speeds.",
    "class": "Mantis Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "124",
    "ndex": "124",
    "species": "Jynx",
    "forme": "Jynx",
    "type1": "Ice",
    "type2": "Psychic",
    "ability1": "Oblivious",
    "ability2": "Forewarn",
    "abilityH": "Dry Skin",
    "hp": "65",
    "attack": "50",
    "defense": "35",
    "spattack": "115",
    "spdefense": "95",
    "speed": "95",
    "total": "455",
    "weight": "89.5 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Human Shape Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Smoochum",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "125",
    "ndex": "125",
    "species": "Electabuzz",
    "forme": "Electabuzz",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "",
    "abilityH": "Vital Spirit",
    "hp": "65",
    "attack": "83",
    "defense": "57",
    "spattack": "95",
    "spdefense": "85",
    "speed": "105",
    "total": "490",
    "weight": "66.1 lbs.",
    "height": "3'07\"",
    "dex1": "Half of all sudden blackouts are caused by Electabuzz gathering at electric power plants and gobbling up electricity.",
    "dex2": "Electricity leaks from it in amounts far greater than the amount of electricity it eats.",
    "class": "Electric Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Elekid",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "126",
    "ndex": "126",
    "species": "Magmar",
    "forme": "Magmar",
    "type1": "Fire",
    "type2": "",
    "ability1": "Flame Body",
    "ability2": "",
    "abilityH": "Vital Spirit",
    "hp": "65",
    "attack": "95",
    "defense": "57",
    "spattack": "100",
    "spdefense": "85",
    "speed": "93",
    "total": "495",
    "weight": "98.1 lbs.",
    "height": "4'03\"",
    "dex1": "When it’s tired, it leaps into the mouth of a volcano and soaks its body in magma to ease its weariness. Its body burns at 2,192 degrees F.",
    "dex2": "When angered, it spouts brilliant fire from all over its body. It doesn’t calm down until its opponent has burned to ash.",
    "class": "Spitfire Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Magby",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "127",
    "ndex": "127",
    "species": "Pinsir",
    "forme": "Pinsir",
    "type1": "Bug",
    "type2": "",
    "ability1": "Hyper Cutter",
    "ability2": "Mold Breaker",
    "abilityH": "Moxie",
    "hp": "65",
    "attack": "125",
    "defense": "100",
    "spattack": "55",
    "spdefense": "70",
    "speed": "85",
    "total": "500",
    "weight": "121.3 lbs.",
    "height": "4'11\"",
    "dex1": "It grips its prey in its pincers and splits them apart. Although it is a powerful Pokémon, it can’t deal with the cold.",
    "dex2": "One solid blow from its horns is enough to split apart a large tree. Its greatest rival in Alola is Vikavolt.",
    "class": "Stag Beetle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "128",
    "ndex": "128",
    "species": "Tauros",
    "forme": "Tauros",
    "type1": "Normal",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Anger Point",
    "abilityH": "Sheer Force",
    "hp": "75",
    "attack": "100",
    "defense": "95",
    "spattack": "40",
    "spdefense": "70",
    "speed": "110",
    "total": "490",
    "weight": "194.9 lbs.",
    "height": "4'07\"",
    "dex1": "Historically, people in areas all over the world have ridden Tauros, but the practice is said to have started in Alola.",
    "dex2": "Although it’s known to be a fierce Pokémon, Tauros in the Alola region are said to possess a measure of calmness.",
    "class": "Wild Bull Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "129",
    "ndex": "129",
    "species": "Magikarp",
    "forme": "Magikarp",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "",
    "abilityH": "Rattled",
    "hp": "20",
    "attack": "10",
    "defense": "55",
    "spattack": "15",
    "spdefense": "20",
    "speed": "80",
    "total": "200",
    "weight": "22.0 lbs.",
    "height": "2'11\"",
    "dex1": "Although weak and helpless, this Pokémon is incredibly fertile. They exist in such multitudes, you’ll soon grow tired of seeing them.",
    "dex2": "Its reckless leaps make it easy pickings for predators. On the bright side, many Pokémon enjoy longer life spans, thanks to Magikarp.",
    "class": "Fish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": "Dragon"
  },
  {
    "id": "130",
    "ndex": "130",
    "species": "Gyarados",
    "forme": "Gyarados",
    "type1": "Water",
    "type2": "Flying",
    "ability1": "Intimidate",
    "ability2": "",
    "abilityH": "Moxie",
    "hp": "95",
    "attack": "125",
    "defense": "79",
    "spattack": "60",
    "spdefense": "100",
    "speed": "81",
    "total": "540",
    "weight": "518.1 lbs.",
    "height": "21'04\"",
    "dex1": "A tale is told of a town that angered Gyarados. Before the sun rose the next day, flames utterly consumed the town, leaving not a trace behind.",
    "dex2": "There are people who swear that any place Gyarados appears is fated for destruction.",
    "class": "Atrocious Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Magikarp",
    "egg-group1": "Water 2",
    "egg-group2": "Dragon"
  },
  {
    "id": "131",
    "ndex": "131",
    "species": "Lapras",
    "forme": "Lapras",
    "type1": "Water",
    "type2": "Ice",
    "ability1": "Water Absorb",
    "ability2": "Shell Armor",
    "abilityH": "Hydration",
    "hp": "130",
    "attack": "85",
    "defense": "80",
    "spattack": "85",
    "spdefense": "95",
    "speed": "60",
    "total": "535",
    "weight": "485.0 lbs.",
    "height": "8'02\"",
    "dex1": "Its high intelligence enables it to comprehend human speech. When it’s in a good mood, it sings in its beautiful voice.",
    "dex2": "These Pokémon were once near extinction due to poaching. Following protective regulations, there is now an overabundance of them.",
    "class": "Transport Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "132",
    "ndex": "132",
    "species": "Ditto",
    "forme": "Ditto",
    "type1": "Normal",
    "type2": "",
    "ability1": "Limber",
    "ability2": "",
    "abilityH": "Imposter",
    "hp": "48",
    "attack": "48",
    "defense": "48",
    "spattack": "48",
    "spdefense": "48",
    "speed": "48",
    "total": "288",
    "weight": "8.8 lbs.",
    "height": "1'00\"",
    "dex1": "It can reorganize its cells to make itself into a duplicate of anything it sees. The quality of the duplicate depends on the individual.",
    "dex2": "With its astonishing capacity for metamorphosis, it can get along with anything. It does not get along well with its fellow Ditto.",
    "class": "Transform Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Ditto",
    "egg-group2": ""
  },
  {
    "id": "133",
    "ndex": "133",
    "species": "Eevee",
    "forme": "Eevee",
    "type1": "Normal",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Adaptability",
    "abilityH": "Anticipation",
    "hp": "55",
    "attack": "55",
    "defense": "50",
    "spattack": "45",
    "spdefense": "65",
    "speed": "55",
    "total": "325",
    "weight": "14.3 lbs.",
    "height": "1'00\"",
    "dex1": "Possessing an unbalanced and unstable genetic makeup, it conceals many possible evolutions.",
    "dex2": "Current studies show it can evolve into an incredible eight different species of Pokémon.",
    "class": "Evolution Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "134",
    "ndex": "134",
    "species": "Vaporeon",
    "forme": "Vaporeon",
    "type1": "Water",
    "type2": "",
    "ability1": "Water Absorb",
    "ability2": "",
    "abilityH": "Hydration",
    "hp": "130",
    "attack": "65",
    "defense": "60",
    "spattack": "110",
    "spdefense": "95",
    "speed": "65",
    "total": "525",
    "weight": "63.9 lbs.",
    "height": "3'03\"",
    "dex1": "Its cells are composed of units much like water molecules. It lives close to water and is often mistaken for a mermaid.",
    "dex2": "Blending in with the water and erasing all signs of its presence, it patiently waits for its prey, fish Pokémon.",
    "class": "Bubble Jet Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Eevee",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "135",
    "ndex": "135",
    "species": "Jolteon",
    "forme": "Jolteon",
    "type1": "Electric",
    "type2": "",
    "ability1": "Volt Absorb",
    "ability2": "",
    "abilityH": "Quick Feet",
    "hp": "65",
    "attack": "65",
    "defense": "60",
    "spattack": "110",
    "spdefense": "95",
    "speed": "130",
    "total": "525",
    "weight": "54.0 lbs.",
    "height": "2'07\"",
    "dex1": "They send out electrical charges of about 10,000 volts. Because they are high-strung, it can be difficult to grow close to them.",
    "dex2": "When its fur stands on end, that’s a sign it’s about to give off a jolt of electricity. Take care, as sometimes lightning strikes next to it, too.",
    "class": "Lightning Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Eevee",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "136",
    "ndex": "136",
    "species": "Flareon",
    "forme": "Flareon",
    "type1": "Fire",
    "type2": "",
    "ability1": "Flash Fire",
    "ability2": "",
    "abilityH": "Guts",
    "hp": "65",
    "attack": "130",
    "defense": "60",
    "spattack": "95",
    "spdefense": "110",
    "speed": "65",
    "total": "525",
    "weight": "55.1 lbs.",
    "height": "2'11\"",
    "dex1": "When it catches prey or finds berries, it breathes fire on them until they’re well done, and then it gobbles them up.",
    "dex2": "Its average body temperature is between 1,300 and 1,500 degrees Fahrenheit. In its internal flame sac, temperatures reach 3,000 degrees.",
    "class": "Flame Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Eevee",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "137",
    "ndex": "137",
    "species": "Porygon",
    "forme": "Porygon",
    "type1": "Normal",
    "type2": "",
    "ability1": "Trace",
    "ability2": "Download",
    "abilityH": "Analytic",
    "hp": "65",
    "attack": "60",
    "defense": "70",
    "spattack": "85",
    "spdefense": "75",
    "speed": "40",
    "total": "395",
    "weight": "80.5 lbs.",
    "height": "2'07\"",
    "dex1": "Roughly 20 years ago, it was artificially created, utilizing the latest technology of the time.",
    "dex2": "It can convert its body into digital data, which enables it to enter cyberspace.",
    "class": "Virtual Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "138",
    "ndex": "138",
    "species": "Omanyte",
    "forme": "Omanyte",
    "type1": "Rock",
    "type2": "Water",
    "ability1": "Swift Swim",
    "ability2": "Shell Armor",
    "abilityH": "Weak Armor",
    "hp": "35",
    "attack": "40",
    "defense": "100",
    "spattack": "90",
    "spdefense": "55",
    "speed": "35",
    "total": "355",
    "weight": "16.5 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Spiral Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "139",
    "ndex": "139",
    "species": "Omastar",
    "forme": "Omastar",
    "type1": "Rock",
    "type2": "Water",
    "ability1": "Swift Swim",
    "ability2": "Shell Armor",
    "abilityH": "Weak Armor",
    "hp": "70",
    "attack": "60",
    "defense": "125",
    "spattack": "115",
    "spdefense": "70",
    "speed": "55",
    "total": "495",
    "weight": "77.2 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Spiral Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Omanyte",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "140",
    "ndex": "140",
    "species": "Kabuto",
    "forme": "Kabuto",
    "type1": "Rock",
    "type2": "Water",
    "ability1": "Swift Swim",
    "ability2": "Battle Armor",
    "abilityH": "Weak Armor",
    "hp": "30",
    "attack": "80",
    "defense": "90",
    "spattack": "55",
    "spdefense": "45",
    "speed": "55",
    "total": "355",
    "weight": "25.4 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Shellfish Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "141",
    "ndex": "141",
    "species": "Kabutops",
    "forme": "Kabutops",
    "type1": "Rock",
    "type2": "Water",
    "ability1": "Swift Swim",
    "ability2": "Battle Armor",
    "abilityH": "Weak Armor",
    "hp": "60",
    "attack": "115",
    "defense": "105",
    "spattack": "65",
    "spdefense": "70",
    "speed": "80",
    "total": "495",
    "weight": "89.3 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Shellfish Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Kabuto",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "142",
    "ndex": "142",
    "species": "Aerodactyl",
    "forme": "Aerodactyl",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Rock Head",
    "ability2": "Pressure",
    "abilityH": "Unnerve",
    "hp": "80",
    "attack": "105",
    "defense": "65",
    "spattack": "60",
    "spdefense": "75",
    "speed": "130",
    "total": "515",
    "weight": "130.1 lbs.",
    "height": "5'11\"",
    "dex1": "A Pokémon from the age of the dinosaurs. It used its sawlike fangs to shred its prey before eating them.",
    "dex2": "In ancient times, it ruled the skies. A widely accepted theory is that it went extinct due to a large meteor impact.",
    "class": "Fossil Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "143",
    "ndex": "143",
    "species": "Snorlax",
    "forme": "Snorlax",
    "type1": "Normal",
    "type2": "",
    "ability1": "Immunity",
    "ability2": "Thick Fat",
    "abilityH": "Gluttony",
    "hp": "160",
    "attack": "110",
    "defense": "65",
    "spattack": "65",
    "spdefense": "110",
    "speed": "30",
    "total": "540",
    "weight": "1014.1 lbs.",
    "height": "6'11\"",
    "dex1": "Its stomach is said to be incomparably strong. Even Muk’s poison is nothing more than a hint of spice on Snorlax’s tongue.",
    "dex2": "It eats nearly 900 pounds of food every day. It starts nodding off while eating—and continues to eat even while it’s asleep.",
    "class": "Sleeping Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Munchlax",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "144",
    "ndex": "144",
    "species": "Articuno",
    "forme": "Articuno",
    "type1": "Ice",
    "type2": "Flying",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Snow Cloak",
    "hp": "90",
    "attack": "85",
    "defense": "100",
    "spattack": "95",
    "spdefense": "125",
    "speed": "85",
    "total": "580",
    "weight": "122.1 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Freeze Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "145",
    "ndex": "145",
    "species": "Zapdos",
    "forme": "Zapdos",
    "type1": "Electric",
    "type2": "Flying",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Static",
    "hp": "90",
    "attack": "90",
    "defense": "85",
    "spattack": "125",
    "spdefense": "90",
    "speed": "100",
    "total": "580",
    "weight": "116.0 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Electric Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "146",
    "ndex": "146",
    "species": "Moltres",
    "forme": "Moltres",
    "type1": "Fire",
    "type2": "Flying",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Flame Body",
    "hp": "90",
    "attack": "100",
    "defense": "90",
    "spattack": "125",
    "spdefense": "85",
    "speed": "90",
    "total": "580",
    "weight": "132.3 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Flame Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "147",
    "ndex": "147",
    "species": "Dratini",
    "forme": "Dratini",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Marvel Scale",
    "hp": "41",
    "attack": "64",
    "defense": "45",
    "spattack": "50",
    "spdefense": "50",
    "speed": "50",
    "total": "300",
    "weight": "7.3 lbs.",
    "height": "5'11\"",
    "dex1": "It grows by molting repeatedly. Boots made from the tanned cast-off skin are a super luxury item.",
    "dex2": "After a 10-hour struggle, a fisherman was able to pull one up and confirm its existence.",
    "class": "Dragon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "148",
    "ndex": "148",
    "species": "Dragonair",
    "forme": "Dragonair",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Marvel Scale",
    "hp": "61",
    "attack": "84",
    "defense": "65",
    "spattack": "70",
    "spdefense": "70",
    "speed": "70",
    "total": "420",
    "weight": "36.4 lbs.",
    "height": "13'01\"",
    "dex1": "It has long been thought that its crystalline orbs are imbued with the power to control the weather.",
    "dex2": "From time immemorial, it has been venerated by agricultural peoples as an entity able to control the weather.",
    "class": "Dragon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Dratini",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "149",
    "ndex": "149",
    "species": "Dragonite",
    "forme": "Dragonite",
    "type1": "Dragon",
    "type2": "Flying",
    "ability1": "Inner Focus",
    "ability2": "",
    "abilityH": "Multiscale",
    "hp": "91",
    "attack": "134",
    "defense": "95",
    "spattack": "100",
    "spdefense": "100",
    "speed": "80",
    "total": "600",
    "weight": "463.0 lbs.",
    "height": "7'03\"",
    "dex1": "This Pokémon saved a shipwrecked man, taking him to a remote island—a paradise occupied solely by Dragonite.",
    "dex2": "Incur the wrath of this normally calm Pokémon at your peril, because it will smash everything to smithereens before it’s satisfied.",
    "class": "Dragon Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Dragonair",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "150",
    "ndex": "150",
    "species": "Mewtwo",
    "forme": "Mewtwo",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Unnerve",
    "hp": "106",
    "attack": "110",
    "defense": "90",
    "spattack": "154",
    "spdefense": "90",
    "speed": "130",
    "total": "680",
    "weight": "269.0 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Genetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "151",
    "ndex": "151",
    "species": "Mew",
    "forme": "Mew",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Synchronize",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "100",
    "defense": "100",
    "spattack": "100",
    "spdefense": "100",
    "speed": "100",
    "total": "600",
    "weight": "8.8 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "New Species Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "152",
    "ndex": "152",
    "species": "Chikorita",
    "forme": "Chikorita",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Leaf Guard",
    "hp": "45",
    "attack": "49",
    "defense": "65",
    "spattack": "49",
    "spdefense": "65",
    "speed": "45",
    "total": "318",
    "weight": "14.1 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Leaf Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "153",
    "ndex": "153",
    "species": "Bayleef",
    "forme": "Bayleef",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Leaf Guard",
    "hp": "60",
    "attack": "62",
    "defense": "80",
    "spattack": "63",
    "spdefense": "80",
    "speed": "60",
    "total": "405",
    "weight": "34.8 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Leaf Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Chikorita",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "154",
    "ndex": "154",
    "species": "Meganium",
    "forme": "Meganium",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Leaf Guard",
    "hp": "80",
    "attack": "82",
    "defense": "100",
    "spattack": "83",
    "spdefense": "100",
    "speed": "80",
    "total": "525",
    "weight": "221.6 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Herb Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Bayleef",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "155",
    "ndex": "155",
    "species": "Cyndaquil",
    "forme": "Cyndaquil",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Flash Fire",
    "hp": "39",
    "attack": "52",
    "defense": "43",
    "spattack": "60",
    "spdefense": "50",
    "speed": "65",
    "total": "309",
    "weight": "17.4 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Fire Mouse Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "156",
    "ndex": "156",
    "species": "Quilava",
    "forme": "Quilava",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Flash Fire",
    "hp": "58",
    "attack": "64",
    "defense": "58",
    "spattack": "80",
    "spdefense": "65",
    "speed": "80",
    "total": "405",
    "weight": "41.9 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Volcano Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Cyndaquil",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "157",
    "ndex": "157",
    "species": "Typhlosion",
    "forme": "Typhlosion",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Flash Fire",
    "hp": "78",
    "attack": "84",
    "defense": "78",
    "spattack": "109",
    "spdefense": "85",
    "speed": "100",
    "total": "534",
    "weight": "175.3 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Volcano Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Quilava",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "158",
    "ndex": "158",
    "species": "Totodile",
    "forme": "Totodile",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Sheer Force",
    "hp": "50",
    "attack": "65",
    "defense": "64",
    "spattack": "44",
    "spdefense": "48",
    "speed": "43",
    "total": "314",
    "weight": "20.9 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Big Jaw Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "159",
    "ndex": "159",
    "species": "Croconaw",
    "forme": "Croconaw",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Sheer Force",
    "hp": "65",
    "attack": "80",
    "defense": "80",
    "spattack": "59",
    "spdefense": "63",
    "speed": "58",
    "total": "405",
    "weight": "55.1 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Big Jaw Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Totodile",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "160",
    "ndex": "160",
    "species": "Feraligatr",
    "forme": "Feraligatr",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Sheer Force",
    "hp": "85",
    "attack": "105",
    "defense": "100",
    "spattack": "79",
    "spdefense": "83",
    "speed": "78",
    "total": "530",
    "weight": "195.8 lbs.",
    "height": "7'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Big Jaw Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Croconaw",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "161",
    "ndex": "161",
    "species": "Sentret",
    "forme": "Sentret",
    "type1": "Normal",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Keen Eye",
    "abilityH": "Frisk",
    "hp": "35",
    "attack": "46",
    "defense": "34",
    "spattack": "35",
    "spdefense": "45",
    "speed": "20",
    "total": "215",
    "weight": "13.2 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Scout Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "162",
    "ndex": "162",
    "species": "Furret",
    "forme": "Furret",
    "type1": "Normal",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Keen Eye",
    "abilityH": "Frisk",
    "hp": "85",
    "attack": "76",
    "defense": "64",
    "spattack": "45",
    "spdefense": "55",
    "speed": "90",
    "total": "415",
    "weight": "71.6 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Long Body Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sentret",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "163",
    "ndex": "163",
    "species": "Hoothoot",
    "forme": "Hoothoot",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Insomnia",
    "ability2": "Keen Eye",
    "abilityH": "Tinted Lens",
    "hp": "60",
    "attack": "30",
    "defense": "30",
    "spattack": "36",
    "spdefense": "56",
    "speed": "50",
    "total": "262",
    "weight": "46.7 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Owl Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "164",
    "ndex": "164",
    "species": "Noctowl",
    "forme": "Noctowl",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Insomnia",
    "ability2": "Keen Eye",
    "abilityH": "Tinted Lens",
    "hp": "100",
    "attack": "50",
    "defense": "50",
    "spattack": "86",
    "spdefense": "96",
    "speed": "70",
    "total": "452",
    "weight": "89.9 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Owl Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Hoothoot",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "165",
    "ndex": "165",
    "species": "Ledyba",
    "forme": "Ledyba",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Swarm",
    "ability2": "Early Bird",
    "abilityH": "Rattled",
    "hp": "40",
    "attack": "20",
    "defense": "30",
    "spattack": "40",
    "spdefense": "80",
    "speed": "55",
    "total": "265",
    "weight": "23.8 lbs.",
    "height": "3'03\"",
    "dex1": "They are timid and grow uneasy when not in a swarm with others of their kind. The pattern on their backs differs slightly from one to another.",
    "dex2": "They communicate with one another using bodily fluids that give off odors. When they’re angry, their odor smells sour.",
    "class": "Five Star Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "166",
    "ndex": "166",
    "species": "Ledian",
    "forme": "Ledian",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Swarm",
    "ability2": "Early Bird",
    "abilityH": "Iron Fist",
    "hp": "55",
    "attack": "35",
    "defense": "50",
    "spattack": "55",
    "spdefense": "110",
    "speed": "85",
    "total": "390",
    "weight": "78.5 lbs.",
    "height": "4'07\"",
    "dex1": "While it’s believed that starlight provides it with energy, this Pokémon also loves to eat berries. In the daytime, it curls up in the grass to sleep.",
    "dex2": "In battle, it throws punches with all four arms. The power of each individual blow is piddly, so it aims to win by quantity rather than quality.",
    "class": "Five Star Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Ledyba",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "167",
    "ndex": "167",
    "species": "Spinarak",
    "forme": "Spinarak",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Swarm",
    "ability2": "Insomnia",
    "abilityH": "Sniper",
    "hp": "40",
    "attack": "60",
    "defense": "40",
    "spattack": "40",
    "spdefense": "40",
    "speed": "30",
    "total": "250",
    "weight": "18.7 lbs.",
    "height": "1'08\"",
    "dex1": "It waits intently until its preferred prey, Cutiefly, gets caught in its web. In fact, it’s quite a patient Pokémon.",
    "dex2": "Some fishermen weave its sturdy thread into nets to catch fish Pokémon.",
    "class": "String Spit Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "168",
    "ndex": "168",
    "species": "Ariados",
    "forme": "Ariados",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Swarm",
    "ability2": "Insomnia",
    "abilityH": "Sniper",
    "hp": "70",
    "attack": "90",
    "defense": "70",
    "spattack": "60",
    "spdefense": "70",
    "speed": "40",
    "total": "400",
    "weight": "73.9 lbs.",
    "height": "3'07\"",
    "dex1": "There are some areas where people use the string Ariados spins for their own weaving. The resulting cloth is popular for its strength.",
    "dex2": "It spins thread from both its rear and its mouth. Then it wraps its prey up in thread and sips their bodily fluids at its leisure.",
    "class": "Long Leg Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spinarak",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "169",
    "ndex": "169",
    "species": "Crobat",
    "forme": "Crobat",
    "type1": "Poison",
    "type2": "Flying",
    "ability1": "Inner Focus",
    "ability2": "",
    "abilityH": "Infiltrator",
    "hp": "85",
    "attack": "90",
    "defense": "80",
    "spattack": "70",
    "spdefense": "80",
    "speed": "130",
    "total": "535",
    "weight": "165.3 lbs.",
    "height": "5'11\"",
    "dex1": "Both its legs became wings, and as a result, it can’t move well on the ground. All it can do is crawl around.",
    "dex2": "Silent and swift in its four-winged flight, it bites down on its prey before they realize what’s happening. In a heartbeat, it drains their blood.",
    "class": "Bat Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Golbat",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "170",
    "ndex": "170",
    "species": "Chinchou",
    "forme": "Chinchou",
    "type1": "Water",
    "type2": "Electric",
    "ability1": "Volt Absorb",
    "ability2": "Illuminate",
    "abilityH": "Water Absorb",
    "hp": "75",
    "attack": "38",
    "defense": "38",
    "spattack": "56",
    "spdefense": "56",
    "speed": "67",
    "total": "330",
    "weight": "26.5 lbs.",
    "height": "1'08\"",
    "dex1": "Its two antennae were originally fins. It discharges electricity to stun its prey before attacking.",
    "dex2": "It lives in the depths beyond the reach of sunlight. It flashes lights on its antennae to communicate with others of its kind.",
    "class": "Angler Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "171",
    "ndex": "171",
    "species": "Lanturn",
    "forme": "Lanturn",
    "type1": "Water",
    "type2": "Electric",
    "ability1": "Volt Absorb",
    "ability2": "Illuminate",
    "abilityH": "Water Absorb",
    "hp": "125",
    "attack": "58",
    "defense": "58",
    "spattack": "76",
    "spdefense": "76",
    "speed": "67",
    "total": "460",
    "weight": "49.6 lbs.",
    "height": "3'11\"",
    "dex1": "Should you peer into the ocean at night and see a light shining like the stars, that is Lanturn.",
    "dex2": "This Pokémon flashes a bright light that blinds its prey. This creates an opening for it to deliver an electrical attack.",
    "class": "Light Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Chinchou",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "172",
    "ndex": "172",
    "species": "Pichu",
    "forme": "Pichu",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "",
    "abilityH": "Lightning Rod",
    "hp": "20",
    "attack": "40",
    "defense": "15",
    "spattack": "35",
    "spdefense": "35",
    "speed": "60",
    "total": "205",
    "weight": "4.4 lbs.",
    "height": "1'00\"",
    "dex1": "It is not yet skilled at controlling electricity. If you take your eyes off it, it may shock itself.",
    "dex2": "Despite this Pokémon’s cute appearance, those who want to live with one should prepare to be on the receiving end of its electric jolts.",
    "class": "Tiny Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "173",
    "ndex": "173",
    "species": "Cleffa",
    "forme": "Cleffa",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Cute Charm",
    "ability2": "Magic Guard",
    "abilityH": "Friend Guard",
    "hp": "50",
    "attack": "25",
    "defense": "28",
    "spattack": "45",
    "spdefense": "55",
    "speed": "15",
    "total": "218",
    "weight": "6.6 lbs.",
    "height": "1'00\"",
    "dex1": "On late nights illuminated by shooting stars, it gazes intently skyward, as if thinking of its home.",
    "dex2": "Because of its silhouette, it’s believed to be a star reborn. For some reason, it loves Minior.",
    "class": "Star Shape Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "174",
    "ndex": "174",
    "species": "Igglybuff",
    "forme": "Igglybuff",
    "type1": "Normal",
    "type2": "Fairy",
    "ability1": "Cute Charm",
    "ability2": "Competitive",
    "abilityH": "Friend Guard",
    "hp": "90",
    "attack": "30",
    "defense": "15",
    "spattack": "40",
    "spdefense": "20",
    "speed": "15",
    "total": "210",
    "weight": "2.2 lbs.",
    "height": "1'00\"",
    "dex1": "It likes to sing but is not yet good at it. With praise and encouragement, it will get better little by little.",
    "dex2": "It moves by bouncing along. As it moves a lot, it sweats, and its body gives off a sweet aroma.",
    "class": "Balloon Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "175",
    "ndex": "175",
    "species": "Togepi",
    "forme": "Togepi",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Hustle",
    "ability2": "Serene Grace",
    "abilityH": "Super Luck",
    "hp": "35",
    "attack": "20",
    "defense": "65",
    "spattack": "40",
    "spdefense": "65",
    "speed": "20",
    "total": "245",
    "weight": "3.3 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Spike Ball Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "176",
    "ndex": "176",
    "species": "Togetic",
    "forme": "Togetic",
    "type1": "Fairy",
    "type2": "Flying",
    "ability1": "Hustle",
    "ability2": "Serene Grace",
    "abilityH": "Super Luck",
    "hp": "55",
    "attack": "40",
    "defense": "85",
    "spattack": "80",
    "spdefense": "105",
    "speed": "40",
    "total": "405",
    "weight": "7.1 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Happiness Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Togepi",
    "egg-group1": "Flying",
    "egg-group2": "Fairy"
  },
  {
    "id": "177",
    "ndex": "177",
    "species": "Natu",
    "forme": "Natu",
    "type1": "Psychic",
    "type2": "Flying",
    "ability1": "Synchronize",
    "ability2": "Early Bird",
    "abilityH": "Magic Bounce",
    "hp": "40",
    "attack": "50",
    "defense": "45",
    "spattack": "70",
    "spdefense": "45",
    "speed": "70",
    "total": "320",
    "weight": "4.4 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Tiny Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "178",
    "ndex": "178",
    "species": "Xatu",
    "forme": "Xatu",
    "type1": "Psychic",
    "type2": "Flying",
    "ability1": "Synchronize",
    "ability2": "Early Bird",
    "abilityH": "Magic Bounce",
    "hp": "65",
    "attack": "75",
    "defense": "70",
    "spattack": "95",
    "spdefense": "70",
    "speed": "95",
    "total": "470",
    "weight": "33.1 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Mystic Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Natu",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "179",
    "ndex": "179",
    "species": "Mareep",
    "forme": "Mareep",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "",
    "abilityH": "Plus",
    "hp": "55",
    "attack": "40",
    "defense": "40",
    "spattack": "65",
    "spdefense": "45",
    "speed": "35",
    "total": "280",
    "weight": "17.2 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Wool Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "180",
    "ndex": "180",
    "species": "Flaaffy",
    "forme": "Flaaffy",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "",
    "abilityH": "Plus",
    "hp": "70",
    "attack": "55",
    "defense": "55",
    "spattack": "80",
    "spdefense": "60",
    "speed": "45",
    "total": "365",
    "weight": "29.3 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Wool Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Mareep",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "181",
    "ndex": "181",
    "species": "Ampharos",
    "forme": "Ampharos",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "",
    "abilityH": "Plus",
    "hp": "90",
    "attack": "75",
    "defense": "85",
    "spattack": "115",
    "spdefense": "90",
    "speed": "55",
    "total": "510",
    "weight": "135.6 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Light Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Flaaffy",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "182",
    "ndex": "182",
    "species": "Bellossom",
    "forme": "Bellossom",
    "type1": "Grass",
    "type2": "",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "Healer",
    "hp": "75",
    "attack": "80",
    "defense": "95",
    "spattack": "90",
    "spdefense": "100",
    "speed": "50",
    "total": "490",
    "weight": "12.8 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Flower Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gloom",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "183",
    "ndex": "183",
    "species": "Marill",
    "forme": "Marill",
    "type1": "Water",
    "type2": "Fairy",
    "ability1": "Thick Fat",
    "ability2": "Huge Power",
    "abilityH": "Sap Sipper",
    "hp": "70",
    "attack": "20",
    "defense": "50",
    "spattack": "20",
    "spdefense": "50",
    "speed": "40",
    "total": "250",
    "weight": "18.7 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Aqua Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Azurill",
    "egg-group1": "Water 1",
    "egg-group2": "Fairy"
  },
  {
    "id": "184",
    "ndex": "184",
    "species": "Azumarill",
    "forme": "Azumarill",
    "type1": "Water",
    "type2": "Fairy",
    "ability1": "Thick Fat",
    "ability2": "Huge Power",
    "abilityH": "Sap Sipper",
    "hp": "100",
    "attack": "50",
    "defense": "80",
    "spattack": "60",
    "spdefense": "80",
    "speed": "50",
    "total": "420",
    "weight": "62.8 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Aqua Rabbit Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Marill",
    "egg-group1": "Water 1",
    "egg-group2": "Fairy"
  },
  {
    "id": "185",
    "ndex": "185",
    "species": "Sudowoodo",
    "forme": "Sudowoodo",
    "type1": "Rock",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "Rock Head",
    "abilityH": "Rattled",
    "hp": "70",
    "attack": "100",
    "defense": "115",
    "spattack": "30",
    "spdefense": "65",
    "speed": "30",
    "total": "410",
    "weight": "83.8 lbs.",
    "height": "3'11\"",
    "dex1": "To avoid attack, it mimics a tree. It will run off if splashed with water, which it hates.",
    "dex2": "Apparently, the larger the green parts of this Pokémon, the more collectors value it. It’s a particular favorite among elderly people.",
    "class": "Imitation Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Bonsly",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "186",
    "ndex": "186",
    "species": "Politoed",
    "forme": "Politoed",
    "type1": "Water",
    "type2": "",
    "ability1": "Water Absorb",
    "ability2": "Damp",
    "abilityH": "Drizzle",
    "hp": "90",
    "attack": "75",
    "defense": "75",
    "spattack": "90",
    "spdefense": "100",
    "speed": "70",
    "total": "500",
    "weight": "74.7 lbs.",
    "height": "3'07\"",
    "dex1": "They gather on moonlit nights to form a large chorus. Their cries sound angry and not at all pleasant, but they are certainly distinctive.",
    "dex2": "It’s the leader of Poliwag and Poliwhirl. When Politoed roars, they all cower in fear.",
    "class": "Frog Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Poliwhirl",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "187",
    "ndex": "187",
    "species": "Hoppip",
    "forme": "Hoppip",
    "type1": "Grass",
    "type2": "Flying",
    "ability1": "Chlorophyll",
    "ability2": "Leaf Guard",
    "abilityH": "Infiltrator",
    "hp": "35",
    "attack": "35",
    "defense": "40",
    "spattack": "35",
    "spdefense": "55",
    "speed": "50",
    "total": "250",
    "weight": "1.1 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Cottonweed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "188",
    "ndex": "188",
    "species": "Skiploom",
    "forme": "Skiploom",
    "type1": "Grass",
    "type2": "Flying",
    "ability1": "Chlorophyll",
    "ability2": "Leaf Guard",
    "abilityH": "Infiltrator",
    "hp": "55",
    "attack": "45",
    "defense": "50",
    "spattack": "45",
    "spdefense": "65",
    "speed": "80",
    "total": "340",
    "weight": "2.2 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Cottonweed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Hoppip",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "189",
    "ndex": "189",
    "species": "Jumpluff",
    "forme": "Jumpluff",
    "type1": "Grass",
    "type2": "Flying",
    "ability1": "Chlorophyll",
    "ability2": "Leaf Guard",
    "abilityH": "Infiltrator",
    "hp": "75",
    "attack": "55",
    "defense": "70",
    "spattack": "55",
    "spdefense": "95",
    "speed": "110",
    "total": "460",
    "weight": "6.6 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Cottonweed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Skiploom",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "190",
    "ndex": "190",
    "species": "Aipom",
    "forme": "Aipom",
    "type1": "Normal",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Pickup",
    "abilityH": "Skill Link",
    "hp": "55",
    "attack": "70",
    "defense": "55",
    "spattack": "40",
    "spdefense": "55",
    "speed": "85",
    "total": "360",
    "weight": "25.4 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Long Tail Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "191",
    "ndex": "191",
    "species": "Sunkern",
    "forme": "Sunkern",
    "type1": "Grass",
    "type2": "",
    "ability1": "Chlorophyll",
    "ability2": "Solar Power",
    "abilityH": "Early Bird",
    "hp": "30",
    "attack": "30",
    "defense": "30",
    "spattack": "30",
    "spdefense": "30",
    "speed": "30",
    "total": "180",
    "weight": "4.0 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Seed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "192",
    "ndex": "192",
    "species": "Sunflora",
    "forme": "Sunflora",
    "type1": "Grass",
    "type2": "",
    "ability1": "Chlorophyll",
    "ability2": "Solar Power",
    "abilityH": "Early Bird",
    "hp": "75",
    "attack": "75",
    "defense": "55",
    "spattack": "105",
    "spdefense": "85",
    "speed": "30",
    "total": "425",
    "weight": "18.7 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Sun Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sunkern",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "193",
    "ndex": "193",
    "species": "Yanma",
    "forme": "Yanma",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Speed Boost",
    "ability2": "Compound Eyes",
    "abilityH": "Frisk",
    "hp": "65",
    "attack": "65",
    "defense": "45",
    "spattack": "75",
    "spdefense": "45",
    "speed": "95",
    "total": "390",
    "weight": "83.8 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Clear Wing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "194",
    "ndex": "194",
    "species": "Wooper",
    "forme": "Wooper",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Damp",
    "ability2": "Water Absorb",
    "abilityH": "Unaware",
    "hp": "55",
    "attack": "45",
    "defense": "45",
    "spattack": "25",
    "spdefense": "25",
    "speed": "15",
    "total": "210",
    "weight": "18.7 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Water Fish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "195",
    "ndex": "195",
    "species": "Quagsire",
    "forme": "Quagsire",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Damp",
    "ability2": "Water Absorb",
    "abilityH": "Unaware",
    "hp": "95",
    "attack": "85",
    "defense": "85",
    "spattack": "65",
    "spdefense": "65",
    "speed": "35",
    "total": "430",
    "weight": "165.3 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Water Fish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Wooper",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "196",
    "ndex": "196",
    "species": "Espeon",
    "forme": "Espeon",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Synchronize",
    "ability2": "",
    "abilityH": "Magic Bounce",
    "hp": "65",
    "attack": "65",
    "defense": "60",
    "spattack": "130",
    "spdefense": "95",
    "speed": "110",
    "total": "525",
    "weight": "58.4 lbs.",
    "height": "2'11\"",
    "dex1": "It can instantaneously sense its opponent’s movements by feeling air currents with its fine fur.",
    "dex2": "It unleashes psychic power from the orb on its forehead. When its power is exhausted, the orb grows dull and dark.",
    "class": "Sun Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Eevee",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "197",
    "ndex": "197",
    "species": "Umbreon",
    "forme": "Umbreon",
    "type1": "Dark",
    "type2": "",
    "ability1": "Synchronize",
    "ability2": "",
    "abilityH": "Inner Focus",
    "hp": "95",
    "attack": "65",
    "defense": "110",
    "spattack": "60",
    "spdefense": "130",
    "speed": "65",
    "total": "525",
    "weight": "59.5 lbs.",
    "height": "3'03\"",
    "dex1": "When this Pokémon becomes angry, its pores secrete a poisonous sweat, which it sprays at its opponent’s eyes.",
    "dex2": "With its black fur, it blends into the darkness. It bides its time, and when prey appears, this Pokémon goes for its throat, and then eats it.",
    "class": "Moonlight Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Eevee",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "198",
    "ndex": "198",
    "species": "Murkrow",
    "forme": "Murkrow",
    "type1": "Dark",
    "type2": "Flying",
    "ability1": "Insomnia",
    "ability2": "Super Luck",
    "abilityH": "Prankster",
    "hp": "60",
    "attack": "85",
    "defense": "42",
    "spattack": "85",
    "spdefense": "42",
    "speed": "91",
    "total": "405",
    "weight": "4.6 lbs.",
    "height": "1'08\"",
    "dex1": "They awaken at dusk and take wing in the twilight, leading to the expression, “Get home before the Murkrow fly.”",
    "dex2": "Seen as a symbol of bad luck, it’s generally disliked. Yet it gives presents—objects that sparkle or shine—to Trainers it’s close to.",
    "class": "Darkness Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "199",
    "ndex": "199",
    "species": "Slowking",
    "forme": "Slowking",
    "type1": "Water",
    "type2": "Psychic",
    "ability1": "Oblivious",
    "ability2": "Own Tempo",
    "abilityH": "Regenerator",
    "hp": "95",
    "attack": "75",
    "defense": "80",
    "spattack": "100",
    "spdefense": "110",
    "speed": "30",
    "total": "490",
    "weight": "175.3 lbs.",
    "height": "6'07\"",
    "dex1": "A poisonous bite reacted with its system, blessing it with the enhanced intellect of a genius. It has full control of its psychic powers.",
    "dex2": "This Pokémon is so famed for its intellect that a proverb still persists in some regions: “When in doubt, ask Slowking.”",
    "class": "Royal Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Slowpoke",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "200",
    "ndex": "200",
    "species": "Misdreavus",
    "forme": "Misdreavus",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "60",
    "attack": "60",
    "defense": "60",
    "spattack": "85",
    "spdefense": "85",
    "speed": "85",
    "total": "435",
    "weight": "2.2 lbs.",
    "height": "2'04\"",
    "dex1": "It will use any means necessary to frighten people and absorb their life energy. It practices constantly to hone its skill in causing fear.",
    "dex2": "If you hear a sobbing sound emanating from a vacant room, it’s undoubtedly a bit of mischief from Misdreavus.",
    "class": "Screech Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "201",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Misdreavus",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "202",
    "ndex": "202",
    "species": "Wobbuffet",
    "forme": "Wobbuffet",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Shadow Tag",
    "ability2": "",
    "abilityH": "Telepathy",
    "hp": "190",
    "attack": "33",
    "defense": "58",
    "spattack": "33",
    "spdefense": "58",
    "speed": "33",
    "total": "405",
    "weight": "62.8 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Patient Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Wynaut",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "203",
    "ndex": "203",
    "species": "Girafarig",
    "forme": "Girafarig",
    "type1": "Normal",
    "type2": "Psychic",
    "ability1": "Inner Focus",
    "ability2": "Early Bird",
    "abilityH": "Sap Sipper",
    "hp": "70",
    "attack": "80",
    "defense": "65",
    "spattack": "90",
    "spdefense": "65",
    "speed": "85",
    "total": "455",
    "weight": "91.5 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Long Neck Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "204",
    "ndex": "204",
    "species": "Pineco",
    "forme": "Pineco",
    "type1": "Bug",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "50",
    "attack": "65",
    "defense": "90",
    "spattack": "35",
    "spdefense": "35",
    "speed": "15",
    "total": "290",
    "weight": "15.9 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Bagworm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "205",
    "ndex": "205",
    "species": "Forretress",
    "forme": "Forretress",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Sturdy",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "75",
    "attack": "90",
    "defense": "140",
    "spattack": "60",
    "spdefense": "60",
    "speed": "40",
    "total": "465",
    "weight": "277.3 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Bagworm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pineco",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "206",
    "ndex": "206",
    "species": "Dunsparce",
    "forme": "Dunsparce",
    "type1": "Normal",
    "type2": "",
    "ability1": "Serene Grace",
    "ability2": "Run Away",
    "abilityH": "Rattled",
    "hp": "100",
    "attack": "70",
    "defense": "70",
    "spattack": "65",
    "spdefense": "65",
    "speed": "45",
    "total": "415",
    "weight": "30.9 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Land Snake Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "207",
    "ndex": "207",
    "species": "Gligar",
    "forme": "Gligar",
    "type1": "Ground",
    "type2": "Flying",
    "ability1": "Hyper Cutter",
    "ability2": "Sand Veil",
    "abilityH": "Immunity",
    "hp": "65",
    "attack": "75",
    "defense": "105",
    "spattack": "35",
    "spdefense": "65",
    "speed": "85",
    "total": "430",
    "weight": "142.9 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Fly Scorpion Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "208",
    "ndex": "208",
    "species": "Steelix",
    "forme": "Steelix",
    "type1": "Steel",
    "type2": "Ground",
    "ability1": "Rock Head",
    "ability2": "Sturdy",
    "abilityH": "Sheer Force",
    "hp": "75",
    "attack": "85",
    "defense": "200",
    "spattack": "55",
    "spdefense": "65",
    "speed": "30",
    "total": "510",
    "weight": "881.8 lbs.",
    "height": "30'02\"",
    "dex1": "",
    "dex2": "",
    "class": "Iron Snake Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Onix",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "209",
    "ndex": "209",
    "species": "Snubbull",
    "forme": "Snubbull",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Run Away",
    "abilityH": "Rattled",
    "hp": "60",
    "attack": "80",
    "defense": "50",
    "spattack": "40",
    "spdefense": "40",
    "speed": "30",
    "total": "300",
    "weight": "17.2 lbs.",
    "height": "2'00\"",
    "dex1": "Despite its intimidating face, it’s quite cowardly. Its desperate attempts to appear threatening make it popular with people.",
    "dex2": "Its growls make its opponents uneasy. This laid-back Pokémon tends to sleep half the day.",
    "class": "Fairy Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "210",
    "ndex": "210",
    "species": "Granbull",
    "forme": "Granbull",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Quick Feet",
    "abilityH": "Rattled",
    "hp": "90",
    "attack": "120",
    "defense": "75",
    "spattack": "60",
    "spdefense": "60",
    "speed": "45",
    "total": "450",
    "weight": "107.4 lbs.",
    "height": "4'07\"",
    "dex1": "Its well-developed lower jaw and heavy fangs are its weapons. As long as it’s not provoked, it rarely bites.",
    "dex2": "More timid than Snubbull, this Pokémon is doted on by young people amused at the contrast between its looks and its attitude.",
    "class": "Fairy Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Snubbull",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "211",
    "ndex": "211",
    "species": "Qwilfish",
    "forme": "Qwilfish",
    "type1": "Water",
    "type2": "Poison",
    "ability1": "Poison Point",
    "ability2": "Swift Swim",
    "abilityH": "Intimidate",
    "hp": "65",
    "attack": "95",
    "defense": "85",
    "spattack": "55",
    "spdefense": "55",
    "speed": "85",
    "total": "440",
    "weight": "8.6 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Balloon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "212",
    "ndex": "212",
    "species": "Scizor",
    "forme": "Scizor",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Swarm",
    "ability2": "Technician",
    "abilityH": "Light Metal",
    "hp": "70",
    "attack": "130",
    "defense": "100",
    "spattack": "55",
    "spdefense": "80",
    "speed": "65",
    "total": "500",
    "weight": "260.1 lbs.",
    "height": "5'11\"",
    "dex1": "It uses its wings to adjust its body temperature. Otherwise, its metal body would become too hot and melt in the heat of battle.",
    "dex2": "Once it has identified an enemy, this Pokémon smashes it mercilessly with pincers hard as steel.",
    "class": "Pincer Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Scyther",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "213",
    "ndex": "213",
    "species": "Shuckle",
    "forme": "Shuckle",
    "type1": "Bug",
    "type2": "Rock",
    "ability1": "Sturdy",
    "ability2": "Gluttony",
    "abilityH": "Contrary",
    "hp": "20",
    "attack": "10",
    "defense": "230",
    "spattack": "10",
    "spdefense": "230",
    "speed": "5",
    "total": "505",
    "weight": "45.2 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Mold Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "214",
    "ndex": "214",
    "species": "Heracross",
    "forme": "Heracross",
    "type1": "Bug",
    "type2": "Fighting",
    "ability1": "Swarm",
    "ability2": "Guts",
    "abilityH": "Moxie",
    "hp": "80",
    "attack": "125",
    "defense": "75",
    "spattack": "40",
    "spdefense": "95",
    "speed": "85",
    "total": "500",
    "weight": "119.0 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Horn Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "215",
    "ndex": "215",
    "species": "Sneasel",
    "forme": "Sneasel",
    "type1": "Dark",
    "type2": "Ice",
    "ability1": "Inner Focus",
    "ability2": "Keen Eye",
    "abilityH": "Pickpocket",
    "hp": "55",
    "attack": "95",
    "defense": "55",
    "spattack": "35",
    "spdefense": "75",
    "speed": "115",
    "total": "430",
    "weight": "61.7 lbs.",
    "height": "2'11\"",
    "dex1": "It has a cunning yet savage disposition. It waits for parents to leave their nests, and then it sneaks in to steal their eggs.",
    "dex2": "It uses its claws to poke holes in eggs so it can slurp out the insides. Breeders consider it a scourge and will drive it away or eradicate it.",
    "class": "Sharp Claw Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "216",
    "ndex": "216",
    "species": "Teddiursa",
    "forme": "Teddiursa",
    "type1": "Normal",
    "type2": "",
    "ability1": "Pickup",
    "ability2": "Quick Feet",
    "abilityH": "Honey Gather",
    "hp": "60",
    "attack": "80",
    "defense": "50",
    "spattack": "50",
    "spdefense": "50",
    "speed": "40",
    "total": "330",
    "weight": "19.4 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Little Bear Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "217",
    "ndex": "217",
    "species": "Ursaring",
    "forme": "Ursaring",
    "type1": "Normal",
    "type2": "",
    "ability1": "Guts",
    "ability2": "Quick Feet",
    "abilityH": "Unnerve",
    "hp": "90",
    "attack": "130",
    "defense": "75",
    "spattack": "75",
    "spdefense": "75",
    "speed": "55",
    "total": "500",
    "weight": "277.3 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Hibernator Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Teddiursa",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "218",
    "ndex": "218",
    "species": "Slugma",
    "forme": "Slugma",
    "type1": "Fire",
    "type2": "",
    "ability1": "Magma Armor",
    "ability2": "Flame Body",
    "abilityH": "Weak Armor",
    "hp": "40",
    "attack": "40",
    "defense": "40",
    "spattack": "70",
    "spdefense": "40",
    "speed": "20",
    "total": "250",
    "weight": "77.2 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Lava Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "219",
    "ndex": "219",
    "species": "Magcargo",
    "forme": "Magcargo",
    "type1": "Fire",
    "type2": "Rock",
    "ability1": "Magma Armor",
    "ability2": "Flame Body",
    "abilityH": "Weak Armor",
    "hp": "60",
    "attack": "50",
    "defense": "120",
    "spattack": "90",
    "spdefense": "80",
    "speed": "30",
    "total": "430",
    "weight": "121.3 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Lava Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Slugma",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "220",
    "ndex": "220",
    "species": "Swinub",
    "forme": "Swinub",
    "type1": "Ice",
    "type2": "Ground",
    "ability1": "Oblivious",
    "ability2": "Snow Cloak",
    "abilityH": "Thick Fat",
    "hp": "50",
    "attack": "50",
    "defense": "40",
    "spattack": "30",
    "spdefense": "30",
    "speed": "50",
    "total": "250",
    "weight": "14.3 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Pig Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "221",
    "ndex": "221",
    "species": "Piloswine",
    "forme": "Piloswine",
    "type1": "Ice",
    "type2": "Ground",
    "ability1": "Oblivious",
    "ability2": "Snow Cloak",
    "abilityH": "Thick Fat",
    "hp": "100",
    "attack": "100",
    "defense": "80",
    "spattack": "60",
    "spdefense": "60",
    "speed": "50",
    "total": "450",
    "weight": "123.0 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Swine Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Swinub",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "222",
    "ndex": "222",
    "species": "Corsola",
    "forme": "Corsola",
    "type1": "Water",
    "type2": "Rock",
    "ability1": "Hustle",
    "ability2": "Natural Cure",
    "abilityH": "Regenerator",
    "hp": "65",
    "attack": "55",
    "defense": "95",
    "spattack": "65",
    "spdefense": "95",
    "speed": "35",
    "total": "410",
    "weight": "11.0 lbs.",
    "height": "2'00\"",
    "dex1": "Coral branches grow from its head. They break off quite easily, but they grow back in about three days.",
    "dex2": "Pursued by Mareanie for the branches on its head, this Pokémon will sometimes snap its own branches off as a diversion while it escapes.",
    "class": "Coral Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "223",
    "ndex": "223",
    "species": "Remoraid",
    "forme": "Remoraid",
    "type1": "Water",
    "type2": "",
    "ability1": "Hustle",
    "ability2": "Sniper",
    "abilityH": "Moody",
    "hp": "35",
    "attack": "65",
    "defense": "35",
    "spattack": "65",
    "spdefense": "35",
    "speed": "65",
    "total": "300",
    "weight": "26.5 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Jet Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 2"
  },
  {
    "id": "224",
    "ndex": "224",
    "species": "Octillery",
    "forme": "Octillery",
    "type1": "Water",
    "type2": "",
    "ability1": "Suction Cups",
    "ability2": "Sniper",
    "abilityH": "Moody",
    "hp": "75",
    "attack": "105",
    "defense": "75",
    "spattack": "105",
    "spdefense": "75",
    "speed": "45",
    "total": "480",
    "weight": "62.8 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Jet Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Remoraid",
    "egg-group1": "Water 1",
    "egg-group2": "Water 2"
  },
  {
    "id": "225",
    "ndex": "225",
    "species": "Delibird",
    "forme": "Delibird",
    "type1": "Ice",
    "type2": "Flying",
    "ability1": "Vital Spirit",
    "ability2": "Hustle",
    "abilityH": "Insomnia",
    "hp": "45",
    "attack": "55",
    "defense": "45",
    "spattack": "65",
    "spdefense": "45",
    "speed": "75",
    "total": "330",
    "weight": "35.3 lbs.",
    "height": "2'11\"",
    "dex1": "Although it naturally prefers colder locales, Delibird in Alola seem able to withstand the heat to a certain extent.",
    "dex2": "It has a generous habit of sharing its food with people and Pokémon, so it’s always scrounging around for more food.",
    "class": "Delivery Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "226",
    "ndex": "226",
    "species": "Mantine",
    "forme": "Mantine",
    "type1": "Water",
    "type2": "Flying",
    "ability1": "Swift Swim",
    "ability2": "Water Absorb",
    "abilityH": "Water Veil",
    "hp": "85",
    "attack": "40",
    "defense": "70",
    "spattack": "80",
    "spdefense": "140",
    "speed": "70",
    "total": "485",
    "weight": "485.0 lbs.",
    "height": "6'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Kite Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Mantyke",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "227",
    "ndex": "227",
    "species": "Skarmory",
    "forme": "Skarmory",
    "type1": "Steel",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Sturdy",
    "abilityH": "Weak Armor",
    "hp": "65",
    "attack": "80",
    "defense": "140",
    "spattack": "40",
    "spdefense": "70",
    "speed": "70",
    "total": "465",
    "weight": "111.3 lbs.",
    "height": "5'07\"",
    "dex1": "Its feathers, which fall off as it grows, are thin and sharp. In times long past, warriors used them as swords.",
    "dex2": "Its metal body is sturdy, but it does rust rather easily. So on rainy days, this Pokémon prefers to stay put in its nest.",
    "class": "Armor Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "228",
    "ndex": "228",
    "species": "Houndour",
    "forme": "Houndour",
    "type1": "Dark",
    "type2": "Fire",
    "ability1": "Early Bird",
    "ability2": "Flash Fire",
    "abilityH": "Unnerve",
    "hp": "45",
    "attack": "60",
    "defense": "30",
    "spattack": "80",
    "spdefense": "50",
    "speed": "65",
    "total": "330",
    "weight": "23.8 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Dark Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "229",
    "ndex": "229",
    "species": "Houndoom",
    "forme": "Houndoom",
    "type1": "Dark",
    "type2": "Fire",
    "ability1": "Early Bird",
    "ability2": "Flash Fire",
    "abilityH": "Unnerve",
    "hp": "75",
    "attack": "90",
    "defense": "50",
    "spattack": "110",
    "spdefense": "80",
    "speed": "95",
    "total": "500",
    "weight": "77.2 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Dark Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Houndour",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "230",
    "ndex": "230",
    "species": "Kingdra",
    "forme": "Kingdra",
    "type1": "Water",
    "type2": "Dragon",
    "ability1": "Swift Swim",
    "ability2": "Sniper",
    "abilityH": "Damp",
    "hp": "75",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "85",
    "total": "540",
    "weight": "335.1 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Dragon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Seadra",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "231",
    "ndex": "231",
    "species": "Phanpy",
    "forme": "Phanpy",
    "type1": "Ground",
    "type2": "",
    "ability1": "Pickup",
    "ability2": "",
    "abilityH": "Sand Veil",
    "hp": "90",
    "attack": "60",
    "defense": "60",
    "spattack": "40",
    "spdefense": "40",
    "speed": "40",
    "total": "330",
    "weight": "73.9 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Long Nose Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "232",
    "ndex": "232",
    "species": "Donphan",
    "forme": "Donphan",
    "type1": "Ground",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "",
    "abilityH": "Sand Veil",
    "hp": "90",
    "attack": "120",
    "defense": "120",
    "spattack": "60",
    "spdefense": "60",
    "speed": "50",
    "total": "500",
    "weight": "264.6 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Armor Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Phanpy",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "233",
    "ndex": "233",
    "species": "Porygon2",
    "forme": "Porygon2",
    "type1": "Normal",
    "type2": "",
    "ability1": "Trace",
    "ability2": "Download",
    "abilityH": "Analytic",
    "hp": "85",
    "attack": "80",
    "defense": "90",
    "spattack": "105",
    "spdefense": "95",
    "speed": "60",
    "total": "515",
    "weight": "71.6 lbs.",
    "height": "2'00\"",
    "dex1": "For the purposes of planetary development, Porygon was updated with the most cutting-edge technology available.",
    "dex2": "Porygon was updated to a new version in readiness for planetary development. But that dream remains unrealized as yet.",
    "class": "Virtual Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Porygon",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "234",
    "ndex": "234",
    "species": "Stantler",
    "forme": "Stantler",
    "type1": "Normal",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Frisk",
    "abilityH": "Sap Sipper",
    "hp": "73",
    "attack": "95",
    "defense": "62",
    "spattack": "85",
    "spdefense": "65",
    "speed": "85",
    "total": "465",
    "weight": "157.0 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Big Horn Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "235",
    "ndex": "235",
    "species": "Smeargle",
    "forme": "Smeargle",
    "type1": "Normal",
    "type2": "",
    "ability1": "Own Tempo",
    "ability2": "Technician",
    "abilityH": "Moody",
    "hp": "55",
    "attack": "20",
    "defense": "35",
    "spattack": "20",
    "spdefense": "45",
    "speed": "75",
    "total": "250",
    "weight": "127.9 lbs.",
    "height": "3'11\"",
    "dex1": "The unique creations produced by each Smeargle are painted using the fluid that oozes from its tail. This is how it marks its territory.",
    "dex2": "It draws symbols all over the place to mark its territory. In towns with many Smeargle, the walls are covered in graffiti.",
    "class": "Painter Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "236",
    "ndex": "236",
    "species": "Tyrogue",
    "forme": "Tyrogue",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Guts",
    "ability2": "Steadfast",
    "abilityH": "Vital Spirit",
    "hp": "35",
    "attack": "35",
    "defense": "35",
    "spattack": "35",
    "spdefense": "35",
    "speed": "35",
    "total": "210",
    "weight": "46.3 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Scuffle Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "237",
    "ndex": "237",
    "species": "Hitmontop",
    "forme": "Hitmontop",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Technician",
    "abilityH": "Steadfast",
    "hp": "50",
    "attack": "95",
    "defense": "95",
    "spattack": "35",
    "spdefense": "110",
    "speed": "70",
    "total": "455",
    "weight": "105.8 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Handstand Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Tyrogue",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "238",
    "ndex": "238",
    "species": "Smoochum",
    "forme": "Smoochum",
    "type1": "Ice",
    "type2": "Psychic",
    "ability1": "Oblivious",
    "ability2": "Forewarn",
    "abilityH": "Hydration",
    "hp": "45",
    "attack": "30",
    "defense": "15",
    "spattack": "85",
    "spdefense": "65",
    "speed": "65",
    "total": "305",
    "weight": "13.2 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Kiss Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "239",
    "ndex": "239",
    "species": "Elekid",
    "forme": "Elekid",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "",
    "abilityH": "Vital Spirit",
    "hp": "45",
    "attack": "63",
    "defense": "37",
    "spattack": "65",
    "spdefense": "55",
    "speed": "95",
    "total": "360",
    "weight": "51.8 lbs.",
    "height": "2'00\"",
    "dex1": "When it’s in a house, electrical outlets serve as its baby bottles. It sucks down electricity.",
    "dex2": "This Pokémon is constantly fighting with Togedemaru that try to steal its electricity. It’s a pretty even match.",
    "class": "Electric Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "240",
    "ndex": "240",
    "species": "Magby",
    "forme": "Magby",
    "type1": "Fire",
    "type2": "",
    "ability1": "Flame Body",
    "ability2": "",
    "abilityH": "Vital Spirit",
    "hp": "45",
    "attack": "75",
    "defense": "37",
    "spattack": "70",
    "spdefense": "55",
    "speed": "83",
    "total": "365",
    "weight": "47.2 lbs.",
    "height": "2'04\"",
    "dex1": "Many of these Pokémon can be seen in areas with volcanic activity. Feeding can get them so excited, they exhale flames of 1,100 degrees F.",
    "dex2": "A famous potter lives with a Magby. Apparently its soft flames produce fine works.",
    "class": "Live Coal Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "241",
    "ndex": "241",
    "species": "Miltank",
    "forme": "Miltank",
    "type1": "Normal",
    "type2": "",
    "ability1": "Thick Fat",
    "ability2": "Scrappy",
    "abilityH": "Sap Sipper",
    "hp": "95",
    "attack": "80",
    "defense": "105",
    "spattack": "40",
    "spdefense": "70",
    "speed": "100",
    "total": "490",
    "weight": "166.4 lbs.",
    "height": "3'11\"",
    "dex1": "Its milk is high in calories and packed with nutrients. Therefore, if you drink too much of it, you may wind up with a body like Miltank’s.",
    "dex2": "Most people raise it for its milk, but it’s quite tough and strong, so it’s also well suited for battle.",
    "class": "Milk Cow Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "242",
    "ndex": "242",
    "species": "Blissey",
    "forme": "Blissey",
    "type1": "Normal",
    "type2": "",
    "ability1": "Natural Cure",
    "ability2": "Serene Grace",
    "abilityH": "Healer",
    "hp": "255",
    "attack": "10",
    "defense": "10",
    "spattack": "75",
    "spdefense": "135",
    "speed": "55",
    "total": "540",
    "weight": "103.2 lbs.",
    "height": "4'11\"",
    "dex1": "Even the most ferocious Pokémon become calm when they eat Blissey’s egg, which is said to be filled with happiness.",
    "dex2": "Its fluffy fur coat acts as a sensor, enabling it to read the feelings of people and Pokémon.",
    "class": "Happiness Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Chansey",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "243",
    "ndex": "243",
    "species": "Raikou",
    "forme": "Raikou",
    "type1": "Electric",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Inner Focus",
    "hp": "90",
    "attack": "85",
    "defense": "75",
    "spattack": "115",
    "spdefense": "100",
    "speed": "115",
    "total": "580",
    "weight": "392.4 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Thunder Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "244",
    "ndex": "244",
    "species": "Entei",
    "forme": "Entei",
    "type1": "Fire",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Inner Focus",
    "hp": "115",
    "attack": "115",
    "defense": "85",
    "spattack": "90",
    "spdefense": "75",
    "speed": "100",
    "total": "580",
    "weight": "436.5 lbs.",
    "height": "6'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Volcano Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "245",
    "ndex": "245",
    "species": "Suicune",
    "forme": "Suicune",
    "type1": "Water",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Inner Focus",
    "hp": "100",
    "attack": "75",
    "defense": "115",
    "spattack": "90",
    "spdefense": "115",
    "speed": "85",
    "total": "580",
    "weight": "412.3 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Aurora Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "246",
    "ndex": "246",
    "species": "Larvitar",
    "forme": "Larvitar",
    "type1": "Rock",
    "type2": "Ground",
    "ability1": "Guts",
    "ability2": "",
    "abilityH": "Sand Veil",
    "hp": "50",
    "attack": "64",
    "defense": "50",
    "spattack": "45",
    "spdefense": "50",
    "speed": "41",
    "total": "300",
    "weight": "158.7 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Rock Skin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "247",
    "ndex": "247",
    "species": "Pupitar",
    "forme": "Pupitar",
    "type1": "Rock",
    "type2": "Ground",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "84",
    "defense": "70",
    "spattack": "65",
    "spdefense": "70",
    "speed": "51",
    "total": "410",
    "weight": "335.1 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Hard Shell Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Larvitar",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "248",
    "ndex": "248",
    "species": "Tyranitar",
    "forme": "Tyranitar",
    "type1": "Rock",
    "type2": "Dark",
    "ability1": "Sand Stream",
    "ability2": "",
    "abilityH": "Unnerve",
    "hp": "100",
    "attack": "134",
    "defense": "110",
    "spattack": "95",
    "spdefense": "100",
    "speed": "61",
    "total": "600",
    "weight": "445.3 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Armor Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pupitar",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "249",
    "ndex": "249",
    "species": "Lugia",
    "forme": "Lugia",
    "type1": "Psychic",
    "type2": "Flying",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Multiscale",
    "hp": "106",
    "attack": "90",
    "defense": "130",
    "spattack": "90",
    "spdefense": "154",
    "speed": "110",
    "total": "680",
    "weight": "476.2 lbs.",
    "height": "17'01\"",
    "dex1": "",
    "dex2": "",
    "class": "Diving Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "250",
    "ndex": "250",
    "species": "Ho-Oh",
    "forme": "Ho-Oh",
    "type1": "Fire",
    "type2": "Flying",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Regenerator",
    "hp": "106",
    "attack": "130",
    "defense": "90",
    "spattack": "110",
    "spdefense": "154",
    "speed": "90",
    "total": "680",
    "weight": "438.7 lbs.",
    "height": "12'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Rainbow Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "251",
    "ndex": "251",
    "species": "Celebi",
    "forme": "Celebi",
    "type1": "Psychic",
    "type2": "Grass",
    "ability1": "Natural Cure",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "100",
    "defense": "100",
    "spattack": "100",
    "spdefense": "100",
    "speed": "100",
    "total": "600",
    "weight": "11.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Time Travel Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "252",
    "ndex": "252",
    "species": "Treecko",
    "forme": "Treecko",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Unburden",
    "hp": "40",
    "attack": "45",
    "defense": "35",
    "spattack": "65",
    "spdefense": "55",
    "speed": "70",
    "total": "310",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Wood Gecko Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "253",
    "ndex": "253",
    "species": "Grovyle",
    "forme": "Grovyle",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Unburden",
    "hp": "50",
    "attack": "65",
    "defense": "45",
    "spattack": "85",
    "spdefense": "65",
    "speed": "95",
    "total": "405",
    "weight": "47.6 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Wood Gecko Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Treecko",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "254",
    "ndex": "254",
    "species": "Sceptile",
    "forme": "Sceptile",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Unburden",
    "hp": "70",
    "attack": "85",
    "defense": "65",
    "spattack": "105",
    "spdefense": "85",
    "speed": "120",
    "total": "530",
    "weight": "115.1 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Forest Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Grovyle",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "255",
    "ndex": "255",
    "species": "Torchic",
    "forme": "Torchic",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Speed Boost",
    "hp": "45",
    "attack": "60",
    "defense": "40",
    "spattack": "70",
    "spdefense": "50",
    "speed": "45",
    "total": "310",
    "weight": "5.5 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Chick Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "256",
    "ndex": "256",
    "species": "Combusken",
    "forme": "Combusken",
    "type1": "Fire",
    "type2": "Fighting",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Speed Boost",
    "hp": "60",
    "attack": "85",
    "defense": "60",
    "spattack": "85",
    "spdefense": "60",
    "speed": "55",
    "total": "405",
    "weight": "43.0 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Young Fowl Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Torchic",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "257",
    "ndex": "257",
    "species": "Blaziken",
    "forme": "Blaziken",
    "type1": "Fire",
    "type2": "Fighting",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Speed Boost",
    "hp": "80",
    "attack": "120",
    "defense": "70",
    "spattack": "110",
    "spdefense": "70",
    "speed": "80",
    "total": "530",
    "weight": "114.6 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Blaze Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Combusken",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "258",
    "ndex": "258",
    "species": "Mudkip",
    "forme": "Mudkip",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Damp",
    "hp": "50",
    "attack": "70",
    "defense": "50",
    "spattack": "50",
    "spdefense": "50",
    "speed": "40",
    "total": "310",
    "weight": "16.8 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Mud Fish Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "259",
    "ndex": "259",
    "species": "Marshtomp",
    "forme": "Marshtomp",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Damp",
    "hp": "70",
    "attack": "85",
    "defense": "70",
    "spattack": "60",
    "spdefense": "70",
    "speed": "50",
    "total": "405",
    "weight": "61.7 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Mud Fish Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Mudkip",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "260",
    "ndex": "260",
    "species": "Swampert",
    "forme": "Swampert",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Damp",
    "hp": "100",
    "attack": "110",
    "defense": "90",
    "spattack": "85",
    "spdefense": "90",
    "speed": "60",
    "total": "535",
    "weight": "180.6 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Mud Fish Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Marshtomp",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "261",
    "ndex": "261",
    "species": "Poochyena",
    "forme": "Poochyena",
    "type1": "Dark",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Quick Feet",
    "abilityH": "Rattled",
    "hp": "35",
    "attack": "55",
    "defense": "35",
    "spattack": "30",
    "spdefense": "30",
    "speed": "35",
    "total": "220",
    "weight": "30.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bite Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "262",
    "ndex": "262",
    "species": "Mightyena",
    "forme": "Mightyena",
    "type1": "Dark",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Quick Feet",
    "abilityH": "Moxie",
    "hp": "70",
    "attack": "90",
    "defense": "70",
    "spattack": "60",
    "spdefense": "60",
    "speed": "70",
    "total": "420",
    "weight": "81.6 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Bite Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Poochyena",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "263",
    "ndex": "263",
    "species": "Zigzagoon",
    "forme": "Zigzagoon",
    "type1": "Normal",
    "type2": "",
    "ability1": "Pickup",
    "ability2": "Gluttony",
    "abilityH": "Quick Feet",
    "hp": "38",
    "attack": "30",
    "defense": "41",
    "spattack": "30",
    "spdefense": "41",
    "speed": "60",
    "total": "240",
    "weight": "38.6 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Tiny Raccoon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "264",
    "ndex": "264",
    "species": "Linoone",
    "forme": "Linoone",
    "type1": "Normal",
    "type2": "",
    "ability1": "Pickup",
    "ability2": "Gluttony",
    "abilityH": "Quick Feet",
    "hp": "78",
    "attack": "70",
    "defense": "61",
    "spattack": "50",
    "spdefense": "61",
    "speed": "100",
    "total": "420",
    "weight": "71.6 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Rushing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Zigzagoon",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "265",
    "ndex": "265",
    "species": "Wurmple",
    "forme": "Wurmple",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shield Dust",
    "ability2": "",
    "abilityH": "Run Away",
    "hp": "45",
    "attack": "45",
    "defense": "35",
    "spattack": "20",
    "spdefense": "30",
    "speed": "20",
    "total": "195",
    "weight": "7.9 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Worm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "266",
    "ndex": "266",
    "species": "Silcoon",
    "forme": "Silcoon",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "35",
    "defense": "55",
    "spattack": "25",
    "spdefense": "25",
    "speed": "15",
    "total": "205",
    "weight": "22.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Cocoon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Wurmple",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "267",
    "ndex": "267",
    "species": "Beautifly",
    "forme": "Beautifly",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Swarm",
    "ability2": "",
    "abilityH": "Rivalry",
    "hp": "60",
    "attack": "70",
    "defense": "50",
    "spattack": "100",
    "spdefense": "50",
    "speed": "65",
    "total": "395",
    "weight": "62.6 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Butterfly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Silcoon",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "268",
    "ndex": "268",
    "species": "Cascoon",
    "forme": "Cascoon",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "35",
    "defense": "55",
    "spattack": "25",
    "spdefense": "25",
    "speed": "15",
    "total": "205",
    "weight": "25.4 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Cocoon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Wumple",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "269",
    "ndex": "269",
    "species": "Dustox",
    "forme": "Dustox",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Shield Dust",
    "ability2": "",
    "abilityH": "Compound Eyes",
    "hp": "60",
    "attack": "50",
    "defense": "70",
    "spattack": "50",
    "spdefense": "90",
    "speed": "65",
    "total": "385",
    "weight": "69.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Moth Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Cascoon",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "270",
    "ndex": "270",
    "species": "Lotad",
    "forme": "Lotad",
    "type1": "Water",
    "type2": "Grass",
    "ability1": "Swift Swim",
    "ability2": "Rain Dish",
    "abilityH": "Own Tempo",
    "hp": "40",
    "attack": "30",
    "defense": "30",
    "spattack": "40",
    "spdefense": "50",
    "speed": "30",
    "total": "220",
    "weight": "5.7 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Water Weed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Grass"
  },
  {
    "id": "271",
    "ndex": "271",
    "species": "Lombre",
    "forme": "Lombre",
    "type1": "Water",
    "type2": "Grass",
    "ability1": "Swift Swim",
    "ability2": "Rain Dish",
    "abilityH": "Own Tempo",
    "hp": "60",
    "attack": "50",
    "defense": "50",
    "spattack": "60",
    "spdefense": "70",
    "speed": "50",
    "total": "340",
    "weight": "71.6 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Jolly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Lotad",
    "egg-group1": "Water 1",
    "egg-group2": "Grass"
  },
  {
    "id": "272",
    "ndex": "272",
    "species": "Ludicolo",
    "forme": "Ludicolo",
    "type1": "Water",
    "type2": "Grass",
    "ability1": "Swift Swim",
    "ability2": "Rain Dish",
    "abilityH": "Own Tempo",
    "hp": "80",
    "attack": "70",
    "defense": "70",
    "spattack": "90",
    "spdefense": "100",
    "speed": "70",
    "total": "480",
    "weight": "121.3 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Carefree Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Lombre",
    "egg-group1": "Water 1",
    "egg-group2": "Grass"
  },
  {
    "id": "273",
    "ndex": "273",
    "species": "Seedot",
    "forme": "Seedot",
    "type1": "Grass",
    "type2": "",
    "ability1": "Chlorophyll",
    "ability2": "Early Bird",
    "abilityH": "Pickpocket",
    "hp": "40",
    "attack": "40",
    "defense": "50",
    "spattack": "30",
    "spdefense": "30",
    "speed": "30",
    "total": "220",
    "weight": "8.8 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Acorn Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Grass"
  },
  {
    "id": "274",
    "ndex": "274",
    "species": "Nuzleaf",
    "forme": "Nuzleaf",
    "type1": "Grass",
    "type2": "Dark",
    "ability1": "Chlorophyll",
    "ability2": "Early Bird",
    "abilityH": "Pickpocket",
    "hp": "70",
    "attack": "70",
    "defense": "40",
    "spattack": "60",
    "spdefense": "40",
    "speed": "60",
    "total": "340",
    "weight": "61.7 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Wily Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Seedot",
    "egg-group1": "Field",
    "egg-group2": "Grass"
  },
  {
    "id": "275",
    "ndex": "275",
    "species": "Shiftry",
    "forme": "Shiftry",
    "type1": "Grass",
    "type2": "Dark",
    "ability1": "Chlorophyll",
    "ability2": "Early Bird",
    "abilityH": "Pickpocket",
    "hp": "90",
    "attack": "100",
    "defense": "60",
    "spattack": "90",
    "spdefense": "60",
    "speed": "80",
    "total": "480",
    "weight": "131.4 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Wicked Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Nuzleaf",
    "egg-group1": "Field",
    "egg-group2": "Grass"
  },
  {
    "id": "276",
    "ndex": "276",
    "species": "Taillow",
    "forme": "Taillow",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Guts",
    "ability2": "",
    "abilityH": "Scrappy",
    "hp": "40",
    "attack": "55",
    "defense": "30",
    "spattack": "30",
    "spdefense": "30",
    "speed": "85",
    "total": "270",
    "weight": "5.1 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Tiny Swallow Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "277",
    "ndex": "277",
    "species": "Swellow",
    "forme": "Swellow",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Guts",
    "ability2": "",
    "abilityH": "Scrappy",
    "hp": "60",
    "attack": "85",
    "defense": "60",
    "spattack": "75",
    "spdefense": "50",
    "speed": "125",
    "total": "455",
    "weight": "43.7 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Swallow Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Taillow",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "278",
    "ndex": "278",
    "species": "Wingull",
    "forme": "Wingull",
    "type1": "Water",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Hydration",
    "abilityH": "Rain Dish",
    "hp": "40",
    "attack": "30",
    "defense": "30",
    "spattack": "55",
    "spdefense": "30",
    "speed": "85",
    "total": "270",
    "weight": "20.9 lbs.",
    "height": "2'00\"",
    "dex1": "Its hollow bones enhance its lightness. It spreads its wings to the wind and soars away into the sky.",
    "dex2": "Fishermen keep an eye out for Wingull in the sky, because wherever they’re circling, the ocean is sure to be teeming with fish Pokémon.",
    "class": "Seagull Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Flying"
  },
  {
    "id": "279",
    "ndex": "279",
    "species": "Pelipper",
    "forme": "Pelipper",
    "type1": "Water",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Drizzle",
    "abilityH": "Rain Dish",
    "hp": "60",
    "attack": "50",
    "defense": "100",
    "spattack": "95",
    "spdefense": "70",
    "speed": "65",
    "total": "440",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "Its spacious beak is large enough for a small child to fit right inside.",
    "dex2": "Gathering food is the work of young males. They store food in their capacious beaks and carry it back to others waiting in the nest.",
    "class": "Water Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Wingull",
    "egg-group1": "Water 1",
    "egg-group2": "Flying"
  },
  {
    "id": "280",
    "ndex": "280",
    "species": "Ralts",
    "forme": "Ralts",
    "type1": "Psychic",
    "type2": "Fairy",
    "ability1": "Synchronize",
    "ability2": "Trace",
    "abilityH": "Telepathy",
    "hp": "28",
    "attack": "25",
    "defense": "25",
    "spattack": "45",
    "spdefense": "35",
    "speed": "40",
    "total": "198",
    "weight": "14.6 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Feeling Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "281",
    "ndex": "281",
    "species": "Kirlia",
    "forme": "Kirlia",
    "type1": "Psychic",
    "type2": "Fairy",
    "ability1": "Synchronize",
    "ability2": "Trace",
    "abilityH": "Telepathy",
    "hp": "38",
    "attack": "35",
    "defense": "35",
    "spattack": "65",
    "spdefense": "55",
    "speed": "50",
    "total": "278",
    "weight": "44.5 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Emotion Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Ralts",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "282",
    "ndex": "282",
    "species": "Gardevoir",
    "forme": "Gardevoir",
    "type1": "Psychic",
    "type2": "Fairy",
    "ability1": "Synchronize",
    "ability2": "Trace",
    "abilityH": "Telepathy",
    "hp": "68",
    "attack": "65",
    "defense": "65",
    "spattack": "125",
    "spdefense": "115",
    "speed": "80",
    "total": "518",
    "weight": "106.7 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Embrace Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Kirlia",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "283",
    "ndex": "283",
    "species": "Surskit",
    "forme": "Surskit",
    "type1": "Bug",
    "type2": "Water",
    "ability1": "Swift Swim",
    "ability2": "",
    "abilityH": "Rain Dish",
    "hp": "40",
    "attack": "30",
    "defense": "32",
    "spattack": "50",
    "spdefense": "52",
    "speed": "65",
    "total": "269",
    "weight": "3.7 lbs.",
    "height": "1'08\"",
    "dex1": "It moves as if skating on the surface of the water. It often fights with Dewpider over food.",
    "dex2": "When this Pokémon senses danger, a sweet fluid oozes from the tip of its head. The taste of it disgusts bird Pokémon.",
    "class": "Pond Skater Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Bug"
  },
  {
    "id": "284",
    "ndex": "284",
    "species": "Masquerain",
    "forme": "Masquerain",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Intimidate",
    "ability2": "",
    "abilityH": "Unnerve",
    "hp": "70",
    "attack": "60",
    "defense": "62",
    "spattack": "100",
    "spdefense": "82",
    "speed": "80",
    "total": "454",
    "weight": "7.9 lbs.",
    "height": "2'07\"",
    "dex1": "It intimidates enemies with the eye-like patterns on its antennae. Its four wings allow it to fly in any direction.",
    "dex2": "Its wings and antennae don’t cope well with moisture. After a rain, it faces sunward to dry off.",
    "class": "Eyeball Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Surskit",
    "egg-group1": "Water 1",
    "egg-group2": "Bug"
  },
  {
    "id": "285",
    "ndex": "285",
    "species": "Shroomish",
    "forme": "Shroomish",
    "type1": "Grass",
    "type2": "",
    "ability1": "Effect Spore",
    "ability2": "Poison Heal",
    "abilityH": "Quick Feet",
    "hp": "60",
    "attack": "40",
    "defense": "60",
    "spattack": "40",
    "spdefense": "60",
    "speed": "35",
    "total": "295",
    "weight": "9.9 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Mushroom Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "286",
    "ndex": "286",
    "species": "Breloom",
    "forme": "Breloom",
    "type1": "Grass",
    "type2": "Fighting",
    "ability1": "Effect Spore",
    "ability2": "Poison Heal",
    "abilityH": "Technician",
    "hp": "60",
    "attack": "130",
    "defense": "80",
    "spattack": "60",
    "spdefense": "60",
    "speed": "70",
    "total": "460",
    "weight": "86.4 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Mushroom Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shroomish",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "287",
    "ndex": "287",
    "species": "Slakoth",
    "forme": "Slakoth",
    "type1": "Normal",
    "type2": "",
    "ability1": "Truant",
    "ability2": "",
    "abilityH": "",
    "hp": "60",
    "attack": "60",
    "defense": "60",
    "spattack": "35",
    "spdefense": "35",
    "speed": "30",
    "total": "280",
    "weight": "52.9 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Slacker Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "288",
    "ndex": "288",
    "species": "Vigoroth",
    "forme": "Vigoroth",
    "type1": "Normal",
    "type2": "",
    "ability1": "Vital Spirit",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "80",
    "defense": "80",
    "spattack": "55",
    "spdefense": "55",
    "speed": "90",
    "total": "440",
    "weight": "102.5 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Wild Monkey Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Slakoth",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "289",
    "ndex": "289",
    "species": "Slaking",
    "forme": "Slaking",
    "type1": "Normal",
    "type2": "",
    "ability1": "Truant",
    "ability2": "",
    "abilityH": "",
    "hp": "150",
    "attack": "160",
    "defense": "100",
    "spattack": "95",
    "spdefense": "65",
    "speed": "100",
    "total": "670",
    "weight": "287.7 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Lazy Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Vigoroth",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "290",
    "ndex": "290",
    "species": "Nincada",
    "forme": "Nincada",
    "type1": "Bug",
    "type2": "Ground",
    "ability1": "Compound Eyes",
    "ability2": "",
    "abilityH": "Run Away",
    "hp": "31",
    "attack": "45",
    "defense": "90",
    "spattack": "30",
    "spdefense": "30",
    "speed": "40",
    "total": "266",
    "weight": "12.1 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Trainee Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "291",
    "ndex": "291",
    "species": "Ninjask",
    "forme": "Ninjask",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Speed Boost",
    "ability2": "",
    "abilityH": "Infiltrator",
    "hp": "61",
    "attack": "90",
    "defense": "45",
    "spattack": "50",
    "spdefense": "50",
    "speed": "160",
    "total": "456",
    "weight": "26.5 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Ninja Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Nincada",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "292",
    "ndex": "292",
    "species": "Shedinja",
    "forme": "Shedinja",
    "type1": "Bug",
    "type2": "Ghost",
    "ability1": "Wonder Guard",
    "ability2": "",
    "abilityH": "Wonder Guard",
    "hp": "1",
    "attack": "90",
    "defense": "45",
    "spattack": "30",
    "spdefense": "30",
    "speed": "40",
    "total": "236",
    "weight": "2.6 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Shed Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Nincada",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "293",
    "ndex": "293",
    "species": "Whismur",
    "forme": "Whismur",
    "type1": "Normal",
    "type2": "",
    "ability1": "Soundproof",
    "ability2": "",
    "abilityH": "Rattled",
    "hp": "64",
    "attack": "51",
    "defense": "23",
    "spattack": "51",
    "spdefense": "23",
    "speed": "28",
    "total": "240",
    "weight": "35.9 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Whisper Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "294",
    "ndex": "294",
    "species": "Loudred",
    "forme": "Loudred",
    "type1": "Normal",
    "type2": "",
    "ability1": "Soundproof",
    "ability2": "",
    "abilityH": "Scrappy",
    "hp": "84",
    "attack": "71",
    "defense": "43",
    "spattack": "71",
    "spdefense": "43",
    "speed": "48",
    "total": "360",
    "weight": "89.3 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Big Voice Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Whismur",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "295",
    "ndex": "295",
    "species": "Exploud",
    "forme": "Exploud",
    "type1": "Normal",
    "type2": "",
    "ability1": "Soundproof",
    "ability2": "",
    "abilityH": "Scrappy",
    "hp": "104",
    "attack": "91",
    "defense": "63",
    "spattack": "91",
    "spdefense": "73",
    "speed": "68",
    "total": "490",
    "weight": "185.2 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Loud Noise Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Loudred",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "296",
    "ndex": "296",
    "species": "Makuhita",
    "forme": "Makuhita",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Thick Fat",
    "ability2": "Guts",
    "abilityH": "Sheer Force",
    "hp": "72",
    "attack": "60",
    "defense": "30",
    "spattack": "20",
    "spdefense": "30",
    "speed": "25",
    "total": "237",
    "weight": "190.5 lbs.",
    "height": "3'03\"",
    "dex1": "It was originally brought in from another region, but now Makuhita from Alola are more famous.",
    "dex2": "Their daily routine consists of training together first thing in the morning, eating and napping in the afternoon, and then more training afterward.",
    "class": "Guts Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "297",
    "ndex": "297",
    "species": "Hariyama",
    "forme": "Hariyama",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Thick Fat",
    "ability2": "Guts",
    "abilityH": "Sheer Force",
    "hp": "144",
    "attack": "120",
    "defense": "60",
    "spattack": "40",
    "spdefense": "60",
    "speed": "50",
    "total": "474",
    "weight": "559.5 lbs.",
    "height": "7'07\"",
    "dex1": "It is known for its fantastic strength, but as it grows older, it focuses more on training Makuhita.",
    "dex2": "They love to compare their freakish strength— strength enough to send a truck flying with a single slap.",
    "class": "Arm Thrust Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Makuhita",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "298",
    "ndex": "298",
    "species": "Azurill",
    "forme": "Azurill",
    "type1": "Normal",
    "type2": "Fairy",
    "ability1": "Thick Fat",
    "ability2": "Huge Power",
    "abilityH": "Sap Sipper",
    "hp": "50",
    "attack": "20",
    "defense": "40",
    "spattack": "20",
    "spdefense": "40",
    "speed": "20",
    "total": "190",
    "weight": "4.4 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Polka Dot Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "299",
    "ndex": "299",
    "species": "Nosepass",
    "forme": "Nosepass",
    "type1": "Rock",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "Magnet Pull",
    "abilityH": "Sand Force",
    "hp": "30",
    "attack": "45",
    "defense": "135",
    "spattack": "45",
    "spdefense": "90",
    "speed": "30",
    "total": "375",
    "weight": "213.8 lbs.",
    "height": "3'03\"",
    "dex1": "The magnet in Nosepass’s nose provides an unerring compass, making it an excellent partner for Trainers going on a journey.",
    "dex2": "It uses powerful magnetism to drag its prey toward it. It’s also been known to pull in metal, which it collects and uses to protect itself.",
    "class": "Compass Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "300",
    "ndex": "300",
    "species": "Skitty",
    "forme": "Skitty",
    "type1": "Normal",
    "type2": "",
    "ability1": "Cute Charm",
    "ability2": "Normalize",
    "abilityH": "Wonder Skin",
    "hp": "50",
    "attack": "45",
    "defense": "45",
    "spattack": "35",
    "spdefense": "35",
    "speed": "50",
    "total": "260",
    "weight": "24.3 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Kitten Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "301",
    "ndex": "301",
    "species": "Delcatty",
    "forme": "Delcatty",
    "type1": "Normal",
    "type2": "",
    "ability1": "Cute Charm",
    "ability2": "Normalize",
    "abilityH": "Wonder Skin",
    "hp": "70",
    "attack": "65",
    "defense": "65",
    "spattack": "55",
    "spdefense": "55",
    "speed": "90",
    "total": "400",
    "weight": "71.9 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Prim Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "Skitty",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "302",
    "ndex": "302",
    "species": "Sableye",
    "forme": "Sableye",
    "type1": "Dark",
    "type2": "Ghost",
    "ability1": "Keen Eye",
    "ability2": "Stall",
    "abilityH": "Prankster",
    "hp": "50",
    "attack": "75",
    "defense": "75",
    "spattack": "65",
    "spdefense": "65",
    "speed": "50",
    "total": "380",
    "weight": "24.3 lbs.",
    "height": "1'08\"",
    "dex1": "It’s a fiend for gemstones, so it stalks Carbink. Unfortunately, Gabite almost always grabs them first.",
    "dex2": "This Pokémon is feared. When its gemstone eyes begin to glow with a sinister shine, it’s believed that Sableye will steal people’s spirits away.",
    "class": "Darkness Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "303",
    "ndex": "303",
    "species": "Mawile",
    "forme": "Mawile",
    "type1": "Steel",
    "type2": "Fairy",
    "ability1": "Hyper Cutter",
    "ability2": "Intimidate",
    "abilityH": "Sheer Force",
    "hp": "50",
    "attack": "85",
    "defense": "85",
    "spattack": "55",
    "spdefense": "55",
    "speed": "50",
    "total": "380",
    "weight": "25.4 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Deceiver Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "304",
    "ndex": "304",
    "species": "Aron",
    "forme": "Aron",
    "type1": "Steel",
    "type2": "Rock",
    "ability1": "Sturdy",
    "ability2": "Rock Head",
    "abilityH": "Heavy Metal",
    "hp": "50",
    "attack": "70",
    "defense": "100",
    "spattack": "40",
    "spdefense": "40",
    "speed": "30",
    "total": "330",
    "weight": "132.3 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Iron Armor Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "305",
    "ndex": "305",
    "species": "Lairon",
    "forme": "Lairon",
    "type1": "Steel",
    "type2": "Rock",
    "ability1": "Sturdy",
    "ability2": "Rock Head",
    "abilityH": "Heavy Metal",
    "hp": "60",
    "attack": "90",
    "defense": "140",
    "spattack": "50",
    "spdefense": "50",
    "speed": "40",
    "total": "430",
    "weight": "264.6 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Iron Armor Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Aron",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "306",
    "ndex": "306",
    "species": "Aggron",
    "forme": "Aggron",
    "type1": "Steel",
    "type2": "Rock",
    "ability1": "Sturdy",
    "ability2": "Rock Head",
    "abilityH": "Heavy Metal",
    "hp": "70",
    "attack": "110",
    "defense": "180",
    "spattack": "60",
    "spdefense": "60",
    "speed": "50",
    "total": "530",
    "weight": "793.7 lbs.",
    "height": "6'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Iron Armor Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Lairon",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "307",
    "ndex": "307",
    "species": "Meditite",
    "forme": "Meditite",
    "type1": "Fighting",
    "type2": "Psychic",
    "ability1": "Pure Power",
    "ability2": "",
    "abilityH": "Telepathy",
    "hp": "30",
    "attack": "40",
    "defense": "55",
    "spattack": "40",
    "spdefense": "55",
    "speed": "60",
    "total": "280",
    "weight": "24.7 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Meditate Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "308",
    "ndex": "308",
    "species": "Medicham",
    "forme": "Medicham",
    "type1": "Fighting",
    "type2": "Psychic",
    "ability1": "Pure Power",
    "ability2": "",
    "abilityH": "Telepathy",
    "hp": "60",
    "attack": "60",
    "defense": "75",
    "spattack": "60",
    "spdefense": "75",
    "speed": "80",
    "total": "410",
    "weight": "69.4 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Meditate Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Meditite",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "309",
    "ndex": "309",
    "species": "Electrike",
    "forme": "Electrike",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Lightning Rod",
    "abilityH": "Minus",
    "hp": "40",
    "attack": "45",
    "defense": "40",
    "spattack": "65",
    "spdefense": "40",
    "speed": "65",
    "total": "295",
    "weight": "33.5 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Lightning Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "310",
    "ndex": "310",
    "species": "Manectric",
    "forme": "Manectric",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Lightning Rod",
    "abilityH": "Minus",
    "hp": "70",
    "attack": "75",
    "defense": "60",
    "spattack": "105",
    "spdefense": "60",
    "speed": "105",
    "total": "475",
    "weight": "88.6 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Discharge Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Electrike",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "311",
    "ndex": "311",
    "species": "Plusle",
    "forme": "Plusle",
    "type1": "Electric",
    "type2": "",
    "ability1": "Plus",
    "ability2": "",
    "abilityH": "Lightning Rod",
    "hp": "60",
    "attack": "50",
    "defense": "40",
    "spattack": "85",
    "spdefense": "75",
    "speed": "95",
    "total": "405",
    "weight": "9.3 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Cheering Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "312",
    "ndex": "312",
    "species": "Minun",
    "forme": "Minun",
    "type1": "Electric",
    "type2": "",
    "ability1": "Minus",
    "ability2": "",
    "abilityH": "Volt Absorb",
    "hp": "60",
    "attack": "40",
    "defense": "50",
    "spattack": "75",
    "spdefense": "85",
    "speed": "95",
    "total": "405",
    "weight": "9.3 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Cheering Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "313",
    "ndex": "313",
    "species": "Volbeat",
    "forme": "Volbeat",
    "type1": "Bug",
    "type2": "",
    "ability1": "Illuminate",
    "ability2": "Swarm",
    "abilityH": "Prankster",
    "hp": "65",
    "attack": "73",
    "defense": "75",
    "spattack": "47",
    "spdefense": "85",
    "speed": "85",
    "total": "430",
    "weight": "39.0 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Firefly Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": "Human-Like"
  },
  {
    "id": "314",
    "ndex": "314",
    "species": "Illumise",
    "forme": "Illumise",
    "type1": "Bug",
    "type2": "",
    "ability1": "Oblivious",
    "ability2": "Tinted Lens",
    "abilityH": "Prankster",
    "hp": "65",
    "attack": "47",
    "defense": "75",
    "spattack": "73",
    "spdefense": "85",
    "speed": "85",
    "total": "430",
    "weight": "39.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Firefly Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": "Human-Like"
  },
  {
    "id": "315",
    "ndex": "315",
    "species": "Roselia",
    "forme": "Roselia",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Natural Cure",
    "ability2": "Poison Point",
    "abilityH": "Leaf Guard",
    "hp": "50",
    "attack": "60",
    "defense": "45",
    "spattack": "100",
    "spdefense": "80",
    "speed": "65",
    "total": "400",
    "weight": "4.4 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Thorn Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Budew",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "316",
    "ndex": "316",
    "species": "Gulpin",
    "forme": "Gulpin",
    "type1": "Poison",
    "type2": "",
    "ability1": "Liquid Ooze",
    "ability2": "Sticky Hold",
    "abilityH": "Gluttony",
    "hp": "70",
    "attack": "43",
    "defense": "53",
    "spattack": "43",
    "spdefense": "53",
    "speed": "40",
    "total": "302",
    "weight": "22.7 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Stomach Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "317",
    "ndex": "317",
    "species": "Swalot",
    "forme": "Swalot",
    "type1": "Poison",
    "type2": "",
    "ability1": "Liquid Ooze",
    "ability2": "Sticky Hold",
    "abilityH": "Gluttony",
    "hp": "100",
    "attack": "73",
    "defense": "83",
    "spattack": "73",
    "spdefense": "83",
    "speed": "55",
    "total": "467",
    "weight": "176.4 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Bag Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gulpin",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "318",
    "ndex": "318",
    "species": "Carvanha",
    "forme": "Carvanha",
    "type1": "Water",
    "type2": "Dark",
    "ability1": "Rough Skin",
    "ability2": "",
    "abilityH": "Speed Boost",
    "hp": "45",
    "attack": "90",
    "defense": "20",
    "spattack": "65",
    "spdefense": "20",
    "speed": "65",
    "total": "305",
    "weight": "45.9 lbs.",
    "height": "2'07\"",
    "dex1": "Each school has its own territory. Any intruders are mercilessly attacked with fangs bared.",
    "dex2": "If they scent the faintest trace of blood, they rush to attack en masse. When alone, they’re rather cowardly.",
    "class": "Savage Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "319",
    "ndex": "319",
    "species": "Sharpedo",
    "forme": "Sharpedo",
    "type1": "Water",
    "type2": "Dark",
    "ability1": "Rough Skin",
    "ability2": "",
    "abilityH": "Speed Boost",
    "hp": "70",
    "attack": "120",
    "defense": "40",
    "spattack": "95",
    "spdefense": "40",
    "speed": "95",
    "total": "460",
    "weight": "195.8 lbs.",
    "height": "5'11\"",
    "dex1": "It pursues its prey at speeds of 75 mph and finishes them off with fangs that can crush iron. It is known as the bully of the sea.",
    "dex2": "It has a sad history. In the past, its dorsal fin was a treasured foodstuff, so this Pokémon became a victim of overfishing.",
    "class": "Brutal Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Carvanha",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "320",
    "ndex": "320",
    "species": "Wailmer",
    "forme": "Wailmer",
    "type1": "Water",
    "type2": "",
    "ability1": "Water Veil",
    "ability2": "Oblivious",
    "abilityH": "Pressure",
    "hp": "130",
    "attack": "70",
    "defense": "35",
    "spattack": "70",
    "spdefense": "35",
    "speed": "60",
    "total": "400",
    "weight": "286.6 lbs.",
    "height": "6'07\"",
    "dex1": "It loves to startle people. It fills itself up with seawater and plays by bouncing around like a ball.",
    "dex2": "It shows off by spraying jets of seawater from the nostrils above its eyes. It eats a solid ton of Wishiwashi every day.",
    "class": "Ball Whale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Water 2"
  },
  {
    "id": "321",
    "ndex": "321",
    "species": "Wailord",
    "forme": "Wailord",
    "type1": "Water",
    "type2": "",
    "ability1": "Water Veil",
    "ability2": "Oblivious",
    "abilityH": "Pressure",
    "hp": "170",
    "attack": "90",
    "defense": "45",
    "spattack": "90",
    "spdefense": "45",
    "speed": "60",
    "total": "500",
    "weight": "877.4 lbs.",
    "height": "47'07\"",
    "dex1": "Wailord pursue their prey in pods. With their large mouths, they can swallow entire schools of Wishiwashi whole.",
    "dex2": "Its immense size is the reason for its popularity. Wailord watching is a favorite sightseeing activity in various parts of the world.",
    "class": "Float Whale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Wailmer",
    "egg-group1": "Field",
    "egg-group2": "Water 2"
  },
  {
    "id": "322",
    "ndex": "322",
    "species": "Numel",
    "forme": "Numel",
    "type1": "Fire",
    "type2": "Ground",
    "ability1": "Oblivious",
    "ability2": "Simple",
    "abilityH": "Own Tempo",
    "hp": "60",
    "attack": "60",
    "defense": "40",
    "spattack": "65",
    "spdefense": "45",
    "speed": "35",
    "total": "305",
    "weight": "52.9 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Numb Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "323",
    "ndex": "323",
    "species": "Camerupt",
    "forme": "Camerupt",
    "type1": "Fire",
    "type2": "Ground",
    "ability1": "Magma Armor",
    "ability2": "Solid Rock",
    "abilityH": "Anger Point",
    "hp": "70",
    "attack": "100",
    "defense": "70",
    "spattack": "105",
    "spdefense": "75",
    "speed": "40",
    "total": "460",
    "weight": "485.0 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Eruption Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Numel",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "324",
    "ndex": "324",
    "species": "Torkoal",
    "forme": "Torkoal",
    "type1": "Fire",
    "type2": "",
    "ability1": "White Smoke",
    "ability2": "Drought",
    "abilityH": "Shell Armor",
    "hp": "70",
    "attack": "85",
    "defense": "140",
    "spattack": "85",
    "spdefense": "70",
    "speed": "20",
    "total": "470",
    "weight": "177.2 lbs.",
    "height": "1'08\"",
    "dex1": "Coal is the source of Torkoal’s energy. Large amounts of coal can be found in the mountains where they live.",
    "dex2": "If the fire burning within its shell goes out, it will die. Those who wish to raise one in their home must always keep something flammable at hand.",
    "class": "Coal Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "325",
    "ndex": "325",
    "species": "Spoink",
    "forme": "Spoink",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Thick Fat",
    "ability2": "Own Tempo",
    "abilityH": "Gluttony",
    "hp": "60",
    "attack": "25",
    "defense": "35",
    "spattack": "70",
    "spdefense": "80",
    "speed": "60",
    "total": "330",
    "weight": "67.5 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Bounce Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "326",
    "ndex": "326",
    "species": "Grumpig",
    "forme": "Grumpig",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Thick Fat",
    "ability2": "Own Tempo",
    "abilityH": "Gluttony",
    "hp": "80",
    "attack": "45",
    "defense": "65",
    "spattack": "90",
    "spdefense": "110",
    "speed": "80",
    "total": "470",
    "weight": "157.6 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Manipulate Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spoink",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "327",
    "ndex": "327",
    "species": "Spinda",
    "forme": "Spinda",
    "type1": "Normal",
    "type2": "",
    "ability1": "Own Tempo",
    "ability2": "Tangled Feet",
    "abilityH": "Contrary",
    "hp": "60",
    "attack": "60",
    "defense": "60",
    "spattack": "60",
    "spdefense": "60",
    "speed": "60",
    "total": "360",
    "weight": "11.0 lbs.",
    "height": "3'07\"",
    "dex1": "Its steps are staggering and unsteady, but Spinda thinks it’s walking in a straight line.",
    "dex2": "Each and every Spinda has a slightly different configuration of spots. There are collectors who enjoy the tiny differences in their spot patterns.",
    "class": "Spot Panda Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "328",
    "ndex": "328",
    "species": "Trapinch",
    "forme": "Trapinch",
    "type1": "Ground",
    "type2": "",
    "ability1": "Hyper Cutter",
    "ability2": "Arena Trap",
    "abilityH": "Sheer Force",
    "hp": "45",
    "attack": "100",
    "defense": "45",
    "spattack": "45",
    "spdefense": "45",
    "speed": "10",
    "total": "290",
    "weight": "33.1 lbs.",
    "height": "2'04\"",
    "dex1": "It can live for a week without eating a thing. It waits patiently at the bottom of its nest for prey to appear.",
    "dex2": "As it digs through the sand, its giant jaws crush any rocks that obstruct its path. It builds a funnel-shaped nest.",
    "class": "Ant Pit Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "329",
    "ndex": "329",
    "species": "Vibrava",
    "forme": "Vibrava",
    "type1": "Ground",
    "type2": "Dragon",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "70",
    "defense": "50",
    "spattack": "50",
    "spdefense": "50",
    "speed": "70",
    "total": "340",
    "weight": "33.7 lbs.",
    "height": "3'07\"",
    "dex1": "Rather than using its underdeveloped wings for flight, it rubs them together, producing ultrasonic waves to attack its enemies.",
    "dex2": "To help make its wings grow, it dissolves quantities of prey in its digestive juices and guzzles them down every day.",
    "class": "Vibration Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Trapinch",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "330",
    "ndex": "330",
    "species": "Flygon",
    "forme": "Flygon",
    "type1": "Ground",
    "type2": "Dragon",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "100",
    "defense": "80",
    "spattack": "80",
    "spdefense": "80",
    "speed": "100",
    "total": "520",
    "weight": "180.8 lbs.",
    "height": "6'07\"",
    "dex1": "The flapping of its wings sounds something like singing. Those lured by the sound are enveloped in a sandstorm, becoming Flygon’s prey.",
    "dex2": "This Pokémon hides in the heart of sandstorms it creates and seldom appears where people can see it.",
    "class": "Mystic Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Vibrava",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "331",
    "ndex": "331",
    "species": "Cacnea",
    "forme": "Cacnea",
    "type1": "Grass",
    "type2": "",
    "ability1": "Sand Veil",
    "ability2": "",
    "abilityH": "Water Absorb",
    "hp": "50",
    "attack": "85",
    "defense": "40",
    "spattack": "85",
    "spdefense": "40",
    "speed": "35",
    "total": "335",
    "weight": "113.1 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Cactus Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": "Human-Like"
  },
  {
    "id": "332",
    "ndex": "332",
    "species": "Cacturne",
    "forme": "Cacturne",
    "type1": "Grass",
    "type2": "Dark",
    "ability1": "Sand Veil",
    "ability2": "",
    "abilityH": "Water Absorb",
    "hp": "70",
    "attack": "115",
    "defense": "60",
    "spattack": "115",
    "spdefense": "60",
    "speed": "55",
    "total": "475",
    "weight": "170.6 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Scarecrow Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Cacnea",
    "egg-group1": "Grass",
    "egg-group2": "Human-Like"
  },
  {
    "id": "333",
    "ndex": "333",
    "species": "Swablu",
    "forme": "Swablu",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Natural Cure",
    "ability2": "",
    "abilityH": "Cloud Nine",
    "hp": "45",
    "attack": "40",
    "defense": "60",
    "spattack": "40",
    "spdefense": "75",
    "speed": "50",
    "total": "310",
    "weight": "2.6 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Cotton Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": "Dragon"
  },
  {
    "id": "334",
    "ndex": "334",
    "species": "Altaria",
    "forme": "Altaria",
    "type1": "Dragon",
    "type2": "Flying",
    "ability1": "Natural Cure",
    "ability2": "",
    "abilityH": "Cloud Nine",
    "hp": "75",
    "attack": "70",
    "defense": "90",
    "spattack": "70",
    "spdefense": "105",
    "speed": "80",
    "total": "490",
    "weight": "45.4 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Humming Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Swablu",
    "egg-group1": "Flying",
    "egg-group2": "Dragon"
  },
  {
    "id": "335",
    "ndex": "335",
    "species": "Zangoose",
    "forme": "Zangoose",
    "type1": "Normal",
    "type2": "",
    "ability1": "Immunity",
    "ability2": "",
    "abilityH": "Toxic Boost",
    "hp": "73",
    "attack": "115",
    "defense": "60",
    "spattack": "60",
    "spdefense": "60",
    "speed": "90",
    "total": "458",
    "weight": "88.8 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Cat Ferret Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "336",
    "ndex": "336",
    "species": "Seviper",
    "forme": "Seviper",
    "type1": "Poison",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Infiltrator",
    "hp": "73",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "65",
    "total": "458",
    "weight": "115.7 lbs.",
    "height": "8'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Fang Snake Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Dragon"
  },
  {
    "id": "337",
    "ndex": "337",
    "species": "Lunatone",
    "forme": "Lunatone",
    "type1": "Rock",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "90",
    "attack": "55",
    "defense": "65",
    "spattack": "95",
    "spdefense": "85",
    "speed": "70",
    "total": "460",
    "weight": "370.4 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Meteorite Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "338",
    "ndex": "338",
    "species": "Solrock",
    "forme": "Solrock",
    "type1": "Rock",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "90",
    "attack": "95",
    "defense": "85",
    "spattack": "55",
    "spdefense": "65",
    "speed": "70",
    "total": "460",
    "weight": "339.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Meteorite Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "339",
    "ndex": "339",
    "species": "Barboach",
    "forme": "Barboach",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Oblivious",
    "ability2": "Anticipation",
    "abilityH": "Hydration",
    "hp": "50",
    "attack": "48",
    "defense": "43",
    "spattack": "46",
    "spdefense": "41",
    "speed": "60",
    "total": "288",
    "weight": "4.2 lbs.",
    "height": "1'04\"",
    "dex1": "Its two whiskers provide a sensitive radar. Even in muddy waters, it can detect its prey’s location.",
    "dex2": "Its slippery body is hard to grasp, so much so that there are festivals where people compete to see how many they can catch barehanded.",
    "class": "Whiskers Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "340",
    "ndex": "340",
    "species": "Whiscash",
    "forme": "Whiscash",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Oblivious",
    "ability2": "Anticipation",
    "abilityH": "Hydration",
    "hp": "110",
    "attack": "78",
    "defense": "73",
    "spattack": "76",
    "spdefense": "71",
    "speed": "60",
    "total": "468",
    "weight": "52.0 lbs.",
    "height": "2'11\"",
    "dex1": "A glutton that devours anything that moves, it quietly lurks at the bottom of swamps, lying in wait for prey.",
    "dex2": "Sighting Whiscash leaping from the water is believed to herald an earthquake.",
    "class": "Whiskers Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Barboach",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "341",
    "ndex": "341",
    "species": "Corphish",
    "forme": "Corphish",
    "type1": "Water",
    "type2": "",
    "ability1": "Hyper Cutter",
    "ability2": "Shell Armor",
    "abilityH": "Adaptability",
    "hp": "43",
    "attack": "80",
    "defense": "65",
    "spattack": "50",
    "spdefense": "35",
    "speed": "35",
    "total": "308",
    "weight": "25.4 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Ruffian Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "342",
    "ndex": "342",
    "species": "Crawdaunt",
    "forme": "Crawdaunt",
    "type1": "Water",
    "type2": "Dark",
    "ability1": "Hyper Cutter",
    "ability2": "Shell Armor",
    "abilityH": "Adaptability",
    "hp": "63",
    "attack": "120",
    "defense": "85",
    "spattack": "90",
    "spdefense": "55",
    "speed": "55",
    "total": "468",
    "weight": "72.3 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Rogue Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Corphish",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "343",
    "ndex": "343",
    "species": "Baltoy",
    "forme": "Baltoy",
    "type1": "Ground",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "40",
    "attack": "40",
    "defense": "55",
    "spattack": "40",
    "spdefense": "70",
    "speed": "55",
    "total": "300",
    "weight": "47.4 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Clay Doll Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "344",
    "ndex": "344",
    "species": "Claydol",
    "forme": "Claydol",
    "type1": "Ground",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "60",
    "attack": "70",
    "defense": "105",
    "spattack": "70",
    "spdefense": "120",
    "speed": "75",
    "total": "500",
    "weight": "238.1 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Clay Doll Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Baltoy",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "345",
    "ndex": "345",
    "species": "Lileep",
    "forme": "Lileep",
    "type1": "Rock",
    "type2": "Grass",
    "ability1": "Suction Cups",
    "ability2": "",
    "abilityH": "Storm Drain",
    "hp": "66",
    "attack": "41",
    "defense": "77",
    "spattack": "61",
    "spdefense": "87",
    "speed": "23",
    "total": "355",
    "weight": "52.5 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Sea Lily Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "346",
    "ndex": "346",
    "species": "Cradily",
    "forme": "Cradily",
    "type1": "Rock",
    "type2": "Grass",
    "ability1": "Suction Cups",
    "ability2": "",
    "abilityH": "Storm Drain",
    "hp": "86",
    "attack": "81",
    "defense": "97",
    "spattack": "81",
    "spdefense": "107",
    "speed": "43",
    "total": "495",
    "weight": "133.2 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Barnacle Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Lileep",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "347",
    "ndex": "347",
    "species": "Anorith",
    "forme": "Anorith",
    "type1": "Rock",
    "type2": "Bug",
    "ability1": "Battle Armor",
    "ability2": "",
    "abilityH": "Swift Swim",
    "hp": "45",
    "attack": "95",
    "defense": "50",
    "spattack": "40",
    "spdefense": "50",
    "speed": "75",
    "total": "355",
    "weight": "27.6 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Old Shrimp Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "348",
    "ndex": "348",
    "species": "Armaldo",
    "forme": "Armaldo",
    "type1": "Rock",
    "type2": "Bug",
    "ability1": "Battle Armor",
    "ability2": "",
    "abilityH": "Swift Swim",
    "hp": "75",
    "attack": "125",
    "defense": "100",
    "spattack": "70",
    "spdefense": "80",
    "speed": "45",
    "total": "495",
    "weight": "150.4 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Plate Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Anorith",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "349",
    "ndex": "349",
    "species": "Feebas",
    "forme": "Feebas",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "Oblivious",
    "abilityH": "Adaptability",
    "hp": "20",
    "attack": "15",
    "defense": "20",
    "spattack": "10",
    "spdefense": "55",
    "speed": "80",
    "total": "200",
    "weight": "16.3 lbs.",
    "height": "2'00\"",
    "dex1": "A tough Pokémon that is perfectly fine even in dirty water. However, due to its ragged, shabby appearance, it isn’t popular.",
    "dex2": "Although unattractive and unpopular, this Pokémon’s marvelous vitality has made it a subject of research.",
    "class": "Fish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "350",
    "ndex": "350",
    "species": "Milotic",
    "forme": "Milotic",
    "type1": "Water",
    "type2": "",
    "ability1": "Marvel Scale",
    "ability2": "Competitive",
    "abilityH": "Cute Charm",
    "hp": "95",
    "attack": "60",
    "defense": "79",
    "spattack": "100",
    "spdefense": "125",
    "speed": "81",
    "total": "540",
    "weight": "357.1 lbs.",
    "height": "20'04\"",
    "dex1": "Milotic has provided inspiration to many artists. It has even been referred to as the most beautiful Pokémon of all.",
    "dex2": "It lives at the bottom of clear lakes. In times of war, it shows itself, which soothes people’s minds and hearts.",
    "class": "Tender Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Feebas",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "351",
    "ndex": "351",
    "species": "Castform",
    "forme": "Castform (Normal)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Forecast",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "70",
    "defense": "70",
    "spattack": "70",
    "spdefense": "70",
    "speed": "70",
    "total": "420",
    "weight": "1.8 lbs.",
    "height": "1'00\"",
    "dex1": "It changes its form depending on the weather. Changes in the temperature or humidity appear to affect its cellular structure.",
    "dex2": "Its form changes on its own, due to its cells’ sensitive reactions to temperature and humidity.",
    "class": "Weather Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": "Amorphous"
  },
  {
    "id": "352",
    "ndex": "352",
    "species": "Kecleon",
    "forme": "Kecleon",
    "type1": "Normal",
    "type2": "",
    "ability1": "Color Change",
    "ability2": "",
    "abilityH": "Protean",
    "hp": "60",
    "attack": "90",
    "defense": "70",
    "spattack": "60",
    "spdefense": "120",
    "speed": "40",
    "total": "440",
    "weight": "48.5 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Color Swap Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "353",
    "ndex": "353",
    "species": "Shuppet",
    "forme": "Shuppet",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Insomnia",
    "ability2": "Frisk",
    "abilityH": "Cursed Body",
    "hp": "44",
    "attack": "75",
    "defense": "35",
    "spattack": "63",
    "spdefense": "33",
    "speed": "45",
    "total": "295",
    "weight": "5.1 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Puppet Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "354",
    "ndex": "354",
    "species": "Banette",
    "forme": "Banette",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Insomnia",
    "ability2": "Frisk",
    "abilityH": "Cursed Body",
    "hp": "64",
    "attack": "115",
    "defense": "65",
    "spattack": "83",
    "spdefense": "63",
    "speed": "65",
    "total": "455",
    "weight": "27.6 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Marionette Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shuppet",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "355",
    "ndex": "355",
    "species": "Duskull",
    "forme": "Duskull",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "Frisk",
    "hp": "20",
    "attack": "40",
    "defense": "90",
    "spattack": "30",
    "spdefense": "90",
    "speed": "25",
    "total": "295",
    "weight": "33.1 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Requiem Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "356",
    "ndex": "356",
    "species": "Dusclops",
    "forme": "Dusclops",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Frisk",
    "hp": "40",
    "attack": "70",
    "defense": "130",
    "spattack": "60",
    "spdefense": "130",
    "speed": "25",
    "total": "455",
    "weight": "67.5 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Beckon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Duskull",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "357",
    "ndex": "357",
    "species": "Tropius",
    "forme": "Tropius",
    "type1": "Grass",
    "type2": "Flying",
    "ability1": "Chlorophyll",
    "ability2": "Solar Power",
    "abilityH": "Harvest",
    "hp": "99",
    "attack": "68",
    "defense": "83",
    "spattack": "72",
    "spdefense": "87",
    "speed": "51",
    "total": "460",
    "weight": "220.5 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Fruit Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "358",
    "ndex": "358",
    "species": "Chimecho",
    "forme": "Chimecho",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "50",
    "defense": "80",
    "spattack": "95",
    "spdefense": "90",
    "speed": "65",
    "total": "455",
    "weight": "2.2 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Wind Chime Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Chingling",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "359",
    "ndex": "359",
    "species": "Absol",
    "forme": "Absol",
    "type1": "Dark",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "Super Luck",
    "abilityH": "Justified",
    "hp": "65",
    "attack": "130",
    "defense": "60",
    "spattack": "75",
    "spdefense": "60",
    "speed": "75",
    "total": "465",
    "weight": "103.6 lbs.",
    "height": "3'11\"",
    "dex1": "Long ago, superstitions were spread about it, saying it brought disaster. This fed a hatred of it, and it was driven deep into the mountains.",
    "dex2": "Although it’s said to bring disaster, in actuality, this Pokémon possesses a calm disposition and warns people of any crises that loom.",
    "class": "Disaster Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "360",
    "ndex": "360",
    "species": "Wynaut",
    "forme": "Wynaut",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Shadow Tag",
    "ability2": "",
    "abilityH": "Telepathy",
    "hp": "95",
    "attack": "23",
    "defense": "48",
    "spattack": "23",
    "spdefense": "48",
    "speed": "23",
    "total": "260",
    "weight": "30.9 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Bright Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "361",
    "ndex": "361",
    "species": "Snorunt",
    "forme": "Snorunt",
    "type1": "Ice",
    "type2": "",
    "ability1": "Inner Focus",
    "ability2": "Ice Body",
    "abilityH": "Moody",
    "hp": "50",
    "attack": "50",
    "defense": "50",
    "spattack": "50",
    "spdefense": "50",
    "speed": "50",
    "total": "300",
    "weight": "37.0 lbs.",
    "height": "2'04\"",
    "dex1": "Their numbers seem to have rapidly increased in Alola. Custom has it that houses where Snorunt live will be prosperous for generations to come.",
    "dex2": "It can only survive in cold areas. It bounces happily around, even in environments as cold as -150 degrees Fahrenheit.",
    "class": "Snow Hat Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": "Mineral"
  },
  {
    "id": "362",
    "ndex": "362",
    "species": "Glalie",
    "forme": "Glalie",
    "type1": "Ice",
    "type2": "",
    "ability1": "Inner Focus",
    "ability2": "Ice Body",
    "abilityH": "Moody",
    "hp": "80",
    "attack": "80",
    "defense": "80",
    "spattack": "80",
    "spdefense": "80",
    "speed": "80",
    "total": "480",
    "weight": "565.5 lbs.",
    "height": "4'11\"",
    "dex1": "Legend says a boulder on an icy mountain absorbed the distress and regrets of a stranded mountaineer, giving rise to Glalie.",
    "dex2": "Its prey is instantaneously frozen stiff by the cold air it exhales from its huge mouth. While they’re in that frozen state, it gobbles them up.",
    "class": "Face Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Snorunt",
    "egg-group1": "Fairy",
    "egg-group2": "Mineral"
  },
  {
    "id": "363",
    "ndex": "363",
    "species": "Spheal",
    "forme": "Spheal",
    "type1": "Ice",
    "type2": "Water",
    "ability1": "Thick Fat",
    "ability2": "Ice Body",
    "abilityH": "Oblivious",
    "hp": "70",
    "attack": "40",
    "defense": "50",
    "spattack": "55",
    "spdefense": "50",
    "speed": "25",
    "total": "290",
    "weight": "87.1 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Clap Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "364",
    "ndex": "364",
    "species": "Sealeo",
    "forme": "Sealeo",
    "type1": "Ice",
    "type2": "Water",
    "ability1": "Thick Fat",
    "ability2": "Ice Body",
    "abilityH": "Oblivious",
    "hp": "90",
    "attack": "60",
    "defense": "70",
    "spattack": "75",
    "spdefense": "70",
    "speed": "45",
    "total": "410",
    "weight": "193.1 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Ball Roll Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spheal",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "365",
    "ndex": "365",
    "species": "Walrein",
    "forme": "Walrein",
    "type1": "Ice",
    "type2": "Water",
    "ability1": "Thick Fat",
    "ability2": "Ice Body",
    "abilityH": "Oblivious",
    "hp": "110",
    "attack": "80",
    "defense": "90",
    "spattack": "95",
    "spdefense": "90",
    "speed": "65",
    "total": "530",
    "weight": "332.0 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Ice Break Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sealeo",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "366",
    "ndex": "366",
    "species": "Clamperl",
    "forme": "Clamperl",
    "type1": "Water",
    "type2": "",
    "ability1": "Shell Armor",
    "ability2": "",
    "abilityH": "Rattled",
    "hp": "35",
    "attack": "64",
    "defense": "85",
    "spattack": "74",
    "spdefense": "55",
    "speed": "32",
    "total": "345",
    "weight": "115.7 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Bivalve Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "367",
    "ndex": "367",
    "species": "Huntail",
    "forme": "Huntail",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "",
    "abilityH": "Water Veil",
    "hp": "55",
    "attack": "104",
    "defense": "105",
    "spattack": "94",
    "spdefense": "75",
    "speed": "52",
    "total": "485",
    "weight": "59.5 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Deep Sea Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Clamperl",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "368",
    "ndex": "368",
    "species": "Gorebyss",
    "forme": "Gorebyss",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "",
    "abilityH": "Hydration",
    "hp": "55",
    "attack": "84",
    "defense": "105",
    "spattack": "114",
    "spdefense": "75",
    "speed": "52",
    "total": "485",
    "weight": "49.8 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "South Sea Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Clamperl",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "369",
    "ndex": "369",
    "species": "Relicanth",
    "forme": "Relicanth",
    "type1": "Water",
    "type2": "Rock",
    "ability1": "Swift Swim",
    "ability2": "Rock Head",
    "abilityH": "Sturdy",
    "hp": "100",
    "attack": "90",
    "defense": "130",
    "spattack": "45",
    "spdefense": "65",
    "speed": "55",
    "total": "485",
    "weight": "51.6 lbs.",
    "height": "3'03\"",
    "dex1": "Its form has remained the same for one hundred million years. Its body is filled with fat, so it can withstand the water pressure of the deep sea.",
    "dex2": "It was fortuitously discovered during a deep sea expedition. Its teeth have atrophied, so it now survives on microscopic organisms it sucks up.",
    "class": "Longevity Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 2"
  },
  {
    "id": "370",
    "ndex": "370",
    "species": "Luvdisc",
    "forme": "Luvdisc",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "",
    "abilityH": "Hydration",
    "hp": "43",
    "attack": "30",
    "defense": "55",
    "spattack": "40",
    "spdefense": "65",
    "speed": "97",
    "total": "330",
    "weight": "19.2 lbs.",
    "height": "2'00\"",
    "dex1": "If a Luvdisc is left on its own, it becomes despondent, leaving itself open to attack. That is when Pelipper snatch them up.",
    "dex2": "Loving couples have a soft spot for this Pokémon, so honeymoon hotels often release this Pokémon into their pools.",
    "class": "Rendezvous Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "371",
    "ndex": "371",
    "species": "Bagon",
    "forme": "Bagon",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Rock Head",
    "ability2": "",
    "abilityH": "Sheer Force",
    "hp": "45",
    "attack": "75",
    "defense": "60",
    "spattack": "40",
    "spdefense": "30",
    "speed": "50",
    "total": "300",
    "weight": "92.8 lbs.",
    "height": "2'00\"",
    "dex1": "Its belief that it will be able to fly one day is apparently the influence of information carried in its genes.",
    "dex2": "With its steel-hard stone head, it headbutts indiscriminately. This is because of the stress it feels at being unable to fly.",
    "class": "Rock Head Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "372",
    "ndex": "372",
    "species": "Shelgon",
    "forme": "Shelgon",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Rock Head",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "65",
    "attack": "95",
    "defense": "100",
    "spattack": "60",
    "spdefense": "50",
    "speed": "50",
    "total": "420",
    "weight": "243.6 lbs.",
    "height": "3'07\"",
    "dex1": "The cells within its shell transform with explosive speed, preparing it for evolution.",
    "dex2": "They lurk deep within caves—motionless, neither eating nor drinking. Why they don’t die is not known.",
    "class": "Endurance Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Bagon",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "373",
    "ndex": "373",
    "species": "Salamence",
    "forme": "Salamence",
    "type1": "Dragon",
    "type2": "Flying",
    "ability1": "Intimidate",
    "ability2": "",
    "abilityH": "Moxie",
    "hp": "95",
    "attack": "135",
    "defense": "80",
    "spattack": "110",
    "spdefense": "80",
    "speed": "100",
    "total": "600",
    "weight": "226.2 lbs.",
    "height": "4'11\"",
    "dex1": "When angered, it loses all sense of itself and destroys everything around it. The destruction will continue until Salamence has tired itself out.",
    "dex2": "It flies around on its wings, which have grown in at last. In its happiness, it gushes hot flames, burning up the fields it passes over.",
    "class": "Dragon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shelgon",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "374",
    "ndex": "374",
    "species": "Beldum",
    "forme": "Beldum",
    "type1": "Steel",
    "type2": "Psychic",
    "ability1": "Clear Body",
    "ability2": "",
    "abilityH": "Light Metal",
    "hp": "40",
    "attack": "55",
    "defense": "80",
    "spattack": "35",
    "spdefense": "60",
    "speed": "30",
    "total": "300",
    "weight": "209.9 lbs.",
    "height": "2'00\"",
    "dex1": "Its cells are all magnets. It uses magnetism to communicate with others of its kind.",
    "dex2": "With magnetic traction, it pulls its opponents in close. When they’re in range, it slashes them with its rear claws.",
    "class": "Iron Ball Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "375",
    "ndex": "375",
    "species": "Metang",
    "forme": "Metang",
    "type1": "Steel",
    "type2": "Psychic",
    "ability1": "Clear Body",
    "ability2": "",
    "abilityH": "Light Metal",
    "hp": "60",
    "attack": "75",
    "defense": "100",
    "spattack": "55",
    "spdefense": "80",
    "speed": "50",
    "total": "420",
    "weight": "446.4 lbs.",
    "height": "3'11\"",
    "dex1": "When two Beldum link together, their psychic power is doubled. Their intelligence, however, remains unchanged.",
    "dex2": "It adores magnetic minerals, so it pursues Nosepass at speeds exceeding 60 mph.",
    "class": "Iron Claw Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Beldum",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "376",
    "ndex": "376",
    "species": "Metagross",
    "forme": "Metagross",
    "type1": "Steel",
    "type2": "Psychic",
    "ability1": "Clear Body",
    "ability2": "",
    "abilityH": "Light Metal",
    "hp": "80",
    "attack": "135",
    "defense": "130",
    "spattack": "95",
    "spdefense": "90",
    "speed": "70",
    "total": "600",
    "weight": "1212.5 lbs.",
    "height": "5'03\"",
    "dex1": "It firmly pins its prey using its four claws and large body. Then the teeth in the mouth on its stomach chew the prey to bits.",
    "dex2": "A linkage of two Metang, this Pokémon can perform any calculation in a flash by utilizing parallel processing in its four brains.",
    "class": "Iron Leg Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Metang",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "377",
    "ndex": "377",
    "species": "Regirock",
    "forme": "Regirock",
    "type1": "Rock",
    "type2": "",
    "ability1": "Clear Body",
    "ability2": "",
    "abilityH": "Sturdy",
    "hp": "80",
    "attack": "100",
    "defense": "200",
    "spattack": "50",
    "spdefense": "100",
    "speed": "50",
    "total": "580",
    "weight": "507.1 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Rock Peak Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "378",
    "ndex": "378",
    "species": "Regice",
    "forme": "Regice",
    "type1": "Ice",
    "type2": "",
    "ability1": "Clear Body",
    "ability2": "",
    "abilityH": "Ice Body",
    "hp": "80",
    "attack": "50",
    "defense": "100",
    "spattack": "100",
    "spdefense": "200",
    "speed": "50",
    "total": "580",
    "weight": "385.8 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Iceberg Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "379",
    "ndex": "379",
    "species": "Registeel",
    "forme": "Registeel",
    "type1": "Steel",
    "type2": "",
    "ability1": "Clear Body",
    "ability2": "",
    "abilityH": "Light Metal",
    "hp": "80",
    "attack": "75",
    "defense": "150",
    "spattack": "75",
    "spdefense": "150",
    "speed": "50",
    "total": "580",
    "weight": "451.9 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Iron Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "380",
    "ndex": "380",
    "species": "Latias",
    "forme": "Latias",
    "type1": "Dragon",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "80",
    "defense": "90",
    "spattack": "110",
    "spdefense": "130",
    "speed": "110",
    "total": "600",
    "weight": "88.2 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Eon Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "381",
    "ndex": "381",
    "species": "Latios",
    "forme": "Latios",
    "type1": "Dragon",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "90",
    "defense": "80",
    "spattack": "130",
    "spdefense": "110",
    "speed": "110",
    "total": "600",
    "weight": "132.3 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Eon Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "382",
    "ndex": "382",
    "species": "Kyogre",
    "forme": "Kyogre",
    "type1": "Water",
    "type2": "",
    "ability1": "Drizzle",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "100",
    "defense": "90",
    "spattack": "150",
    "spdefense": "140",
    "speed": "90",
    "total": "670",
    "weight": "776.0 lbs.",
    "height": "14'09\"",
    "dex1": "",
    "dex2": "",
    "class": "Sea Basin Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "383",
    "ndex": "383",
    "species": "Groudon",
    "forme": "Groudon",
    "type1": "Ground",
    "type2": "",
    "ability1": "Drought",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "150",
    "defense": "140",
    "spattack": "100",
    "spdefense": "90",
    "speed": "90",
    "total": "670",
    "weight": "2094.4 lbs.",
    "height": "11'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Continent Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "384",
    "ndex": "384",
    "species": "Rayquaza",
    "forme": "Rayquaza",
    "type1": "Dragon",
    "type2": "Flying",
    "ability1": "Air Lock",
    "ability2": "",
    "abilityH": "",
    "hp": "105",
    "attack": "150",
    "defense": "90",
    "spattack": "150",
    "spdefense": "90",
    "speed": "95",
    "total": "680",
    "weight": "455.2 lbs.",
    "height": "23'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Sky High Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "385",
    "ndex": "385",
    "species": "Jirachi",
    "forme": "Jirachi",
    "type1": "Steel",
    "type2": "Psychic",
    "ability1": "Serene Grace",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "100",
    "defense": "100",
    "spattack": "100",
    "spdefense": "100",
    "speed": "100",
    "total": "600",
    "weight": "2.4 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Wish Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "386",
    "ndex": "386",
    "species": "Deoxys",
    "forme": "Deoxys (Normal Forme)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "150",
    "defense": "50",
    "spattack": "150",
    "spdefense": "50",
    "speed": "150",
    "total": "600",
    "weight": "134.0 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "DNA Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "387",
    "ndex": "387",
    "species": "Turtwig",
    "forme": "Turtwig",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Shell Armor",
    "hp": "55",
    "attack": "68",
    "defense": "64",
    "spattack": "45",
    "spdefense": "55",
    "speed": "31",
    "total": "318",
    "weight": "22.5 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Tiny Leaf Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "388",
    "ndex": "388",
    "species": "Grotle",
    "forme": "Grotle",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Shell Armor",
    "hp": "75",
    "attack": "89",
    "defense": "85",
    "spattack": "55",
    "spdefense": "65",
    "speed": "36",
    "total": "405",
    "weight": "213.8 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Grove Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Turtwig",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "389",
    "ndex": "389",
    "species": "Torterra",
    "forme": "Torterra",
    "type1": "Grass",
    "type2": "Ground",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Shell Armor",
    "hp": "95",
    "attack": "109",
    "defense": "105",
    "spattack": "75",
    "spdefense": "85",
    "speed": "56",
    "total": "525",
    "weight": "683.4 lbs.",
    "height": "7'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Continent Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Grotle",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "390",
    "ndex": "390",
    "species": "Chimchar",
    "forme": "Chimchar",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Iron Fist",
    "hp": "44",
    "attack": "58",
    "defense": "44",
    "spattack": "58",
    "spdefense": "44",
    "speed": "61",
    "total": "309",
    "weight": "13.7 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Chimp Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "391",
    "ndex": "391",
    "species": "Monferno",
    "forme": "Monferno",
    "type1": "Fire",
    "type2": "Fighting",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Iron Fist",
    "hp": "64",
    "attack": "78",
    "defense": "52",
    "spattack": "78",
    "spdefense": "52",
    "speed": "81",
    "total": "405",
    "weight": "48.5 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Playful Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Chimchar",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "392",
    "ndex": "392",
    "species": "Infernape",
    "forme": "Infernape",
    "type1": "Fire",
    "type2": "Fighting",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Iron Fist",
    "hp": "76",
    "attack": "104",
    "defense": "71",
    "spattack": "104",
    "spdefense": "71",
    "speed": "108",
    "total": "534",
    "weight": "121.3 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Flame Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Monferno",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "393",
    "ndex": "393",
    "species": "Piplup",
    "forme": "Piplup",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Defiant",
    "hp": "53",
    "attack": "51",
    "defense": "53",
    "spattack": "61",
    "spdefense": "56",
    "speed": "40",
    "total": "314",
    "weight": "11.5 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Penguin Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "394",
    "ndex": "394",
    "species": "Prinplup",
    "forme": "Prinplup",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Defiant",
    "hp": "64",
    "attack": "66",
    "defense": "68",
    "spattack": "81",
    "spdefense": "76",
    "speed": "50",
    "total": "405",
    "weight": "50.7 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Penguin Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Piplup",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "395",
    "ndex": "395",
    "species": "Empoleon",
    "forme": "Empoleon",
    "type1": "Water",
    "type2": "Steel",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Defiant",
    "hp": "84",
    "attack": "86",
    "defense": "88",
    "spattack": "111",
    "spdefense": "101",
    "speed": "60",
    "total": "530",
    "weight": "186.3 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Emperor Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Prinplup",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "396",
    "ndex": "396",
    "species": "Starly",
    "forme": "Starly",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "",
    "abilityH": "Reckless",
    "hp": "40",
    "attack": "55",
    "defense": "30",
    "spattack": "30",
    "spdefense": "30",
    "speed": "60",
    "total": "245",
    "weight": "4.4 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Starling Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "397",
    "ndex": "397",
    "species": "Staravia",
    "forme": "Staravia",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Intimidate",
    "ability2": "",
    "abilityH": "Reckless",
    "hp": "55",
    "attack": "75",
    "defense": "50",
    "spattack": "40",
    "spdefense": "40",
    "speed": "80",
    "total": "340",
    "weight": "34.2 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Starling Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Starly",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "398",
    "ndex": "398",
    "species": "Staraptor",
    "forme": "Staraptor",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Intimidate",
    "ability2": "",
    "abilityH": "Reckless",
    "hp": "85",
    "attack": "120",
    "defense": "70",
    "spattack": "50",
    "spdefense": "60",
    "speed": "100",
    "total": "485",
    "weight": "54.9 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Predator Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Staravia",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "399",
    "ndex": "399",
    "species": "Bidoof",
    "forme": "Bidoof",
    "type1": "Normal",
    "type2": "",
    "ability1": "Simple",
    "ability2": "Unaware",
    "abilityH": "Moody",
    "hp": "59",
    "attack": "45",
    "defense": "40",
    "spattack": "35",
    "spdefense": "40",
    "speed": "31",
    "total": "250",
    "weight": "44.1 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Plump Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "400",
    "ndex": "400",
    "species": "Bibarel",
    "forme": "Bibarel",
    "type1": "Normal",
    "type2": "Water",
    "ability1": "Simple",
    "ability2": "Unaware",
    "abilityH": "Moody",
    "hp": "79",
    "attack": "85",
    "defense": "60",
    "spattack": "55",
    "spdefense": "60",
    "speed": "71",
    "total": "410",
    "weight": "69.4 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Beaver Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Bidoof",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "401",
    "ndex": "401",
    "species": "Kricketot",
    "forme": "Kricketot",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Run Away",
    "hp": "37",
    "attack": "25",
    "defense": "41",
    "spattack": "25",
    "spdefense": "41",
    "speed": "25",
    "total": "194",
    "weight": "4.9 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Cricket Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "402",
    "ndex": "402",
    "species": "Kricketune",
    "forme": "Kricketune",
    "type1": "Bug",
    "type2": "",
    "ability1": "Swarm",
    "ability2": "",
    "abilityH": "Technician",
    "hp": "77",
    "attack": "85",
    "defense": "51",
    "spattack": "55",
    "spdefense": "51",
    "speed": "65",
    "total": "384",
    "weight": "56.2 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Cricket Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Kricketot",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "403",
    "ndex": "403",
    "species": "Shinx",
    "forme": "Shinx",
    "type1": "Electric",
    "type2": "",
    "ability1": "Rivalry",
    "ability2": "Intimidate",
    "abilityH": "Guts",
    "hp": "45",
    "attack": "65",
    "defense": "34",
    "spattack": "40",
    "spdefense": "34",
    "speed": "45",
    "total": "263",
    "weight": "20.9 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Flash Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "404",
    "ndex": "404",
    "species": "Luxio",
    "forme": "Luxio",
    "type1": "Electric",
    "type2": "",
    "ability1": "Rivalry",
    "ability2": "Intimidate",
    "abilityH": "Guts",
    "hp": "60",
    "attack": "85",
    "defense": "49",
    "spattack": "60",
    "spdefense": "49",
    "speed": "60",
    "total": "363",
    "weight": "67.2 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Spark Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shinx",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "405",
    "ndex": "405",
    "species": "Luxray",
    "forme": "Luxray",
    "type1": "Electric",
    "type2": "",
    "ability1": "Rivalry",
    "ability2": "Intimidate",
    "abilityH": "Guts",
    "hp": "80",
    "attack": "120",
    "defense": "79",
    "spattack": "95",
    "spdefense": "79",
    "speed": "70",
    "total": "523",
    "weight": "92.6 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Gleam Eyes Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Luxio",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "406",
    "ndex": "406",
    "species": "Budew",
    "forme": "Budew",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Mold Breaker",
    "ability2": "",
    "abilityH": "Sheer Force",
    "hp": "40",
    "attack": "30",
    "defense": "35",
    "spattack": "50",
    "spdefense": "70",
    "speed": "55",
    "total": "280",
    "weight": "2.6 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bud Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "407",
    "ndex": "407",
    "species": "Roserade",
    "forme": "Roserade",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Mold Breaker",
    "ability2": "",
    "abilityH": "Sheer Force",
    "hp": "60",
    "attack": "70",
    "defense": "65",
    "spattack": "125",
    "spdefense": "105",
    "speed": "90",
    "total": "515",
    "weight": "32.0 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Bouquet Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Roselia",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "408",
    "ndex": "408",
    "species": "Cranidos",
    "forme": "Cranidos",
    "type1": "Rock",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "",
    "abilityH": "Soundproof",
    "hp": "67",
    "attack": "125",
    "defense": "40",
    "spattack": "30",
    "spdefense": "30",
    "speed": "58",
    "total": "350",
    "weight": "69.4 lbs.",
    "height": "2'11\"",
    "dex1": "It lived in jungles around a hundred million years ago. It used its skillful headbutts to combat Aerodactyl.",
    "dex2": "In rock layers where Cranidos fossils are found, the fossilized trunks of trees snapped in two are also often found.",
    "class": "Head Butt Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "409",
    "ndex": "409",
    "species": "Rampardos",
    "forme": "Rampardos",
    "type1": "Rock",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "",
    "abilityH": "Soundproof",
    "hp": "97",
    "attack": "165",
    "defense": "60",
    "spattack": "65",
    "spdefense": "50",
    "speed": "58",
    "total": "495",
    "weight": "226.0 lbs.",
    "height": "5'03\"",
    "dex1": "The result of repeated headbutts is a skull grown thick and hard. However, its brain has shrunk in size compared with Cranidos’s.",
    "dex2": "Records exist of a revived fossil that evolved into Rampardos. It proceeded to escape and then destroy a skyscraper with a headbutt.",
    "class": "Head Butt Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Cranidos",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "410",
    "ndex": "410",
    "species": "Shieldon",
    "forme": "Shieldon",
    "type1": "Rock",
    "type2": "Steel",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "30",
    "attack": "42",
    "defense": "118",
    "spattack": "42",
    "spdefense": "88",
    "speed": "30",
    "total": "350",
    "weight": "125.7 lbs.",
    "height": "1'08\"",
    "dex1": "Many fossils of this Pokémon have been found, but almost none have shown signs of damage to the face.",
    "dex2": "This Pokémon lived in primeval jungles. Few enemies would have been willing to square off against its heavily armored face, so it’s thought.",
    "class": "Shield Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "411",
    "ndex": "411",
    "species": "Bastiodon",
    "forme": "Bastiodon",
    "type1": "Rock",
    "type2": "Steel",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "60",
    "attack": "52",
    "defense": "168",
    "spattack": "47",
    "spdefense": "138",
    "speed": "30",
    "total": "495",
    "weight": "329.6 lbs.",
    "height": "4'03\"",
    "dex1": "While it can guard against any sort of attack from the front, it is left without recourse when attacked from behind.",
    "dex2": "It lived in the same environments as Rampardos. Their fossils have been found together— seemingly from after they’d fought to the finish.",
    "class": "Shield Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Shieldon",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "412",
    "ndex": "412",
    "species": "Burmy",
    "forme": "Burmy (Plant Cloak)",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "40",
    "attack": "29",
    "defense": "45",
    "spattack": "29",
    "spdefense": "45",
    "speed": "36",
    "total": "224",
    "weight": "7.5 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bagworm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "413",
    "ndex": "413",
    "species": "Wormadam",
    "forme": "Wormadam (Plant Cloak)",
    "type1": "Bug",
    "type2": "Grass",
    "ability1": "Anticipation",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "60",
    "attack": "59",
    "defense": "85",
    "spattack": "79",
    "spdefense": "105",
    "speed": "36",
    "total": "424",
    "weight": "14.3 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bagworm Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Burmy",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "414",
    "ndex": "414",
    "species": "Mothim",
    "forme": "Mothim",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Swarm",
    "ability2": "",
    "abilityH": "Tinted Lens",
    "hp": "70",
    "attack": "94",
    "defense": "50",
    "spattack": "94",
    "spdefense": "50",
    "speed": "66",
    "total": "424",
    "weight": "51.4 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Moth Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Burmy",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "415",
    "ndex": "415",
    "species": "Combee",
    "forme": "Combee",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Honey Gather",
    "ability2": "",
    "abilityH": "Hustle",
    "hp": "30",
    "attack": "30",
    "defense": "42",
    "spattack": "30",
    "spdefense": "42",
    "speed": "70",
    "total": "244",
    "weight": "12.1 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Tiny Bee Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "416",
    "ndex": "416",
    "species": "Vespiquen",
    "forme": "Vespiquen",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Unnerve",
    "hp": "70",
    "attack": "80",
    "defense": "102",
    "spattack": "80",
    "spdefense": "102",
    "speed": "40",
    "total": "474",
    "weight": "84.9 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Beehive Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Combee",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "417",
    "ndex": "417",
    "species": "Pachirisu",
    "forme": "Pachirisu",
    "type1": "Electric",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Pickup",
    "abilityH": "Volt Absorb",
    "hp": "60",
    "attack": "45",
    "defense": "70",
    "spattack": "45",
    "spdefense": "90",
    "speed": "95",
    "total": "405",
    "weight": "8.6 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "EleSquirrel Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "418",
    "ndex": "418",
    "species": "Buizel",
    "forme": "Buizel",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "",
    "abilityH": "Water Veil",
    "hp": "55",
    "attack": "65",
    "defense": "35",
    "spattack": "60",
    "spdefense": "30",
    "speed": "85",
    "total": "330",
    "weight": "65.0 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Sea Weasel Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "419",
    "ndex": "419",
    "species": "Floatzel",
    "forme": "Floatzel",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "",
    "abilityH": "Water Veil",
    "hp": "85",
    "attack": "105",
    "defense": "55",
    "spattack": "85",
    "spdefense": "50",
    "speed": "115",
    "total": "495",
    "weight": "73.9 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Sea Weasel Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Buizel",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "420",
    "ndex": "420",
    "species": "Cherubi",
    "forme": "Cherubi",
    "type1": "Grass",
    "type2": "",
    "ability1": "Chlorophyll",
    "ability2": "",
    "abilityH": "",
    "hp": "45",
    "attack": "35",
    "defense": "45",
    "spattack": "62",
    "spdefense": "53",
    "speed": "35",
    "total": "275",
    "weight": "7.3 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Cherry Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "421",
    "ndex": "421",
    "species": "Cherrim",
    "forme": "Cherrim (Overcast Form)",
    "type1": "Grass",
    "type2": "",
    "ability1": "Flower Gift",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "60",
    "defense": "70",
    "spattack": "87",
    "spdefense": "78",
    "speed": "85",
    "total": "450",
    "weight": "20.5 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Blossom Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Cherubi",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "422",
    "ndex": "422",
    "species": "Shellos",
    "forme": "Shellos (West Sea)",
    "type1": "Water",
    "type2": "",
    "ability1": "Sticky Hold",
    "ability2": "Storm Drain",
    "abilityH": "Sand Force",
    "hp": "76",
    "attack": "48",
    "defense": "48",
    "spattack": "57",
    "spdefense": "62",
    "speed": "34",
    "total": "325",
    "weight": "13.9 lbs.",
    "height": "1'00\"",
    "dex1": "For the most part, it makes its home along the seashore. Its color and form differ according to its habitat and the quality of its food.",
    "dex2": "Purple mucus sticks to the hands of anyone who touches it. Take care, as the substance is troublesome to wash off.",
    "class": "Sea Slug Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Amorphous"
  },
  {
    "id": "423",
    "ndex": "423",
    "species": "Gastrodon",
    "forme": "Gastrodon (West Sea)",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Sticky Hold",
    "ability2": "Storm Drain",
    "abilityH": "Sand Force",
    "hp": "111",
    "attack": "83",
    "defense": "68",
    "spattack": "92",
    "spdefense": "82",
    "speed": "39",
    "total": "475",
    "weight": "65.9 lbs.",
    "height": "2'11\"",
    "dex1": "It has strong regenerative capabilities. Even if parts of it are bitten off by fish Pokémon, it will return to normal within a few hours.",
    "dex2": "Plankton, invisible to the naked eye, is its main food source. It comes onto the land periodically, but the reason for this is not known.",
    "class": "Sea Slug Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shellos",
    "egg-group1": "Water 1",
    "egg-group2": "Amorphous"
  },
  {
    "id": "424",
    "ndex": "424",
    "species": "Ambipom",
    "forme": "Ambipom",
    "type1": "Normal",
    "type2": "",
    "ability1": "Technician",
    "ability2": "Pickup",
    "abilityH": "Skill Link",
    "hp": "75",
    "attack": "100",
    "defense": "66",
    "spattack": "60",
    "spdefense": "66",
    "speed": "115",
    "total": "482",
    "weight": "44.8 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Long Tail Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Aipom",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "425",
    "ndex": "425",
    "species": "Drifloon",
    "forme": "Drifloon",
    "type1": "Ghost",
    "type2": "Flying",
    "ability1": "Aftermath",
    "ability2": "Unburden",
    "abilityH": "Flare Boost",
    "hp": "90",
    "attack": "50",
    "defense": "34",
    "spattack": "60",
    "spdefense": "44",
    "speed": "70",
    "total": "348",
    "weight": "2.6 lbs.",
    "height": "1'04\"",
    "dex1": "Stories go that it grabs the hands of small children and drags them away to the afterlife. It dislikes heavy children.",
    "dex2": "If for some reason its body bursts, its soul spills out with a screaming sound.",
    "class": "Balloon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "426",
    "ndex": "426",
    "species": "Drifblim",
    "forme": "Drifblim",
    "type1": "Ghost",
    "type2": "Flying",
    "ability1": "Aftermath",
    "ability2": "Unburden",
    "abilityH": "Flare Boost",
    "hp": "150",
    "attack": "80",
    "defense": "44",
    "spattack": "90",
    "spdefense": "54",
    "speed": "80",
    "total": "498",
    "weight": "33.1 lbs.",
    "height": "3'11\"",
    "dex1": "There was once an incident in which a man took a trip riding a Drifblim, only to go missing.",
    "dex2": "Even while under careful observation, large flocks of Drifblim flying at dusk will inexplicably disappear from view.",
    "class": "Blimp Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Drifloon",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "427",
    "ndex": "427",
    "species": "Buneary",
    "forme": "Buneary",
    "type1": "Normal",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Klutz",
    "abilityH": "Limber",
    "hp": "55",
    "attack": "66",
    "defense": "44",
    "spattack": "44",
    "spdefense": "56",
    "speed": "85",
    "total": "350",
    "weight": "12.1 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Rabbit Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "428",
    "ndex": "428",
    "species": "Lopunny",
    "forme": "Lopunny",
    "type1": "Normal",
    "type2": "",
    "ability1": "Cute Charm",
    "ability2": "Klutz",
    "abilityH": "Limber",
    "hp": "65",
    "attack": "76",
    "defense": "84",
    "spattack": "54",
    "spdefense": "96",
    "speed": "105",
    "total": "480",
    "weight": "73.4 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Rabbit Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Buneary",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "429",
    "ndex": "429",
    "species": "Mismagius",
    "forme": "Mismagius",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "60",
    "attack": "60",
    "defense": "60",
    "spattack": "105",
    "spdefense": "105",
    "speed": "105",
    "total": "495",
    "weight": "9.7 lbs.",
    "height": "2'11\"",
    "dex1": "It appears as if from nowhere—muttering incantations, placing curses, and giving people terrifying visions.",
    "dex2": "Mismagius have been known to cast spells to make people fall in love, so some people search for this Pokémon as if their life depended on it.",
    "class": "Magical Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Misdreavus",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "430",
    "ndex": "430",
    "species": "Honchkrow",
    "forme": "Honchkrow",
    "type1": "Dark",
    "type2": "Flying",
    "ability1": "Insomnia",
    "ability2": "Super Luck",
    "abilityH": "Moxie",
    "hp": "100",
    "attack": "125",
    "defense": "52",
    "spattack": "105",
    "spdefense": "52",
    "speed": "71",
    "total": "505",
    "weight": "60.2 lbs.",
    "height": "2'11\"",
    "dex1": "A single cry from this nocturnal Pokémon, and more than a hundred of its Murkrow cronies will assemble.",
    "dex2": "If its Murkrow cronies fail to catch food for it, or if it feels they have betrayed it, it will hunt them down wherever they are and punish them.",
    "class": "Big Boss Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Murkrow",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "431",
    "ndex": "431",
    "species": "Glameow",
    "forme": "Glameow",
    "type1": "Normal",
    "type2": "",
    "ability1": "Limber",
    "ability2": "Own Tempo",
    "abilityH": "Keen Eye",
    "hp": "49",
    "attack": "55",
    "defense": "42",
    "spattack": "42",
    "spdefense": "37",
    "speed": "85",
    "total": "310",
    "weight": "8.6 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Catty Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "432",
    "ndex": "432",
    "species": "Purugly",
    "forme": "Purugly",
    "type1": "Normal",
    "type2": "",
    "ability1": "Thick Fat",
    "ability2": "Own Tempo",
    "abilityH": "Defiant",
    "hp": "71",
    "attack": "82",
    "defense": "64",
    "spattack": "64",
    "spdefense": "59",
    "speed": "112",
    "total": "452",
    "weight": "96.6 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Tiger Cat Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "Glameow",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "433",
    "ndex": "433",
    "species": "Chingling",
    "forme": "Chingling",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "45",
    "attack": "30",
    "defense": "50",
    "spattack": "65",
    "spdefense": "50",
    "speed": "45",
    "total": "285",
    "weight": "1.3 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bell Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "434",
    "ndex": "434",
    "species": "Stunky",
    "forme": "Stunky",
    "type1": "Poison",
    "type2": "Dark",
    "ability1": "Stench",
    "ability2": "Aftermath",
    "abilityH": "Keen Eye",
    "hp": "63",
    "attack": "63",
    "defense": "47",
    "spattack": "41",
    "spdefense": "41",
    "speed": "74",
    "total": "329",
    "weight": "42.3 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Skunk Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "435",
    "ndex": "435",
    "species": "Skuntank",
    "forme": "Skuntank",
    "type1": "Poison",
    "type2": "Dark",
    "ability1": "Stench",
    "ability2": "Aftermath",
    "abilityH": "Keen Eye",
    "hp": "103",
    "attack": "93",
    "defense": "67",
    "spattack": "71",
    "spdefense": "61",
    "speed": "84",
    "total": "479",
    "weight": "83.8 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Skunk Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Stunky",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "436",
    "ndex": "436",
    "species": "Bronzor",
    "forme": "Bronzor",
    "type1": "Steel",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "Heatproof",
    "abilityH": "Heavy Metal",
    "hp": "57",
    "attack": "24",
    "defense": "86",
    "spattack": "24",
    "spdefense": "86",
    "speed": "23",
    "total": "300",
    "weight": "133.4 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bronze Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "437",
    "ndex": "437",
    "species": "Bronzong",
    "forme": "Bronzong",
    "type1": "Steel",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "Heatproof",
    "abilityH": "Heavy Metal",
    "hp": "67",
    "attack": "89",
    "defense": "116",
    "spattack": "79",
    "spdefense": "116",
    "speed": "33",
    "total": "500",
    "weight": "412.3 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Bronze Bell Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Bronzor",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "438",
    "ndex": "438",
    "species": "Bonsly",
    "forme": "Bonsly",
    "type1": "Rock",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "Rock Head",
    "abilityH": "Rattled",
    "hp": "50",
    "attack": "80",
    "defense": "95",
    "spattack": "10",
    "spdefense": "45",
    "speed": "10",
    "total": "290",
    "weight": "33.1 lbs.",
    "height": "1'08\"",
    "dex1": "It does not deal well with water, so it lives in dry locales. Since its surroundings tend to lack greenery, it stands out noticeably.",
    "dex2": "From its eyes, it can expel excess moisture from its body. This liquid is similar in composition to human sweat.",
    "class": "Bonsai Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "439",
    "ndex": "439",
    "species": "Mime Jr.",
    "forme": "Mime Jr.",
    "type1": "Psychic",
    "type2": "Fairy",
    "ability1": "Soundproof",
    "ability2": "Filter",
    "abilityH": "Technician",
    "hp": "20",
    "attack": "25",
    "defense": "45",
    "spattack": "70",
    "spdefense": "90",
    "speed": "60",
    "total": "310",
    "weight": "28.7 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Mime Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "440",
    "ndex": "440",
    "species": "Happiny",
    "forme": "Happiny",
    "type1": "Normal",
    "type2": "",
    "ability1": "Natural Cure",
    "ability2": "Serene Grace",
    "abilityH": "Friend Guard",
    "hp": "100",
    "attack": "5",
    "defense": "5",
    "spattack": "15",
    "spdefense": "65",
    "speed": "30",
    "total": "220",
    "weight": "53.8 lbs.",
    "height": "2'00\"",
    "dex1": "It carries a round white rock in its belly pouch. If it gets along well with someone, it will sometimes give that person the rock.",
    "dex2": "It’s too small to lay eggs yet. As a surrogate, it searches out round white stones.",
    "class": "Playhouse Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "441",
    "ndex": "441",
    "species": "Chatot",
    "forme": "Chatot",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Tangled Feet",
    "abilityH": "Big Pecks",
    "hp": "76",
    "attack": "65",
    "defense": "45",
    "spattack": "92",
    "spdefense": "42",
    "speed": "91",
    "total": "411",
    "weight": "4.2 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Music Note Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "442",
    "ndex": "442",
    "species": "Spiritomb",
    "forme": "Spiritomb",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Infiltrator",
    "hp": "50",
    "attack": "92",
    "defense": "108",
    "spattack": "92",
    "spdefense": "108",
    "speed": "35",
    "total": "485",
    "weight": "238.1 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Forbidden Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "443",
    "ndex": "443",
    "species": "Gible",
    "forme": "Gible",
    "type1": "Dragon",
    "type2": "Ground",
    "ability1": "Sand Veil",
    "ability2": "",
    "abilityH": "Rough Skin",
    "hp": "58",
    "attack": "70",
    "defense": "45",
    "spattack": "40",
    "spdefense": "45",
    "speed": "42",
    "total": "300",
    "weight": "45.2 lbs.",
    "height": "2'04\"",
    "dex1": "It lives in caves warmed by geothermal heat. Even so, when the weather gets cold, it will huddle close with others of its kind.",
    "dex2": "It skulks in caves, and when prey or an enemy passes by, it leaps out and chomps them. The force of its attack sometimes chips its teeth.",
    "class": "Land Shark Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "444",
    "ndex": "444",
    "species": "Gabite",
    "forme": "Gabite",
    "type1": "Dragon",
    "type2": "Ground",
    "ability1": "Sand Veil",
    "ability2": "",
    "abilityH": "Rough Skin",
    "hp": "68",
    "attack": "90",
    "defense": "65",
    "spattack": "50",
    "spdefense": "55",
    "speed": "82",
    "total": "410",
    "weight": "123.5 lbs.",
    "height": "4'07\"",
    "dex1": "In rare cases, it molts and sheds its scales. Medicine containing its scales as an ingredient will make a weary body feel invigorated.",
    "dex2": "Shiny objects are its passion. It can be found in its cave, scarcely moving, its gaze fixed on the jewels it’s amassed or Carbink it has caught.",
    "class": "Cave Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gible",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "445",
    "ndex": "445",
    "species": "Garchomp",
    "forme": "Garchomp",
    "type1": "Dragon",
    "type2": "Ground",
    "ability1": "Sand Veil",
    "ability2": "",
    "abilityH": "Rough Skin",
    "hp": "108",
    "attack": "130",
    "defense": "95",
    "spattack": "80",
    "spdefense": "85",
    "speed": "102",
    "total": "600",
    "weight": "209.4 lbs.",
    "height": "6'03\"",
    "dex1": "It can fly at speeds rivaling jet planes. It dives into flocks of bird Pokémon and gulps the entire flock down whole.",
    "dex2": "The protuberances on its head serve as sensors. It can even detect distant prey.",
    "class": "Mach Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gabite",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "446",
    "ndex": "446",
    "species": "Munchlax",
    "forme": "Munchlax",
    "type1": "Normal",
    "type2": "",
    "ability1": "Pickup",
    "ability2": "Thick Fat",
    "abilityH": "Gluttony",
    "hp": "135",
    "attack": "85",
    "defense": "40",
    "spattack": "40",
    "spdefense": "85",
    "speed": "5",
    "total": "390",
    "weight": "231.5 lbs.",
    "height": "2'00\"",
    "dex1": "It needs to consume its own weight in food every day. As far as flavor is concerned, it’s indifferent.",
    "dex2": "When it finds something that looks like it might be edible, it goes right ahead and swallows it whole. That’s why it gets fatter day by day.",
    "class": "Big Eater Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "447",
    "ndex": "447",
    "species": "Riolu",
    "forme": "Riolu",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Steadfast",
    "ability2": "Inner Focus",
    "abilityH": "Prankster",
    "hp": "40",
    "attack": "70",
    "defense": "40",
    "spattack": "35",
    "spdefense": "40",
    "speed": "60",
    "total": "285",
    "weight": "44.5 lbs.",
    "height": "2'04\"",
    "dex1": "It can discern the physical and emotional states of people, Pokémon, and other natural things from the shape of their aura waves.",
    "dex2": "It’s tough enough to run right through the night, and it’s also a hard worker, but it’s still just a youngster.",
    "class": "Emanation Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "448",
    "ndex": "448",
    "species": "Lucario",
    "forme": "Lucario",
    "type1": "Fighting",
    "type2": "Steel",
    "ability1": "Steadfast",
    "ability2": "Inner Focus",
    "abilityH": "Justified",
    "hp": "70",
    "attack": "110",
    "defense": "70",
    "spattack": "115",
    "spdefense": "70",
    "speed": "90",
    "total": "525",
    "weight": "119.0 lbs.",
    "height": "3'11\"",
    "dex1": "Not only does it perceive auras, but it has also gained the power to control them. It employs them in battle.",
    "dex2": "They can detect the species of a living being— and its emotions—from over half a mile away. They control auras and hunt their prey in packs.",
    "class": "Aura Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Riolu",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "449",
    "ndex": "449",
    "species": "Hippopotas",
    "forme": "Hippopotas",
    "type1": "Ground",
    "type2": "",
    "ability1": "Sand Stream",
    "ability2": "",
    "abilityH": "Sand Force",
    "hp": "68",
    "attack": "72",
    "defense": "78",
    "spattack": "38",
    "spdefense": "42",
    "speed": "32",
    "total": "330",
    "weight": "109.1 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Hippo Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "450",
    "ndex": "450",
    "species": "Hippowdon",
    "forme": "Hippowdon",
    "type1": "Ground",
    "type2": "",
    "ability1": "Sand Stream",
    "ability2": "",
    "abilityH": "Sand Force",
    "hp": "108",
    "attack": "112",
    "defense": "118",
    "spattack": "68",
    "spdefense": "72",
    "speed": "47",
    "total": "525",
    "weight": "661.4 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Heavyweight Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Hippopotas",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "451",
    "ndex": "451",
    "species": "Skorupi",
    "forme": "Skorupi",
    "type1": "Poison",
    "type2": "Bug",
    "ability1": "Battle Armor",
    "ability2": "Sniper",
    "abilityH": "Keen Eye",
    "hp": "40",
    "attack": "50",
    "defense": "90",
    "spattack": "30",
    "spdefense": "55",
    "speed": "65",
    "total": "330",
    "weight": "26.5 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Scorpion Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": "Water 3"
  },
  {
    "id": "452",
    "ndex": "452",
    "species": "Drapion",
    "forme": "Drapion",
    "type1": "Poison",
    "type2": "Dark",
    "ability1": "Battle Armor",
    "ability2": "Sniper",
    "abilityH": "Keen Eye",
    "hp": "70",
    "attack": "90",
    "defense": "110",
    "spattack": "60",
    "spdefense": "75",
    "speed": "95",
    "total": "500",
    "weight": "135.6 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Ogre Scorpion Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Skorupi",
    "egg-group1": "Bug",
    "egg-group2": "Water 3"
  },
  {
    "id": "453",
    "ndex": "453",
    "species": "Croagunk",
    "forme": "Croagunk",
    "type1": "Poison",
    "type2": "Fighting",
    "ability1": "Anticipation",
    "ability2": "Dry Skin",
    "abilityH": "Poison Touch",
    "hp": "48",
    "attack": "61",
    "defense": "40",
    "spattack": "61",
    "spdefense": "40",
    "speed": "50",
    "total": "300",
    "weight": "50.7 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Toxic Mouth Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "454",
    "ndex": "454",
    "species": "Toxicroak",
    "forme": "Toxicroak",
    "type1": "Poison",
    "type2": "Fighting",
    "ability1": "Anticipation",
    "ability2": "Dry Skin",
    "abilityH": "Poison Touch",
    "hp": "83",
    "attack": "106",
    "defense": "65",
    "spattack": "86",
    "spdefense": "65",
    "speed": "85",
    "total": "490",
    "weight": "97.9 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Toxic Mouth Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Croagunk",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "455",
    "ndex": "455",
    "species": "Carnivine",
    "forme": "Carnivine",
    "type1": "Grass",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "74",
    "attack": "100",
    "defense": "72",
    "spattack": "90",
    "spdefense": "72",
    "speed": "46",
    "total": "454",
    "weight": "59.5 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Bug Catcher Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "456",
    "ndex": "456",
    "species": "Finneon",
    "forme": "Finneon",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "Storm Drain",
    "abilityH": "Water Veil",
    "hp": "49",
    "attack": "49",
    "defense": "56",
    "spattack": "49",
    "spdefense": "61",
    "speed": "66",
    "total": "330",
    "weight": "15.4 lbs.",
    "height": "1'04\"",
    "dex1": "It absorbs sunlight with the pink areas of its skin, which then shine. This appears to be a form of camouflage.",
    "dex2": "Its double tail fins propel its energetic jumps. When it breaks the surface of the sea, Wingull swoop down to grab it on the fly.",
    "class": "Wing Fish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "457",
    "ndex": "457",
    "species": "Lumineon",
    "forme": "Lumineon",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "Storm Drain",
    "abilityH": "Water Veil",
    "hp": "69",
    "attack": "69",
    "defense": "76",
    "spattack": "69",
    "spdefense": "86",
    "speed": "91",
    "total": "460",
    "weight": "52.9 lbs.",
    "height": "3'11\"",
    "dex1": "With its shining light, it lures its prey close. However, the light also happens to attract ferocious fish Pokémon—its natural predators.",
    "dex2": "This deep-sea Pokémon lives at the bottom of the sea. Its fins haul it over the seabed in search of its favorite food—Starmie.",
    "class": "Neon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Finneon",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "458",
    "ndex": "458",
    "species": "Mantyke",
    "forme": "Mantyke",
    "type1": "Water",
    "type2": "Flying",
    "ability1": "Swift Swim",
    "ability2": "Water Absorb",
    "abilityH": "Water Veil",
    "hp": "45",
    "attack": "20",
    "defense": "50",
    "spattack": "60",
    "spdefense": "120",
    "speed": "50",
    "total": "345",
    "weight": "143.3 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Kite Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "459",
    "ndex": "459",
    "species": "Snover",
    "forme": "Snover",
    "type1": "Grass",
    "type2": "Ice",
    "ability1": "Snow Warning",
    "ability2": "",
    "abilityH": "Soundproof",
    "hp": "60",
    "attack": "62",
    "defense": "50",
    "spattack": "62",
    "spdefense": "60",
    "speed": "40",
    "total": "334",
    "weight": "111.3 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Frost Tree Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "460",
    "ndex": "460",
    "species": "Abomasnow",
    "forme": "Abomasnow",
    "type1": "Grass",
    "type2": "Ice",
    "ability1": "Snow Warning",
    "ability2": "",
    "abilityH": "Soundproof",
    "hp": "90",
    "attack": "92",
    "defense": "75",
    "spattack": "92",
    "spdefense": "85",
    "speed": "60",
    "total": "494",
    "weight": "298.7 lbs.",
    "height": "7'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Frost Tree Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Snover",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "461",
    "ndex": "461",
    "species": "Weavile",
    "forme": "Weavile",
    "type1": "Dark",
    "type2": "Ice",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Pickpocket",
    "hp": "70",
    "attack": "120",
    "defense": "65",
    "spattack": "45",
    "spdefense": "85",
    "speed": "125",
    "total": "510",
    "weight": "75.0 lbs.",
    "height": "3'07\"",
    "dex1": "They travel in groups of four or five, leaving signs for one another on trees and rocks. They bring down their prey with coordinated attacks.",
    "dex2": "They dwell in cold places. This Pokémon’s main food source in Alola is Vulpix and Sandshrew, which they carefully divide among their group.",
    "class": "Sharp Claw Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sneasel",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "462",
    "ndex": "462",
    "species": "Magnezone",
    "forme": "Magnezone",
    "type1": "Electric",
    "type2": "Steel",
    "ability1": "Magnet Pull",
    "ability2": "Sturdy",
    "abilityH": "Analytic",
    "hp": "70",
    "attack": "70",
    "defense": "115",
    "spattack": "130",
    "spdefense": "90",
    "speed": "60",
    "total": "535",
    "weight": "396.8 lbs.",
    "height": "3'11\"",
    "dex1": "Three units generate magnetism. There have been many mistaken reports of UFO sightings when Magnezone flies through the night sky.",
    "dex2": "As it zooms through the sky, this Pokémon seems to be receiving signals of unknown origin, while transmitting signals of unknown purpose.",
    "class": "Magnet Area Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Magneton",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "463",
    "ndex": "463",
    "species": "Lickilicky",
    "forme": "Lickilicky",
    "type1": "Normal",
    "type2": "",
    "ability1": "Own Tempo",
    "ability2": "Oblivious",
    "abilityH": "Cloud Nine",
    "hp": "110",
    "attack": "85",
    "defense": "95",
    "spattack": "80",
    "spdefense": "95",
    "speed": "50",
    "total": "515",
    "weight": "308.6 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Licking Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Lickitung",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "464",
    "ndex": "464",
    "species": "Rhyperior",
    "forme": "Rhyperior",
    "type1": "Ground",
    "type2": "Rock",
    "ability1": "Lightning Rod",
    "ability2": "Solid Rock",
    "abilityH": "Reckless",
    "hp": "115",
    "attack": "140",
    "defense": "130",
    "spattack": "55",
    "spdefense": "55",
    "speed": "40",
    "total": "535",
    "weight": "623.5 lbs.",
    "height": "7'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Drill Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Rhydon",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "465",
    "ndex": "465",
    "species": "Tangrowth",
    "forme": "Tangrowth",
    "type1": "Grass",
    "type2": "",
    "ability1": "Chlorophyll",
    "ability2": "Leaf Guard",
    "abilityH": "Regenerator",
    "hp": "100",
    "attack": "100",
    "defense": "125",
    "spattack": "110",
    "spdefense": "50",
    "speed": "50",
    "total": "535",
    "weight": "283.5 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Vine Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Tangela",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "466",
    "ndex": "466",
    "species": "Electivire",
    "forme": "Electivire",
    "type1": "Electric",
    "type2": "",
    "ability1": "Motor Drive",
    "ability2": "",
    "abilityH": "Vital Spirit",
    "hp": "75",
    "attack": "123",
    "defense": "67",
    "spattack": "95",
    "spdefense": "85",
    "speed": "95",
    "total": "540",
    "weight": "305.6 lbs.",
    "height": "5'11\"",
    "dex1": "It pushes the tips of its tails against its foes and then lets loose a high-voltage current. Its foes are burned to a crisp in an instant.",
    "dex2": "When it gets excited, it thumps its chest. With every thud, thunder roars and electric sparks shower all around.",
    "class": "Thunderbolt Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Electabuzz",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "467",
    "ndex": "467",
    "species": "Magmortar",
    "forme": "Magmortar",
    "type1": "Fire",
    "type2": "",
    "ability1": "Flame Body",
    "ability2": "",
    "abilityH": "Vital Spirit",
    "hp": "75",
    "attack": "95",
    "defense": "67",
    "spattack": "125",
    "spdefense": "95",
    "speed": "83",
    "total": "540",
    "weight": "149.9 lbs.",
    "height": "5'03\"",
    "dex1": "They dwell in volcanic craters. According to what is known, a single pair of male and female Magmortar lives in one volcano.",
    "dex2": "From its arm, it launches fireballs hotter than 3,500 degrees Fahrenheit. Its arm starts to melt when it fires a whole barrage.",
    "class": "Blast Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Magmar",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "468",
    "ndex": "468",
    "species": "Togekiss",
    "forme": "Togekiss",
    "type1": "Fairy",
    "type2": "Flying",
    "ability1": "Hustle",
    "ability2": "Serene Grace",
    "abilityH": "Super Luck",
    "hp": "85",
    "attack": "50",
    "defense": "95",
    "spattack": "120",
    "spdefense": "115",
    "speed": "80",
    "total": "545",
    "weight": "83.8 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Jubilee Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Togetic",
    "egg-group1": "Flying",
    "egg-group2": "Fairy"
  },
  {
    "id": "469",
    "ndex": "469",
    "species": "Yanmega",
    "forme": "Yanmega",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Speed Boost",
    "ability2": "Tinted Lens",
    "abilityH": "Frisk",
    "hp": "86",
    "attack": "76",
    "defense": "86",
    "spattack": "116",
    "spdefense": "56",
    "speed": "95",
    "total": "515",
    "weight": "113.5 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Ogre Darner Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Yanma",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "470",
    "ndex": "470",
    "species": "Leafeon",
    "forme": "Leafeon",
    "type1": "Grass",
    "type2": "",
    "ability1": "Leaf Guard",
    "ability2": "",
    "abilityH": "Chlorophyll",
    "hp": "65",
    "attack": "110",
    "defense": "130",
    "spattack": "60",
    "spdefense": "65",
    "speed": "95",
    "total": "525",
    "weight": "56.2 lbs.",
    "height": "3'03\"",
    "dex1": "Its cellular composition is closer to that of a plant than an animal. It uses photosynthesis to produce its energy supply without eating food.",
    "dex2": "The younger they are, the more they smell like fresh grass. With age, their fragrance takes on the odor of fallen leaves.",
    "class": "Verdant Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Eevee",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "471",
    "ndex": "471",
    "species": "Glaceon",
    "forme": "Glaceon",
    "type1": "Ice",
    "type2": "",
    "ability1": "Snow Cloak",
    "ability2": "",
    "abilityH": "Ice Body",
    "hp": "65",
    "attack": "60",
    "defense": "110",
    "spattack": "130",
    "spdefense": "95",
    "speed": "65",
    "total": "525",
    "weight": "57.1 lbs.",
    "height": "2'07\"",
    "dex1": "It can control its body temperature at will. This enables it to freeze the moisture in the atmosphere, creating flurries of diamond dust.",
    "dex2": "It freezes its fur into icicles, spiky and sharp, and tackles its prey.",
    "class": "Fresh Snow Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Eevee",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "472",
    "ndex": "472",
    "species": "Gliscor",
    "forme": "Gliscor",
    "type1": "Ground",
    "type2": "Flying",
    "ability1": "Hyper Cutter",
    "ability2": "Sand Veil",
    "abilityH": "Poison Heal",
    "hp": "75",
    "attack": "95",
    "defense": "125",
    "spattack": "45",
    "spdefense": "75",
    "speed": "95",
    "total": "510",
    "weight": "93.7 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Fang Scorpion Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gligar",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "473",
    "ndex": "473",
    "species": "Mamoswine",
    "forme": "Mamoswine",
    "type1": "Ice",
    "type2": "Ground",
    "ability1": "Oblivious",
    "ability2": "Snow Cloak",
    "abilityH": "Thick Fat",
    "hp": "110",
    "attack": "130",
    "defense": "80",
    "spattack": "70",
    "spdefense": "60",
    "speed": "80",
    "total": "530",
    "weight": "641.5 lbs.",
    "height": "8'02\"",
    "dex1": "",
    "dex2": "",
    "class": "Twin Tusk Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Piloswine",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "474",
    "ndex": "474",
    "species": "Porygon-Z",
    "forme": "Porygon-Z",
    "type1": "Normal",
    "type2": "",
    "ability1": "Adaptability",
    "ability2": "Download",
    "abilityH": "Analytic",
    "hp": "85",
    "attack": "80",
    "defense": "70",
    "spattack": "135",
    "spdefense": "75",
    "speed": "90",
    "total": "535",
    "weight": "75.0 lbs.",
    "height": "2'11\"",
    "dex1": "In order to create a more advanced Pokémon, an additional program was installed, but apparently it contained a defect that makes it move oddly.",
    "dex2": "Its program was modified to facilitate extra-dimensional activities, but that led to noticeably strange behavior.",
    "class": "Virtual Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Porygon2",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "475",
    "ndex": "475",
    "species": "Gallade",
    "forme": "Gallade",
    "type1": "Psychic",
    "type2": "Fighting",
    "ability1": "Steadfast",
    "ability2": "",
    "abilityH": "Justified",
    "hp": "68",
    "attack": "125",
    "defense": "65",
    "spattack": "65",
    "spdefense": "115",
    "speed": "80",
    "total": "518",
    "weight": "114.6 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Blade Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Kirlia",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "476",
    "ndex": "476",
    "species": "Probopass",
    "forme": "Probopass",
    "type1": "Rock",
    "type2": "Steel",
    "ability1": "Sturdy",
    "ability2": "Magnet Pull",
    "abilityH": "Sand Force",
    "hp": "60",
    "attack": "55",
    "defense": "145",
    "spattack": "75",
    "spdefense": "150",
    "speed": "40",
    "total": "525",
    "weight": "749.6 lbs.",
    "height": "4'07\"",
    "dex1": "It radiates such a powerful magnetic field that nearby electrical appliances become unusable.",
    "dex2": "The main body controls three mobile units called Mini-Noses, which it maneuvers to catch prey.",
    "class": "Compass Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Nosepass",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "477",
    "ndex": "477",
    "species": "Dusknoir",
    "forme": "Dusknoir",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Frisk",
    "hp": "45",
    "attack": "100",
    "defense": "135",
    "spattack": "65",
    "spdefense": "135",
    "speed": "45",
    "total": "525",
    "weight": "235.0 lbs.",
    "height": "7'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Gripper Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Dusclops",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "478",
    "ndex": "478",
    "species": "Froslass",
    "forme": "Froslass",
    "type1": "Ice",
    "type2": "Ghost",
    "ability1": "Snow Cloak",
    "ability2": "",
    "abilityH": "Cursed Body",
    "hp": "70",
    "attack": "80",
    "defense": "70",
    "spattack": "80",
    "spdefense": "70",
    "speed": "110",
    "total": "480",
    "weight": "58.6 lbs.",
    "height": "4'03\"",
    "dex1": "When it finds humans or Pokémon it likes, it freezes them and takes them to its chilly den, where they become decorations.",
    "dex2": "The soul of a woman lost on a snowy mountain possessed an icicle, becoming this Pokémon. The food it most relishes is the souls of men.",
    "class": "Snow Land Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Snorunt",
    "egg-group1": "Fairy",
    "egg-group2": "Mineral"
  },
  {
    "id": "479",
    "ndex": "479",
    "species": "Rotom",
    "forme": "Rotom (Rotom)",
    "type1": "Electric",
    "type2": "Ghost",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "50",
    "defense": "77",
    "spattack": "95",
    "spdefense": "77",
    "speed": "91",
    "total": "440",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Plasma Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "480",
    "ndex": "480",
    "species": "Uxie",
    "forme": "Uxie",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "75",
    "defense": "130",
    "spattack": "75",
    "spdefense": "130",
    "speed": "95",
    "total": "580",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Knowledge Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "481",
    "ndex": "481",
    "species": "Mesprit",
    "forme": "Mesprit",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "105",
    "defense": "105",
    "spattack": "105",
    "spdefense": "105",
    "speed": "80",
    "total": "580",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Emotion Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "482",
    "ndex": "482",
    "species": "Azelf",
    "forme": "Azelf",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "125",
    "defense": "70",
    "spattack": "125",
    "spdefense": "70",
    "speed": "115",
    "total": "580",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Willpower Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "483",
    "ndex": "483",
    "species": "Dialga",
    "forme": "Dialga",
    "type1": "Steel",
    "type2": "Dragon",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Telepathy",
    "hp": "100",
    "attack": "120",
    "defense": "120",
    "spattack": "150",
    "spdefense": "100",
    "speed": "90",
    "total": "680",
    "weight": "1505.8 lbs.",
    "height": "17'09\"",
    "dex1": "",
    "dex2": "",
    "class": "Temporal Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "484",
    "ndex": "484",
    "species": "Palkia",
    "forme": "Palkia",
    "type1": "Water",
    "type2": "Dragon",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Telepathy",
    "hp": "90",
    "attack": "120",
    "defense": "100",
    "spattack": "150",
    "spdefense": "120",
    "speed": "100",
    "total": "680",
    "weight": "740.8 lbs.",
    "height": "13'09\"",
    "dex1": "",
    "dex2": "",
    "class": "Spatial Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "485",
    "ndex": "485",
    "species": "Heatran",
    "forme": "Heatran",
    "type1": "Fire",
    "type2": "Steel",
    "ability1": "Flash Fire",
    "ability2": "",
    "abilityH": "Flame Body",
    "hp": "91",
    "attack": "90",
    "defense": "106",
    "spattack": "130",
    "spdefense": "106",
    "speed": "77",
    "total": "600",
    "weight": "948.0 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Lava Dome Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "486",
    "ndex": "486",
    "species": "Regigigas",
    "forme": "Regigigas",
    "type1": "Normal",
    "type2": "",
    "ability1": "Slow Start",
    "ability2": "",
    "abilityH": "",
    "hp": "110",
    "attack": "160",
    "defense": "110",
    "spattack": "80",
    "spdefense": "110",
    "speed": "100",
    "total": "670",
    "weight": "925.9 lbs.",
    "height": "12'02\"",
    "dex1": "",
    "dex2": "",
    "class": "Colossal Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "487",
    "ndex": "487",
    "species": "Giratina",
    "forme": "Giratina (Altered Forme)",
    "type1": "Ghost",
    "type2": "Dragon",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "Telepathy",
    "hp": "150",
    "attack": "100",
    "defense": "120",
    "spattack": "100",
    "spdefense": "120",
    "speed": "90",
    "total": "680",
    "weight": "1653.5 lbs.",
    "height": "14'09\"",
    "dex1": "",
    "dex2": "",
    "class": "Renegade Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "488",
    "ndex": "488",
    "species": "Cresselia",
    "forme": "Cresselia",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "70",
    "defense": "120",
    "spattack": "75",
    "spdefense": "130",
    "speed": "85",
    "total": "600",
    "weight": "188.7 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Lunar Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "489",
    "ndex": "489",
    "species": "Phione",
    "forme": "Phione",
    "type1": "Water",
    "type2": "",
    "ability1": "Hydration",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "80",
    "defense": "80",
    "spattack": "80",
    "spdefense": "80",
    "speed": "80",
    "total": "480",
    "weight": "6.8 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Sea Drifter Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Fairy"
  },
  {
    "id": "490",
    "ndex": "490",
    "species": "Manaphy",
    "forme": "Manaphy",
    "type1": "Water",
    "type2": "",
    "ability1": "Hydration",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "100",
    "defense": "100",
    "spattack": "100",
    "spdefense": "100",
    "speed": "100",
    "total": "600",
    "weight": "3.1 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Seafaring Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Fairy"
  },
  {
    "id": "491",
    "ndex": "491",
    "species": "Darkrai",
    "forme": "Darkrai",
    "type1": "Dark",
    "type2": "",
    "ability1": "Bad Dreams",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "90",
    "defense": "90",
    "spattack": "135",
    "spdefense": "90",
    "speed": "125",
    "total": "600",
    "weight": "111.3 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Pitch-Black Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "492",
    "ndex": "492",
    "species": "Shaymin",
    "forme": "Shaymin (Land Forme)",
    "type1": "Grass",
    "type2": "",
    "ability1": "Natural Cure",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "100",
    "defense": "100",
    "spattack": "100",
    "spdefense": "100",
    "speed": "100",
    "total": "600",
    "weight": "4.6 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Gratitude Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "493",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Normal)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "494",
    "ndex": "494",
    "species": "Victini",
    "forme": "Victini",
    "type1": "Psychic",
    "type2": "Fire",
    "ability1": "Victory Star",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "100",
    "defense": "100",
    "spattack": "100",
    "spdefense": "100",
    "speed": "100",
    "total": "600",
    "weight": "8.8 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Victory Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "495",
    "ndex": "495",
    "species": "Snivy",
    "forme": "Snivy",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Contrary",
    "hp": "45",
    "attack": "45",
    "defense": "55",
    "spattack": "45",
    "spdefense": "55",
    "speed": "63",
    "total": "308",
    "weight": "17.9 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Grass Snake Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Grass"
  },
  {
    "id": "496",
    "ndex": "496",
    "species": "Servine",
    "forme": "Servine",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Contrary",
    "hp": "60",
    "attack": "60",
    "defense": "75",
    "spattack": "60",
    "spdefense": "75",
    "speed": "83",
    "total": "413",
    "weight": "35.3 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Grass Snake Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Snivy",
    "egg-group1": "Field",
    "egg-group2": "Grass"
  },
  {
    "id": "497",
    "ndex": "497",
    "species": "Serperior",
    "forme": "Serperior",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Contrary",
    "hp": "75",
    "attack": "75",
    "defense": "95",
    "spattack": "75",
    "spdefense": "95",
    "speed": "113",
    "total": "528",
    "weight": "138.9 lbs.",
    "height": "10'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Regal Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Servine",
    "egg-group1": "Field",
    "egg-group2": "Grass"
  },
  {
    "id": "498",
    "ndex": "498",
    "species": "Tepig",
    "forme": "Tepig",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Thick Fat",
    "hp": "65",
    "attack": "63",
    "defense": "45",
    "spattack": "45",
    "spdefense": "45",
    "speed": "45",
    "total": "308",
    "weight": "21.8 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Fire Pig Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "499",
    "ndex": "499",
    "species": "Pignite",
    "forme": "Pignite",
    "type1": "Fire",
    "type2": "Fighting",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Thick Fat",
    "hp": "90",
    "attack": "93",
    "defense": "55",
    "spattack": "70",
    "spdefense": "55",
    "speed": "55",
    "total": "418",
    "weight": "122.4 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Fire Pig Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Tepig",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "500",
    "ndex": "500",
    "species": "Emboar",
    "forme": "Emboar",
    "type1": "Fire",
    "type2": "Fighting",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Reckless",
    "hp": "110",
    "attack": "123",
    "defense": "65",
    "spattack": "100",
    "spdefense": "65",
    "speed": "65",
    "total": "528",
    "weight": "330.7 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Mega Fire Pig Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Pignite",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "501",
    "ndex": "501",
    "species": "Oshawott",
    "forme": "Oshawott",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Shell Armor",
    "hp": "55",
    "attack": "55",
    "defense": "45",
    "spattack": "63",
    "spdefense": "45",
    "speed": "45",
    "total": "308",
    "weight": "13.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Sea Otter Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "502",
    "ndex": "502",
    "species": "Dewott",
    "forme": "Dewott",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Shell Armor",
    "hp": "75",
    "attack": "75",
    "defense": "60",
    "spattack": "83",
    "spdefense": "60",
    "speed": "60",
    "total": "413",
    "weight": "54.0 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Discipline Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Oshawott",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "503",
    "ndex": "503",
    "species": "Samurott",
    "forme": "Samurott",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Shell Armor",
    "hp": "95",
    "attack": "100",
    "defense": "85",
    "spattack": "108",
    "spdefense": "70",
    "speed": "70",
    "total": "528",
    "weight": "208.6 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Formidable Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Dewott",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "504",
    "ndex": "504",
    "species": "Patrat",
    "forme": "Patrat",
    "type1": "Normal",
    "type2": "",
    "ability1": "Run Away",
    "ability2": "Keen Eye",
    "abilityH": "Analytic",
    "hp": "45",
    "attack": "55",
    "defense": "39",
    "spattack": "35",
    "spdefense": "39",
    "speed": "42",
    "total": "255",
    "weight": "25.6 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Scout Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "505",
    "ndex": "505",
    "species": "Watchog",
    "forme": "Watchog",
    "type1": "Normal",
    "type2": "",
    "ability1": "Illuminate",
    "ability2": "Keen Eye",
    "abilityH": "Analytic",
    "hp": "60",
    "attack": "85",
    "defense": "69",
    "spattack": "60",
    "spdefense": "69",
    "speed": "77",
    "total": "420",
    "weight": "59.5 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Lookout Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Patrat",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "506",
    "ndex": "506",
    "species": "Lillipup",
    "forme": "Lillipup",
    "type1": "Normal",
    "type2": "",
    "ability1": "Vital Spirit",
    "ability2": "Pickup",
    "abilityH": "Run Away",
    "hp": "45",
    "attack": "60",
    "defense": "45",
    "spattack": "25",
    "spdefense": "45",
    "speed": "55",
    "total": "275",
    "weight": "9.0 lbs.",
    "height": "1'04\"",
    "dex1": "Because it doesn’t yelp, it’s extremely popular with Trainers who live in apartment buildings.",
    "dex2": "The long fur surrounding its face functions as radar, enabling it to probe the condition of its battle opponents.",
    "class": "Puppy Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "507",
    "ndex": "507",
    "species": "Herdier",
    "forme": "Herdier",
    "type1": "Normal",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Sand Rush",
    "abilityH": "Scrappy",
    "hp": "65",
    "attack": "80",
    "defense": "65",
    "spattack": "35",
    "spdefense": "65",
    "speed": "60",
    "total": "370",
    "weight": "32.4 lbs.",
    "height": "2'11\"",
    "dex1": "Its dense black fur grows continuously. The high cost of keeping its hard fur properly groomed makes this a troublesome Pokémon to train.",
    "dex2": "This Pokémon obeys its master’s orders faithfully. However, it refuses to listen to anything said by a person it doesn’t respect.",
    "class": "Loyal Dog Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Lillipup",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "508",
    "ndex": "508",
    "species": "Stoutland",
    "forme": "Stoutland",
    "type1": "Normal",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "Sand Rush",
    "abilityH": "Scrappy",
    "hp": "85",
    "attack": "110",
    "defense": "90",
    "spattack": "45",
    "spdefense": "90",
    "speed": "80",
    "total": "500",
    "weight": "134.5 lbs.",
    "height": "3'11\"",
    "dex1": "Intelligent, good-natured, and valiant, it’s a trustworthy partner on rescue teams.",
    "dex2": "With this wise Pokémon, there could be no concern that it would ever attack people. Some parents even trust it to babysit.",
    "class": "Big-Hearted Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Herdier",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "509",
    "ndex": "509",
    "species": "Purrloin",
    "forme": "Purrloin",
    "type1": "Dark",
    "type2": "",
    "ability1": "Limber",
    "ability2": "Unburden",
    "abilityH": "Prankster",
    "hp": "41",
    "attack": "50",
    "defense": "37",
    "spattack": "50",
    "spdefense": "37",
    "speed": "66",
    "total": "281",
    "weight": "22.3 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Devious Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "510",
    "ndex": "510",
    "species": "Liepard",
    "forme": "Liepard",
    "type1": "Dark",
    "type2": "",
    "ability1": "Limber",
    "ability2": "Unburden",
    "abilityH": "Prankster",
    "hp": "64",
    "attack": "88",
    "defense": "50",
    "spattack": "88",
    "spdefense": "50",
    "speed": "106",
    "total": "446",
    "weight": "82.7 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Cruel Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Purrloin",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "511",
    "ndex": "511",
    "species": "Pansage",
    "forme": "Pansage",
    "type1": "Grass",
    "type2": "",
    "ability1": "Gluttony",
    "ability2": "",
    "abilityH": "Overgrow",
    "hp": "50",
    "attack": "53",
    "defense": "48",
    "spattack": "53",
    "spdefense": "48",
    "speed": "64",
    "total": "316",
    "weight": "23.1 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Grass Monkey Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "512",
    "ndex": "512",
    "species": "Simisage",
    "forme": "Simisage",
    "type1": "Grass",
    "type2": "",
    "ability1": "Gluttony",
    "ability2": "",
    "abilityH": "Overgrow",
    "hp": "75",
    "attack": "98",
    "defense": "63",
    "spattack": "98",
    "spdefense": "63",
    "speed": "101",
    "total": "498",
    "weight": "67.2 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Thorn Monkey Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Pansage",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "513",
    "ndex": "513",
    "species": "Pansear",
    "forme": "Pansear",
    "type1": "Fire",
    "type2": "",
    "ability1": "Gluttony",
    "ability2": "",
    "abilityH": "Blaze",
    "hp": "50",
    "attack": "53",
    "defense": "48",
    "spattack": "53",
    "spdefense": "48",
    "speed": "64",
    "total": "316",
    "weight": "24.3 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "High Temp Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "514",
    "ndex": "514",
    "species": "Simisear",
    "forme": "Simisear",
    "type1": "Fire",
    "type2": "",
    "ability1": "Gluttony",
    "ability2": "",
    "abilityH": "Blaze",
    "hp": "75",
    "attack": "98",
    "defense": "63",
    "spattack": "98",
    "spdefense": "63",
    "speed": "101",
    "total": "498",
    "weight": "61.7 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Ember Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Pansear",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "515",
    "ndex": "515",
    "species": "Panpour",
    "forme": "Panpour",
    "type1": "Water",
    "type2": "",
    "ability1": "Gluttony",
    "ability2": "",
    "abilityH": "Torrent",
    "hp": "50",
    "attack": "53",
    "defense": "48",
    "spattack": "53",
    "spdefense": "48",
    "speed": "64",
    "total": "316",
    "weight": "29.8 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Spray Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "516",
    "ndex": "516",
    "species": "Simipour",
    "forme": "Simipour",
    "type1": "Water",
    "type2": "",
    "ability1": "Gluttony",
    "ability2": "",
    "abilityH": "Torrent",
    "hp": "75",
    "attack": "98",
    "defense": "63",
    "spattack": "98",
    "spdefense": "63",
    "speed": "101",
    "total": "498",
    "weight": "63.9 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Geyser Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Panpour",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "517",
    "ndex": "517",
    "species": "Munna",
    "forme": "Munna",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Forewarn",
    "ability2": "Synchronize",
    "abilityH": "Telepathy",
    "hp": "76",
    "attack": "25",
    "defense": "45",
    "spattack": "67",
    "spdefense": "55",
    "speed": "24",
    "total": "292",
    "weight": "51.4 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Dream Eater Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "518",
    "ndex": "518",
    "species": "Musharna",
    "forme": "Musharna",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Forewarn",
    "ability2": "Synchronize",
    "abilityH": "Telepathy",
    "hp": "116",
    "attack": "55",
    "defense": "85",
    "spattack": "107",
    "spdefense": "95",
    "speed": "29",
    "total": "487",
    "weight": "133.4 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Drowsing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Munna",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "519",
    "ndex": "519",
    "species": "Pidove",
    "forme": "Pidove",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Big Pecks",
    "ability2": "Super Luck",
    "abilityH": "Rivalry",
    "hp": "50",
    "attack": "55",
    "defense": "50",
    "spattack": "36",
    "spdefense": "30",
    "speed": "43",
    "total": "264",
    "weight": "4.6 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Tiny Pigeon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "520",
    "ndex": "520",
    "species": "Tranquill",
    "forme": "Tranquill",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Big Pecks",
    "ability2": "Super Luck",
    "abilityH": "Rivalry",
    "hp": "62",
    "attack": "77",
    "defense": "62",
    "spattack": "50",
    "spdefense": "42",
    "speed": "65",
    "total": "358",
    "weight": "33.1 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Wild Pigeon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pidove",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "521",
    "ndex": "521",
    "species": "Unfezant",
    "forme": "Unfezant",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Big Pecks",
    "ability2": "Super Luck",
    "abilityH": "Rivalry",
    "hp": "80",
    "attack": "115",
    "defense": "80",
    "spattack": "65",
    "spdefense": "55",
    "speed": "93",
    "total": "488",
    "weight": "63.9 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Proud Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Tranquill",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "522",
    "ndex": "522",
    "species": "Blitzle",
    "forme": "Blitzle",
    "type1": "Electric",
    "type2": "",
    "ability1": "Lightning Rod",
    "ability2": "Motor Drive",
    "abilityH": "Sap Sipper",
    "hp": "45",
    "attack": "60",
    "defense": "32",
    "spattack": "50",
    "spdefense": "32",
    "speed": "76",
    "total": "295",
    "weight": "65.7 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Electrified Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "523",
    "ndex": "523",
    "species": "Zebstrika",
    "forme": "Zebstrika",
    "type1": "Electric",
    "type2": "",
    "ability1": "Lightning Rod",
    "ability2": "Motor Drive",
    "abilityH": "Sap Sipper",
    "hp": "75",
    "attack": "100",
    "defense": "63",
    "spattack": "80",
    "spdefense": "63",
    "speed": "116",
    "total": "497",
    "weight": "175.3 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Thunderbolt Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Blitzle",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "524",
    "ndex": "524",
    "species": "Roggenrola",
    "forme": "Roggenrola",
    "type1": "Rock",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "Weak Armor",
    "abilityH": "Sand Force",
    "hp": "55",
    "attack": "75",
    "defense": "85",
    "spattack": "25",
    "spdefense": "25",
    "speed": "15",
    "total": "280",
    "weight": "39.7 lbs.",
    "height": "1'04\"",
    "dex1": "Born deep within the ground, it compares itself with similar species, such as Geodude and Carbink, to settle which has the hardest body.",
    "dex2": "The hexagonal cavity is its ear. It walks in the direction of sounds it hears, but if the sounds cease, it panics and topples over.",
    "class": "Mantle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "525",
    "ndex": "525",
    "species": "Boldore",
    "forme": "Boldore",
    "type1": "Rock",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "Weak Armor",
    "abilityH": "Sand Force",
    "hp": "70",
    "attack": "105",
    "defense": "105",
    "spattack": "50",
    "spdefense": "40",
    "speed": "20",
    "total": "390",
    "weight": "224.9 lbs.",
    "height": "2'11\"",
    "dex1": "Its orange crystal is a mass of energy. Just one crystal fragment would provide enough fuel for a hundred dump trucks.",
    "dex2": "It explores caves in search of underground water. It’s not comfortable around water, so this Pokémon takes great care in lapping it up.",
    "class": "Ore Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Roggenrola",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "526",
    "ndex": "526",
    "species": "Gigalith",
    "forme": "Gigalith",
    "type1": "Rock",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "Sand Stream",
    "abilityH": "Sand Force",
    "hp": "85",
    "attack": "135",
    "defense": "130",
    "spattack": "60",
    "spdefense": "80",
    "speed": "25",
    "total": "515",
    "weight": "573.2 lbs.",
    "height": "5'07\"",
    "dex1": "The blasts of energy it makes from sunbeams have terrifying power. However, it’s not able to fire its blasts at night or on rainy days.",
    "dex2": "Known for its hefty horsepower, this Pokémon is a popular partner for construction workers.",
    "class": "Compressed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Boldore",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "527",
    "ndex": "527",
    "species": "Woobat",
    "forme": "Woobat",
    "type1": "Psychic",
    "type2": "Flying",
    "ability1": "Unaware",
    "ability2": "Klutz",
    "abilityH": "Simple",
    "hp": "65",
    "attack": "45",
    "defense": "43",
    "spattack": "55",
    "spdefense": "43",
    "speed": "72",
    "total": "323",
    "weight": "4.6 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Bat Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Flying"
  },
  {
    "id": "528",
    "ndex": "528",
    "species": "Swoobat",
    "forme": "Swoobat",
    "type1": "Psychic",
    "type2": "Flying",
    "ability1": "Unaware",
    "ability2": "Klutz",
    "abilityH": "Simple",
    "hp": "67",
    "attack": "57",
    "defense": "55",
    "spattack": "77",
    "spdefense": "55",
    "speed": "114",
    "total": "425",
    "weight": "23.1 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Courting Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Woobat",
    "egg-group1": "Field",
    "egg-group2": "Flying"
  },
  {
    "id": "529",
    "ndex": "529",
    "species": "Drilbur",
    "forme": "Drilbur",
    "type1": "Ground",
    "type2": "",
    "ability1": "Sand Rush",
    "ability2": "Sand Force",
    "abilityH": "Mold Breaker",
    "hp": "60",
    "attack": "85",
    "defense": "40",
    "spattack": "30",
    "spdefense": "45",
    "speed": "68",
    "total": "328",
    "weight": "18.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Mole Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "530",
    "ndex": "530",
    "species": "Excadrill",
    "forme": "Excadrill",
    "type1": "Ground",
    "type2": "Steel",
    "ability1": "Sand Rush",
    "ability2": "Sand Force",
    "abilityH": "Mold Breaker",
    "hp": "110",
    "attack": "135",
    "defense": "60",
    "spattack": "50",
    "spdefense": "65",
    "speed": "88",
    "total": "508",
    "weight": "89.1 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Subterrene Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Drilbur",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "531",
    "ndex": "531",
    "species": "Audino",
    "forme": "Audino",
    "type1": "Normal",
    "type2": "",
    "ability1": "Healer",
    "ability2": "Regenerator",
    "abilityH": "Klutz",
    "hp": "103",
    "attack": "60",
    "defense": "86",
    "spattack": "60",
    "spdefense": "86",
    "speed": "50",
    "total": "445",
    "weight": "68.3 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Hearing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "532",
    "ndex": "532",
    "species": "Timburr",
    "forme": "Timburr",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Guts",
    "ability2": "Sheer Force",
    "abilityH": "Iron Fist",
    "hp": "75",
    "attack": "80",
    "defense": "55",
    "spattack": "25",
    "spdefense": "35",
    "speed": "35",
    "total": "305",
    "weight": "27.6 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Muscular Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "533",
    "ndex": "533",
    "species": "Gurdurr",
    "forme": "Gurdurr",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Guts",
    "ability2": "Sheer Force",
    "abilityH": "Iron Fist",
    "hp": "85",
    "attack": "105",
    "defense": "85",
    "spattack": "40",
    "spdefense": "50",
    "speed": "40",
    "total": "405",
    "weight": "88.2 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Muscular Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Timburr",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "534",
    "ndex": "534",
    "species": "Conkeldurr",
    "forme": "Conkeldurr",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Guts",
    "ability2": "Sheer Force",
    "abilityH": "Iron Fist",
    "hp": "105",
    "attack": "140",
    "defense": "95",
    "spattack": "55",
    "spdefense": "65",
    "speed": "45",
    "total": "505",
    "weight": "191.8 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Muscular Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Gurdurr",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "535",
    "ndex": "535",
    "species": "Tympole",
    "forme": "Tympole",
    "type1": "Water",
    "type2": "",
    "ability1": "Swift Swim",
    "ability2": "Hydration",
    "abilityH": "Water Absorb",
    "hp": "50",
    "attack": "50",
    "defense": "40",
    "spattack": "50",
    "spdefense": "40",
    "speed": "64",
    "total": "294",
    "weight": "9.9 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Tadpole Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "536",
    "ndex": "536",
    "species": "Palpitoad",
    "forme": "Palpitoad",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Swift Swim",
    "ability2": "Hydration",
    "abilityH": "Water Absorb",
    "hp": "75",
    "attack": "65",
    "defense": "55",
    "spattack": "65",
    "spdefense": "55",
    "speed": "69",
    "total": "384",
    "weight": "37.5 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Vibration Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Tympole",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "537",
    "ndex": "537",
    "species": "Seismitoad",
    "forme": "Seismitoad",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Swift Swim",
    "ability2": "Poison Touch",
    "abilityH": "Water Absorb",
    "hp": "105",
    "attack": "95",
    "defense": "75",
    "spattack": "85",
    "spdefense": "75",
    "speed": "74",
    "total": "509",
    "weight": "136.7 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Vibration Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Palpitoad",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "538",
    "ndex": "538",
    "species": "Throh",
    "forme": "Throh",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Guts",
    "ability2": "Inner Focus",
    "abilityH": "Mold Breaker",
    "hp": "120",
    "attack": "100",
    "defense": "85",
    "spattack": "30",
    "spdefense": "85",
    "speed": "45",
    "total": "465",
    "weight": "122.4 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Judo Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "539",
    "ndex": "539",
    "species": "Sawk",
    "forme": "Sawk",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "Inner Focus",
    "abilityH": "Mold Breaker",
    "hp": "75",
    "attack": "125",
    "defense": "75",
    "spattack": "30",
    "spdefense": "75",
    "speed": "85",
    "total": "465",
    "weight": "112.4 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Karate Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "540",
    "ndex": "540",
    "species": "Sewaddle",
    "forme": "Sewaddle",
    "type1": "Bug",
    "type2": "Grass",
    "ability1": "Swarm",
    "ability2": "Chlorophyll",
    "abilityH": "Overcoat",
    "hp": "45",
    "attack": "53",
    "defense": "70",
    "spattack": "40",
    "spdefense": "60",
    "speed": "42",
    "total": "310",
    "weight": "5.5 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Sewing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "541",
    "ndex": "541",
    "species": "Swadloon",
    "forme": "Swadloon",
    "type1": "Bug",
    "type2": "Grass",
    "ability1": "Leaf Guard",
    "ability2": "Chlorophyll",
    "abilityH": "Overcoat",
    "hp": "55",
    "attack": "63",
    "defense": "90",
    "spattack": "50",
    "spdefense": "80",
    "speed": "42",
    "total": "380",
    "weight": "16.1 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Leaf-Wrapped Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sewaddle",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "542",
    "ndex": "542",
    "species": "Leavanny",
    "forme": "Leavanny",
    "type1": "Bug",
    "type2": "Grass",
    "ability1": "Swarm",
    "ability2": "Chlorophyll",
    "abilityH": "Overcoat",
    "hp": "75",
    "attack": "103",
    "defense": "80",
    "spattack": "70",
    "spdefense": "80",
    "speed": "92",
    "total": "500",
    "weight": "45.2 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Nurturing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Swadloon",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "543",
    "ndex": "543",
    "species": "Venipede",
    "forme": "Venipede",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Poison Point",
    "ability2": "Swarm",
    "abilityH": "Speed Boost",
    "hp": "30",
    "attack": "45",
    "defense": "59",
    "spattack": "30",
    "spdefense": "39",
    "speed": "57",
    "total": "260",
    "weight": "11.7 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Centipede Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "544",
    "ndex": "544",
    "species": "Whirlipede",
    "forme": "Whirlipede",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Poison Point",
    "ability2": "Swarm",
    "abilityH": "Speed Boost",
    "hp": "40",
    "attack": "55",
    "defense": "99",
    "spattack": "40",
    "spdefense": "79",
    "speed": "47",
    "total": "360",
    "weight": "129.0 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Curlipede Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Venipede",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "545",
    "ndex": "545",
    "species": "Scolipede",
    "forme": "Scolipede",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Poison Point",
    "ability2": "Swarm",
    "abilityH": "Speed Boost",
    "hp": "60",
    "attack": "100",
    "defense": "89",
    "spattack": "55",
    "spdefense": "69",
    "speed": "112",
    "total": "485",
    "weight": "442.0 lbs.",
    "height": "8'02\"",
    "dex1": "",
    "dex2": "",
    "class": "Megapede Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Whirlipede",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "546",
    "ndex": "546",
    "species": "Cottonee",
    "forme": "Cottonee",
    "type1": "Grass",
    "type2": "Fairy",
    "ability1": "Prankster",
    "ability2": "Infiltrator",
    "abilityH": "Chlorophyll",
    "hp": "40",
    "attack": "27",
    "defense": "60",
    "spattack": "37",
    "spdefense": "50",
    "speed": "66",
    "total": "280",
    "weight": "1.3 lbs.",
    "height": "1'00\"",
    "dex1": "When it finds others of its kind, they all stick together. When enough of them have collected, the mass resembles a cumulonimbus cloud.",
    "dex2": "Pillows and beds stuffed with cotton exhaled by Cottonee are soft and puffy, light and airy— altogether top quality.",
    "class": "Cotton Puff Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": "Fairy"
  },
  {
    "id": "547",
    "ndex": "547",
    "species": "Whimsicott",
    "forme": "Whimsicott",
    "type1": "Grass",
    "type2": "Fairy",
    "ability1": "Prankster",
    "ability2": "Infiltrator",
    "abilityH": "Chlorophyll",
    "hp": "60",
    "attack": "67",
    "defense": "85",
    "spattack": "77",
    "spdefense": "75",
    "speed": "116",
    "total": "480",
    "weight": "14.6 lbs.",
    "height": "2'04\"",
    "dex1": "It rides on the wind and slips into people’s homes. After it has turned a room into a cotton- filled mess, it giggles to itself and takes off.",
    "dex2": "This Pokémon appears, riding upon the wind. But if the wind gusts up, it’ll blow the cotton on this Pokémon’s head clean off.",
    "class": "Windveiled Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Cottonee",
    "egg-group1": "Grass",
    "egg-group2": "Fairy"
  },
  {
    "id": "548",
    "ndex": "548",
    "species": "Petilil",
    "forme": "Petilil",
    "type1": "Grass",
    "type2": "",
    "ability1": "Chlorophyll",
    "ability2": "Own Tempo",
    "abilityH": "Leaf Guard",
    "hp": "45",
    "attack": "35",
    "defense": "50",
    "spattack": "70",
    "spdefense": "50",
    "speed": "30",
    "total": "280",
    "weight": "14.6 lbs.",
    "height": "1'08\"",
    "dex1": "Although the leaves on its head are bitter enough to cause dizziness, they provide relief from weariness—even more so when boiled.",
    "dex2": "By pruning the leaves on its head with regularity, this Pokémon can be grown into a fine plump shape.",
    "class": "Bulb Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "549",
    "ndex": "549",
    "species": "Lilligant",
    "forme": "Lilligant",
    "type1": "Grass",
    "type2": "",
    "ability1": "Chlorophyll",
    "ability2": "Own Tempo",
    "abilityH": "Leaf Guard",
    "hp": "70",
    "attack": "60",
    "defense": "75",
    "spattack": "110",
    "spdefense": "75",
    "speed": "90",
    "total": "480",
    "weight": "35.9 lbs.",
    "height": "3'07\"",
    "dex1": "No matter how much time and money is spent raising it, its flowers are the most beautiful when they bloom in the wild.",
    "dex2": "As soon as it finds a male to be its partner, the beautiful flower on its head darkens, droops, and withers away.",
    "class": "Flowering Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Petilil",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "550",
    "ndex": "550",
    "species": "Basculin",
    "forme": "Basculin (Red-Striped Form)",
    "type1": "Water",
    "type2": "",
    "ability1": "Reckless",
    "ability2": "Adaptability",
    "abilityH": "Mold Breaker",
    "hp": "70",
    "attack": "92",
    "defense": "65",
    "spattack": "80",
    "spdefense": "55",
    "speed": "98",
    "total": "460",
    "weight": "39.7 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Hostile Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "551",
    "ndex": "551",
    "species": "Sandile",
    "forme": "Sandile",
    "type1": "Ground",
    "type2": "Dark",
    "ability1": "Intimidate",
    "ability2": "Moxie",
    "abilityH": "Anger Point",
    "hp": "50",
    "attack": "72",
    "defense": "35",
    "spattack": "35",
    "spdefense": "35",
    "speed": "65",
    "total": "292",
    "weight": "33.5 lbs.",
    "height": "2'04\"",
    "dex1": "It submerges itself in sand and moves as if swimming. This wise behavior keeps its enemies from finding it and maintains its temperature.",
    "dex2": "It conceals itself in the sand and chomps down on the legs of any prey that unwarily walk over it. Its favorite food is Trapinch.",
    "class": "Desert Croc Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "552",
    "ndex": "552",
    "species": "Krokorok",
    "forme": "Krokorok",
    "type1": "Ground",
    "type2": "Dark",
    "ability1": "Intimidate",
    "ability2": "Moxie",
    "abilityH": "Anger Point",
    "hp": "60",
    "attack": "82",
    "defense": "45",
    "spattack": "45",
    "spdefense": "45",
    "speed": "74",
    "total": "351",
    "weight": "73.6 lbs.",
    "height": "3'03\"",
    "dex1": "They move in groups of a few individuals. A female is often the leader of the group, and the males will gather food.",
    "dex2": "Thanks to the special membrane covering its eyes, it can see its surroundings clearly, even in the middle of the night.",
    "class": "Desert Croc Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sandile",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "553",
    "ndex": "553",
    "species": "Krookodile",
    "forme": "Krookodile",
    "type1": "Ground",
    "type2": "Dark",
    "ability1": "Intimidate",
    "ability2": "Moxie",
    "abilityH": "Anger Point",
    "hp": "95",
    "attack": "117",
    "defense": "80",
    "spattack": "65",
    "spdefense": "70",
    "speed": "92",
    "total": "519",
    "weight": "212.3 lbs.",
    "height": "4'11\"",
    "dex1": "Its unique faculty of sight can detect small prey more than 30 miles away, even in the midst of a sandstorm.",
    "dex2": "After clamping down with its powerful jaws, it twists its body around to rip its prey in half.",
    "class": "Intimidation Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Krokorok",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "554",
    "ndex": "554",
    "species": "Darumaka",
    "forme": "Darumaka",
    "type1": "Fire",
    "type2": "",
    "ability1": "Hustle",
    "ability2": "",
    "abilityH": "Inner Focus",
    "hp": "70",
    "attack": "90",
    "defense": "45",
    "spattack": "15",
    "spdefense": "45",
    "speed": "50",
    "total": "315",
    "weight": "82.7 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Zen Charm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "555",
    "ndex": "555",
    "species": "Darmanitan",
    "forme": "Darmanitan (Standard Mode)",
    "type1": "Fire",
    "type2": "",
    "ability1": "Sheer Force",
    "ability2": "",
    "abilityH": "Zen Mode",
    "hp": "105",
    "attack": "140",
    "defense": "55",
    "spattack": "30",
    "spdefense": "55",
    "speed": "95",
    "total": "480",
    "weight": "204.8 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Blazing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Darumaka",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "556",
    "ndex": "556",
    "species": "Maractus",
    "forme": "Maractus",
    "type1": "Grass",
    "type2": "",
    "ability1": "Water Absorb",
    "ability2": "Chlorophyll",
    "abilityH": "Storm Drain",
    "hp": "75",
    "attack": "86",
    "defense": "67",
    "spattack": "106",
    "spdefense": "67",
    "speed": "60",
    "total": "461",
    "weight": "61.7 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Cactus Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "557",
    "ndex": "557",
    "species": "Dwebble",
    "forme": "Dwebble",
    "type1": "Bug",
    "type2": "Rock",
    "ability1": "Sturdy",
    "ability2": "Shell Armor",
    "abilityH": "Weak Armor",
    "hp": "50",
    "attack": "65",
    "defense": "85",
    "spattack": "35",
    "spdefense": "35",
    "speed": "55",
    "total": "325",
    "weight": "32.0 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Rock Inn Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": "Mineral"
  },
  {
    "id": "558",
    "ndex": "558",
    "species": "Crustle",
    "forme": "Crustle",
    "type1": "Bug",
    "type2": "Rock",
    "ability1": "Sturdy",
    "ability2": "Shell Armor",
    "abilityH": "Weak Armor",
    "hp": "70",
    "attack": "105",
    "defense": "125",
    "spattack": "65",
    "spdefense": "75",
    "speed": "45",
    "total": "485",
    "weight": "440.9 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Stone Home Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Dwebble",
    "egg-group1": "Bug",
    "egg-group2": "Mineral"
  },
  {
    "id": "559",
    "ndex": "559",
    "species": "Scraggy",
    "forme": "Scraggy",
    "type1": "Dark",
    "type2": "Fighting",
    "ability1": "Shed Skin",
    "ability2": "Moxie",
    "abilityH": "Intimidate",
    "hp": "50",
    "attack": "75",
    "defense": "70",
    "spattack": "35",
    "spdefense": "70",
    "speed": "48",
    "total": "348",
    "weight": "26.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Shedding Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Dragon"
  },
  {
    "id": "560",
    "ndex": "560",
    "species": "Scrafty",
    "forme": "Scrafty",
    "type1": "Dark",
    "type2": "Fighting",
    "ability1": "Shed Skin",
    "ability2": "Moxie",
    "abilityH": "Intimidate",
    "hp": "65",
    "attack": "90",
    "defense": "115",
    "spattack": "45",
    "spdefense": "115",
    "speed": "58",
    "total": "488",
    "weight": "66.1 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Hoodlum Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Scraggy",
    "egg-group1": "Field",
    "egg-group2": "Dragon"
  },
  {
    "id": "561",
    "ndex": "561",
    "species": "Sigilyph",
    "forme": "Sigilyph",
    "type1": "Psychic",
    "type2": "Flying",
    "ability1": "Wonder Skin",
    "ability2": "Magic Guard",
    "abilityH": "Tinted Lens",
    "hp": "72",
    "attack": "58",
    "defense": "80",
    "spattack": "103",
    "spdefense": "80",
    "speed": "97",
    "total": "490",
    "weight": "30.9 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Avianoid Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "562",
    "ndex": "562",
    "species": "Yamask",
    "forme": "Yamask",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Mummy",
    "ability2": "",
    "abilityH": "",
    "hp": "38",
    "attack": "30",
    "defense": "85",
    "spattack": "55",
    "spdefense": "65",
    "speed": "30",
    "total": "303",
    "weight": "3.3 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Spirit Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": "Amorphous"
  },
  {
    "id": "563",
    "ndex": "563",
    "species": "Cofagrigus",
    "forme": "Cofagrigus",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Mummy",
    "ability2": "",
    "abilityH": "",
    "hp": "58",
    "attack": "50",
    "defense": "145",
    "spattack": "95",
    "spdefense": "105",
    "speed": "30",
    "total": "483",
    "weight": "168.7 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Coffin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Yamask",
    "egg-group1": "Mineral",
    "egg-group2": "Amorphous"
  },
  {
    "id": "564",
    "ndex": "564",
    "species": "Tirtouga",
    "forme": "Tirtouga",
    "type1": "Water",
    "type2": "Rock",
    "ability1": "Solid Rock",
    "ability2": "Sturdy",
    "abilityH": "Swift Swim",
    "hp": "54",
    "attack": "78",
    "defense": "103",
    "spattack": "53",
    "spdefense": "45",
    "speed": "22",
    "total": "355",
    "weight": "36.4 lbs.",
    "height": "2'04\"",
    "dex1": "Based on studies of its skeletal structure, it can apparently dive to ocean depths of over half a mile.",
    "dex2": "Reputed to be the ancestor of most turtle Pokémon, it lived in warm seas approximately a hundred million years ago.",
    "class": "Prototurtle Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "565",
    "ndex": "565",
    "species": "Carracosta",
    "forme": "Carracosta",
    "type1": "Water",
    "type2": "Rock",
    "ability1": "Solid Rock",
    "ability2": "Sturdy",
    "abilityH": "Swift Swim",
    "hp": "74",
    "attack": "108",
    "defense": "133",
    "spattack": "83",
    "spdefense": "65",
    "speed": "32",
    "total": "495",
    "weight": "178.6 lbs.",
    "height": "3'11\"",
    "dex1": "It constructed its sturdy shell by crunching and swallowing the hard shells or bones of its prey.",
    "dex2": "Active both on land and in the sea, this Pokémon drags its land-based prey into the water to finish it off.",
    "class": "Prototurtle Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Tirtouga",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "566",
    "ndex": "566",
    "species": "Archen",
    "forme": "Archen",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Defeatist",
    "ability2": "",
    "abilityH": "",
    "hp": "55",
    "attack": "112",
    "defense": "45",
    "spattack": "74",
    "spdefense": "45",
    "speed": "70",
    "total": "401",
    "weight": "20.9 lbs.",
    "height": "1'08\"",
    "dex1": "It is the ancestor of all bird Pokémon. Archen itself could not actually fly but moved by hopping from treetop to treetop.",
    "dex2": "To all appearances flightless, it was able to glide down from tall treetops to snag its prey.",
    "class": "First Bird Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": "Water 3"
  },
  {
    "id": "567",
    "ndex": "567",
    "species": "Archeops",
    "forme": "Archeops",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Defeatist",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "140",
    "defense": "65",
    "spattack": "112",
    "spdefense": "65",
    "speed": "110",
    "total": "567",
    "weight": "70.5 lbs.",
    "height": "4'07\"",
    "dex1": "Although apparently able to fly, they tended to run along the ground, averaging speeds of roughly 25 mph.",
    "dex2": "They hunted in flocks. When one Archeops had the prey cornered, another would swoop on it.",
    "class": "First Bird Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Archen",
    "egg-group1": "Flying",
    "egg-group2": "Water 3"
  },
  {
    "id": "568",
    "ndex": "568",
    "species": "Trubbish",
    "forme": "Trubbish",
    "type1": "Poison",
    "type2": "",
    "ability1": "Stench",
    "ability2": "Sticky Hold",
    "abilityH": "Aftermath",
    "hp": "50",
    "attack": "50",
    "defense": "62",
    "spattack": "40",
    "spdefense": "62",
    "speed": "65",
    "total": "329",
    "weight": "68.3 lbs.",
    "height": "2'00\"",
    "dex1": "Unsanitary places are what they like best. They can be spotted in Alola, often with Grimer in hot pursuit.",
    "dex2": "It gorges on trash until its stomach is full. Then it belches toxic gas. An unlucky whiff of gas will put a person in the hospital.",
    "class": "Trash Bag Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "569",
    "ndex": "569",
    "species": "Garbodor",
    "forme": "Garbodor",
    "type1": "Poison",
    "type2": "",
    "ability1": "Stench",
    "ability2": "Weak Armor",
    "abilityH": "Aftermath",
    "hp": "80",
    "attack": "95",
    "defense": "82",
    "spattack": "60",
    "spdefense": "82",
    "speed": "75",
    "total": "474",
    "weight": "236.6 lbs.",
    "height": "6'03\"",
    "dex1": "Beware the poisonous liquid it shoots from its right arm. If even a little of it gets on you, you’ll experience the effects of the unidentified toxin.",
    "dex2": "For a time, their numbers increased explosively in Alola. Since the arrival of Grimer, their population has decreased dramatically.",
    "class": "Trash Heap Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Trubbish",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "570",
    "ndex": "570",
    "species": "Zorua",
    "forme": "Zorua",
    "type1": "Dark",
    "type2": "",
    "ability1": "Illusion",
    "ability2": "",
    "abilityH": "",
    "hp": "40",
    "attack": "65",
    "defense": "40",
    "spattack": "80",
    "spdefense": "40",
    "speed": "65",
    "total": "330",
    "weight": "27.6 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Tricky Fox Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "571",
    "ndex": "571",
    "species": "Zoroark",
    "forme": "Zoroark",
    "type1": "Dark",
    "type2": "",
    "ability1": "Illusion",
    "ability2": "",
    "abilityH": "",
    "hp": "60",
    "attack": "105",
    "defense": "60",
    "spattack": "120",
    "spdefense": "60",
    "speed": "105",
    "total": "510",
    "weight": "178.8 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Illusion Fox Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Zorua",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "572",
    "ndex": "572",
    "species": "Minccino",
    "forme": "Minccino",
    "type1": "Normal",
    "type2": "",
    "ability1": "Cute Charm",
    "ability2": "Technician",
    "abilityH": "Skill Link",
    "hp": "55",
    "attack": "50",
    "defense": "40",
    "spattack": "40",
    "spdefense": "40",
    "speed": "75",
    "total": "300",
    "weight": "12.8 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Chinchilla Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "573",
    "ndex": "573",
    "species": "Cinccino",
    "forme": "Cinccino",
    "type1": "Normal",
    "type2": "",
    "ability1": "Cute Charm",
    "ability2": "Technician",
    "abilityH": "Skill Link",
    "hp": "75",
    "attack": "95",
    "defense": "60",
    "spattack": "65",
    "spdefense": "60",
    "speed": "115",
    "total": "470",
    "weight": "16.5 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Scarf Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Minccino",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "574",
    "ndex": "574",
    "species": "Gothita",
    "forme": "Gothita",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Frisk",
    "ability2": "Competitive",
    "abilityH": "Shadow Tag",
    "hp": "45",
    "attack": "30",
    "defense": "50",
    "spattack": "55",
    "spdefense": "65",
    "speed": "45",
    "total": "290",
    "weight": "12.8 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Fixation Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "575",
    "ndex": "575",
    "species": "Gothorita",
    "forme": "Gothorita",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Frisk",
    "ability2": "Competitive",
    "abilityH": "Shadow Tag",
    "hp": "60",
    "attack": "45",
    "defense": "70",
    "spattack": "75",
    "spdefense": "85",
    "speed": "55",
    "total": "390",
    "weight": "39.7 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Manipulate Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gothita",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "576",
    "ndex": "576",
    "species": "Gothitelle",
    "forme": "Gothitelle",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Frisk",
    "ability2": "Competitive",
    "abilityH": "Shadow Tag",
    "hp": "70",
    "attack": "55",
    "defense": "95",
    "spattack": "95",
    "spdefense": "110",
    "speed": "65",
    "total": "490",
    "weight": "97.0 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Astral Body Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gothorita",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "577",
    "ndex": "577",
    "species": "Solosis",
    "forme": "Solosis",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Overcoat",
    "ability2": "Magic Guard",
    "abilityH": "Regenerator",
    "hp": "45",
    "attack": "30",
    "defense": "40",
    "spattack": "105",
    "spdefense": "50",
    "speed": "20",
    "total": "290",
    "weight": "2.2 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Cell Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "578",
    "ndex": "578",
    "species": "Duosion",
    "forme": "Duosion",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Overcoat",
    "ability2": "Magic Guard",
    "abilityH": "Regenerator",
    "hp": "65",
    "attack": "40",
    "defense": "50",
    "spattack": "125",
    "spdefense": "60",
    "speed": "30",
    "total": "370",
    "weight": "17.6 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Mitosis Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Solosis",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "579",
    "ndex": "579",
    "species": "Reuniclus",
    "forme": "Reuniclus",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Overcoat",
    "ability2": "Magic Guard",
    "abilityH": "Regenerator",
    "hp": "110",
    "attack": "65",
    "defense": "75",
    "spattack": "125",
    "spdefense": "85",
    "speed": "30",
    "total": "490",
    "weight": "44.3 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Multiplying Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Duosion",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "580",
    "ndex": "580",
    "species": "Ducklett",
    "forme": "Ducklett",
    "type1": "Water",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Big Pecks",
    "abilityH": "Hydration",
    "hp": "62",
    "attack": "44",
    "defense": "50",
    "spattack": "44",
    "spdefense": "50",
    "speed": "55",
    "total": "305",
    "weight": "12.1 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Water Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Flying"
  },
  {
    "id": "581",
    "ndex": "581",
    "species": "Swanna",
    "forme": "Swanna",
    "type1": "Water",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Big Pecks",
    "abilityH": "Hydration",
    "hp": "75",
    "attack": "87",
    "defense": "63",
    "spattack": "87",
    "spdefense": "63",
    "speed": "98",
    "total": "473",
    "weight": "53.4 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "White Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Ducklett",
    "egg-group1": "Water 1",
    "egg-group2": "Flying"
  },
  {
    "id": "582",
    "ndex": "582",
    "species": "Vanillite",
    "forme": "Vanillite",
    "type1": "Ice",
    "type2": "",
    "ability1": "Ice Body",
    "ability2": "Snow Cloak",
    "abilityH": "Weak Armor",
    "hp": "36",
    "attack": "50",
    "defense": "50",
    "spattack": "65",
    "spdefense": "60",
    "speed": "44",
    "total": "305",
    "weight": "12.6 lbs.",
    "height": "1'04\"",
    "dex1": "Born of an icicle, this Pokémon uses its frosty breath to make ice crystals, causing snow to fall.",
    "dex2": "It feels pleasantly cool when embraced. This Pokémon is treasured by households in warm regions.",
    "class": "Fresh Snow Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "583",
    "ndex": "583",
    "species": "Vanillish",
    "forme": "Vanillish",
    "type1": "Ice",
    "type2": "",
    "ability1": "Ice Body",
    "ability2": "Snow Cloak",
    "abilityH": "Weak Armor",
    "hp": "51",
    "attack": "65",
    "defense": "65",
    "spattack": "80",
    "spdefense": "75",
    "speed": "59",
    "total": "395",
    "weight": "90.4 lbs.",
    "height": "3'07\"",
    "dex1": "Hot days cause its body to melt. It can be restored by refreezing it, but the process leaves its body slightly warped.",
    "dex2": "This Pokémon has existed since the Ice Age. It controls particles of ice, freezes its opponents, and then shatters them with a headbutt.",
    "class": "Icy Snow Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Vanillite",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "584",
    "ndex": "584",
    "species": "Vanilluxe",
    "forme": "Vanilluxe",
    "type1": "Ice",
    "type2": "",
    "ability1": "Ice Body",
    "ability2": "Snow Warning",
    "abilityH": "Weak Armor",
    "hp": "71",
    "attack": "95",
    "defense": "85",
    "spattack": "110",
    "spdefense": "95",
    "speed": "79",
    "total": "535",
    "weight": "126.8 lbs.",
    "height": "4'03\"",
    "dex1": "Each of its two heads has a brain, and when they are in agreement, it attacks its enemies by exhaling a violent blizzard.",
    "dex2": "Even if it loses one of its heads, it can live relatively problem-free. It makes snow clouds inside its body.",
    "class": "Snowstorm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Vanillish",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "585",
    "ndex": "585",
    "species": "Deerling",
    "forme": "Deerling (Spring Form)",
    "type1": "Normal",
    "type2": "Grass",
    "ability1": "Chlorophyll",
    "ability2": "Sap Sipper",
    "abilityH": "Serene Grace",
    "hp": "60",
    "attack": "60",
    "defense": "50",
    "spattack": "40",
    "spdefense": "50",
    "speed": "75",
    "total": "335",
    "weight": "43.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Season Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "586",
    "ndex": "586",
    "species": "Sawsbuck",
    "forme": "Sawsbuck (Spring Form)",
    "type1": "Normal",
    "type2": "Grass",
    "ability1": "Chlorophyll",
    "ability2": "Sap Sipper",
    "abilityH": "Serene Grace",
    "hp": "80",
    "attack": "100",
    "defense": "70",
    "spattack": "60",
    "spdefense": "70",
    "speed": "95",
    "total": "475",
    "weight": "203.9 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Season Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Deerling",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "587",
    "ndex": "587",
    "species": "Emolga",
    "forme": "Emolga",
    "type1": "Electric",
    "type2": "Flying",
    "ability1": "Static",
    "ability2": "",
    "abilityH": "Motor Drive",
    "hp": "55",
    "attack": "75",
    "defense": "60",
    "spattack": "75",
    "spdefense": "60",
    "speed": "103",
    "total": "428",
    "weight": "11.0 lbs.",
    "height": "1'04\"",
    "dex1": "It glides using its cape-like membrane. Electrical energy scatters from it, shocking its friends and foes alike.",
    "dex2": "It grills berries and bug Pokémon with electric shocks and makes a meal of them. It usually nests in the holes gouged in trees by Pikipek.",
    "class": "Sky Squirrel Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "588",
    "ndex": "588",
    "species": "Karrablast",
    "forme": "Karrablast",
    "type1": "Bug",
    "type2": "",
    "ability1": "Swarm",
    "ability2": "Shed Skin",
    "abilityH": "No Guard",
    "hp": "50",
    "attack": "75",
    "defense": "45",
    "spattack": "40",
    "spdefense": "45",
    "speed": "60",
    "total": "315",
    "weight": "13.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Clamping Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "589",
    "ndex": "589",
    "species": "Escavalier",
    "forme": "Escavalier",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Swarm",
    "ability2": "Shell Armor",
    "abilityH": "Overcoat",
    "hp": "70",
    "attack": "135",
    "defense": "105",
    "spattack": "60",
    "spdefense": "105",
    "speed": "20",
    "total": "495",
    "weight": "72.8 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Cavalry Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Karrablast",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "590",
    "ndex": "590",
    "species": "Foongus",
    "forme": "Foongus",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Effect Spore",
    "ability2": "",
    "abilityH": "Regenerator",
    "hp": "69",
    "attack": "55",
    "defense": "45",
    "spattack": "55",
    "spdefense": "55",
    "speed": "15",
    "total": "294",
    "weight": "2.2 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Mushroom Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "591",
    "ndex": "591",
    "species": "Amoonguss",
    "forme": "Amoonguss",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Effect Spore",
    "ability2": "",
    "abilityH": "Regenerator",
    "hp": "114",
    "attack": "85",
    "defense": "70",
    "spattack": "85",
    "spdefense": "80",
    "speed": "30",
    "total": "464",
    "weight": "23.1 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Mushroom Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Foongus",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "592",
    "ndex": "592",
    "species": "Frillish",
    "forme": "Frillish",
    "type1": "Water",
    "type2": "Ghost",
    "ability1": "Water Absorb",
    "ability2": "Cursed Body",
    "abilityH": "Damp",
    "hp": "55",
    "attack": "40",
    "defense": "50",
    "spattack": "65",
    "spdefense": "85",
    "speed": "40",
    "total": "335",
    "weight": "72.8 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Floating Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "593",
    "ndex": "593",
    "species": "Jellicent",
    "forme": "Jellicent",
    "type1": "Water",
    "type2": "Ghost",
    "ability1": "Water Absorb",
    "ability2": "Cursed Body",
    "abilityH": "Damp",
    "hp": "100",
    "attack": "60",
    "defense": "70",
    "spattack": "85",
    "spdefense": "105",
    "speed": "60",
    "total": "480",
    "weight": "297.6 lbs.",
    "height": "7'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Floating Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Frillish",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "594",
    "ndex": "594",
    "species": "Alomomola",
    "forme": "Alomomola",
    "type1": "Water",
    "type2": "",
    "ability1": "Healer",
    "ability2": "Hydration",
    "abilityH": "Regenerator",
    "hp": "165",
    "attack": "75",
    "defense": "80",
    "spattack": "40",
    "spdefense": "45",
    "speed": "65",
    "total": "470",
    "weight": "69.7 lbs.",
    "height": "3'11\"",
    "dex1": "It uses its special mucus to close the wounds of injured Pokémon. The reason for this behavior remains unknown.",
    "dex2": "They float upon the open sea. Many water Pokémon gather in the area around Alomomola.",
    "class": "Caring Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 2"
  },
  {
    "id": "595",
    "ndex": "595",
    "species": "Joltik",
    "forme": "Joltik",
    "type1": "Bug",
    "type2": "Electric",
    "ability1": "Compound Eyes",
    "ability2": "Unnerve",
    "abilityH": "Swarm",
    "hp": "50",
    "attack": "47",
    "defense": "50",
    "spattack": "57",
    "spdefense": "50",
    "speed": "65",
    "total": "319",
    "weight": "1.3 lbs.",
    "height": "0'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Attaching Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "596",
    "ndex": "596",
    "species": "Galvantula",
    "forme": "Galvantula",
    "type1": "Bug",
    "type2": "Electric",
    "ability1": "Compound Eyes",
    "ability2": "Unnerve",
    "abilityH": "Swarm",
    "hp": "70",
    "attack": "77",
    "defense": "60",
    "spattack": "97",
    "spdefense": "60",
    "speed": "108",
    "total": "472",
    "weight": "31.5 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "EleSpider Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Joltik",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "597",
    "ndex": "597",
    "species": "Ferroseed",
    "forme": "Ferroseed",
    "type1": "Grass",
    "type2": "Steel",
    "ability1": "Iron Barbs",
    "ability2": "",
    "abilityH": "",
    "hp": "44",
    "attack": "50",
    "defense": "91",
    "spattack": "24",
    "spdefense": "86",
    "speed": "10",
    "total": "305",
    "weight": "41.4 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Thorn Seed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": "Mineral"
  },
  {
    "id": "598",
    "ndex": "598",
    "species": "Ferrothorn",
    "forme": "Ferrothorn",
    "type1": "Grass",
    "type2": "Steel",
    "ability1": "Iron Barbs",
    "ability2": "",
    "abilityH": "Anticipation",
    "hp": "74",
    "attack": "94",
    "defense": "131",
    "spattack": "54",
    "spdefense": "116",
    "speed": "20",
    "total": "489",
    "weight": "242.5 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Thorn Pod Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Ferroseed",
    "egg-group1": "Grass",
    "egg-group2": "Mineral"
  },
  {
    "id": "599",
    "ndex": "599",
    "species": "Klink",
    "forme": "Klink",
    "type1": "Steel",
    "type2": "",
    "ability1": "Plus",
    "ability2": "Minus",
    "abilityH": "Clear Body",
    "hp": "40",
    "attack": "55",
    "defense": "70",
    "spattack": "45",
    "spdefense": "60",
    "speed": "30",
    "total": "300",
    "weight": "46.3 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Gear Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "600",
    "ndex": "600",
    "species": "Klang",
    "forme": "Klang",
    "type1": "Steel",
    "type2": "",
    "ability1": "Plus",
    "ability2": "Minus",
    "abilityH": "Clear Body",
    "hp": "60",
    "attack": "80",
    "defense": "95",
    "spattack": "70",
    "spdefense": "85",
    "speed": "50",
    "total": "440",
    "weight": "112.4 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Gear Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Klink",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "601",
    "ndex": "601",
    "species": "Klinklang",
    "forme": "Klinklang",
    "type1": "Steel",
    "type2": "",
    "ability1": "Plus",
    "ability2": "Minus",
    "abilityH": "Clear Body",
    "hp": "60",
    "attack": "100",
    "defense": "115",
    "spattack": "70",
    "spdefense": "85",
    "speed": "90",
    "total": "520",
    "weight": "178.6 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Gear Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Klang",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "602",
    "ndex": "602",
    "species": "Tynamo",
    "forme": "Tynamo",
    "type1": "Electric",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "35",
    "attack": "55",
    "defense": "40",
    "spattack": "45",
    "spdefense": "40",
    "speed": "60",
    "total": "275",
    "weight": "0.7 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "EleFish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "603",
    "ndex": "603",
    "species": "Eelektrik",
    "forme": "Eelektrik",
    "type1": "Electric",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "65",
    "attack": "85",
    "defense": "70",
    "spattack": "75",
    "spdefense": "70",
    "speed": "40",
    "total": "405",
    "weight": "48.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "EleFish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Tynamo",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "604",
    "ndex": "604",
    "species": "Eelektross",
    "forme": "Eelektross",
    "type1": "Electric",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "85",
    "attack": "115",
    "defense": "80",
    "spattack": "105",
    "spdefense": "80",
    "speed": "50",
    "total": "515",
    "weight": "177.5 lbs.",
    "height": "6'11\"",
    "dex1": "",
    "dex2": "",
    "class": "EleFish Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Eelektrik",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "605",
    "ndex": "605",
    "species": "Elgyem",
    "forme": "Elgyem",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Telepathy",
    "ability2": "Synchronize",
    "abilityH": "Analytic",
    "hp": "55",
    "attack": "55",
    "defense": "55",
    "spattack": "85",
    "spdefense": "55",
    "speed": "30",
    "total": "335",
    "weight": "19.8 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Cerebral Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "606",
    "ndex": "606",
    "species": "Beheeyem",
    "forme": "Beheeyem",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Telepathy",
    "ability2": "Synchronize",
    "abilityH": "Analytic",
    "hp": "75",
    "attack": "75",
    "defense": "75",
    "spattack": "125",
    "spdefense": "95",
    "speed": "40",
    "total": "485",
    "weight": "76.1 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Cerebral Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Elgyem",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "607",
    "ndex": "607",
    "species": "Litwick",
    "forme": "Litwick",
    "type1": "Ghost",
    "type2": "Fire",
    "ability1": "Flash Fire",
    "ability2": "Flame Body",
    "abilityH": "Infiltrator",
    "hp": "50",
    "attack": "30",
    "defense": "55",
    "spattack": "65",
    "spdefense": "55",
    "speed": "20",
    "total": "275",
    "weight": "6.8 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Candle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "608",
    "ndex": "608",
    "species": "Lampent",
    "forme": "Lampent",
    "type1": "Ghost",
    "type2": "Fire",
    "ability1": "Flash Fire",
    "ability2": "Flame Body",
    "abilityH": "Infiltrator",
    "hp": "60",
    "attack": "40",
    "defense": "60",
    "spattack": "95",
    "spdefense": "60",
    "speed": "55",
    "total": "370",
    "weight": "28.7 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Lamp Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Litwick",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "609",
    "ndex": "609",
    "species": "Chandelure",
    "forme": "Chandelure",
    "type1": "Ghost",
    "type2": "Fire",
    "ability1": "Flash Fire",
    "ability2": "Flame Body",
    "abilityH": "Infiltrator",
    "hp": "60",
    "attack": "55",
    "defense": "90",
    "spattack": "145",
    "spdefense": "90",
    "speed": "80",
    "total": "520",
    "weight": "75.6 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Luring Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Lampent",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "610",
    "ndex": "610",
    "species": "Axew",
    "forme": "Axew",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Rivalry",
    "ability2": "Mold Breaker",
    "abilityH": "Unnerve",
    "hp": "46",
    "attack": "87",
    "defense": "60",
    "spattack": "30",
    "spdefense": "40",
    "speed": "57",
    "total": "320",
    "weight": "39.7 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Tusk Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "611",
    "ndex": "611",
    "species": "Fraxure",
    "forme": "Fraxure",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Rivalry",
    "ability2": "Mold Breaker",
    "abilityH": "Unnerve",
    "hp": "66",
    "attack": "117",
    "defense": "70",
    "spattack": "40",
    "spdefense": "50",
    "speed": "67",
    "total": "410",
    "weight": "79.4 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Axe Jaw Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Axew",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "612",
    "ndex": "612",
    "species": "Haxorus",
    "forme": "Haxorus",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Rivalry",
    "ability2": "Mold Breaker",
    "abilityH": "Unnerve",
    "hp": "76",
    "attack": "147",
    "defense": "90",
    "spattack": "60",
    "spdefense": "70",
    "speed": "97",
    "total": "540",
    "weight": "232.6 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Axe Jaw Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Fraxure",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "613",
    "ndex": "613",
    "species": "Cubchoo",
    "forme": "Cubchoo",
    "type1": "Ice",
    "type2": "",
    "ability1": "Snow Cloak",
    "ability2": "Slush Rush",
    "abilityH": "Rattled",
    "hp": "55",
    "attack": "70",
    "defense": "40",
    "spattack": "60",
    "spdefense": "40",
    "speed": "40",
    "total": "305",
    "weight": "18.7 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Chill Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "614",
    "ndex": "614",
    "species": "Beartic",
    "forme": "Beartic",
    "type1": "Ice",
    "type2": "",
    "ability1": "Snow Cloak",
    "ability2": "Slush Rush",
    "abilityH": "Swift Swim",
    "hp": "95",
    "attack": "130",
    "defense": "80",
    "spattack": "70",
    "spdefense": "80",
    "speed": "50",
    "total": "505",
    "weight": "573.2 lbs.",
    "height": "8'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Freezing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Cubchoo",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "615",
    "ndex": "615",
    "species": "Cryogonal",
    "forme": "Cryogonal",
    "type1": "Ice",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "50",
    "defense": "50",
    "spattack": "95",
    "spdefense": "135",
    "speed": "105",
    "total": "515",
    "weight": "326.3 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Crystallizing Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "616",
    "ndex": "616",
    "species": "Shelmet",
    "forme": "Shelmet",
    "type1": "Bug",
    "type2": "",
    "ability1": "Hydration",
    "ability2": "Shell Armor",
    "abilityH": "Overcoat",
    "hp": "50",
    "attack": "40",
    "defense": "85",
    "spattack": "40",
    "spdefense": "65",
    "speed": "25",
    "total": "305",
    "weight": "17.0 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Snail Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "617",
    "ndex": "617",
    "species": "Accelgor",
    "forme": "Accelgor",
    "type1": "Bug",
    "type2": "",
    "ability1": "Hydration",
    "ability2": "Sticky Hold",
    "abilityH": "Unburden",
    "hp": "80",
    "attack": "70",
    "defense": "40",
    "spattack": "100",
    "spdefense": "60",
    "speed": "145",
    "total": "495",
    "weight": "55.8 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Shell Out Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shelmet",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "618",
    "ndex": "618",
    "species": "Stunfisk",
    "forme": "Stunfisk",
    "type1": "Ground",
    "type2": "Electric",
    "ability1": "Static",
    "ability2": "Limber",
    "abilityH": "Sand Veil",
    "hp": "109",
    "attack": "66",
    "defense": "84",
    "spattack": "81",
    "spdefense": "99",
    "speed": "32",
    "total": "471",
    "weight": "24.3 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Trap Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Amorphous"
  },
  {
    "id": "619",
    "ndex": "619",
    "species": "Mienfoo",
    "forme": "Mienfoo",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Inner Focus",
    "ability2": "Regenerator",
    "abilityH": "Reckless",
    "hp": "45",
    "attack": "85",
    "defense": "50",
    "spattack": "55",
    "spdefense": "50",
    "speed": "65",
    "total": "350",
    "weight": "44.1 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Martial Arts Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "620",
    "ndex": "620",
    "species": "Mienshao",
    "forme": "Mienshao",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Inner Focus",
    "ability2": "Regenerator",
    "abilityH": "Reckless",
    "hp": "65",
    "attack": "125",
    "defense": "60",
    "spattack": "95",
    "spdefense": "60",
    "speed": "105",
    "total": "510",
    "weight": "78.3 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Martial Arts Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Mienfoo",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "621",
    "ndex": "621",
    "species": "Druddigon",
    "forme": "Druddigon",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Rough Skin",
    "ability2": "Sheer Force",
    "abilityH": "Mold Breaker",
    "hp": "77",
    "attack": "120",
    "defense": "90",
    "spattack": "60",
    "spdefense": "90",
    "speed": "48",
    "total": "485",
    "weight": "306.4 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Cave Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Dragon",
    "egg-group2": "Monster"
  },
  {
    "id": "622",
    "ndex": "622",
    "species": "Golett",
    "forme": "Golett",
    "type1": "Ground",
    "type2": "Ghost",
    "ability1": "Iron Fist",
    "ability2": "Klutz",
    "abilityH": "No Guard",
    "hp": "59",
    "attack": "74",
    "defense": "50",
    "spattack": "35",
    "spdefense": "50",
    "speed": "35",
    "total": "303",
    "weight": "202.8 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Automaton Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "623",
    "ndex": "623",
    "species": "Golurk",
    "forme": "Golurk",
    "type1": "Ground",
    "type2": "Ghost",
    "ability1": "Iron Fist",
    "ability2": "Klutz",
    "abilityH": "No Guard",
    "hp": "89",
    "attack": "124",
    "defense": "80",
    "spattack": "55",
    "spdefense": "80",
    "speed": "55",
    "total": "483",
    "weight": "727.5 lbs.",
    "height": "9'02\"",
    "dex1": "",
    "dex2": "",
    "class": "Automaton Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Golett",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "624",
    "ndex": "624",
    "species": "Pawniard",
    "forme": "Pawniard",
    "type1": "Dark",
    "type2": "Steel",
    "ability1": "Defiant",
    "ability2": "Inner Focus",
    "abilityH": "Pressure",
    "hp": "45",
    "attack": "85",
    "defense": "70",
    "spattack": "40",
    "spdefense": "40",
    "speed": "60",
    "total": "340",
    "weight": "22.5 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Sharp Blade Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "625",
    "ndex": "625",
    "species": "Bisharp",
    "forme": "Bisharp",
    "type1": "Dark",
    "type2": "Steel",
    "ability1": "Defiant",
    "ability2": "Inner Focus",
    "abilityH": "Pressure",
    "hp": "65",
    "attack": "125",
    "defense": "100",
    "spattack": "60",
    "spdefense": "70",
    "speed": "70",
    "total": "490",
    "weight": "154.3 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Sword Blade Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pawniard",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "626",
    "ndex": "626",
    "species": "Bouffalant",
    "forme": "Bouffalant",
    "type1": "Normal",
    "type2": "",
    "ability1": "Reckless",
    "ability2": "Sap Sipper",
    "abilityH": "Soundproof",
    "hp": "95",
    "attack": "110",
    "defense": "95",
    "spattack": "40",
    "spdefense": "95",
    "speed": "55",
    "total": "490",
    "weight": "208.6 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Bash Buffalo Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "627",
    "ndex": "627",
    "species": "Rufflet",
    "forme": "Rufflet",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Sheer Force",
    "abilityH": "Hustle",
    "hp": "70",
    "attack": "83",
    "defense": "50",
    "spattack": "37",
    "spdefense": "50",
    "speed": "60",
    "total": "350",
    "weight": "23.1 lbs.",
    "height": "1'08\"",
    "dex1": "They pick fights indiscriminately. They grow stronger and more powerful each time they faint or are injured.",
    "dex2": "With its sharp claws, this Pokémon pierces its prey, and then it pecks at them. Although it also consumes berries, it’s a carnivore at heart.",
    "class": "Eaglet Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "628",
    "ndex": "628",
    "species": "Braviary",
    "forme": "Braviary",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Sheer Force",
    "abilityH": "Defiant",
    "hp": "100",
    "attack": "123",
    "defense": "75",
    "spattack": "57",
    "spdefense": "75",
    "speed": "80",
    "total": "510",
    "weight": "90.4 lbs.",
    "height": "4'11\"",
    "dex1": "With its brave disposition, it fears nothing—not even death. Ancient Alolan people respected it, referring to it as “the hero of the sky.”",
    "dex2": "It’s thought that people disturbed their habitats in the past, so Braviary banded together to fight back.",
    "class": "Valiant Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Rufflet",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "629",
    "ndex": "629",
    "species": "Vullaby",
    "forme": "Vullaby",
    "type1": "Dark",
    "type2": "Flying",
    "ability1": "Big Pecks",
    "ability2": "Overcoat",
    "abilityH": "Weak Armor",
    "hp": "70",
    "attack": "55",
    "defense": "75",
    "spattack": "45",
    "spdefense": "65",
    "speed": "60",
    "total": "370",
    "weight": "19.8 lbs.",
    "height": "1'08\"",
    "dex1": "It protects its plump posterior with the bones of prey it has consumed. As it grows, it replaces the bones.",
    "dex2": "It can’t fly yet and must wait until its wings have developed more. Since it’s still at a playful age, it hops around friskily.",
    "class": "Diapered Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "630",
    "ndex": "630",
    "species": "Mandibuzz",
    "forme": "Mandibuzz",
    "type1": "Dark",
    "type2": "Flying",
    "ability1": "Big Pecks",
    "ability2": "Overcoat",
    "abilityH": "Weak Armor",
    "hp": "110",
    "attack": "65",
    "defense": "105",
    "spattack": "55",
    "spdefense": "95",
    "speed": "80",
    "total": "510",
    "weight": "87.1 lbs.",
    "height": "3'11\"",
    "dex1": "They adorn themselves beautifully with bones. This is supposedly an effort to attract males, but no male Mandibuzz have ever been found.",
    "dex2": "It circles in the sky, keeping a keen eye out for Pokémon in a weakened state. Its choicest food is Cubone.",
    "class": "Bone Vulture Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Vullaby",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "631",
    "ndex": "631",
    "species": "Heatmor",
    "forme": "Heatmor",
    "type1": "Fire",
    "type2": "",
    "ability1": "Gluttony",
    "ability2": "Flash Fire",
    "abilityH": "White Smoke",
    "hp": "85",
    "attack": "97",
    "defense": "66",
    "spattack": "105",
    "spdefense": "66",
    "speed": "65",
    "total": "484",
    "weight": "127.9 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Anteater Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "632",
    "ndex": "632",
    "species": "Durant",
    "forme": "Durant",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Swarm",
    "ability2": "Hustle",
    "abilityH": "Truant",
    "hp": "58",
    "attack": "109",
    "defense": "112",
    "spattack": "48",
    "spdefense": "48",
    "speed": "109",
    "total": "484",
    "weight": "72.8 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Iron Ant Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "633",
    "ndex": "633",
    "species": "Deino",
    "forme": "Deino",
    "type1": "Dark",
    "type2": "Dragon",
    "ability1": "Hustle",
    "ability2": "",
    "abilityH": "",
    "hp": "52",
    "attack": "65",
    "defense": "50",
    "spattack": "45",
    "spdefense": "50",
    "speed": "38",
    "total": "300",
    "weight": "38.1 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Irate Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "634",
    "ndex": "634",
    "species": "Zweilous",
    "forme": "Zweilous",
    "type1": "Dark",
    "type2": "Dragon",
    "ability1": "Hustle",
    "ability2": "",
    "abilityH": "",
    "hp": "72",
    "attack": "85",
    "defense": "70",
    "spattack": "65",
    "spdefense": "70",
    "speed": "58",
    "total": "420",
    "weight": "110.2 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Hostile Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Deino",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "635",
    "ndex": "635",
    "species": "Hydreigon",
    "forme": "Hydreigon",
    "type1": "Dark",
    "type2": "Dragon",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "92",
    "attack": "105",
    "defense": "90",
    "spattack": "125",
    "spdefense": "90",
    "speed": "98",
    "total": "600",
    "weight": "352.7 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Brutal Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Zweilous",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "636",
    "ndex": "636",
    "species": "Larvesta",
    "forme": "Larvesta",
    "type1": "Bug",
    "type2": "Fire",
    "ability1": "Flame Body",
    "ability2": "",
    "abilityH": "Swarm",
    "hp": "55",
    "attack": "85",
    "defense": "55",
    "spattack": "50",
    "spdefense": "55",
    "speed": "60",
    "total": "360",
    "weight": "63.5 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Torch Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "637",
    "ndex": "637",
    "species": "Volcarona",
    "forme": "Volcarona",
    "type1": "Bug",
    "type2": "Fire",
    "ability1": "Flame Body",
    "ability2": "",
    "abilityH": "Swarm",
    "hp": "85",
    "attack": "60",
    "defense": "65",
    "spattack": "135",
    "spdefense": "105",
    "speed": "100",
    "total": "550",
    "weight": "101.4 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Sun Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Larvesta",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "638",
    "ndex": "638",
    "species": "Cobalion",
    "forme": "Cobalion",
    "type1": "Steel",
    "type2": "Fighting",
    "ability1": "Justified",
    "ability2": "",
    "abilityH": "",
    "hp": "91",
    "attack": "90",
    "defense": "129",
    "spattack": "90",
    "spdefense": "72",
    "speed": "108",
    "total": "580",
    "weight": "551.2 lbs.",
    "height": "6'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Iron Will Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "639",
    "ndex": "639",
    "species": "Terrakion",
    "forme": "Terrakion",
    "type1": "Rock",
    "type2": "Fighting",
    "ability1": "Justified",
    "ability2": "",
    "abilityH": "",
    "hp": "91",
    "attack": "129",
    "defense": "90",
    "spattack": "72",
    "spdefense": "90",
    "speed": "108",
    "total": "580",
    "weight": "573.2 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Cavern Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "640",
    "ndex": "640",
    "species": "Virizion",
    "forme": "Virizion",
    "type1": "Grass",
    "type2": "Fighting",
    "ability1": "Justified",
    "ability2": "",
    "abilityH": "",
    "hp": "91",
    "attack": "90",
    "defense": "72",
    "spattack": "90",
    "spdefense": "129",
    "speed": "108",
    "total": "580",
    "weight": "440.9 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Grassland Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "641",
    "ndex": "641",
    "species": "Tornadus",
    "forme": "Tornadus (Incarnate Forme)",
    "type1": "Flying",
    "type2": "",
    "ability1": "Prankster",
    "ability2": "",
    "abilityH": "Defiant",
    "hp": "79",
    "attack": "115",
    "defense": "70",
    "spattack": "125",
    "spdefense": "80",
    "speed": "111",
    "total": "580",
    "weight": "138.9 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Cyclone Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "642",
    "ndex": "642",
    "species": "Thundurus",
    "forme": "Thundurus (Incarnate Forme)",
    "type1": "Electric",
    "type2": "Flying",
    "ability1": "Prankster",
    "ability2": "",
    "abilityH": "Defiant",
    "hp": "79",
    "attack": "115",
    "defense": "70",
    "spattack": "125",
    "spdefense": "80",
    "speed": "111",
    "total": "580",
    "weight": "134.5 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Bolt Strike Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "643",
    "ndex": "643",
    "species": "Reshiram",
    "forme": "Reshiram",
    "type1": "Dragon",
    "type2": "Fire",
    "ability1": "Turboblaze",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "120",
    "defense": "100",
    "spattack": "150",
    "spdefense": "120",
    "speed": "90",
    "total": "680",
    "weight": "727.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Vast White Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "644",
    "ndex": "644",
    "species": "Zekrom",
    "forme": "Zekrom",
    "type1": "Dragon",
    "type2": "Electric",
    "ability1": "Teravolt",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "150",
    "defense": "120",
    "spattack": "120",
    "spdefense": "100",
    "speed": "90",
    "total": "680",
    "weight": "760.6 lbs.",
    "height": "9'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Deep Black Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "645",
    "ndex": "645",
    "species": "Landorus",
    "forme": "Landorus (Incarnate Forme)",
    "type1": "Ground",
    "type2": "Flying",
    "ability1": "Sand Force",
    "ability2": "",
    "abilityH": "Sheer Force",
    "hp": "89",
    "attack": "125",
    "defense": "90",
    "spattack": "115",
    "spdefense": "80",
    "speed": "101",
    "total": "600",
    "weight": "149.9 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Abundance Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "646",
    "ndex": "646",
    "species": "Kyurem",
    "forme": "Kyurem (Kyurem)",
    "type1": "Dragon",
    "type2": "Ice",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "",
    "hp": "125",
    "attack": "130",
    "defense": "90",
    "spattack": "130",
    "spdefense": "90",
    "speed": "95",
    "total": "660",
    "weight": "716.5 lbs.",
    "height": "9'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Boundary Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "647",
    "ndex": "647",
    "species": "Keldeo",
    "forme": "Keldeo (Ordinary Form)",
    "type1": "Water",
    "type2": "Fighting",
    "ability1": "Justified",
    "ability2": "",
    "abilityH": "",
    "hp": "91",
    "attack": "72",
    "defense": "90",
    "spattack": "129",
    "spdefense": "90",
    "speed": "108",
    "total": "580",
    "weight": "106.9 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Colt Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "648",
    "ndex": "648",
    "species": "Meloetta",
    "forme": "Meloetta (Aria Forme)",
    "type1": "Normal",
    "type2": "Psychic",
    "ability1": "Serene Grace",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "77",
    "defense": "77",
    "spattack": "128",
    "spdefense": "128",
    "speed": "90",
    "total": "600",
    "weight": "14.3 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Melody Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "649",
    "ndex": "649",
    "species": "Genesect",
    "forme": "Genesect (Genesect)",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Download",
    "ability2": "",
    "abilityH": "",
    "hp": "71",
    "attack": "120",
    "defense": "95",
    "spattack": "120",
    "spdefense": "95",
    "speed": "99",
    "total": "600",
    "weight": "181.9 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Paleozoic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "650",
    "ndex": "650",
    "species": "Chespin",
    "forme": "Chespin",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Bulletproof",
    "hp": "56",
    "attack": "61",
    "defense": "65",
    "spattack": "48",
    "spdefense": "45",
    "speed": "38",
    "total": "313",
    "weight": "19.8 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Spiny Nut Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "651",
    "ndex": "651",
    "species": "Quilladin",
    "forme": "Quilladin",
    "type1": "Grass",
    "type2": "",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Bulletproof",
    "hp": "61",
    "attack": "78",
    "defense": "95",
    "spattack": "56",
    "spdefense": "58",
    "speed": "57",
    "total": "405",
    "weight": "63.9 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Spiny Armor Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Chespin",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "652",
    "ndex": "652",
    "species": "Chesnaught",
    "forme": "Chesnaught",
    "type1": "Grass",
    "type2": "Fighting",
    "ability1": "Overgrow",
    "ability2": "",
    "abilityH": "Bulletproof",
    "hp": "88",
    "attack": "107",
    "defense": "122",
    "spattack": "74",
    "spdefense": "75",
    "speed": "64",
    "total": "530",
    "weight": "198.4 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Spiny Armor Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Quilladin",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "653",
    "ndex": "653",
    "species": "Fennekin",
    "forme": "Fennekin",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Magician",
    "hp": "40",
    "attack": "45",
    "defense": "40",
    "spattack": "62",
    "spdefense": "60",
    "speed": "60",
    "total": "307",
    "weight": "20.7 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Fox Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "654",
    "ndex": "654",
    "species": "Braixen",
    "forme": "Braixen",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Magician",
    "hp": "59",
    "attack": "59",
    "defense": "58",
    "spattack": "90",
    "spdefense": "70",
    "speed": "73",
    "total": "409",
    "weight": "32.0 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Fox Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Fennekin",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "655",
    "ndex": "655",
    "species": "Delphox",
    "forme": "Delphox",
    "type1": "Fire",
    "type2": "Psychic",
    "ability1": "Blaze",
    "ability2": "",
    "abilityH": "Magician",
    "hp": "75",
    "attack": "69",
    "defense": "72",
    "spattack": "114",
    "spdefense": "100",
    "speed": "104",
    "total": "534",
    "weight": "86.0 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Fox Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Braixen",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "656",
    "ndex": "656",
    "species": "Froakie",
    "forme": "Froakie",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Protean",
    "hp": "41",
    "attack": "56",
    "defense": "40",
    "spattack": "62",
    "spdefense": "44",
    "speed": "71",
    "total": "314",
    "weight": "15.4 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Bubble Frog Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "657",
    "ndex": "657",
    "species": "Frogadier",
    "forme": "Frogadier",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "",
    "abilityH": "Protean",
    "hp": "54",
    "attack": "63",
    "defense": "52",
    "spattack": "83",
    "spdefense": "56",
    "speed": "97",
    "total": "405",
    "weight": "24.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Bubble Frog Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Froakie",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "658",
    "ndex": "658",
    "species": "Greninja",
    "forme": "Greninja",
    "type1": "Water",
    "type2": "Dark",
    "ability1": "Torrent",
    "ability2": "Torrent",
    "abilityH": "Protean",
    "hp": "72",
    "attack": "95",
    "defense": "67",
    "spattack": "103",
    "spdefense": "71",
    "speed": "122",
    "total": "530",
    "weight": "88.2 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Ninja Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Frogadier",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "659",
    "ndex": "659",
    "species": "Bunnelby",
    "forme": "Bunnelby",
    "type1": "Normal",
    "type2": "",
    "ability1": "Pickup",
    "ability2": "Cheek Pouch",
    "abilityH": "Huge Power",
    "hp": "38",
    "attack": "36",
    "defense": "38",
    "spattack": "32",
    "spdefense": "36",
    "speed": "57",
    "total": "237",
    "weight": "11.0 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Digging Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "660",
    "ndex": "660",
    "species": "Diggersby",
    "forme": "Diggersby",
    "type1": "Normal",
    "type2": "Ground",
    "ability1": "Pickup",
    "ability2": "Cheek Pouch",
    "abilityH": "Huge Power",
    "hp": "85",
    "attack": "56",
    "defense": "77",
    "spattack": "50",
    "spdefense": "77",
    "speed": "78",
    "total": "423",
    "weight": "93.5 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Digging Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Bunnelby",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "661",
    "ndex": "661",
    "species": "Fletchling",
    "forme": "Fletchling",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Big Pecks",
    "ability2": "",
    "abilityH": "Gale Wings",
    "hp": "45",
    "attack": "50",
    "defense": "43",
    "spattack": "40",
    "spdefense": "38",
    "speed": "62",
    "total": "278",
    "weight": "3.7 lbs.",
    "height": "1'00\"",
    "dex1": "This amiable Pokémon is easy to train. But when battle is joined, it shows its ferocious side.",
    "dex2": "When it’s excited, its temperature can double, spiking hormone production in its body.",
    "class": "Tiny Robin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "662",
    "ndex": "662",
    "species": "Fletchinder",
    "forme": "Fletchinder",
    "type1": "Fire",
    "type2": "Flying",
    "ability1": "Flame Body",
    "ability2": "",
    "abilityH": "Gale Wings",
    "hp": "62",
    "attack": "73",
    "defense": "55",
    "spattack": "56",
    "spdefense": "52",
    "speed": "84",
    "total": "382",
    "weight": "35.3 lbs.",
    "height": "2'04\"",
    "dex1": "From its beak, it fires embers at its prey. Once it has caught them, it grills them at high heat before feasting upon them.",
    "dex2": "It will not tolerate other Fletchinder entering its territory, which has a radius of several miles.",
    "class": "Ember Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Fletchling",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "663",
    "ndex": "663",
    "species": "Talonflame",
    "forme": "Talonflame",
    "type1": "Fire",
    "type2": "Flying",
    "ability1": "Flame Body",
    "ability2": "",
    "abilityH": "Gale Wings",
    "hp": "78",
    "attack": "81",
    "defense": "71",
    "spattack": "74",
    "spdefense": "69",
    "speed": "126",
    "total": "499",
    "weight": "54.0 lbs.",
    "height": "3'11\"",
    "dex1": "Its favorite foods are Wingull and Pikipek. It attacks with a powerful kick and grasps them firmly in its talons.",
    "dex2": "It zooms directly at its prey at flight speeds of close to 310 mph, while fiery embers scatter from gaps in its feathers.",
    "class": "Scorching Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Fletchinder",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "664",
    "ndex": "664",
    "species": "Scatterbug",
    "forme": "Scatterbug",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "38",
    "attack": "35",
    "defense": "40",
    "spattack": "27",
    "spdefense": "25",
    "speed": "35",
    "total": "200",
    "weight": "5.5 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Scatterdust Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "665",
    "ndex": "665",
    "species": "Spewpa",
    "forme": "Spewpa",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Friend Guard",
    "hp": "45",
    "attack": "22",
    "defense": "60",
    "spattack": "27",
    "spdefense": "30",
    "speed": "29",
    "total": "213",
    "weight": "18.5 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Scatterdust Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Scatterbug",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "666",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Icy Snow Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "667",
    "ndex": "667",
    "species": "Litleo",
    "forme": "Litleo",
    "type1": "Fire",
    "type2": "Normal",
    "ability1": "Rivalry",
    "ability2": "Unnerve",
    "abilityH": "Moxie",
    "hp": "62",
    "attack": "50",
    "defense": "58",
    "spattack": "73",
    "spdefense": "54",
    "speed": "72",
    "total": "369",
    "weight": "29.8 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Lion Cub Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "668",
    "ndex": "668",
    "species": "Pyroar",
    "forme": "Pyroar",
    "type1": "Fire",
    "type2": "Normal",
    "ability1": "Rivalry",
    "ability2": "Unnerve",
    "abilityH": "Moxie",
    "hp": "86",
    "attack": "68",
    "defense": "72",
    "spattack": "109",
    "spdefense": "66",
    "speed": "106",
    "total": "507",
    "weight": "179.7 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Royal Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Litleo",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "669",
    "ndex": "669",
    "species": "Flabébé",
    "forme": "Flabébé (Red Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "44",
    "attack": "38",
    "defense": "39",
    "spattack": "61",
    "spdefense": "79",
    "speed": "42",
    "total": "303",
    "weight": "0.2 lbs.",
    "height": "0'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "670",
    "ndex": "670",
    "species": "Floette",
    "forme": "Floette (Red Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "54",
    "attack": "45",
    "defense": "47",
    "spattack": "75",
    "spdefense": "98",
    "speed": "52",
    "total": "371",
    "weight": "2.0 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Flabébé",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "671",
    "ndex": "671",
    "species": "Florges",
    "forme": "Florges (Red Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "78",
    "attack": "65",
    "defense": "68",
    "spattack": "112",
    "spdefense": "154",
    "speed": "75",
    "total": "552",
    "weight": "22.0 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Garden Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Floette",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "672",
    "ndex": "672",
    "species": "Skiddo",
    "forme": "Skiddo",
    "type1": "Grass",
    "type2": "",
    "ability1": "Sap Sipper",
    "ability2": "",
    "abilityH": "Grass Pelt",
    "hp": "66",
    "attack": "65",
    "defense": "48",
    "spattack": "62",
    "spdefense": "57",
    "speed": "52",
    "total": "350",
    "weight": "68.3 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Mount Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "673",
    "ndex": "673",
    "species": "Gogoat",
    "forme": "Gogoat",
    "type1": "Grass",
    "type2": "",
    "ability1": "Sap Sipper",
    "ability2": "",
    "abilityH": "Grass Pelt",
    "hp": "123",
    "attack": "100",
    "defense": "62",
    "spattack": "97",
    "spdefense": "81",
    "speed": "68",
    "total": "531",
    "weight": "200.6 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Mount Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Skiddo",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "674",
    "ndex": "674",
    "species": "Pancham",
    "forme": "Pancham",
    "type1": "Dark",
    "type2": "",
    "ability1": "Iron Fist",
    "ability2": "Mold Breaker",
    "abilityH": "Scrappy",
    "hp": "67",
    "attack": "82",
    "defense": "62",
    "spattack": "46",
    "spdefense": "48",
    "speed": "43",
    "total": "348",
    "weight": "17.6 lbs.",
    "height": "2'00\"",
    "dex1": "It grows up imitating the behavior of Pangoro, which it looks up to as a leader.",
    "dex2": "There’s no point to the leaf in its mouth, aside from an effort to look cool. It’s mischievous, so it’s not well suited to inexperienced Trainers.",
    "class": "Playful Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "675",
    "ndex": "675",
    "species": "Pangoro",
    "forme": "Pangoro",
    "type1": "Dark",
    "type2": "Fighting",
    "ability1": "Iron Fist",
    "ability2": "Mold Breaker",
    "abilityH": "Scrappy",
    "hp": "95",
    "attack": "124",
    "defense": "78",
    "spattack": "69",
    "spdefense": "71",
    "speed": "58",
    "total": "495",
    "weight": "299.8 lbs.",
    "height": "6'11\"",
    "dex1": "It boasts superb physical strength. Those who wish to become Pangoro’s Trainer have no choice but to converse with their fists.",
    "dex2": "From the slight twitches of its bamboo leaf, it deduces its opponent’s movements. It’s eager to tussle but kindhearted toward its companions.",
    "class": "Daunting Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pancham",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "676",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (Natural Form)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "677",
    "ndex": "677",
    "species": "Espurr",
    "forme": "Espurr",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Keen Eye",
    "ability2": "Infiltrator",
    "abilityH": "Own Tempo",
    "hp": "62",
    "attack": "48",
    "defense": "54",
    "spattack": "63",
    "spdefense": "60",
    "speed": "68",
    "total": "355",
    "weight": "7.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Restraint Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "678",
    "ndex": "678",
    "species": "Meowstic",
    "forme": "Meowstic (Male)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Keen Eye",
    "ability2": "Infiltrator",
    "abilityH": "Prankster",
    "hp": "74",
    "attack": "48",
    "defense": "76",
    "spattack": "83",
    "spdefense": "81",
    "speed": "104",
    "total": "466",
    "weight": "18.7 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Constraint Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Espurr",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "679",
    "ndex": "679",
    "species": "Honedge",
    "forme": "Honedge",
    "type1": "Steel",
    "type2": "Ghost",
    "ability1": "No Guard",
    "ability2": "",
    "abilityH": "",
    "hp": "45",
    "attack": "80",
    "defense": "100",
    "spattack": "35",
    "spdefense": "37",
    "speed": "28",
    "total": "325",
    "weight": "4.4 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Sword Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "680",
    "ndex": "680",
    "species": "Doublade",
    "forme": "Doublade",
    "type1": "Steel",
    "type2": "Ghost",
    "ability1": "No Guard",
    "ability2": "",
    "abilityH": "",
    "hp": "59",
    "attack": "110",
    "defense": "150",
    "spattack": "45",
    "spdefense": "49",
    "speed": "35",
    "total": "448",
    "weight": "9.9 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Sword Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Honedge",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "681",
    "ndex": "681",
    "species": "Aegislash",
    "forme": "Aegislash (Shield Forme)",
    "type1": "Steel",
    "type2": "Ghost",
    "ability1": "Stance Change",
    "ability2": "",
    "abilityH": "",
    "hp": "60",
    "attack": "50",
    "defense": "150",
    "spattack": "50",
    "spdefense": "150",
    "speed": "60",
    "total": "520",
    "weight": "116.8 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Royal Sword Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Doublade",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "682",
    "ndex": "682",
    "species": "Spritzee",
    "forme": "Spritzee",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Healer",
    "ability2": "",
    "abilityH": "Aroma Veil",
    "hp": "78",
    "attack": "52",
    "defense": "60",
    "spattack": "63",
    "spdefense": "65",
    "speed": "23",
    "total": "341",
    "weight": "1.1 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Perfume Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "683",
    "ndex": "683",
    "species": "Aromatisse",
    "forme": "Aromatisse",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Healer",
    "ability2": "",
    "abilityH": "Aroma Veil",
    "hp": "101",
    "attack": "72",
    "defense": "72",
    "spattack": "99",
    "spdefense": "89",
    "speed": "29",
    "total": "462",
    "weight": "34.2 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Fragrance Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spritzee",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "684",
    "ndex": "684",
    "species": "Swirlix",
    "forme": "Swirlix",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Sweet Veil",
    "ability2": "",
    "abilityH": "Unburden",
    "hp": "62",
    "attack": "48",
    "defense": "66",
    "spattack": "59",
    "spdefense": "57",
    "speed": "49",
    "total": "341",
    "weight": "7.7 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Cotton Candy Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "685",
    "ndex": "685",
    "species": "Slurpuff",
    "forme": "Slurpuff",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Sweet Veil",
    "ability2": "",
    "abilityH": "Unburden",
    "hp": "82",
    "attack": "80",
    "defense": "86",
    "spattack": "85",
    "spdefense": "75",
    "speed": "72",
    "total": "480",
    "weight": "11.0 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Meringue Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Swirlix",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "686",
    "ndex": "686",
    "species": "Inkay",
    "forme": "Inkay",
    "type1": "Dark",
    "type2": "Psychic",
    "ability1": "Contrary",
    "ability2": "Suction Cups",
    "abilityH": "Infiltrator",
    "hp": "53",
    "attack": "54",
    "defense": "53",
    "spattack": "37",
    "spdefense": "46",
    "speed": "45",
    "total": "288",
    "weight": "7.7 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Revolving Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 2"
  },
  {
    "id": "687",
    "ndex": "687",
    "species": "Malamar",
    "forme": "Malamar",
    "type1": "Dark",
    "type2": "Psychic",
    "ability1": "Contrary",
    "ability2": "Suction Cups",
    "abilityH": "Infiltrator",
    "hp": "86",
    "attack": "92",
    "defense": "88",
    "spattack": "68",
    "spdefense": "75",
    "speed": "73",
    "total": "482",
    "weight": "103.6 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Overturning Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Inkay",
    "egg-group1": "Water 1",
    "egg-group2": "Water 2"
  },
  {
    "id": "688",
    "ndex": "688",
    "species": "Binacle",
    "forme": "Binacle",
    "type1": "Rock",
    "type2": "Water",
    "ability1": "Tough Claws",
    "ability2": "Sniper",
    "abilityH": "Pickpocket",
    "hp": "42",
    "attack": "52",
    "defense": "67",
    "spattack": "39",
    "spdefense": "56",
    "speed": "50",
    "total": "306",
    "weight": "68.3 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Two-Handed Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "689",
    "ndex": "689",
    "species": "Barbaracle",
    "forme": "Barbaracle",
    "type1": "Rock",
    "type2": "Water",
    "ability1": "Tough Claws",
    "ability2": "Sniper",
    "abilityH": "Pickpocket",
    "hp": "72",
    "attack": "105",
    "defense": "115",
    "spattack": "54",
    "spdefense": "86",
    "speed": "68",
    "total": "500",
    "weight": "211.6 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Collective Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Binacle",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "690",
    "ndex": "690",
    "species": "Skrelp",
    "forme": "Skrelp",
    "type1": "Poison",
    "type2": "Water",
    "ability1": "Poison Point",
    "ability2": "Poison Touch",
    "abilityH": "Adaptability",
    "hp": "50",
    "attack": "60",
    "defense": "60",
    "spattack": "60",
    "spdefense": "60",
    "speed": "30",
    "total": "320",
    "weight": "16.1 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Mock Kelp Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "691",
    "ndex": "691",
    "species": "Dragalge",
    "forme": "Dragalge",
    "type1": "Poison",
    "type2": "Dragon",
    "ability1": "Poison Point",
    "ability2": "Poison Touch",
    "abilityH": "Adaptability",
    "hp": "65",
    "attack": "75",
    "defense": "90",
    "spattack": "97",
    "spdefense": "123",
    "speed": "44",
    "total": "494",
    "weight": "179.7 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Mock Kelp Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Skrelp",
    "egg-group1": "Water 1",
    "egg-group2": "Dragon"
  },
  {
    "id": "692",
    "ndex": "692",
    "species": "Clauncher",
    "forme": "Clauncher",
    "type1": "Water",
    "type2": "",
    "ability1": "Mega Launcher",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "53",
    "defense": "62",
    "spattack": "58",
    "spdefense": "63",
    "speed": "44",
    "total": "330",
    "weight": "18.3 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Water Gun Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "693",
    "ndex": "693",
    "species": "Clawitzer",
    "forme": "Clawitzer",
    "type1": "Water",
    "type2": "",
    "ability1": "Mega Launcher",
    "ability2": "",
    "abilityH": "",
    "hp": "71",
    "attack": "73",
    "defense": "88",
    "spattack": "120",
    "spdefense": "89",
    "speed": "59",
    "total": "500",
    "weight": "77.8 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Howitzer Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Clauncher",
    "egg-group1": "Water 1",
    "egg-group2": "Water 3"
  },
  {
    "id": "694",
    "ndex": "694",
    "species": "Helioptile",
    "forme": "Helioptile",
    "type1": "Electric",
    "type2": "Normal",
    "ability1": "Dry Skin",
    "ability2": "Sand Veil",
    "abilityH": "Solar Power",
    "hp": "44",
    "attack": "38",
    "defense": "33",
    "spattack": "61",
    "spdefense": "43",
    "speed": "70",
    "total": "289",
    "weight": "13.2 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Generator Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "695",
    "ndex": "695",
    "species": "Heliolisk",
    "forme": "Heliolisk",
    "type1": "Electric",
    "type2": "Normal",
    "ability1": "Dry Skin",
    "ability2": "Sand Veil",
    "abilityH": "Solar Power",
    "hp": "62",
    "attack": "55",
    "defense": "52",
    "spattack": "109",
    "spdefense": "94",
    "speed": "109",
    "total": "481",
    "weight": "46.3 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Generator Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Helioptile",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "696",
    "ndex": "696",
    "species": "Tyrunt",
    "forme": "Tyrunt",
    "type1": "Rock",
    "type2": "Dragon",
    "ability1": "Strong Jaw",
    "ability2": "",
    "abilityH": "Sturdy",
    "hp": "58",
    "attack": "89",
    "defense": "77",
    "spattack": "45",
    "spdefense": "45",
    "speed": "48",
    "total": "362",
    "weight": "57.3 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Royal Heir Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "697",
    "ndex": "697",
    "species": "Tyrantrum",
    "forme": "Tyrantrum",
    "type1": "Rock",
    "type2": "Dragon",
    "ability1": "Strong Jaw",
    "ability2": "",
    "abilityH": "Rock Head",
    "hp": "82",
    "attack": "121",
    "defense": "119",
    "spattack": "69",
    "spdefense": "59",
    "speed": "71",
    "total": "521",
    "weight": "595.2 lbs.",
    "height": "8'02\"",
    "dex1": "",
    "dex2": "",
    "class": "Despot Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Tyrunt",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "698",
    "ndex": "698",
    "species": "Amaura",
    "forme": "Amaura",
    "type1": "Rock",
    "type2": "Ice",
    "ability1": "Refrigerate",
    "ability2": "",
    "abilityH": "Snow Warning",
    "hp": "77",
    "attack": "59",
    "defense": "50",
    "spattack": "67",
    "spdefense": "63",
    "speed": "46",
    "total": "362",
    "weight": "55.6 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Tundra Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "699",
    "ndex": "699",
    "species": "Aurorus",
    "forme": "Aurorus",
    "type1": "Rock",
    "type2": "Ice",
    "ability1": "Refrigerate",
    "ability2": "",
    "abilityH": "Snow Warning",
    "hp": "123",
    "attack": "77",
    "defense": "72",
    "spattack": "99",
    "spdefense": "92",
    "speed": "58",
    "total": "521",
    "weight": "496.0 lbs.",
    "height": "8'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Tundra Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Amaura",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "700",
    "ndex": "700",
    "species": "Sylveon",
    "forme": "Sylveon",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Cute Charm",
    "ability2": "",
    "abilityH": "Pixilate",
    "hp": "95",
    "attack": "65",
    "defense": "65",
    "spattack": "110",
    "spdefense": "130",
    "speed": "60",
    "total": "525",
    "weight": "51.8 lbs.",
    "height": "3'03\"",
    "dex1": "Its ribbonlike feelers give off an aura that weakens hostility in its prey, causing them to let down their guard. Then it attacks.",
    "dex2": "When this Pokémon sights its prey, it swirls its ribbonlike feelers as a distraction. A moment later, it pounces.",
    "class": "Intertwining Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Eevee",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "701",
    "ndex": "701",
    "species": "Hawlucha",
    "forme": "Hawlucha",
    "type1": "Fighting",
    "type2": "Flying",
    "ability1": "Limber",
    "ability2": "Unburden",
    "abilityH": "Mold Breaker",
    "hp": "78",
    "attack": "92",
    "defense": "75",
    "spattack": "74",
    "spdefense": "63",
    "speed": "118",
    "total": "500",
    "weight": "47.4 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Wrestling Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "702",
    "ndex": "702",
    "species": "Dedenne",
    "forme": "Dedenne",
    "type1": "Electric",
    "type2": "Fairy",
    "ability1": "Cheek Pouch",
    "ability2": "Pickup",
    "abilityH": "Plus",
    "hp": "67",
    "attack": "58",
    "defense": "57",
    "spattack": "81",
    "spdefense": "67",
    "speed": "101",
    "total": "431",
    "weight": "4.9 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Antenna Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "703",
    "ndex": "703",
    "species": "Carbink",
    "forme": "Carbink",
    "type1": "Rock",
    "type2": "Fairy",
    "ability1": "Clear Body",
    "ability2": "",
    "abilityH": "Sturdy",
    "hp": "50",
    "attack": "50",
    "defense": "150",
    "spattack": "50",
    "spdefense": "150",
    "speed": "50",
    "total": "500",
    "weight": "12.6 lbs.",
    "height": "1'00\"",
    "dex1": "Born from the high temperatures and pressures deep underground, it defends itself by firing beams from the jewel part of its body.",
    "dex2": "Although this Pokémon is not especially rare, its glittering, jewel-draped body draws attention from people.",
    "class": "Jewel Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": "Mineral"
  },
  {
    "id": "704",
    "ndex": "704",
    "species": "Goomy",
    "forme": "Goomy",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Sap Sipper",
    "ability2": "Hydration",
    "abilityH": "Gooey",
    "hp": "45",
    "attack": "50",
    "defense": "35",
    "spattack": "55",
    "spdefense": "75",
    "speed": "40",
    "total": "300",
    "weight": "6.2 lbs.",
    "height": "1'00\"",
    "dex1": "The weakest of all Dragon-type Pokémon, it’s unable to breathe if its skin dries out, so it sticks to shady places.",
    "dex2": "Its source of protection is its slimy, germ-laden mucous membrane. Anyone who touches it needs some thorough hand-washing.",
    "class": "Soft Tissue Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "705",
    "ndex": "705",
    "species": "Sliggoo",
    "forme": "Sliggoo",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Sap Sipper",
    "ability2": "Hydration",
    "abilityH": "Gooey",
    "hp": "68",
    "attack": "75",
    "defense": "53",
    "spattack": "83",
    "spdefense": "113",
    "speed": "60",
    "total": "452",
    "weight": "38.6 lbs.",
    "height": "2'07\"",
    "dex1": "It has trouble drawing a line between friends and food. It will calmly try to melt and eat even those it gets along well with.",
    "dex2": "This Pokémon’s mucous can dissolve anything. Toothless, it sprays mucous on its prey. Once they’re nicely dissolved, it slurps them up.",
    "class": "Soft Tissue Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Goomy",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "706",
    "ndex": "706",
    "species": "Goodra",
    "forme": "Goodra",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Sap Sipper",
    "ability2": "Hydration",
    "abilityH": "Gooey",
    "hp": "90",
    "attack": "100",
    "defense": "70",
    "spattack": "110",
    "spdefense": "150",
    "speed": "80",
    "total": "600",
    "weight": "331.8 lbs.",
    "height": "6'07\"",
    "dex1": "An amazingly friendly Pokémon, but if left to itself, loneliness overcomes it, and it oozes gooey tears.",
    "dex2": "It gets picked on because it’s meek. But then, whoever teased it gets to feel the full force of its horns and a good swatting from its thick tail.",
    "class": "Dragon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sliggoo",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "707",
    "ndex": "707",
    "species": "Klefki",
    "forme": "Klefki",
    "type1": "Steel",
    "type2": "Fairy",
    "ability1": "Prankster",
    "ability2": "",
    "abilityH": "Magician",
    "hp": "57",
    "attack": "80",
    "defense": "91",
    "spattack": "80",
    "spdefense": "87",
    "speed": "75",
    "total": "470",
    "weight": "6.6 lbs.",
    "height": "0'08\"",
    "dex1": "This even-tempered Pokémon has a habit of collecting keys. It will sneak into people’s homes to steal their keys.",
    "dex2": "It inserts its horn into chinks in metal, absorbing metal ions. For some reason, it collects keys.",
    "class": "Key Ring Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "708",
    "ndex": "708",
    "species": "Phantump",
    "forme": "Phantump",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Natural Cure",
    "ability2": "Frisk",
    "abilityH": "Harvest",
    "hp": "43",
    "attack": "70",
    "defense": "48",
    "spattack": "50",
    "spdefense": "60",
    "speed": "38",
    "total": "309",
    "weight": "15.4 lbs.",
    "height": "1'04\"",
    "dex1": "These Pokémon are stumps possessed by the spirits of children who died in the forest. Their cries sound like eerie screams.",
    "dex2": "According to legend, medicine to cure any illness can be made by plucking the green leaves on its head, brewing them, and boiling down the liquid.",
    "class": "Stump Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": "Amorphous"
  },
  {
    "id": "709",
    "ndex": "709",
    "species": "Trevenant",
    "forme": "Trevenant",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Natural Cure",
    "ability2": "Frisk",
    "abilityH": "Harvest",
    "hp": "85",
    "attack": "110",
    "defense": "76",
    "spattack": "65",
    "spdefense": "82",
    "speed": "56",
    "total": "474",
    "weight": "156.5 lbs.",
    "height": "4'11\"",
    "dex1": "This Pokémon is said to devour anyone daring to ravage the forest. To the creatures dwelling in the forest, it offers great kindness.",
    "dex2": "Through its roots, it exerts control over other trees. A deadly curse falls upon anyone cutting down trees in forests where Trevenant dwell.",
    "class": "Elder Tree Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Phantump",
    "egg-group1": "Grass",
    "egg-group2": "Amorphous"
  },
  {
    "id": "710",
    "ndex": "710",
    "species": "Pumpkaboo",
    "forme": "Pumpkaboo (Average Size)",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Pickup",
    "ability2": "Frisk",
    "abilityH": "Insomnia",
    "hp": "49",
    "attack": "66",
    "defense": "70",
    "spattack": "44",
    "spdefense": "55",
    "speed": "51",
    "total": "335",
    "weight": "11.0 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Pumpkin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "711",
    "ndex": "711",
    "species": "Gourgeist",
    "forme": "Gourgeist (Average Size)",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Pickup",
    "ability2": "Frisk",
    "abilityH": "Insomnia",
    "hp": "65",
    "attack": "90",
    "defense": "122",
    "spattack": "58",
    "spdefense": "75",
    "speed": "84",
    "total": "494",
    "weight": "27.6 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Pumpkin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pumpkaboo (Average Size)",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "712",
    "ndex": "712",
    "species": "Bergmite",
    "forme": "Bergmite",
    "type1": "Ice",
    "type2": "",
    "ability1": "Own Tempo",
    "ability2": "Ice Body",
    "abilityH": "Sturdy",
    "hp": "55",
    "attack": "69",
    "defense": "85",
    "spattack": "32",
    "spdefense": "35",
    "speed": "28",
    "total": "304",
    "weight": "219.4 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Ice Chunk Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "713",
    "ndex": "713",
    "species": "Avalugg",
    "forme": "Avalugg",
    "type1": "Ice",
    "type2": "",
    "ability1": "Own Tempo",
    "ability2": "Ice Body",
    "abilityH": "Sturdy",
    "hp": "95",
    "attack": "117",
    "defense": "184",
    "spattack": "44",
    "spdefense": "46",
    "speed": "28",
    "total": "514",
    "weight": "1113.3 lbs.",
    "height": "6'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Iceberg Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Bergmite",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "714",
    "ndex": "714",
    "species": "Noibat",
    "forme": "Noibat",
    "type1": "Flying",
    "type2": "Dragon",
    "ability1": "Frisk",
    "ability2": "Infiltrator",
    "abilityH": "Telepathy",
    "hp": "40",
    "attack": "30",
    "defense": "35",
    "spattack": "45",
    "spdefense": "40",
    "speed": "55",
    "total": "245",
    "weight": "17.6 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Sound Wave Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "715",
    "ndex": "715",
    "species": "Noivern",
    "forme": "Noivern",
    "type1": "Flying",
    "type2": "Dragon",
    "ability1": "Frisk",
    "ability2": "Infiltrator",
    "abilityH": "Telepathy",
    "hp": "85",
    "attack": "70",
    "defense": "80",
    "spattack": "97",
    "spdefense": "80",
    "speed": "123",
    "total": "535",
    "weight": "187.4 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Sound Wave Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Noibat",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "716",
    "ndex": "716",
    "species": "Xerneas",
    "forme": "Xerneas (Neutral Mode)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Fairy Aura",
    "ability2": "",
    "abilityH": "",
    "hp": "126",
    "attack": "131",
    "defense": "95",
    "spattack": "131",
    "spdefense": "98",
    "speed": "99",
    "total": "680",
    "weight": "474.0 lbs.",
    "height": "9'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Life Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "717",
    "ndex": "717",
    "species": "Yveltal",
    "forme": "Yveltal",
    "type1": "Dark",
    "type2": "Flying",
    "ability1": "Dark Aura",
    "ability2": "",
    "abilityH": "",
    "hp": "126",
    "attack": "131",
    "defense": "95",
    "spattack": "131",
    "spdefense": "98",
    "speed": "99",
    "total": "680",
    "weight": "447.5 lbs.",
    "height": "19'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Destruction Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "718",
    "ndex": "718",
    "species": "Zygarde",
    "forme": "Zygarde (50% Forme)",
    "type1": "Dragon",
    "type2": "Ground",
    "ability1": "Aura Break",
    "ability2": "",
    "abilityH": "",
    "hp": "108",
    "attack": "100",
    "defense": "121",
    "spattack": "81",
    "spdefense": "95",
    "speed": "95",
    "total": "600",
    "weight": "672.4 lbs.",
    "height": "16'05\"",
    "dex1": "This is Zygarde’s form when it has gathered 50% of its cells. It wipes out all those who oppose it, showing not a shred of mercy.",
    "dex2": "It’s thought to be monitoring the ecosystem. There are rumors that even greater power lies hidden within it.",
    "class": "Order Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "719",
    "ndex": "719",
    "species": "Diancie",
    "forme": "Diancie",
    "type1": "Rock",
    "type2": "Fairy",
    "ability1": "Clear Body",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "100",
    "defense": "150",
    "spattack": "100",
    "spdefense": "150",
    "speed": "50",
    "total": "600",
    "weight": "19.4 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Jewel Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "720",
    "ndex": "720",
    "species": "Hoopa",
    "forme": "Hoopa (Hoopa Confined)",
    "type1": "Psychic",
    "type2": "Ghost",
    "ability1": "Magician",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "110",
    "defense": "60",
    "spattack": "150",
    "spdefense": "130",
    "speed": "70",
    "total": "600",
    "weight": "19.8 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Mischief Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "721",
    "ndex": "721",
    "species": "Volcanion",
    "forme": "Volcanion",
    "type1": "Fire",
    "type2": "Water",
    "ability1": "Water Absorb",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "110",
    "defense": "120",
    "spattack": "130",
    "spdefense": "90",
    "speed": "70",
    "total": "600",
    "weight": "429.9 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Steam Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "722",
    "ndex": "722",
    "species": "Rowlet",
    "forme": "Rowlet",
    "type1": "Grass",
    "type2": "Flying",
    "ability1": "Overgrow",
    "ability2": "Overgrow",
    "abilityH": "Long Reach",
    "hp": "68",
    "attack": "55",
    "defense": "55",
    "spattack": "50",
    "spdefense": "50",
    "speed": "42",
    "total": "320",
    "weight": "3.3 lbs.",
    "height": "1'00\"",
    "dex1": "This wary Pokémon uses photosynthesis to store up energy during the day, while becoming active at night.",
    "dex2": "Silently it glides, drawing near its targets. Before they even notice it, it begins to pelt them with vicious kicks.",
    "class": "Grass Quill Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "723",
    "ndex": "723",
    "species": "Dartrix",
    "forme": "Dartrix",
    "type1": "Grass",
    "type2": "Flying",
    "ability1": "Overgrow",
    "ability2": "Overgrow",
    "abilityH": "Long Reach",
    "hp": "78",
    "attack": "75",
    "defense": "75",
    "spattack": "70",
    "spdefense": "70",
    "speed": "52",
    "total": "420",
    "weight": "35.3 lbs.",
    "height": "2'04\"",
    "dex1": "A bit of a dandy, it spends its free time preening its wings. Its preoccupation with any dirt on its plumage can leave it unable to battle.",
    "dex2": "It throws sharp feathers called blade quills at enemies or prey. It seldom misses.",
    "class": "Blade Quill Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Rowlet",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "724",
    "ndex": "724",
    "species": "Decidueye",
    "forme": "Decidueye",
    "type1": "Grass",
    "type2": "Ghost",
    "ability1": "Overgrow",
    "ability2": "Overgrow",
    "abilityH": "Long Reach",
    "hp": "78",
    "attack": "107",
    "defense": "75",
    "spattack": "100",
    "spdefense": "100",
    "speed": "70",
    "total": "530",
    "weight": "80.7 lbs.",
    "height": "5'03\"",
    "dex1": "It fires arrow quills from its wings with such precision, they can pierce a pebble at distances over a hundred yards.",
    "dex2": "Although basically cool and cautious, when it’s caught by surprise, it’s seized by panic.",
    "class": "Arrow Quill Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Dartrix",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "725",
    "ndex": "725",
    "species": "Litten",
    "forme": "Litten",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "Blaze",
    "abilityH": "Intimidate",
    "hp": "45",
    "attack": "65",
    "defense": "40",
    "spattack": "60",
    "spdefense": "40",
    "speed": "70",
    "total": "320",
    "weight": "9.5 lbs.",
    "height": "1'04\"",
    "dex1": "While grooming itself, it builds up fur inside its stomach. It sets the fur alight and spews fiery attacks, which change based on how it coughs.",
    "dex2": "It doesn’t allow its emotions to be easily seen. Earning its trust takes time. It prefers solitude.",
    "class": "Fire Cat Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "726",
    "ndex": "726",
    "species": "Torracat",
    "forme": "Torracat",
    "type1": "Fire",
    "type2": "",
    "ability1": "Blaze",
    "ability2": "Blaze",
    "abilityH": "Intimidate",
    "hp": "65",
    "attack": "85",
    "defense": "50",
    "spattack": "80",
    "spdefense": "50",
    "speed": "90",
    "total": "420",
    "weight": "55.1 lbs.",
    "height": "2'04\"",
    "dex1": "At its throat, it bears a bell of fire. The bell rings brightly whenever this Pokémon spits fire.",
    "dex2": "It boasts powerful front legs. With a single punch, it can bend an iron bar right over.",
    "class": "Fire Cat Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Litten",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "727",
    "ndex": "727",
    "species": "Incineroar",
    "forme": "Incineroar",
    "type1": "Fire",
    "type2": "Dark",
    "ability1": "Blaze",
    "ability2": "Blaze",
    "abilityH": "Intimidate",
    "hp": "95",
    "attack": "115",
    "defense": "90",
    "spattack": "80",
    "spdefense": "90",
    "speed": "60",
    "total": "530",
    "weight": "183.0 lbs.",
    "height": "5'11\"",
    "dex1": "This Pokémon has a violent, selfish disposition. If it’s not in the mood to listen, it will ignore its Trainer’s orders with complete nonchalance.",
    "dex2": "After hurling ferocious punches and flinging furious kicks, it finishes opponents off by spewing fire from around its navel.",
    "class": "Heel Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Torracat",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "728",
    "ndex": "728",
    "species": "Popplio",
    "forme": "Popplio",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "Torrent",
    "abilityH": "Liquid Voice",
    "hp": "50",
    "attack": "54",
    "defense": "54",
    "spattack": "66",
    "spdefense": "56",
    "speed": "40",
    "total": "320",
    "weight": "16.5 lbs.",
    "height": "1'04\"",
    "dex1": "This Pokémon snorts body fluids from its nose, blowing balloons to smash into its foes. It’s famous for being a hard worker.",
    "dex2": "This Pokémon can control water bubbles. It practices diligently so it can learn to make big bubbles.",
    "class": "Sea Lion Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "729",
    "ndex": "729",
    "species": "Brionne",
    "forme": "Brionne",
    "type1": "Water",
    "type2": "",
    "ability1": "Torrent",
    "ability2": "Torrent",
    "abilityH": "Liquid Voice",
    "hp": "60",
    "attack": "69",
    "defense": "69",
    "spattack": "91",
    "spdefense": "81",
    "speed": "50",
    "total": "420",
    "weight": "38.6 lbs.",
    "height": "2'00\"",
    "dex1": "A skillful dancer, it creates a sequence of water balloons as it dances, and briskly bombards its enemies.",
    "dex2": "It cares deeply for its companions. When its Trainer is feeling down, it performs a cheery dance to try and help.",
    "class": "Pop Star Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Popplio",
    "egg-group1": "Water 1",
    "egg-group2": "Field"
  },
  {
    "id": "730",
    "ndex": "730",
    "species": "Primarina",
    "forme": "Primarina",
    "type1": "Water",
    "type2": "Fairy",
    "ability1": "Torrent",
    "ability2": "Torrent",
    "abilityH": "Liquid Voice",
    "hp": "80",
    "attack": "74",
    "defense": "74",
    "spattack": "126",
    "spdefense": "116",
    "speed": "60",
    "total": "530",
    "weight": "97.0 lbs.",
    "height": "5'11\"",
    "dex1": "It controls its water balloons with song. The melody is learned from others of its kind and is passed down from one generation to the next.",
    "dex2": "Its singing voice is its chief weapon in battle. This Pokémon’s Trainer must prioritize the daily maintenance of its throat at all costs.",
    "class": "Soloist Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Brionne",
    "egg-group1": "Water 2",
    "egg-group2": "Field"
  },
  {
    "id": "731",
    "ndex": "731",
    "species": "Pikipek",
    "forme": "Pikipek",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Skill Link",
    "abilityH": "Pickup",
    "hp": "35",
    "attack": "75",
    "defense": "30",
    "spattack": "30",
    "spdefense": "30",
    "speed": "65",
    "total": "265",
    "weight": "2.6 lbs.",
    "height": "1'00\"",
    "dex1": "It can peck at a rate of 16 times a second to drill holes in trees. It uses the holes for food storage and for nesting.",
    "dex2": "This Pokémon feeds on berries, whose leftover seeds become the ammunition for the attacks it fires off from its mouth.",
    "class": "Woodpecker Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "732",
    "ndex": "732",
    "species": "Trumbeak",
    "forme": "Trumbeak",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Skill Link",
    "abilityH": "Pickup",
    "hp": "55",
    "attack": "85",
    "defense": "50",
    "spattack": "40",
    "spdefense": "50",
    "speed": "75",
    "total": "355",
    "weight": "32.6 lbs.",
    "height": "2'00\"",
    "dex1": "It eats berries and stores their seeds in its beak. When it encounters enemies or prey, it fires off all the seeds in a burst.",
    "dex2": "By bending its beak, it can produce a variety of calls and brand itself a noisy nuisance for its neighbors.",
    "class": "Bugle Beak Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pipipek",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "733",
    "ndex": "733",
    "species": "Toucannon",
    "forme": "Toucannon",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "Keen Eye",
    "ability2": "Skill Link",
    "abilityH": "Sheer Force",
    "hp": "80",
    "attack": "120",
    "defense": "75",
    "spattack": "75",
    "spdefense": "75",
    "speed": "60",
    "total": "485",
    "weight": "57.3 lbs.",
    "height": "3'07\"",
    "dex1": "When it battles, its beak heats up. The temperature can easily exceed 212 degrees Fahrenheit, causing severe burns when it hits.",
    "dex2": "Within its beak, its internal gas ignites, explosively launching seeds with enough power to pulverize boulders.",
    "class": "Cannon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Trumbeak",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "734",
    "ndex": "734",
    "species": "Yungoos",
    "forme": "Yungoos",
    "type1": "Normal",
    "type2": "",
    "ability1": "Stakeout",
    "ability2": "Strong Jaw",
    "abilityH": "Adaptability",
    "hp": "48",
    "attack": "70",
    "defense": "30",
    "spattack": "30",
    "spdefense": "30",
    "speed": "45",
    "total": "253",
    "weight": "13.2 lbs.",
    "height": "1'04\"",
    "dex1": "With its sharp fangs, it will bite anything. It did not originally live in Alola but was imported from another region.",
    "dex2": "It wanders around in a never-ending search for food. At dusk, it collapses from exhaustion and falls asleep on the spot.",
    "class": "Loitering Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "735",
    "ndex": "735",
    "species": "Gumshoos",
    "forme": "Gumshoos",
    "type1": "Normal",
    "type2": "",
    "ability1": "Stakeout",
    "ability2": "Strong Jaw",
    "abilityH": "Adaptability",
    "hp": "88",
    "attack": "110",
    "defense": "60",
    "spattack": "55",
    "spdefense": "60",
    "speed": "45",
    "total": "418",
    "weight": "31.3 lbs.",
    "height": "2'04\"",
    "dex1": "When it finds a trace of its prey, it patiently stakes out the location...but it’s always snoozing by nightfall.",
    "dex2": "It adores having Rattata and Raticate for dinner, but as it’s diurnal, it never encounters them. This Pokémon boasts incredible patience.",
    "class": "Stakeout Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Yungoos",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "736",
    "ndex": "736",
    "species": "Grubbin",
    "forme": "Grubbin",
    "type1": "Bug",
    "type2": "",
    "ability1": "Swarm",
    "ability2": "Swarm",
    "abilityH": "Swarm",
    "hp": "47",
    "attack": "62",
    "defense": "45",
    "spattack": "55",
    "spdefense": "45",
    "speed": "46",
    "total": "300",
    "weight": "9.7 lbs.",
    "height": "1'04\"",
    "dex1": "Its strong jaw enables it to scrape trees and slurp out the sap. It normally lives underground.",
    "dex2": "They often gather near places frequented by electric Pokémon in order to avoid being attacked by bird Pokémon.",
    "class": "Larva Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "737",
    "ndex": "737",
    "species": "Charjabug",
    "forme": "Charjabug",
    "type1": "Bug",
    "type2": "Electric",
    "ability1": "Battery",
    "ability2": "Battery",
    "abilityH": "Battery",
    "hp": "57",
    "attack": "82",
    "defense": "95",
    "spattack": "55",
    "spdefense": "75",
    "speed": "36",
    "total": "400",
    "weight": "23.1 lbs.",
    "height": "1'08\"",
    "dex1": "Its body is capable of storing electricity. On camping trips, people are grateful to have one around.",
    "dex2": "From the food it digests, it generates electricity, and it stores this energy in its electric sac.",
    "class": "Battery Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Grubbin",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "738",
    "ndex": "738",
    "species": "Vikavolt",
    "forme": "Vikavolt",
    "type1": "Bug",
    "type2": "Electric",
    "ability1": "Levitate",
    "ability2": "Levitate",
    "abilityH": "Levitate",
    "hp": "77",
    "attack": "70",
    "defense": "90",
    "spattack": "145",
    "spdefense": "75",
    "speed": "43",
    "total": "500",
    "weight": "99.2 lbs.",
    "height": "4'11\"",
    "dex1": "It zips around, on sharp lookout for an opening. It concentrates electrical energy within its large jaws and uses it to zap its enemies.",
    "dex2": "It produces electricity via an electrical organ in its abdomen. It overwhelms bird Pokémon with shocking beams of electrical energy.",
    "class": "Stag Beetle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Charjabug",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "739",
    "ndex": "739",
    "species": "Crabrawler",
    "forme": "Crabrawler",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Hyper Cutter",
    "ability2": "Iron Fist",
    "abilityH": "Anger Point",
    "hp": "47",
    "attack": "82",
    "defense": "57",
    "spattack": "42",
    "spdefense": "47",
    "speed": "63",
    "total": "338",
    "weight": "15.4 lbs.",
    "height": "2'00\"",
    "dex1": "While guarding its weak points with its pincers, it looks for an opening and unleashes punches. When it loses, it foams at the mouth and faints.",
    "dex2": "It punches so much, its pincers often come off from overuse, but they grow back quickly. What little meat they contain is rich and delicious.",
    "class": "Boxing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 3",
    "egg-group2": ""
  },
  {
    "id": "740",
    "ndex": "740",
    "species": "Crabominable",
    "forme": "Crabominable",
    "type1": "Fighting",
    "type2": "Ice",
    "ability1": "Hyper Cutter",
    "ability2": "Iron Fist",
    "abilityH": "Anger Point",
    "hp": "97",
    "attack": "132",
    "defense": "77",
    "spattack": "62",
    "spdefense": "67",
    "speed": "43",
    "total": "478",
    "weight": "396.8 lbs.",
    "height": "5'07\"",
    "dex1": "It aimed for the top but got lost and ended up on a snowy mountain. Being forced to endure the cold, this Pokémon evolved and grew fur.",
    "dex2": "It just throws punches indiscriminately. In times of desperation, it can lop off its own pincers and fire them like rockets.",
    "class": "Woolly Crab Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Crabrawler",
    "egg-group1": "Water 4",
    "egg-group2": ""
  },
  {
    "id": "741",
    "ndex": "741",
    "species": "Oricorio",
    "forme": "Oricorio (Baile Style)",
    "type1": "Fire",
    "type2": "Flying",
    "ability1": "Dancer",
    "ability2": "Dancer",
    "abilityH": "Dancer",
    "hp": "75",
    "attack": "70",
    "defense": "70",
    "spattack": "98",
    "spdefense": "70",
    "speed": "93",
    "total": "476",
    "weight": "7.5 lbs.",
    "height": "2'00\"",
    "dex1": "It beats its wings together to create fire. As it moves in the steps of its beautiful dance, it bathes opponents in intense flames.",
    "dex2": "This Oricorio has sipped red nectar. Its passionate dance moves cause its enemies to combust in both body and mind.",
    "class": "Dancing Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "742",
    "ndex": "742",
    "species": "Cutiefly",
    "forme": "Cutiefly",
    "type1": "Bug",
    "type2": "Fairy",
    "ability1": "Honey Gather",
    "ability2": "Shield Dust",
    "abilityH": "Sweet Veil",
    "hp": "40",
    "attack": "45",
    "defense": "40",
    "spattack": "55",
    "spdefense": "40",
    "speed": "84",
    "total": "304",
    "weight": "0.4 lbs.",
    "height": "0'04\"",
    "dex1": "It feeds on the nectar and pollen of flowers. Because it’s able to sense auras, it can identify which flowers are about to bloom.",
    "dex2": "Myriads of Cutiefly flutter above the heads of people who have auras resembling those of flowers.",
    "class": "Bee Fly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": "Fairy"
  },
  {
    "id": "743",
    "ndex": "743",
    "species": "Ribombee",
    "forme": "Ribombee",
    "type1": "Bug",
    "type2": "Fairy",
    "ability1": "Honey Gather",
    "ability2": "Shield Dust",
    "abilityH": "Sweet Veil",
    "hp": "60",
    "attack": "55",
    "defense": "60",
    "spattack": "95",
    "spdefense": "70",
    "speed": "124",
    "total": "464",
    "weight": "1.1 lbs.",
    "height": "0'08\"",
    "dex1": "It rolls up pollen into puffs. It makes many different varieties, some used as food and others used in battle.",
    "dex2": "Some of Ribombee’s pollen puffs are highly nutritious. They are sometimes sold as supplements.",
    "class": "Bee Fly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Cutiefly",
    "egg-group1": "Bug",
    "egg-group2": "Fairy"
  },
  {
    "id": "744",
    "ndex": "744",
    "species": "Rockruff",
    "forme": "Rockruff",
    "type1": "Rock",
    "type2": "",
    "ability1": "Keen Eye",
    "ability2": "Vital spirit",
    "abilityH": "Steadfast",
    "hp": "45",
    "attack": "65",
    "defense": "40",
    "spattack": "30",
    "spdefense": "40",
    "speed": "60",
    "total": "280",
    "weight": "20.3 lbs.",
    "height": "1'08\"",
    "dex1": "It’s considered to be a good Pokémon for beginners because of its friendliness, but its disposition grows rougher as it grows up.",
    "dex2": "This Pokémon has lived with people since times long ago. It can sense when its Trainer is in the dumps and will stick close by its Trainer’s side.",
    "class": "Puppy Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "745",
    "ndex": "745",
    "species": "Lycanroc",
    "forme": "Lycanroc (Midday Form)",
    "type1": "Rock",
    "type2": "",
    "ability1": "Keen Eye",
    "ability2": "Sand Rush",
    "abilityH": "Steadfast",
    "hp": "75",
    "attack": "115",
    "defense": "65",
    "spattack": "55",
    "spdefense": "65",
    "speed": "112",
    "total": "487",
    "weight": "55.1 lbs.",
    "height": "2'07\"",
    "dex1": "Its quick movements confuse its enemies. Well equipped with claws and fangs, it also uses the sharp rocks in its mane as weapons.",
    "dex2": "When properly raised from a young age, it will become a trustworthy partner that will absolutely never betray its Trainer.",
    "class": "Wolf Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Rockruff",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "746",
    "ndex": "746",
    "species": "Wishiwashi",
    "forme": "Wishiwashi (Solo Form)",
    "type1": "Water",
    "type2": "",
    "ability1": "Schooling",
    "ability2": "Schooling",
    "abilityH": "Schooling",
    "hp": "45",
    "attack": "20",
    "defense": "20",
    "spattack": "25",
    "spdefense": "25",
    "speed": "40",
    "total": "175",
    "weight": "0.7 lbs.",
    "height": "0'08\"",
    "dex1": "When it’s in trouble, its eyes moisten and begin to shine. The shining light attracts its comrades, and they stand together against their enemies.",
    "dex2": "It’s awfully weak and notably tasty, so everyone is always out to get it. As it happens, anyone trying to bully it receives a painful lesson.",
    "class": "Small Fry Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "747",
    "ndex": "747",
    "species": "Mareanie",
    "forme": "Mareanie",
    "type1": "Poison",
    "type2": "Water",
    "ability1": "Merciless",
    "ability2": "Limber",
    "abilityH": "Regenerator",
    "hp": "50",
    "attack": "53",
    "defense": "62",
    "spattack": "43",
    "spdefense": "52",
    "speed": "45",
    "total": "305",
    "weight": "17.6 lbs.",
    "height": "1'04\"",
    "dex1": "It plunges the poison spike on its head into its prey. When the prey has weakened, Mareanie deals the finishing blow with its 10 tentacles.",
    "dex2": "It’s found crawling on beaches and seafloors. The coral that grows on Corsola’s head is as good as a five-star banquet to this Pokémon.",
    "class": "Brutal Star Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "748",
    "ndex": "748",
    "species": "Toxapex",
    "forme": "Toxapex",
    "type1": "Poison",
    "type2": "Water",
    "ability1": "Merciless",
    "ability2": "Limber",
    "abilityH": "Regenerator",
    "hp": "50",
    "attack": "63",
    "defense": "152",
    "spattack": "53",
    "spdefense": "142",
    "speed": "35",
    "total": "495",
    "weight": "32.0 lbs.",
    "height": "2'04\"",
    "dex1": "Toxapex crawls along the ocean floor on its 12 legs. It leaves a trail of Corsola bits scattered in its wake.",
    "dex2": "Those attacked by Toxapex’s poison will suffer intense pain for three days and three nights. Post-recovery, there will be some aftereffects.",
    "class": "Brutal Star Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Mareanie",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "749",
    "ndex": "749",
    "species": "Mudbray",
    "forme": "Mudbray",
    "type1": "Ground",
    "type2": "",
    "ability1": "Own Tempo",
    "ability2": "Stamina",
    "abilityH": "Inner Focus",
    "hp": "70",
    "attack": "100",
    "defense": "70",
    "spattack": "45",
    "spdefense": "55",
    "speed": "45",
    "total": "385",
    "weight": "242.5 lbs.",
    "height": "3'03\"",
    "dex1": "The mud stuck to Mudbray’s hooves enhances its grip and its powerful running gait.",
    "dex2": "It has a stubborn, individualistic disposition. Eating dirt, making mud, and playing in the mire all form part of its daily routine.",
    "class": "Donkey Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "750",
    "ndex": "750",
    "species": "Mudsdale",
    "forme": "Mudsdale",
    "type1": "Ground",
    "type2": "",
    "ability1": "Own Tempo",
    "ability2": "Stamina",
    "abilityH": "Inner Focus",
    "hp": "100",
    "attack": "125",
    "defense": "100",
    "spattack": "55",
    "spdefense": "85",
    "speed": "35",
    "total": "500",
    "weight": "2028.3 lbs.",
    "height": "8'02\"",
    "dex1": "It spits a mud that provides resistance to both wind and rain, so the walls of old houses were often coated with it.",
    "dex2": "Its heavy, mud-covered kicks are its best means of attack, and it can reduce large trucks to scrap without breaking a sweat.",
    "class": "Draft Horse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Mudbray",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "751",
    "ndex": "751",
    "species": "Dewpider",
    "forme": "Dewpider",
    "type1": "Water",
    "type2": "Bug",
    "ability1": "Water Bubble",
    "ability2": "Water Bubble",
    "abilityH": "Water Absorb",
    "hp": "38",
    "attack": "40",
    "defense": "52",
    "spattack": "40",
    "spdefense": "72",
    "speed": "27",
    "total": "269",
    "weight": "8.8 lbs.",
    "height": "1'00\"",
    "dex1": "It crawls onto the land in search of food. Its water bubble allows it to breathe and protects its soft head.",
    "dex2": "When it comes across enemies or potential prey, this Pokémon smashes its water-bubble-covered head into them.",
    "class": "Water Bubble Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Bug"
  },
  {
    "id": "752",
    "ndex": "752",
    "species": "Araquanid",
    "forme": "Araquanid",
    "type1": "Water",
    "type2": "Bug",
    "ability1": "Water Bubble",
    "ability2": "Water Bubble",
    "abilityH": "Water Absorb",
    "hp": "68",
    "attack": "70",
    "defense": "92",
    "spattack": "50",
    "spdefense": "132",
    "speed": "42",
    "total": "454",
    "weight": "180.8 lbs.",
    "height": "5'11\"",
    "dex1": "It delivers headbutts with the water bubble on its head. Small Pokémon get sucked into the bubble, where they drown.",
    "dex2": "Despite what its appearance suggests, it cares for others. If it finds vulnerable, weak Pokémon, it protectively brings them into its water bubble.",
    "class": "Water Bubble Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Dewpider",
    "egg-group1": "Water 2",
    "egg-group2": "Bug"
  },
  {
    "id": "753",
    "ndex": "753",
    "species": "Fomantis",
    "forme": "Fomantis",
    "type1": "Grass",
    "type2": "",
    "ability1": "Leaf Guard",
    "ability2": "Leaf Guard",
    "abilityH": "Contrary",
    "hp": "40",
    "attack": "55",
    "defense": "35",
    "spattack": "50",
    "spdefense": "35",
    "speed": "35",
    "total": "250",
    "weight": "3.3 lbs.",
    "height": "1'00\"",
    "dex1": "During the day, it sleeps and soaks up light. When night falls, it walks around looking for a safer place to sleep.",
    "dex2": "They give off a sweet and refreshing scent. Cutiefly often gather near the tall grass where Fomantis are hiding.",
    "class": "Sickle Grass Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "754",
    "ndex": "754",
    "species": "Lurantis",
    "forme": "Lurantis",
    "type1": "Grass",
    "type2": "",
    "ability1": "Leaf Guard",
    "ability2": "Leaf Guard",
    "abilityH": "Contrary",
    "hp": "70",
    "attack": "105",
    "defense": "90",
    "spattack": "80",
    "spdefense": "90",
    "speed": "45",
    "total": "480",
    "weight": "40.8 lbs.",
    "height": "2'11\"",
    "dex1": "It requires a lot of effort to maintain Lurantis’s vivid coloring, but some collectors enjoy this work and treat it as their hobby.",
    "dex2": "It fires beams from its sickle-shaped petals. These beams are powerful enough to cleave through thick metal plates.",
    "class": "Bloom Sickle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Fomantis",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "755",
    "ndex": "755",
    "species": "Morelull",
    "forme": "Morelull",
    "type1": "Grass",
    "type2": "Fairy",
    "ability1": "Illuminate",
    "ability2": "Effect Spore",
    "abilityH": "Rain Dish",
    "hp": "40",
    "attack": "35",
    "defense": "55",
    "spattack": "65",
    "spdefense": "75",
    "speed": "15",
    "total": "285",
    "weight": "3.3 lbs.",
    "height": "0'08\"",
    "dex1": "It scatters spores that flicker and glow. Anyone seeing these lights falls into a deep slumber.",
    "dex2": "As it drowses the day away, it nourishes itself by sucking from tree roots. It wakens at the fall of night, wandering off in search of a new tree.",
    "class": "Illuminating Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "756",
    "ndex": "756",
    "species": "Shiinotic",
    "forme": "Shiinotic",
    "type1": "Grass",
    "type2": "Fairy",
    "ability1": "Illuminate",
    "ability2": "Effect Spore",
    "abilityH": "Rain Dish",
    "hp": "60",
    "attack": "45",
    "defense": "80",
    "spattack": "90",
    "spdefense": "100",
    "speed": "30",
    "total": "405",
    "weight": "25.4 lbs.",
    "height": "3'03\"",
    "dex1": "Forests where Shiinotic live are treacherous to enter at night. People confused by its strange lights can never find their way home again.",
    "dex2": "It emits flickering spores that cause drowsiness. When its prey succumb to sleep, this Pokémon feeds on them by sucking in their energy.",
    "class": "Illuminating Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Morelull",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "757",
    "ndex": "757",
    "species": "Salandit",
    "forme": "Salandit",
    "type1": "Poison",
    "type2": "Fire",
    "ability1": "Corrosion",
    "ability2": "Corrosion",
    "abilityH": "Oblivious",
    "hp": "48",
    "attack": "44",
    "defense": "40",
    "spattack": "71",
    "spdefense": "40",
    "speed": "77",
    "total": "320",
    "weight": "10.6 lbs.",
    "height": "2'00\"",
    "dex1": "It burns its bodily fluids to create a poisonous gas. When its enemies become disoriented from inhaling the gas, it attacks them.",
    "dex2": "Volcanoes or dry, craggy places are its home. It emanates a sweet-smelling poisonous gas that attracts bug Pokémon, then attacks them.",
    "class": "Toxic Lizard Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "758",
    "ndex": "758",
    "species": "Salazzle",
    "forme": "Salazzle",
    "type1": "Poison",
    "type2": "Fire",
    "ability1": "Corrosion",
    "ability2": "Corrosion",
    "abilityH": "Oblivious",
    "hp": "68",
    "attack": "64",
    "defense": "60",
    "spattack": "111",
    "spdefense": "60",
    "speed": "117",
    "total": "480",
    "weight": "48.9 lbs.",
    "height": "3'11\"",
    "dex1": "For some reason, only females have been found. It creates a reverse harem of male Salandit that it lives with.",
    "dex2": "Filled with pheromones, its poisonous gas can be diluted to use in the production of luscious perfumes.",
    "class": "Toxic Lizard Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Sandalit",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "759",
    "ndex": "759",
    "species": "Stufful",
    "forme": "Stufful",
    "type1": "Normal",
    "type2": "Fighting",
    "ability1": "Fluffy",
    "ability2": "Klutz",
    "abilityH": "Cute Charm",
    "hp": "70",
    "attack": "75",
    "defense": "50",
    "spattack": "45",
    "spdefense": "50",
    "speed": "50",
    "total": "340",
    "weight": "15.0 lbs.",
    "height": "1'08\"",
    "dex1": "Despite its adorable appearance, when it gets angry and flails about, its arms and legs could knock a pro wrestler sprawling.",
    "dex2": "A touch from anyone except a known friend sends it into a surging frenzy. It’s an incredibly dangerous Pokémon.",
    "class": "Flailing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "760",
    "ndex": "760",
    "species": "Bewear",
    "forme": "Bewear",
    "type1": "Normal",
    "type2": "Fighting",
    "ability1": "Fluffy",
    "ability2": "Klutz",
    "abilityH": "Unnerve",
    "hp": "120",
    "attack": "125",
    "defense": "80",
    "spattack": "55",
    "spdefense": "60",
    "speed": "60",
    "total": "500",
    "weight": "297.6 lbs.",
    "height": "6'11\"",
    "dex1": "This immensely dangerous Pokémon possesses overwhelming physical strength. Its habitat is generally off-limits.",
    "dex2": "This Pokémon has the habit of hugging its companions. Many Trainers have left this world after their spines were squashed by its hug.",
    "class": "Strong Arm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Stufful",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "761",
    "ndex": "761",
    "species": "Bounsweet",
    "forme": "Bounsweet",
    "type1": "Grass",
    "type2": "",
    "ability1": "Leaf Guard",
    "ability2": "Oblivious",
    "abilityH": "Sweet Veil",
    "hp": "42",
    "attack": "30",
    "defense": "38",
    "spattack": "30",
    "spdefense": "38",
    "speed": "32",
    "total": "210",
    "weight": "7.1 lbs.",
    "height": "1'00\"",
    "dex1": "A delectable aroma pours from its body. They are often swallowed whole by Toucannon lured by that wafting deliciousness.",
    "dex2": "Although it’s too sugary for human consumption, Bounsweet’s sweat can be watered down into a juice with just the right amount of sweetness.",
    "class": "Fruit Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "762",
    "ndex": "762",
    "species": "Steenee",
    "forme": "Steenee",
    "type1": "Grass",
    "type2": "",
    "ability1": "Leaf Guard",
    "ability2": "Oblivious",
    "abilityH": "Sweet Veil",
    "hp": "52",
    "attack": "40",
    "defense": "48",
    "spattack": "40",
    "spdefense": "48",
    "speed": "62",
    "total": "290",
    "weight": "18.1 lbs.",
    "height": "2'04\"",
    "dex1": "The sepals on its head developed to protect its body. These are quite hard, so even if pecked by bird Pokémon, this Pokémon is totally fine.",
    "dex2": "This Pokémon is always bouncing around energetically. Other Pokémon are attracted by its lively appearance and pleasant aroma.",
    "class": "Fruit Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Bounsweet",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "763",
    "ndex": "763",
    "species": "Tsareena",
    "forme": "Tsareena",
    "type1": "Grass",
    "type2": "",
    "ability1": "Leaf Guard",
    "ability2": "Queenly Majesty",
    "abilityH": "Sweet Veil",
    "hp": "72",
    "attack": "120",
    "defense": "98",
    "spattack": "50",
    "spdefense": "98",
    "speed": "72",
    "total": "510",
    "weight": "47.2 lbs.",
    "height": "3'11\"",
    "dex1": "Its long, striking legs aren’t just for show but to be used to kick with skill. In victory, it shows off by kicking the defeated, laughing boisterously.",
    "dex2": "A Pokémon known for the beauty of its well-shaped legs, it sometimes appears as a mascot in advertisements for beauty salons.",
    "class": "Fruit Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Steenee",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "764",
    "ndex": "764",
    "species": "Comfey",
    "forme": "Comfey",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "Triage",
    "abilityH": "Natural Cure",
    "hp": "51",
    "attack": "52",
    "defense": "90",
    "spattack": "82",
    "spdefense": "110",
    "speed": "100",
    "total": "485",
    "weight": "0.7 lbs.",
    "height": "0'04\"",
    "dex1": "It attaches flowers to its highly nutritious vine. This revitalizes the flowers, and they give off an aromatic scent.",
    "dex2": "Baths prepared with the flowers from its vine have a relaxing effect, so this Pokémon is a hit with many people.",
    "class": "Posy Picker Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "765",
    "ndex": "765",
    "species": "Oranguru",
    "forme": "Oranguru",
    "type1": "Normal",
    "type2": "Psychic",
    "ability1": "Inner Focus",
    "ability2": "Telepahty",
    "abilityH": "Symbiosis",
    "hp": "90",
    "attack": "60",
    "defense": "80",
    "spattack": "90",
    "spdefense": "110",
    "speed": "60",
    "total": "490",
    "weight": "167.6 lbs.",
    "height": "4'11\"",
    "dex1": "Known for its extreme intelligence, this Pokémon will look down on inexperienced Trainers, so it’s best suited to veteran Trainers.",
    "dex2": "Deep in the jungle, high in the lofty canopy, this Pokémon abides. On rare occasions, it shows up at the beach to match wits with Slowking.",
    "class": "Sage Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "766",
    "ndex": "766",
    "species": "Passimian",
    "forme": "Passimian",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Receiver",
    "ability2": "Receiver",
    "abilityH": "Defiant",
    "hp": "100",
    "attack": "120",
    "defense": "90",
    "spattack": "40",
    "spdefense": "60",
    "speed": "80",
    "total": "490",
    "weight": "182.5 lbs.",
    "height": "6'07\"",
    "dex1": "They form groups of roughly 20 individuals. Their mutual bond is remarkable—they will never let down a comrade.",
    "dex2": "They battle with hard berries for weapons. Their techniques are passed from the boss to the group, generation upon generation.",
    "class": "Teamwork Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "767",
    "ndex": "767",
    "species": "Wimpod",
    "forme": "Wimpod",
    "type1": "Bug",
    "type2": "Water",
    "ability1": "Wimp Out",
    "ability2": "Wimp Out",
    "abilityH": "Wimp Out",
    "hp": "25",
    "attack": "35",
    "defense": "40",
    "spattack": "20",
    "spdefense": "30",
    "speed": "80",
    "total": "230",
    "weight": "26.5 lbs.",
    "height": "1'08\"",
    "dex1": "This Pokémon is a coward. As it desperately dashes off, the flailing of its many legs leaves a sparkling clean path in its wake.",
    "dex2": "Its habitat varies from beaches to seabeds. A natural scavenger, it will gleefully chow down on anything edible, no matter how rotten.",
    "class": "Turn Tail Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": "Water 3"
  },
  {
    "id": "768",
    "ndex": "768",
    "species": "Golisopod",
    "forme": "Golisopod",
    "type1": "Bug",
    "type2": "Water",
    "ability1": "Emergency Exit",
    "ability2": "Emergency Exit",
    "abilityH": "Emergency Exit",
    "hp": "75",
    "attack": "125",
    "defense": "140",
    "spattack": "60",
    "spdefense": "90",
    "speed": "40",
    "total": "530",
    "weight": "238.1 lbs.",
    "height": "6'07\"",
    "dex1": "With a flashing slash of its giant sharp claws, it cleaves seawater—or even air—right in two.",
    "dex2": "It battles skillfully with its six arms, but spends most of its time peacefully meditating in caves deep beneath the sea.",
    "class": "Hard Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Wimpod",
    "egg-group1": "Bug",
    "egg-group2": "Water 3"
  },
  {
    "id": "769",
    "ndex": "769",
    "species": "Sandygast",
    "forme": "Sandygast",
    "type1": "Ghost",
    "type2": "Ground",
    "ability1": "Water Compaction",
    "ability2": "Water Compaction",
    "abilityH": "Sand Veil",
    "hp": "55",
    "attack": "55",
    "defense": "80",
    "spattack": "70",
    "spdefense": "45",
    "speed": "15",
    "total": "320",
    "weight": "154.3 lbs.",
    "height": "1'08\"",
    "dex1": "Born from a sand mound playfully built by a child, this Pokémon embodies the grudges of the departed.",
    "dex2": "It takes control of anyone who puts a hand in its mouth. And so it adds to the accumulation of its sand-mound body.",
    "class": "Sand Heap Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "770",
    "ndex": "770",
    "species": "Palossand",
    "forme": "Palossand",
    "type1": "Ghost",
    "type2": "Ground",
    "ability1": "Water Compaction",
    "ability2": "Water Compaction",
    "abilityH": "Sand Veil",
    "hp": "85",
    "attack": "75",
    "defense": "110",
    "spattack": "100",
    "spdefense": "75",
    "speed": "35",
    "total": "480",
    "weight": "551.2 lbs.",
    "height": "4'03\"",
    "dex1": "Possessed people controlled by this Pokémon transformed its sand mound into a castle. As it evolved, its power to curse grew ever stronger.",
    "dex2": "Buried beneath the castle are masses of dried-up bones from those whose vitality it has drained.",
    "class": "Sand Castle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sandygast",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "771",
    "ndex": "771",
    "species": "Pyukumuku",
    "forme": "Pyukumuku",
    "type1": "Water",
    "type2": "",
    "ability1": "Innards Out",
    "ability2": "Innards Out",
    "abilityH": "Unaware",
    "hp": "55",
    "attack": "60",
    "defense": "130",
    "spattack": "30",
    "spdefense": "130",
    "speed": "5",
    "total": "410",
    "weight": "2.6 lbs.",
    "height": "1'00\"",
    "dex1": "It lives in shallow seas, such as areas near a beach. It can eject its internal organs, which it uses to engulf its prey or battle enemies.",
    "dex2": "These Pokémon line the beaches. The sticky mucous that covers their bodies can be used to soothe sunburned skin. How convenient!",
    "class": "Sea Cucumber Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": ""
  },
  {
    "id": "772",
    "ndex": "772",
    "species": "Type: Null",
    "forme": "Type: Null",
    "type1": "Normal",
    "type2": "",
    "ability1": "Battle Armor",
    "ability2": "Battle Armor",
    "abilityH": "Battle Armor",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "59",
    "total": "534",
    "weight": "265.7 lbs.",
    "height": "6'03\"",
    "dex1": "The heavy control mask it wears suppresses its intrinsic capabilities. This Pokémon has some hidden special power.",
    "dex2": "Due to the danger that this synthetic Pokémon may go on a rampage, it wears a control mask to restrain its power.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "773",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Normal)",
    "type1": "Normal",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "Its trust in its partner is what awakens it. This Pokémon is capable of changing its type, a flexibility that is well displayed in battle.",
    "dex2": "Although its name was Type: Null at first, the boy who evolved it into this form gave it the name by which it is now known.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "774",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Meteor Form)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "60",
    "defense": "100",
    "spattack": "60",
    "spdefense": "100",
    "speed": "60",
    "total": "440",
    "weight": "88.2 lbs.",
    "height": "1'00\"",
    "dex1": "Originally making its home in the ozone layer, it hurtles to the ground when the shell enclosing its body grows too heavy.",
    "dex2": "Strong impacts can knock it out of its shell. This Pokémon was born from mutated nanoparticles.",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "775",
    "ndex": "775",
    "species": "Komala",
    "forme": "Komala",
    "type1": "Normal",
    "type2": "",
    "ability1": "Comatose",
    "ability2": "Comatose",
    "abilityH": "Comatose",
    "hp": "65",
    "attack": "115",
    "defense": "65",
    "spattack": "75",
    "spdefense": "95",
    "speed": "65",
    "total": "480",
    "weight": "43.9 lbs.",
    "height": "1'04\"",
    "dex1": "It is born asleep, and it dies asleep. All its movements are apparently no more than the results of it tossing and turning in its dreams.",
    "dex2": "The log it holds was given to it by its parents at birth. It has also been known to cling to the arm of a friendly Trainer.",
    "class": "Drowsing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "776",
    "ndex": "776",
    "species": "Turtonator",
    "forme": "Turtonator",
    "type1": "Fire",
    "type2": "Dragon",
    "ability1": "Shell Armor",
    "ability2": "Shell Armor",
    "abilityH": "Shell Armor",
    "hp": "60",
    "attack": "78",
    "defense": "135",
    "spattack": "91",
    "spdefense": "85",
    "speed": "36",
    "total": "485",
    "weight": "467.4 lbs.",
    "height": "6'07\"",
    "dex1": "The shell on its back is chemically unstable and explodes violently if struck. The hole in its stomach is its weak point.",
    "dex2": "It gushes fire and poisonous gases from its nostrils. Its dung is an explosive substance and can be put to various uses.",
    "class": "Blast Turtle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "777",
    "ndex": "777",
    "species": "Togedemaru",
    "forme": "Togedemaru",
    "type1": "Electric",
    "type2": "Steel",
    "ability1": "Iron Barbs",
    "ability2": "Lightning Rod",
    "abilityH": "Sturdy",
    "hp": "65",
    "attack": "98",
    "defense": "63",
    "spattack": "40",
    "spdefense": "73",
    "speed": "96",
    "total": "435",
    "weight": "7.3 lbs.",
    "height": "1'00\"",
    "dex1": "The spiny fur on its back is normally at rest. When this Pokémon becomes agitated, its fur stands on end and stabs into its attackers.",
    "dex2": "The long hairs on its back act as lightning rods. The bolts of lightning it attracts are stored as energy in its electric sac.",
    "class": "Roly-Poly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "778",
    "ndex": "778",
    "species": "Mimikyu",
    "forme": "Mimikyu (Disguised Form)",
    "type1": "Ghost",
    "type2": "Fairy",
    "ability1": "Disguise",
    "ability2": "Disguise",
    "abilityH": "Disguise",
    "hp": "55",
    "attack": "90",
    "defense": "80",
    "spattack": "50",
    "spdefense": "105",
    "speed": "96",
    "total": "476",
    "weight": "1.5 lbs.",
    "height": "0'08\"",
    "dex1": "Its actual appearance is unknown. A scholar who saw what was under its rag was overwhelmed by terror and died from the shock.",
    "dex2": "A lonely Pokémon, it conceals its terrifying appearance beneath an old rag so it can get closer to people and other Pokémon.",
    "class": "Disguise Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "779",
    "ndex": "779",
    "species": "Bruxish",
    "forme": "Bruxish",
    "type1": "Water",
    "type2": "Psychic",
    "ability1": "Dazzling",
    "ability2": "Strong Jaw",
    "abilityH": "Wonder Skin",
    "hp": "68",
    "attack": "105",
    "defense": "70",
    "spattack": "70",
    "spdefense": "70",
    "speed": "92",
    "total": "475",
    "weight": "41.9 lbs.",
    "height": "2'11\"",
    "dex1": "When it unleashes its psychic power from the protuberance on its head, the grating sound of grinding teeth echoes through the area.",
    "dex2": "It stuns its prey with psychokinesis and then grinds them to mush with its strong teeth. Even Shellder’s shell is no match for it.",
    "class": "Gnash Teeth Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "780",
    "ndex": "780",
    "species": "Drampa",
    "forme": "Drampa",
    "type1": "Normal",
    "type2": "Dragon",
    "ability1": "Berserk",
    "ability2": "Sap Sipper",
    "abilityH": "Cloud Nine",
    "hp": "78",
    "attack": "60",
    "defense": "85",
    "spattack": "135",
    "spdefense": "91",
    "speed": "36",
    "total": "485",
    "weight": "407.9 lbs.",
    "height": "9'10\"",
    "dex1": "It has a compassionate personality, but if it is angered, it completely destroys its surroundings with its intense breath.",
    "dex2": "This Pokémon is friendly to people and loves children most of all. It comes from deep in the mountains to play with children it likes in town.",
    "class": "Placid Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "781",
    "ndex": "781",
    "species": "Dhelmise",
    "forme": "Dhelmise",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Steelworker",
    "ability2": "Steelworker",
    "abilityH": "Steelworker",
    "hp": "70",
    "attack": "131",
    "defense": "100",
    "spattack": "86",
    "spdefense": "90",
    "speed": "40",
    "total": "517",
    "weight": "463.0 lbs.",
    "height": "12'10\"",
    "dex1": "Swinging its massive anchor, it can KO Wailord in a single blow. What appears to be green seaweed is actually its body.",
    "dex2": "The soul of seaweed adrift in the waves became reborn as this Pokémon. It maintains itself with new infusions of seabed detritus and seaweed.",
    "class": "Sea Creeper Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "782",
    "ndex": "782",
    "species": "Jangmo-o",
    "forme": "Jangmo-o",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Bulletproof",
    "ability2": "Soundproof",
    "abilityH": "Overcoat",
    "hp": "45",
    "attack": "55",
    "defense": "65",
    "spattack": "45",
    "spdefense": "45",
    "speed": "45",
    "total": "300",
    "weight": "65.5 lbs.",
    "height": "2'00\"",
    "dex1": "It expresses its feelings by smacking its scales. Metallic sounds echo through the tall mountains where Jangmo-o lives.",
    "dex2": "They live in mountains where no trace of humans can be detected. Jangmo-o grow little by little as they battle one another.",
    "class": "Scaly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "783",
    "ndex": "783",
    "species": "Hakamo-o",
    "forme": "Hakamo-o",
    "type1": "Dragon",
    "type2": "Fighting",
    "ability1": "Bulletproof",
    "ability2": "Soundproof",
    "abilityH": "Overcoat",
    "hp": "55",
    "attack": "75",
    "defense": "90",
    "spattack": "65",
    "spdefense": "70",
    "speed": "65",
    "total": "420",
    "weight": "103.6 lbs.",
    "height": "3'11\"",
    "dex1": "It leaps at its prey with a courageous shout. Its scaly punches tear its opponents to shreds.",
    "dex2": "It sheds and regrows its scales on a continuous basis. The scales become harder and sharper each time they’re regrown.",
    "class": "Scaly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Jangmo-o",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "784",
    "ndex": "784",
    "species": "Kommo-o",
    "forme": "Kommo-o",
    "type1": "Dragon",
    "type2": "Fighting",
    "ability1": "Bulletproof",
    "ability2": "Soundproof",
    "abilityH": "Overcoat",
    "hp": "75",
    "attack": "110",
    "defense": "125",
    "spattack": "100",
    "spdefense": "105",
    "speed": "85",
    "total": "600",
    "weight": "172.4 lbs.",
    "height": "5'03\"",
    "dex1": "When it spots enemies, it threatens them by jingling the scales on its tail. Weak opponents will crack and flee in panic.",
    "dex2": "Its rigid scales function as offense and defense. In the past, its scales were processed and used to make weapons and other commodities.",
    "class": "Scaly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Hakamo-o",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "785",
    "ndex": "785",
    "species": "Tapu Koko",
    "forme": "Tapu Koko",
    "type1": "Electric",
    "type2": "Fairy",
    "ability1": "Electric Surge",
    "ability2": "Electric Surge",
    "abilityH": "Telepathy",
    "hp": "70",
    "attack": "115",
    "defense": "85",
    "spattack": "95",
    "spdefense": "75",
    "speed": "130",
    "total": "570",
    "weight": "45.2 lbs.",
    "height": "5'11\"",
    "dex1": "This guardian deity of Melemele is brimming with curiosity. It summons thunderclouds and stores their lightning inside its body.",
    "dex2": "It confuses its enemies by flying too quickly for the eye to follow. It has a hair-trigger temper but forgets what made it angry an instant later.",
    "class": "Land Spirit Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "786",
    "ndex": "786",
    "species": "Tapu Lele",
    "forme": "Tapu Lele",
    "type1": "Psychic",
    "type2": "Fairy",
    "ability1": "Psychic Surge",
    "ability2": "Psychic Surge",
    "abilityH": "Telepathy",
    "hp": "70",
    "attack": "85",
    "defense": "75",
    "spattack": "130",
    "spdefense": "115",
    "speed": "95",
    "total": "570",
    "weight": "41.0 lbs.",
    "height": "3'11\"",
    "dex1": "This guardian deity of Akala is guilelessly cruel. The fragrant aroma of flowers is the source of its energy.",
    "dex2": "As it flutters about, it scatters its strangely glowing scales. Touching them is said to restore good health on the spot.",
    "class": "Land Spirit Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "787",
    "ndex": "787",
    "species": "Tapu Bulu",
    "forme": "Tapu Bulu",
    "type1": "Grass",
    "type2": "Fairy",
    "ability1": "Grassy Surge",
    "ability2": "Grassy Surge",
    "abilityH": "Telepathy",
    "hp": "70",
    "attack": "130",
    "defense": "115",
    "spattack": "85",
    "spdefense": "95",
    "speed": "75",
    "total": "570",
    "weight": "100.3 lbs.",
    "height": "6'03\"",
    "dex1": "It pulls large trees up by the roots and swings them around. It causes vegetation to grow, and then it absorbs energy from the growth.",
    "dex2": "The guardian deity of Ula’ula is a lazy Pokémon. It commands plants to immobilize its foes and then deals them a savage blow with its horns.",
    "class": "Land Spirit Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "788",
    "ndex": "788",
    "species": "Tapu Fini",
    "forme": "Tapu Fini",
    "type1": "Water",
    "type2": "Fairy",
    "ability1": "Misty Surge",
    "ability2": "Misty Surge",
    "abilityH": "Telepathy",
    "hp": "70",
    "attack": "75",
    "defense": "115",
    "spattack": "95",
    "spdefense": "130",
    "speed": "85",
    "total": "570",
    "weight": "46.7 lbs.",
    "height": "4'03\"",
    "dex1": "The dense fog it creates brings the downfall and destruction of its confused enemies. Ocean currents are the source of its energy.",
    "dex2": "The guardian deity of Poni, it can control water. People say it can create pure water that will wash away any uncleanness.",
    "class": "Land Spirit Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "789",
    "ndex": "789",
    "species": "Cosmog",
    "forme": "Cosmog",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Unaware",
    "ability2": "Unaware",
    "abilityH": "Unaware",
    "hp": "43",
    "attack": "29",
    "defense": "31",
    "spattack": "29",
    "spdefense": "31",
    "speed": "37",
    "total": "200",
    "weight": "0.2 lbs.",
    "height": "0'08\"",
    "dex1": "Its body is gaseous and frail. It slowly grows as it collects dust from the atmosphere.",
    "dex2": "In ages past, it was called the child of the stars. It’s said to be a Pokémon from another world, but no specific details are known.",
    "class": "Nebula Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "790",
    "ndex": "790",
    "species": "Cosmoem",
    "forme": "Cosmoem",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Sturdy",
    "ability2": "Sturdy",
    "abilityH": "Sturdy",
    "hp": "43",
    "attack": "29",
    "defense": "131",
    "spattack": "29",
    "spdefense": "131",
    "speed": "37",
    "total": "400",
    "weight": "2204.4 lbs.",
    "height": "0'04\"",
    "dex1": "Motionless as if dead, its body is faintly warm to the touch. In the distant past, it was called the cocoon of the stars.",
    "dex2": "There’s something accumulating around the black core within its hard shell. People think this Pokémon may come from another world.",
    "class": "Protostar Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Cosmog",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "791",
    "ndex": "791",
    "species": "Solgaleo",
    "forme": "Solgaleo",
    "type1": "Psychic",
    "type2": "Steel",
    "ability1": "Full Metal Body",
    "ability2": "Full Metal Body",
    "abilityH": "Full Metal Body",
    "hp": "137",
    "attack": "137",
    "defense": "107",
    "spattack": "113",
    "spdefense": "89",
    "speed": "97",
    "total": "680",
    "weight": "507.1 lbs.",
    "height": "11'02\"",
    "dex1": "It is said to live in another world. The intense light it radiates from the surface of its body can make the darkest of nights light up like midday.",
    "dex2": "This Pokémon is said to be a male evolution of Cosmog. At the activation of its third eye, it departs for another world.",
    "class": "Sunne Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Cosmoem",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "792",
    "ndex": "792",
    "species": "Lunala",
    "forme": "Lunala",
    "type1": "Psychic",
    "type2": "Ghost",
    "ability1": "Shadow Shield",
    "ability2": "Shadow Shield",
    "abilityH": "Shadow Shield",
    "hp": "137",
    "attack": "113",
    "defense": "89",
    "spattack": "137",
    "spdefense": "107",
    "speed": "97",
    "total": "680",
    "weight": "264.6 lbs.",
    "height": "13'01\"",
    "dex1": "It is said to be a female evolution of Cosmog. When its third eye activates, away it flies to another world.",
    "dex2": "Said to live in another world, this Pokémon devours light, drawing the moonless dark veil of night over the brightness of day.",
    "class": "Moone Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Cosmoem",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "793",
    "ndex": "793",
    "species": "Nihilego",
    "forme": "Nihilego",
    "type1": "Rock",
    "type2": "Poison",
    "ability1": "Beast Boost",
    "ability2": "Beast Boost",
    "abilityH": "Beast Boost",
    "hp": "109",
    "attack": "53",
    "defense": "47",
    "spattack": "127",
    "spdefense": "131",
    "speed": "103",
    "total": "570",
    "weight": "122.4 lbs.",
    "height": "3'11\"",
    "dex1": "One of several mysterious Ultra Beasts. People on the street report observing those infested by it suddenly becoming violent.",
    "dex2": "One of the Ultra Beasts. It’s unclear whether or not this Pokémon is sentient, but sometimes it can be observed behaving like a young girl.",
    "class": "Parasite Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "794",
    "ndex": "794",
    "species": "Buzzwole",
    "forme": "Buzzwole",
    "type1": "Bug",
    "type2": "Fighting",
    "ability1": "Beast Boost",
    "ability2": "Beast Boost",
    "abilityH": "Beast Boost",
    "hp": "107",
    "attack": "139",
    "defense": "139",
    "spattack": "53",
    "spdefense": "53",
    "speed": "79",
    "total": "570",
    "weight": "735.5 lbs.",
    "height": "7'10\"",
    "dex1": "This Ultra Beast appeared from another world. It shows off its body, but whether that display is a boast or a threat remains unclear.",
    "dex2": "A mysterious life-form called an Ultra Beast. Witnesses saw it pulverize a dump truck with a single punch.",
    "class": "Swollen Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "795",
    "ndex": "795",
    "species": "Pheromosa",
    "forme": "Pheromosa",
    "type1": "Bug",
    "type2": "Fighting",
    "ability1": "Beast Boost",
    "ability2": "Beast Boost",
    "abilityH": "Beast Boost",
    "hp": "71",
    "attack": "137",
    "defense": "37",
    "spattack": "137",
    "spdefense": "37",
    "speed": "151",
    "total": "570",
    "weight": "55.1 lbs.",
    "height": "5'11\"",
    "dex1": "One of the dangerous Ultra Beasts, it has been spotted running across the land at terrific speeds.",
    "dex2": "One of the Ultra Beasts. It refuses to touch anything, perhaps because it senses some uncleanness in this world.",
    "class": "Lissome Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "796",
    "ndex": "796",
    "species": "Xurkitree",
    "forme": "Xurkitree",
    "type1": "Electric",
    "type2": "",
    "ability1": "Beast Boost",
    "ability2": "Beast Boost",
    "abilityH": "Beast Boost",
    "hp": "83",
    "attack": "89",
    "defense": "71",
    "spattack": "173",
    "spdefense": "71",
    "speed": "83",
    "total": "570",
    "weight": "220.5 lbs.",
    "height": "12'06\"",
    "dex1": "One of the mysterious life-forms known as Ultra Beasts. Astonishing electric shocks emanate from its entire body, according to witnesses.",
    "dex2": "It appeared from the Ultra Wormhole. It raided a power plant, so people think it energizes itself with electricity.",
    "class": "Glowing Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "797",
    "ndex": "797",
    "species": "Celesteela",
    "forme": "Celesteela",
    "type1": "Steel",
    "type2": "Flying",
    "ability1": "Beast Boost",
    "ability2": "Beast Boost",
    "abilityH": "Beast Boost",
    "hp": "97",
    "attack": "101",
    "defense": "103",
    "spattack": "107",
    "spdefense": "101",
    "speed": "61",
    "total": "570",
    "weight": "2204.4 lbs.",
    "height": "30'02\"",
    "dex1": "It appeared from the Ultra Wormhole. Witnesses observed it flying across the sky at high speed.",
    "dex2": "One kind of Ultra Beast. Witnesses have seen it burn down a forest by expelling gas from its two arms.",
    "class": "Launch Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "798",
    "ndex": "798",
    "species": "Kartana",
    "forme": "Kartana",
    "type1": "Grass",
    "type2": "Steel",
    "ability1": "Beast Boost",
    "ability2": "Beast Boost",
    "abilityH": "Beast Boost",
    "hp": "59",
    "attack": "181",
    "defense": "131",
    "spattack": "59",
    "spdefense": "31",
    "speed": "109",
    "total": "570",
    "weight": "0.2 lbs.",
    "height": "1'00\"",
    "dex1": "This Ultra Beast came from the Ultra Wormhole. It seems not to attack enemies on its own, but its sharp body is a dangerous weapon in itself.",
    "dex2": "One of the Ultra Beast life-forms, it was observed cutting down a gigantic steel tower with one stroke of its blade.",
    "class": "Drawn Sword Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "799",
    "ndex": "799",
    "species": "Guzzlord",
    "forme": "Guzzlord",
    "type1": "Dark",
    "type2": "Dragon",
    "ability1": "Beast Boost",
    "ability2": "Beast Boost",
    "abilityH": "Beast Boost",
    "hp": "223",
    "attack": "101",
    "defense": "53",
    "spattack": "97",
    "spdefense": "53",
    "speed": "43",
    "total": "570",
    "weight": "1957.7 lbs.",
    "height": "18'01\"",
    "dex1": "It has gobbled mountains and swallowed whole buildings, according to reports. It’s one of the Ultra Beasts.",
    "dex2": "A dangerous Ultra Beast, it appears to be eating constantly, but for some reason its droppings have never been found.",
    "class": "Junkivore Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "800",
    "ndex": "800",
    "species": "Necrozma",
    "forme": "Necrozma",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Prism Armor",
    "ability2": "Prism Armor",
    "abilityH": "Prism Armor",
    "hp": "97",
    "attack": "107",
    "defense": "101",
    "spattack": "127",
    "spdefense": "89",
    "speed": "79",
    "total": "600",
    "weight": "507.1 lbs.",
    "height": "7'10\"",
    "dex1": "Reminiscent of the Ultra Beasts, this life-form, apparently asleep underground, is thought to have come from another world in ancient times.",
    "dex2": "Light is apparently the source of its energy. It has an extraordinarily vicious disposition and is constantly firing off laser beams.",
    "class": "Prism Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "801",
    "ndex": "801",
    "species": "Magearna",
    "forme": "Magearna",
    "type1": "Steel",
    "type2": "Fairy",
    "ability1": "Soul-Heart",
    "ability2": "Soul-Heart",
    "abilityH": "Soul-Heart",
    "hp": "80",
    "attack": "95",
    "defense": "115",
    "spattack": "130",
    "spdefense": "115",
    "speed": "65",
    "total": "600",
    "weight": "177.5 lbs.",
    "height": "3'03\"",
    "dex1": "This artificial Pokémon, constructed more than 500 years ago, can understand human speech but cannot itself speak.",
    "dex2": "Its mechanized body is merely a vessel. Its true self is its Soul-Heart, an artificial soul.",
    "class": "Artificial Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "802",
    "ndex": "802",
    "species": "Marshadow",
    "forme": "Marshadow",
    "type1": "Fighting",
    "type2": "Ghost",
    "ability1": "Technician",
    "ability2": "Technician",
    "abilityH": "Technician",
    "hp": "90",
    "attack": "125",
    "defense": "80",
    "spattack": "90",
    "spdefense": "90",
    "speed": "125",
    "total": "600",
    "weight": "48.9 lbs.",
    "height": "2'04\"",
    "dex1": "Able to conceal itself in shadows, it never appears before humans, so its very existence was the stuff of myth.",
    "dex2": "It lurks in the shadows of others, copying their movements and powers. This Pokémon is craven and cowering.",
    "class": "Gloomdweller Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "804",
    "ndex": "3",
    "species": "Venusaur",
    "forme": "Venusaur (Mega Venusaur)",
    "type1": "Grass",
    "type2": "Poison",
    "ability1": "Thick Fat",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "100",
    "defense": "123",
    "spattack": "122",
    "spdefense": "120",
    "speed": "80",
    "total": "625",
    "weight": "342.8 lbs.",
    "height": "7'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Seed Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Ivysaur",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "805",
    "ndex": "6",
    "species": "Charizard",
    "forme": "Charizard (Mega Charizard X)",
    "type1": "Fire",
    "type2": "Dragon",
    "ability1": "Tough Claws",
    "ability2": "",
    "abilityH": "",
    "hp": "78",
    "attack": "130",
    "defense": "111",
    "spattack": "130",
    "spdefense": "85",
    "speed": "100",
    "total": "634",
    "weight": "243.6 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Flame Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Charmeleon",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "806",
    "ndex": "6",
    "species": "Charizard",
    "forme": "Charizard (Mega Charizard Y)",
    "type1": "Fire",
    "type2": "Flying",
    "ability1": "Drought",
    "ability2": "",
    "abilityH": "",
    "hp": "78",
    "attack": "104",
    "defense": "78",
    "spattack": "159",
    "spdefense": "115",
    "speed": "100",
    "total": "634",
    "weight": "221.6 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Flame Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Charmeleon",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "807",
    "ndex": "9",
    "species": "Blastoise",
    "forme": "Blastoise (Mega Blastoise)",
    "type1": "Water",
    "type2": "",
    "ability1": "Mega Launcher",
    "ability2": "",
    "abilityH": "",
    "hp": "79",
    "attack": "103",
    "defense": "120",
    "spattack": "135",
    "spdefense": "115",
    "speed": "78",
    "total": "630",
    "weight": "222.9 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Shellfish Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Wartortle",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "808",
    "ndex": "15",
    "species": "Beedrill",
    "forme": "Beedrill (Mega Beedrill)",
    "type1": "Bug",
    "type2": "Poison",
    "ability1": "Adaptability",
    "ability2": "Adaptability",
    "abilityH": "Adaptability",
    "hp": "65",
    "attack": "150",
    "defense": "40",
    "spattack": "15",
    "spdefense": "80",
    "speed": "145",
    "total": "495",
    "weight": "89.3 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Poison Bee Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Kakuna",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "809",
    "ndex": "18",
    "species": "Pidgeot",
    "forme": "Pidgeot (Mega Pidgeot)",
    "type1": "Normal",
    "type2": "Flying",
    "ability1": "No Guard",
    "ability2": "No Guard",
    "abilityH": "No Guard",
    "hp": "83",
    "attack": "80",
    "defense": "80",
    "spattack": "135",
    "spdefense": "80",
    "speed": "121",
    "total": "579",
    "weight": "111.3 lbs.",
    "height": "7'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Bird Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pidgeotto",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "810",
    "ndex": "19",
    "species": "Rattata",
    "forme": "Rattata (Alola Form)",
    "type1": "Dark",
    "type2": "Normal",
    "ability1": "Gluttony",
    "ability2": "Hustle",
    "abilityH": "Thick Fat",
    "hp": "30",
    "attack": "56",
    "defense": "35",
    "spattack": "25",
    "spdefense": "35",
    "speed": "72",
    "total": "253",
    "weight": "8.4 lbs.",
    "height": "1'00\"",
    "dex1": "With its incisors, it gnaws through doors and infiltrates people’s homes. Then, with a twitch of its whiskers, it steals whatever food it finds.",
    "dex2": "When the sun goes down, it becomes active. It runs around town on a chase for good food for the boss of its nest—Raticate.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "811",
    "ndex": "20",
    "species": "Raticate",
    "forme": "Raticate (Alola Form)",
    "type1": "Dark",
    "type2": "Normal",
    "ability1": "Gluttony",
    "ability2": "Hustle",
    "abilityH": "Thick Fat",
    "hp": "75",
    "attack": "71",
    "defense": "70",
    "spattack": "40",
    "spdefense": "80",
    "speed": "77",
    "total": "413",
    "weight": "56.2 lbs.",
    "height": "2'04\"",
    "dex1": "It forms a group of Rattata, which it assumes command of. Each group has its own territory, and disputes over food happen often.",
    "dex2": "This gourmet Pokémon is particular about the taste and freshness of its food. Restaurants where Raticate live have a good reputation.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Rattata",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "812",
    "ndex": "20",
    "species": "Raticate",
    "forme": "Raticate (1)",
    "type1": "Dark",
    "type2": "Normal",
    "ability1": "Gluttony",
    "ability2": "Hustle",
    "abilityH": "Thick Fat",
    "hp": "75",
    "attack": "71",
    "defense": "70",
    "spattack": "40",
    "spdefense": "80",
    "speed": "77",
    "total": "413",
    "weight": "56.2 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "813",
    "ndex": "25",
    "species": "Pikachu",
    "forme": "Pikachu (Original Cap)",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Static",
    "abilityH": "Lightning Rod",
    "hp": "35",
    "attack": "55",
    "defense": "40",
    "spattack": "50",
    "spdefense": "50",
    "speed": "90",
    "total": "320",
    "weight": "13.2 lbs.",
    "height": "1'04\"",
    "dex1": "This form of Pikachu is somewhat rare. It wears the hat of its Trainer, who is also its partner.",
    "dex2": "This Pikachu is wearing its Trainer’s cap. Since the cap’s not the right size, the fit is a bit loose.",
    "class": "Mouse Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "814",
    "ndex": "25",
    "species": "Pikachu",
    "forme": "Pikachu (Hoenn Cap)",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Static",
    "abilityH": "Lightning Rod",
    "hp": "35",
    "attack": "55",
    "defense": "40",
    "spattack": "50",
    "spdefense": "50",
    "speed": "90",
    "total": "320",
    "weight": "13.2 lbs.",
    "height": "1'04\"",
    "dex1": "This form of Pikachu is somewhat rare. It wears the hat of its Trainer, who is also its partner.",
    "dex2": "This Pikachu is wearing its Trainer’s cap. Since the cap’s not the right size, the fit is a bit loose.",
    "class": "Mouse Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "815",
    "ndex": "25",
    "species": "Pikachu",
    "forme": "Pikachu (Sinnoh Cap)",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Static",
    "abilityH": "Lightning Rod",
    "hp": "35",
    "attack": "55",
    "defense": "40",
    "spattack": "50",
    "spdefense": "50",
    "speed": "90",
    "total": "320",
    "weight": "13.2 lbs.",
    "height": "1'04\"",
    "dex1": "This form of Pikachu is somewhat rare. It wears the hat of its Trainer, who is also its partner.",
    "dex2": "This Pikachu is wearing its Trainer’s cap. Since the cap’s not the right size, the fit is a bit loose.",
    "class": "Mouse Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "816",
    "ndex": "25",
    "species": "Pikachu",
    "forme": "Pikachu (Unova Cap)",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Static",
    "abilityH": "Lightning Rod",
    "hp": "35",
    "attack": "55",
    "defense": "40",
    "spattack": "50",
    "spdefense": "50",
    "speed": "90",
    "total": "320",
    "weight": "13.2 lbs.",
    "height": "1'04\"",
    "dex1": "This form of Pikachu is somewhat rare. It wears the hat of its Trainer, who is also its partner.",
    "dex2": "This Pikachu is wearing its Trainer’s cap. Since the cap’s not the right size, the fit is a bit loose.",
    "class": "Mouse Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "817",
    "ndex": "25",
    "species": "Pikachu",
    "forme": "Pikachu (Kalos Cap)",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Static",
    "abilityH": "Lightning Rod",
    "hp": "35",
    "attack": "55",
    "defense": "40",
    "spattack": "50",
    "spdefense": "50",
    "speed": "90",
    "total": "320",
    "weight": "13.2 lbs.",
    "height": "1'04\"",
    "dex1": "This form of Pikachu is somewhat rare. It wears the hat of its Trainer, who is also its partner.",
    "dex2": "This Pikachu is wearing its Trainer’s cap. Since the cap’s not the right size, the fit is a bit loose.",
    "class": "Mouse Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "818",
    "ndex": "25",
    "species": "Pikachu",
    "forme": "Pikachu (Alola Cap)",
    "type1": "Electric",
    "type2": "",
    "ability1": "Static",
    "ability2": "Static",
    "abilityH": "Lightning Rod",
    "hp": "35",
    "attack": "55",
    "defense": "40",
    "spattack": "50",
    "spdefense": "50",
    "speed": "90",
    "total": "320",
    "weight": "13.2 lbs.",
    "height": "1'04\"",
    "dex1": "This form of Pikachu is somewhat rare. It wears the hat of its Trainer, who is also its partner.",
    "dex2": "This Pikachu is wearing its Trainer’s cap. Since the cap’s not the right size, the fit is a bit loose.",
    "class": "Mouse Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "819",
    "ndex": "26",
    "species": "Raichu",
    "forme": "Raichu (Alola Form)",
    "type1": "Electric",
    "type2": "Psychic",
    "ability1": "Surge Surfer",
    "ability2": "Surge Surfer",
    "abilityH": "Surge Surfer",
    "hp": "60",
    "attack": "85",
    "defense": "50",
    "spattack": "95",
    "spdefense": "85",
    "speed": "110",
    "total": "485",
    "weight": "46.3 lbs.",
    "height": "2'04\"",
    "dex1": "It only evolves to this form in the Alola region. According to researchers, its diet is one of the causes of this change.",
    "dex2": "It uses psychokinesis to control electricity. It hops aboard its own tail, using psychic power to lift the tail and move about while riding it.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pikachu",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "820",
    "ndex": "27",
    "species": "Sandshrew",
    "forme": "Sandshrew (Alola Form)",
    "type1": "Ice",
    "type2": "Steel",
    "ability1": "Snow Cloak",
    "ability2": "Snow Cloak",
    "abilityH": "Slush Rush",
    "hp": "50",
    "attack": "75",
    "defense": "90",
    "spattack": "10",
    "spdefense": "35",
    "speed": "40",
    "total": "300",
    "weight": "88.2 lbs.",
    "height": "2'04\"",
    "dex1": "It lives on snowy mountains. Its steel shell is very hard—so much so, it can’t roll its body up into a ball.",
    "dex2": "An ancient tradition of Alolan festivals, still carried on to this day, is a competition to slide Sandshrew across ice as far as one can.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "821",
    "ndex": "28",
    "species": "Sandslash",
    "forme": "Sandslash (Alola Form)",
    "type1": "Ice",
    "type2": "Steel",
    "ability1": "Snow Cloak",
    "ability2": "Snow Cloak",
    "abilityH": "Slush Rush",
    "hp": "75",
    "attack": "100",
    "defense": "120",
    "spattack": "25",
    "spdefense": "65",
    "speed": "65",
    "total": "450",
    "weight": "121.3 lbs.",
    "height": "3'11\"",
    "dex1": "Fleeing a volcanic eruption, it settled on a snowy mountain. As it races through the snowfields, it sends up a spray of snow.",
    "dex2": "This Pokémon’s steel spikes are sheathed in ice. Stabs from these spikes cause deep wounds and severe frostbite as well.",
    "class": "Mouse Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Sandshrew (Alola Form)",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "822",
    "ndex": "37",
    "species": "Vulpix",
    "forme": "Vulpix (Alola Form)",
    "type1": "Ice",
    "type2": "",
    "ability1": "Snow Cloak",
    "ability2": "Snow Cloak",
    "abilityH": "Snow Warning",
    "hp": "38",
    "attack": "41",
    "defense": "40",
    "spattack": "50",
    "spdefense": "65",
    "speed": "65",
    "total": "299",
    "weight": "21.8 lbs.",
    "height": "2'00\"",
    "dex1": "It exhales air colder than -58 degrees Fahrenheit. Elderly people in Alola call this Pokémon by an older name—Keokeo.",
    "dex2": "In hot weather, this Pokémon makes ice shards with its six tails and sprays them around to cool itself off.",
    "class": "Fox Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "823",
    "ndex": "38",
    "species": "Ninetales",
    "forme": "Ninetales (Alola Form)",
    "type1": "Ice",
    "type2": "Fairy",
    "ability1": "Snow Cloak",
    "ability2": "Snow Cloak",
    "abilityH": "Snow Warning",
    "hp": "73",
    "attack": "67",
    "defense": "75",
    "spattack": "81",
    "spdefense": "100",
    "speed": "109",
    "total": "505",
    "weight": "43.9 lbs.",
    "height": "3'07\"",
    "dex1": "It creates drops of ice in its coat and showers them over its enemies. Anyone who angers it will be frozen stiff in an instant.",
    "dex2": "Possessing a calm demeanor, this Pokémon was revered as a deity incarnate before it was identified as a regional variant of Ninetales.",
    "class": "Fox Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "Vulpix (Alola Form)",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "824",
    "ndex": "50",
    "species": "Diglett",
    "forme": "Diglett (Alola Form)",
    "type1": "Ground",
    "type2": "Steel",
    "ability1": "Sand Veil",
    "ability2": "Tangling Hair",
    "abilityH": "Sand Force",
    "hp": "10",
    "attack": "55",
    "defense": "30",
    "spattack": "35",
    "spdefense": "45",
    "speed": "90",
    "total": "265",
    "weight": "2.2 lbs.",
    "height": "0'08\"",
    "dex1": "Its head sports an altered form of whiskers made of metal. When in communication with its comrades, its whiskers wobble to and fro.",
    "dex2": "Its golden hairs function as sensors. It pokes them out of its burrow to monitor its surroundings.",
    "class": "Mole Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "825",
    "ndex": "51",
    "species": "Dugtrio",
    "forme": "Dugtrio (Alola Form)",
    "type1": "Ground",
    "type2": "Steel",
    "ability1": "Sand Veil",
    "ability2": "Tangling Hair",
    "abilityH": "Sand Force",
    "hp": "35",
    "attack": "100",
    "defense": "60",
    "spattack": "50",
    "spdefense": "70",
    "speed": "110",
    "total": "425",
    "weight": "146.8 lbs.",
    "height": "2'04\"",
    "dex1": "Its shining gold hair provides it with protection. It’s reputed that keeping any of its fallen hairs will bring bad luck.",
    "dex2": "These Pokémon are cherished in the Alola region, where they are thought to be feminine deities of the land incarnate.",
    "class": "Mole Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Diglett (Alola Form)",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "826",
    "ndex": "52",
    "species": "Meowth",
    "forme": "Meowth (Alola Form)",
    "type1": "Dark",
    "type2": "",
    "ability1": "Pickup",
    "ability2": "Technician",
    "abilityH": "Rattled",
    "hp": "40",
    "attack": "35",
    "defense": "35",
    "spattack": "50",
    "spdefense": "40",
    "speed": "90",
    "total": "290",
    "weight": "9.3 lbs.",
    "height": "1'04\"",
    "dex1": "This Pokémon was not originally found in Alola. Human actions caused a surge in their numbers, and they went feral. They’re prideful and crafty.",
    "dex2": "When its delicate pride is wounded, or when the gold coin on its forehead is dirtied, it flies into a hysterical rage.",
    "class": "Scratch Cat Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "827",
    "ndex": "53",
    "species": "Persian",
    "forme": "Persian (Alola Form)",
    "type1": "Dark",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "Technician",
    "abilityH": "Rattled",
    "hp": "65",
    "attack": "60",
    "defense": "60",
    "spattack": "75",
    "spdefense": "65",
    "speed": "115",
    "total": "440",
    "weight": "72.8 lbs.",
    "height": "3'07\"",
    "dex1": "Its round face and smooth coat—softer than the most high-class velvet—have made this a very popular Pokémon in Alola.",
    "dex2": "It looks down on everyone other than itself. Its preferred tactics are sucker punches and blindside attacks.",
    "class": "Classy Cat Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Meowth (Alola Form)",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "828",
    "ndex": "65",
    "species": "Alakazam",
    "forme": "Alakazam (Mega Alakazam)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Trace",
    "ability2": "",
    "abilityH": "",
    "hp": "55",
    "attack": "50",
    "defense": "65",
    "spattack": "175",
    "spdefense": "95",
    "speed": "150",
    "total": "590",
    "weight": "105.8 lbs.",
    "height": "3'11\"",
    "dex1": "As a result of Mega Evolution, its power has been entirely converted into psychic energy, and it has lost all strength in its muscles.",
    "dex2": "Its hidden psychic power has been unleashed. A glance at someone gives it knowledge of the course of that person’s life, from birth to death.",
    "class": "Psi Pokémon",
    "percent-male": "0.75",
    "percent-female": "0.25",
    "pre-evolution": "Kadabra",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "829",
    "ndex": "74",
    "species": "Geodude",
    "forme": "Geodude (Alola Form)",
    "type1": "Rock",
    "type2": "Electric",
    "ability1": "Magnet Pull",
    "ability2": "Sturdy",
    "abilityH": "Galvanize",
    "hp": "40",
    "attack": "80",
    "defense": "100",
    "spattack": "30",
    "spdefense": "30",
    "speed": "20",
    "total": "300",
    "weight": "44.8 lbs.",
    "height": "1'04\"",
    "dex1": "Its body is a magnetic stone. Iron sand attaches firmly to the portions of its body that are particularly magnetic.",
    "dex2": "If you accidentally step on a Geodude sleeping on the ground, you’ll hear a crunching sound and feel a shock ripple through your entire body.",
    "class": "Rock Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "830",
    "ndex": "75",
    "species": "Graveler",
    "forme": "Graveler (Alola Form)",
    "type1": "Rock",
    "type2": "Electric",
    "ability1": "Magnet Pull",
    "ability2": "Sturdy",
    "abilityH": "Galvanize",
    "hp": "55",
    "attack": "95",
    "defense": "115",
    "spattack": "45",
    "spdefense": "45",
    "speed": "35",
    "total": "390",
    "weight": "242.5 lbs.",
    "height": "3'03\"",
    "dex1": "Its preferred food is dravite. After it has eaten this mineral, crystals form inside the Pokémon, rising to the surface of part of its body.",
    "dex2": "They eat rocks and often get into a scrap over them. The shock of Graveler smashing together causes a flash of light and a booming noise.",
    "class": "Rock Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Geodude (Alola Form)",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "831",
    "ndex": "76",
    "species": "Golem",
    "forme": "Golem (Alola Form)",
    "type1": "Rock",
    "type2": "Electric",
    "ability1": "Magnet Pull",
    "ability2": "Sturdy",
    "abilityH": "Galvanize",
    "hp": "80",
    "attack": "120",
    "defense": "130",
    "spattack": "55",
    "spdefense": "65",
    "speed": "45",
    "total": "495",
    "weight": "696.7 lbs.",
    "height": "5'07\"",
    "dex1": "It fires rocks charged with electricity. Even if the rock isn’t fired that accurately, just grazing an opponent will cause numbness and fainting.",
    "dex2": "Because it can’t fire boulders at a rapid pace, it’s been known to seize nearby Geodude and fire them from its back.",
    "class": "Megaton Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Graveler (Alola Form)",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "832",
    "ndex": "80",
    "species": "Slowbro",
    "forme": "Slowbro (Mega Slowbro)",
    "type1": "Water",
    "type2": "Psychic",
    "ability1": "Shell Armor",
    "ability2": "",
    "abilityH": "",
    "hp": "95",
    "attack": "75",
    "defense": "180",
    "spattack": "130",
    "spdefense": "80",
    "speed": "30",
    "total": "590",
    "weight": "264.6 lbs.",
    "height": "6'07\"",
    "dex1": "All the energy from Mega Evolution poured into the Shellder on its tail, leaving Slowpoke to be swallowed whole.",
    "dex2": "When bathed in the energy of Mega Evolution, Shellder converts into impregnable armor. There is virtually no change in Slowpoke.",
    "class": "Hermit Crab Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Slowpoke",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "833",
    "ndex": "88",
    "species": "Grimer",
    "forme": "Grimer (Alola Form)",
    "type1": "Poison",
    "type2": "Dark",
    "ability1": "Poison Touch",
    "ability2": "Gluttony",
    "abilityH": "Power of Alchemy",
    "hp": "80",
    "attack": "80",
    "defense": "50",
    "spattack": "40",
    "spdefense": "50",
    "speed": "25",
    "total": "325",
    "weight": "92.6 lbs.",
    "height": "2'04\"",
    "dex1": "A Grimer, which had been brought in to solve a problem with garbage, developed over time into this form.",
    "dex2": "The crystals on Grimer’s body are lumps of toxins. If one falls off, lethal poisons leak out.",
    "class": "Sludge Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "834",
    "ndex": "89",
    "species": "Muk",
    "forme": "Muk (Alola Form)",
    "type1": "Poison",
    "type2": "Dark",
    "ability1": "Poison Touch",
    "ability2": "Gluttony",
    "abilityH": "Power of Alchemy",
    "hp": "105",
    "attack": "105",
    "defense": "75",
    "spattack": "65",
    "spdefense": "100",
    "speed": "50",
    "total": "500",
    "weight": "114.6 lbs.",
    "height": "3'03\"",
    "dex1": "The garbage it eats causes continuous chemical changes in its body, which produce its exceedingly vivid coloration.",
    "dex2": "While it’s unexpectedly quiet and friendly, if it’s not fed any trash for a while, it will smash its Trainer’s furnishings and eat up the fragments.",
    "class": "Sludge Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Grimer",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "835",
    "ndex": "94",
    "species": "Gengar",
    "forme": "Gengar (Mega Gengar)",
    "type1": "Ghost",
    "type2": "Poison",
    "ability1": "Shadow Tag",
    "ability2": "",
    "abilityH": "",
    "hp": "60",
    "attack": "65",
    "defense": "80",
    "spattack": "170",
    "spdefense": "95",
    "speed": "130",
    "total": "600",
    "weight": "89.3 lbs.",
    "height": "4'07\"",
    "dex1": "Gengar’s relationships are warped. It has no interest in opponents unless it perceives them as prey.",
    "dex2": "The energy of Mega Evolution awakened it. It sinks into another dimension, where it keeps a patient watch for its chance to attack.",
    "class": "Shadow Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Haunter",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "836",
    "ndex": "103",
    "species": "Exeggutor",
    "forme": "Exeggutor (Alola Form)",
    "type1": "Grass",
    "type2": "Dragon",
    "ability1": "Frisk",
    "ability2": "Frisk",
    "abilityH": "Harvest",
    "hp": "95",
    "attack": "105",
    "defense": "85",
    "spattack": "125",
    "spdefense": "75",
    "speed": "45",
    "total": "530",
    "weight": "916.2 lbs.",
    "height": "35'09\"",
    "dex1": "Alola is the best environment for this Pokémon. Local people take pride in its appearance, saying this is how Exeggutor ought to look.",
    "dex2": "As it grew taller and taller, it outgrew its reliance on psychic powers, while within it awakened the power of the sleeping dragon.",
    "class": "Coconut Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Exeggcute",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "837",
    "ndex": "105",
    "species": "Marowak",
    "forme": "Marowak (Alola Form)",
    "type1": "Fire",
    "type2": "Ghost",
    "ability1": "Cursed Body",
    "ability2": "Lightning Rod",
    "abilityH": "Rock Head",
    "hp": "60",
    "attack": "80",
    "defense": "110",
    "spattack": "50",
    "spdefense": "80",
    "speed": "45",
    "total": "425",
    "weight": "75.0 lbs.",
    "height": "3'03\"",
    "dex1": "The bones it possesses were once its mother’s. Its mother’s regrets have become like a vengeful spirit protecting this Pokémon.",
    "dex2": "Its custom is to mourn its lost companions. Mounds of dirt by the side of the road mark the graves of the Marowak.",
    "class": "Bone Keeper Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Cubone",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "838",
    "ndex": "115",
    "species": "Kangaskhan",
    "forme": "Kangaskhan (Mega Kangaskhan)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Parental Bond",
    "ability2": "",
    "abilityH": "",
    "hp": "105",
    "attack": "125",
    "defense": "100",
    "spattack": "60",
    "spdefense": "100",
    "speed": "100",
    "total": "590",
    "weight": "220.5 lbs.",
    "height": "7'03\"",
    "dex1": "Mega Kangaskhan’s strength derives from the mother’s happiness about her child’s growth. Watching it grow up keeps her spirits high.",
    "dex2": "Thanks to Mega Evolution, its child grows. But as the child is good only at fighting and nothing else, its mother feels uneasy about its future.",
    "class": "Parent Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "839",
    "ndex": "127",
    "species": "Pinsir",
    "forme": "Pinsir (Mega Pinsir)",
    "type1": "Bug",
    "type2": "",
    "ability1": "Aerilate",
    "ability2": "",
    "abilityH": "",
    "hp": "65",
    "attack": "155",
    "defense": "120",
    "spattack": "65",
    "spdefense": "90",
    "speed": "105",
    "total": "600",
    "weight": "130.1 lbs.",
    "height": "5'07\"",
    "dex1": "The influence of Mega Evolution leaves it in a state of constant excitement. It pierces enemies with its two large horns before shredding them.",
    "dex2": "Bathed in the energy of Mega Evolution, its wings become unusually developed. It flies at speeds of approximately 30 mph.",
    "class": "Stag Beetle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "840",
    "ndex": "130",
    "species": "Gyarados",
    "forme": "Gyarados (Mega Gyarados)",
    "type1": "Water",
    "type2": "Flying",
    "ability1": "Mold Breaker",
    "ability2": "",
    "abilityH": "",
    "hp": "95",
    "attack": "155",
    "defense": "109",
    "spattack": "70",
    "spdefense": "130",
    "speed": "81",
    "total": "640",
    "weight": "672.4 lbs.",
    "height": "21'04\"",
    "dex1": "Mega Evolution also affects its brain, leaving no other function except its destructive instinct to burn everything to cinders.",
    "dex2": "It jets water from the orifices on its sides, streaking above the water surface at supersonic speed.",
    "class": "Atrocious Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Magikarp",
    "egg-group1": "Water 2",
    "egg-group2": "Dragon"
  },
  {
    "id": "841",
    "ndex": "142",
    "species": "Aerodactyl",
    "forme": "Aerodactyl (Mega Aerodactyl)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Tough Claws",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "135",
    "defense": "85",
    "spattack": "70",
    "spdefense": "95",
    "speed": "150",
    "total": "615",
    "weight": "174.2 lbs.",
    "height": "6'11\"",
    "dex1": "Part of its body has become stone. Some scholars claim that this is Aerodactyl’s true appearance.",
    "dex2": "When it Mega Evolves, it becomes more vicious than ever before. Some say that’s because its excess of power is causing it pain.",
    "class": "Fossil Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "842",
    "ndex": "150",
    "species": "Mewtwo",
    "forme": "Mewtwo (Mega Mewtwo X)",
    "type1": "Psychic",
    "type2": "Fighting",
    "ability1": "Steadfast",
    "ability2": "",
    "abilityH": "",
    "hp": "106",
    "attack": "190",
    "defense": "100",
    "spattack": "154",
    "spdefense": "100",
    "speed": "130",
    "total": "780",
    "weight": "280.0 lbs.",
    "height": "7'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Genetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "843",
    "ndex": "150",
    "species": "Mewtwo",
    "forme": "Mewtwo (Mega Mewtwo Y)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Insomnia",
    "ability2": "",
    "abilityH": "",
    "hp": "106",
    "attack": "150",
    "defense": "70",
    "spattack": "194",
    "spdefense": "120",
    "speed": "140",
    "total": "780",
    "weight": "72.8 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Genetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "844",
    "ndex": "181",
    "species": "Ampharos",
    "forme": "Ampharos (Mega Ampharos)",
    "type1": "Electric",
    "type2": "",
    "ability1": "Mold Breaker",
    "ability2": "",
    "abilityH": "",
    "hp": "90",
    "attack": "95",
    "defense": "105",
    "spattack": "165",
    "spdefense": "110",
    "speed": "45",
    "total": "610",
    "weight": "135.6 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Light Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Flaaffy",
    "egg-group1": "Monster",
    "egg-group2": "Field"
  },
  {
    "id": "845",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "846",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "847",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "848",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "849",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "850",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "851",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "852",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "853",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "854",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "855",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "856",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "857",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "858",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "859",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "860",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "861",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "862",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "863",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "864",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "865",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "866",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "867",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "868",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "869",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "870",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "871",
    "ndex": "201",
    "species": "Unown",
    "forme": "Unown (One form)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "48",
    "attack": "72",
    "defense": "48",
    "spattack": "72",
    "spdefense": "48",
    "speed": "48",
    "total": "336",
    "weight": "11.0 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Symbol Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "872",
    "ndex": "208",
    "species": "Steelix",
    "forme": "Steelix (Mega Steelix)",
    "type1": "Steel",
    "type2": "Ground",
    "ability1": "Sand Force",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "125",
    "defense": "230",
    "spattack": "55",
    "spdefense": "95",
    "speed": "30",
    "total": "610",
    "weight": "1631.4 lbs.",
    "height": "34'05\"",
    "dex1": "",
    "dex2": "",
    "class": "Iron Snake Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Onix",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "873",
    "ndex": "212",
    "species": "Scizor",
    "forme": "Scizor (Mega Scizor)",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Technician",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "150",
    "defense": "140",
    "spattack": "65",
    "spdefense": "100",
    "speed": "75",
    "total": "600",
    "weight": "275.6 lbs.",
    "height": "6'07\"",
    "dex1": "The excess energy that bathes this Pokémon keeps it in constant danger of overflow. It can’t sustain a battle over long periods of time.",
    "dex2": "Due to the effects of Mega Evolution, its pincers have taken on a more diabolical form, ripping anything they pinch to shreds.",
    "class": "Pincer Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Scyther",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "874",
    "ndex": "214",
    "species": "Heracross",
    "forme": "Heracross (Mega Heracross)",
    "type1": "Bug",
    "type2": "Fighting",
    "ability1": "Skill Link",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "185",
    "defense": "115",
    "spattack": "40",
    "spdefense": "105",
    "speed": "75",
    "total": "600",
    "weight": "137.8 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Horn Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "875",
    "ndex": "229",
    "species": "Houndoom",
    "forme": "Houndoom (Mega Houndoom)",
    "type1": "Dark",
    "type2": "Fire",
    "ability1": "Solar Power",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "90",
    "defense": "90",
    "spattack": "140",
    "spdefense": "90",
    "speed": "115",
    "total": "600",
    "weight": "109.1 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Dark Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Houndour",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "876",
    "ndex": "248",
    "species": "Tyranitar",
    "forme": "Tyranitar (Mega Tyranitar)",
    "type1": "Rock",
    "type2": "Dark",
    "ability1": "Sand Stream",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "164",
    "defense": "150",
    "spattack": "95",
    "spdefense": "120",
    "speed": "71",
    "total": "700",
    "weight": "562.2 lbs.",
    "height": "8'02\"",
    "dex1": "",
    "dex2": "",
    "class": "Armor Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pupitar",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "877",
    "ndex": "254",
    "species": "Sceptile",
    "forme": "Sceptile (Mega Sceptile)",
    "type1": "Grass",
    "type2": "",
    "ability1": "Lightning Rod",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "110",
    "defense": "75",
    "spattack": "145",
    "spdefense": "85",
    "speed": "145",
    "total": "630",
    "weight": "121.7 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Forest Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Grovyle",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "878",
    "ndex": "257",
    "species": "Blaziken",
    "forme": "Blaziken (Mega Blaziken)",
    "type1": "Fire",
    "type2": "Fighting",
    "ability1": "Speed Boost",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "160",
    "defense": "80",
    "spattack": "130",
    "spdefense": "80",
    "speed": "100",
    "total": "630",
    "weight": "114.6 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Blaze Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Combusken",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "879",
    "ndex": "260",
    "species": "Swampert",
    "forme": "Swampert (Mega Swampert)",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Swift Swim",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "150",
    "defense": "110",
    "spattack": "95",
    "spdefense": "110",
    "speed": "70",
    "total": "635",
    "weight": "224.9 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Mud Fish Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Marshtomp",
    "egg-group1": "Monster",
    "egg-group2": "Water 1"
  },
  {
    "id": "880",
    "ndex": "282",
    "species": "Gardevoir",
    "forme": "Gardevoir (Mega Gardevoir)",
    "type1": "Psychic",
    "type2": "Fairy",
    "ability1": "Pixilate",
    "ability2": "",
    "abilityH": "",
    "hp": "68",
    "attack": "85",
    "defense": "65",
    "spattack": "165",
    "spdefense": "135",
    "speed": "100",
    "total": "618",
    "weight": "106.7 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Embrace Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Kirlia",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "881",
    "ndex": "302",
    "species": "Sableye",
    "forme": "Sableye (Mega Sableye)",
    "type1": "Dark",
    "type2": "Ghost",
    "ability1": "Magic Bounce",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "85",
    "defense": "125",
    "spattack": "85",
    "spdefense": "115",
    "speed": "20",
    "total": "480",
    "weight": "354.9 lbs.",
    "height": "1'08\"",
    "dex1": "The jewel from its chest, which has grown gigantic due to the effects of Mega Evolution, can turn back any attack.",
    "dex2": "Supporting a giant heavy jewel, it can’t change direction very nimbly and is vulnerable to attack from behind.",
    "class": "Darkness Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "882",
    "ndex": "303",
    "species": "Mawile",
    "forme": "Mawile (Mega Mawile)",
    "type1": "Steel",
    "type2": "Fairy",
    "ability1": "Huge Power",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "105",
    "defense": "125",
    "spattack": "55",
    "spdefense": "95",
    "speed": "50",
    "total": "480",
    "weight": "51.8 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Deceiver Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": "Fairy"
  },
  {
    "id": "883",
    "ndex": "306",
    "species": "Aggron",
    "forme": "Aggron (Mega Aggron)",
    "type1": "Steel",
    "type2": "Rock",
    "ability1": "Filter",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "140",
    "defense": "230",
    "spattack": "60",
    "spdefense": "80",
    "speed": "50",
    "total": "630",
    "weight": "870.8 lbs.",
    "height": "7'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Iron Armor Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Lairon",
    "egg-group1": "Monster",
    "egg-group2": ""
  },
  {
    "id": "884",
    "ndex": "308",
    "species": "Medicham",
    "forme": "Medicham (Mega Medicham)",
    "type1": "Fighting",
    "type2": "Psychic",
    "ability1": "Pure Power",
    "ability2": "",
    "abilityH": "",
    "hp": "60",
    "attack": "100",
    "defense": "85",
    "spattack": "80",
    "spdefense": "85",
    "speed": "100",
    "total": "510",
    "weight": "69.4 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Meditate Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Meditite",
    "egg-group1": "Human-Like",
    "egg-group2": ""
  },
  {
    "id": "885",
    "ndex": "310",
    "species": "Manectric",
    "forme": "Manectric (Mega Manectric)",
    "type1": "Electric",
    "type2": "",
    "ability1": "Intimidate",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "75",
    "defense": "80",
    "spattack": "135",
    "spdefense": "80",
    "speed": "135",
    "total": "575",
    "weight": "97.0 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Discharge Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Electrike",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "886",
    "ndex": "319",
    "species": "Sharpedo",
    "forme": "Sharpedo (Mega Sharpedo)",
    "type1": "Water",
    "type2": "Dark",
    "ability1": "Strong Jaw",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "140",
    "defense": "70",
    "spattack": "110",
    "spdefense": "65",
    "speed": "105",
    "total": "560",
    "weight": "287.3 lbs.",
    "height": "8'02\"",
    "dex1": "The spines sprouting from its head are transformed fangs. If they’re injured or broken off, the spines will regenerate countless times.",
    "dex2": "As a consequence of Mega Evolution, its combative instincts exploded. The yellow marks it bears are scars from a long history of battles.",
    "class": "Brutal Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Carvanha",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "887",
    "ndex": "323",
    "species": "Camerupt",
    "forme": "Camerupt (Mega Camerupt)",
    "type1": "Fire",
    "type2": "Ground",
    "ability1": "Sheer Force",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "120",
    "defense": "100",
    "spattack": "145",
    "spdefense": "105",
    "speed": "20",
    "total": "560",
    "weight": "706.6 lbs.",
    "height": "8'02\"",
    "dex1": "",
    "dex2": "",
    "class": "Eruption Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Numel",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "888",
    "ndex": "334",
    "species": "Altaria",
    "forme": "Altaria (Mega Altaria)",
    "type1": "Dragon",
    "type2": "Fairy",
    "ability1": "Pixilate",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "110",
    "defense": "110",
    "spattack": "110",
    "spdefense": "105",
    "speed": "80",
    "total": "590",
    "weight": "45.4 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Humming Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Swablu",
    "egg-group1": "Flying",
    "egg-group2": "Dragon"
  },
  {
    "id": "889",
    "ndex": "351",
    "species": "Castform",
    "forme": "Castform (Sunny Form)",
    "type1": "Fire",
    "type2": "",
    "ability1": "Forecast",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "70",
    "defense": "70",
    "spattack": "70",
    "spdefense": "70",
    "speed": "70",
    "total": "420",
    "weight": "1.8 lbs.",
    "height": "1'00\"",
    "dex1": "This is the form Castform takes on the brightest of days. Its skin is unexpectedly hot to the touch, so approach with care.",
    "dex2": "This is Castform’s form when basking in fair weather. Its body is warm and toasty.",
    "class": "Weather Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": "Amorphous"
  },
  {
    "id": "890",
    "ndex": "351",
    "species": "Castform",
    "forme": "Castform (Rainy Form)",
    "type1": "Water",
    "type2": "",
    "ability1": "Forecast",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "70",
    "defense": "70",
    "spattack": "70",
    "spdefense": "70",
    "speed": "70",
    "total": "420",
    "weight": "1.8 lbs.",
    "height": "1'00\"",
    "dex1": "This is the form Castform takes when soaked with rain. When its body is compressed, water will seep out as if from a sponge.",
    "dex2": "This is Castform’s form during a downpour of rain. Its body retains moisture and gets slippery.",
    "class": "Weather Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": "Amorphous"
  },
  {
    "id": "891",
    "ndex": "351",
    "species": "Castform",
    "forme": "Castform (Snowy Form)",
    "type1": "Ice",
    "type2": "",
    "ability1": "Forecast",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "70",
    "defense": "70",
    "spattack": "70",
    "spdefense": "70",
    "speed": "70",
    "total": "420",
    "weight": "1.8 lbs.",
    "height": "1'00\"",
    "dex1": "This is the form Castform takes when covered in snow. Its body becomes an ice-like material, with a temperature near 23 degrees Fahrenheit.",
    "dex2": "This is Castform’s form when caught in a hailstorm. Its cold skin is as smooth as ice.",
    "class": "Weather Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": "Amorphous"
  },
  {
    "id": "892",
    "ndex": "354",
    "species": "Banette",
    "forme": "Banette (Mega Banette)",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Prankster",
    "ability2": "",
    "abilityH": "",
    "hp": "64",
    "attack": "165",
    "defense": "75",
    "spattack": "93",
    "spdefense": "83",
    "speed": "75",
    "total": "555",
    "weight": "28.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Marionette Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shuppet",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "893",
    "ndex": "359",
    "species": "Absol",
    "forme": "Absol (Mega Absol)",
    "type1": "Dark",
    "type2": "",
    "ability1": "Magic Bounce",
    "ability2": "",
    "abilityH": "",
    "hp": "65",
    "attack": "150",
    "defense": "60",
    "spattack": "115",
    "spdefense": "60",
    "speed": "115",
    "total": "565",
    "weight": "108.0 lbs.",
    "height": "3'11\"",
    "dex1": "When this Pokémon whips the winglike fur on its back as though beating its wings, it sends an intimidating aura flying at its opponents.",
    "dex2": "As the energy of Mega Evolution fills it, its fur bristles. What you see on its back are not true wings, and this Pokémon isn’t able to fly.",
    "class": "Disaster Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "894",
    "ndex": "362",
    "species": "Glalie",
    "forme": "Glalie (Mega Glalie)",
    "type1": "Ice",
    "type2": "",
    "ability1": "Refrigerate",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "120",
    "defense": "80",
    "spattack": "120",
    "spdefense": "80",
    "speed": "100",
    "total": "580",
    "weight": "772.1 lbs.",
    "height": "6'11\"",
    "dex1": "The excess energy from Mega Evolution spilled over from its mouth, breaking its jaw. It spews endless blizzards.",
    "dex2": "It envelops prey in its mouth, freezing them instantly. But its jaw is dislocated, so it’s unable to eat them.",
    "class": "Face Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Snorunt",
    "egg-group1": "Fairy",
    "egg-group2": "Mineral"
  },
  {
    "id": "895",
    "ndex": "373",
    "species": "Salamence",
    "forme": "Salamence (Mega Salamence)",
    "type1": "Dragon",
    "type2": "Flying",
    "ability1": "Aerilate",
    "ability2": "",
    "abilityH": "",
    "hp": "95",
    "attack": "145",
    "defense": "130",
    "spattack": "120",
    "spdefense": "90",
    "speed": "120",
    "total": "700",
    "weight": "248.2 lbs.",
    "height": "5'11\"",
    "dex1": "Anyone standing in its path gets sliced right in two, while this Pokémon continues its flight without interruption.",
    "dex2": "Mega Evolution fuels its brutality, and it may even turn on the Trainer who raised it. It’s been dubbed “the blood-soaked crescent.”",
    "class": "Dragon Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shelgon",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "896",
    "ndex": "376",
    "species": "Metagross",
    "forme": "Metagross (Mega Metagross)",
    "type1": "Steel",
    "type2": "Psychic",
    "ability1": "Tough Claws",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "145",
    "defense": "150",
    "spattack": "105",
    "spdefense": "110",
    "speed": "110",
    "total": "700",
    "weight": "2078.7 lbs.",
    "height": "8'02\"",
    "dex1": "This form results from one Metagross, one Metang, and two Beldum linking up.",
    "dex2": "Mega Evolution stimulated its brain. It emerged as a ruthless Pokémon that will clutch at any means of ensuring its victories.",
    "class": "Iron Leg Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Metang",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "897",
    "ndex": "380",
    "species": "Latias",
    "forme": "Latias (Mega Latias)",
    "type1": "Dragon",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "100",
    "defense": "120",
    "spattack": "140",
    "spdefense": "150",
    "speed": "110",
    "total": "700",
    "weight": "114.6 lbs.",
    "height": "5'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Eon Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "898",
    "ndex": "381",
    "species": "Latios",
    "forme": "Latios (Mega Latios)",
    "type1": "Dragon",
    "type2": "Psychic",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "130",
    "defense": "100",
    "spattack": "160",
    "spdefense": "120",
    "speed": "110",
    "total": "700",
    "weight": "154.3 lbs.",
    "height": "7'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Eon Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "899",
    "ndex": "383",
    "species": "Kyogre",
    "forme": "Kyogre (Primal Reversion)",
    "type1": "Water",
    "type2": "",
    "ability1": "Primordial Sea",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "150",
    "defense": "90",
    "spattack": "180",
    "spdefense": "160",
    "speed": "90",
    "total": "770",
    "weight": "948.0 lbs.",
    "height": "32'02\"",
    "dex1": "",
    "dex2": "",
    "class": "Sea Basin Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "900",
    "ndex": "382",
    "species": "Groudon",
    "forme": "Groudon (Primal Reversion)",
    "type1": "Ground",
    "type2": "Fire",
    "ability1": "Desolate Land",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "180",
    "defense": "160",
    "spattack": "150",
    "spdefense": "90",
    "speed": "90",
    "total": "770",
    "weight": "2204.0 lbs.",
    "height": "16'05\"",
    "dex1": "",
    "dex2": "",
    "class": "Continent Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "901",
    "ndex": "384",
    "species": "Rayquaza",
    "forme": "Rayquaza (Mega Rayquaza)",
    "type1": "Dragon",
    "type2": "Flying",
    "ability1": "Delta Stream",
    "ability2": "",
    "abilityH": "",
    "hp": "105",
    "attack": "180",
    "defense": "100",
    "spattack": "180",
    "spdefense": "100",
    "speed": "115",
    "total": "780",
    "weight": "864.2 lbs.",
    "height": "35'05\"",
    "dex1": "",
    "dex2": "",
    "class": "Sky High Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "902",
    "ndex": "386",
    "species": "Deoxys",
    "forme": "Deoxys (Attack Forme)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "180",
    "defense": "20",
    "spattack": "180",
    "spdefense": "20",
    "speed": "150",
    "total": "600",
    "weight": "134.0 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "DNA Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "903",
    "ndex": "386",
    "species": "Deoxys",
    "forme": "Deoxys (Defense Forme)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "70",
    "defense": "160",
    "spattack": "70",
    "spdefense": "160",
    "speed": "90",
    "total": "600",
    "weight": "134.0 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "DNA Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "904",
    "ndex": "386",
    "species": "Deoxys",
    "forme": "Deoxys (Speed Forme)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Pressure",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "95",
    "defense": "90",
    "spattack": "95",
    "spdefense": "90",
    "speed": "180",
    "total": "600",
    "weight": "134.0 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "DNA Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "905",
    "ndex": "412",
    "species": "Burmy",
    "forme": "Burmy (Sandy Cloak)",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "40",
    "attack": "29",
    "defense": "45",
    "spattack": "29",
    "spdefense": "45",
    "speed": "36",
    "total": "224",
    "weight": "7.5 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bagworm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "906",
    "ndex": "412",
    "species": "Burmy",
    "forme": "Burmy (Trash Cloak)",
    "type1": "Bug",
    "type2": "",
    "ability1": "Shed Skin",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "40",
    "attack": "29",
    "defense": "45",
    "spattack": "29",
    "spdefense": "45",
    "speed": "36",
    "total": "224",
    "weight": "7.5 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bagworm Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "907",
    "ndex": "413",
    "species": "Wormadam",
    "forme": "Wormadam (Sandy Cloak)",
    "type1": "Bug",
    "type2": "Ground",
    "ability1": "Anticipation",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "60",
    "attack": "79",
    "defense": "105",
    "spattack": "59",
    "spdefense": "85",
    "speed": "36",
    "total": "424",
    "weight": "14.3 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bagworm Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Burmy",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "908",
    "ndex": "413",
    "species": "Wormadam",
    "forme": "Wormadam (Trash Cloak)",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Anticipation",
    "ability2": "",
    "abilityH": "Overcoat",
    "hp": "60",
    "attack": "69",
    "defense": "95",
    "spattack": "69",
    "spdefense": "95",
    "speed": "36",
    "total": "424",
    "weight": "14.3 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Bagworm Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Burmy",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "909",
    "ndex": "421",
    "species": "Cherrim",
    "forme": "Cherrim (Sunshine Form)",
    "type1": "Grass",
    "type2": "",
    "ability1": "Flower Gift",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "60",
    "defense": "70",
    "spattack": "87",
    "spdefense": "78",
    "speed": "85",
    "total": "450",
    "weight": "20.5 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Blossom Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Cherubi",
    "egg-group1": "Fairy",
    "egg-group2": "Grass"
  },
  {
    "id": "910",
    "ndex": "422",
    "species": "Shellos",
    "forme": "Shellos (East Sea)",
    "type1": "Water",
    "type2": "",
    "ability1": "Sticky Hold",
    "ability2": "Storm Drain",
    "abilityH": "Sand Force",
    "hp": "76",
    "attack": "48",
    "defense": "48",
    "spattack": "57",
    "spdefense": "62",
    "speed": "34",
    "total": "325",
    "weight": "13.9 lbs.",
    "height": "1'00\"",
    "dex1": "Shellos lives in the sea and feasts on plankton. The lovelier the ocean where Shellos resides, the more vibrant its color becomes.",
    "dex2": "The difference in color from one Shellos to another seems to be a result of their diet. No large changes can be seen in their capabilities.",
    "class": "Sea Slug Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 1",
    "egg-group2": "Amorphous"
  },
  {
    "id": "911",
    "ndex": "423",
    "species": "Gastrodon",
    "forme": "Gastrodon (East Sea)",
    "type1": "Water",
    "type2": "Ground",
    "ability1": "Sticky Hold",
    "ability2": "Storm Drain",
    "abilityH": "Sand Force",
    "hp": "111",
    "attack": "83",
    "defense": "68",
    "spattack": "92",
    "spdefense": "82",
    "speed": "39",
    "total": "475",
    "weight": "65.9 lbs.",
    "height": "2'11\"",
    "dex1": "A team of researchers is scouring the oceans of the world in search of a Gastrodon in a color never seen before.",
    "dex2": "Experiments are being conducted to discover what happens when a Gastrodon is raised in a location other than the sea where it was born.",
    "class": "Sea Slug Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Shellos (East Sea)",
    "egg-group1": "Water 1",
    "egg-group2": "Amorphous"
  },
  {
    "id": "912",
    "ndex": "428",
    "species": "Lopunny",
    "forme": "Lopunny (Mega Lopunny)",
    "type1": "Normal",
    "type2": "Fighting",
    "ability1": "Scrappy",
    "ability2": "",
    "abilityH": "",
    "hp": "65",
    "attack": "136",
    "defense": "94",
    "spattack": "54",
    "spdefense": "96",
    "speed": "135",
    "total": "580",
    "weight": "62.4 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Rabbit Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Buneary",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "913",
    "ndex": "445",
    "species": "Garchomp",
    "forme": "Garchomp (Mega Garchomp)",
    "type1": "Dragon",
    "type2": "Ground",
    "ability1": "Sand Force",
    "ability2": "",
    "abilityH": "",
    "hp": "108",
    "attack": "170",
    "defense": "115",
    "spattack": "120",
    "spdefense": "95",
    "speed": "92",
    "total": "700",
    "weight": "209.4 lbs.",
    "height": "6'03\"",
    "dex1": "Excess energy melted its arms and wings, transforming them into giant scythes.",
    "dex2": "Its vaunted wings become scythes, sending it mad with rage. It swings its scythes wildly and slices the ground to pieces.",
    "class": "Mach Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Gabite",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "914",
    "ndex": "448",
    "species": "Lucario",
    "forme": "Lucario (Mega Lucario)",
    "type1": "Fighting",
    "type2": "Steel",
    "ability1": "Adaptability",
    "ability2": "",
    "abilityH": "",
    "hp": "70",
    "attack": "145",
    "defense": "88",
    "spattack": "140",
    "spdefense": "70",
    "speed": "112",
    "total": "625",
    "weight": "126.8 lbs.",
    "height": "4'03\"",
    "dex1": "Black streaks all over its body show where its auras and the energy of Mega Evolution intermingled and raced through it.",
    "dex2": "It readies itself to face its enemies by focusing its mental energies. Its fighting style can be summed up in a single word: heartless.",
    "class": "Aura Pokémon",
    "percent-male": "0.875",
    "percent-female": "0.125",
    "pre-evolution": "Riolu",
    "egg-group1": "Field",
    "egg-group2": "Human-Like"
  },
  {
    "id": "915",
    "ndex": "460",
    "species": "Abomasnow",
    "forme": "Abomasnow (Mega Abomasnow)",
    "type1": "Grass",
    "type2": "Ice",
    "ability1": "Snow Warning",
    "ability2": "",
    "abilityH": "",
    "hp": "90",
    "attack": "132",
    "defense": "105",
    "spattack": "132",
    "spdefense": "105",
    "speed": "30",
    "total": "594",
    "weight": "407.9 lbs.",
    "height": "8'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Frost Tree Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Snover",
    "egg-group1": "Monster",
    "egg-group2": "Grass"
  },
  {
    "id": "916",
    "ndex": "475",
    "species": "Gallade",
    "forme": "Gallade (Mega Gallade)",
    "type1": "Psychic",
    "type2": "Fighting",
    "ability1": "Inner Focus",
    "ability2": "",
    "abilityH": "",
    "hp": "68",
    "attack": "165",
    "defense": "95",
    "spattack": "65",
    "spdefense": "115",
    "speed": "110",
    "total": "618",
    "weight": "124.3 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Blade Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "Kirlia",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "917",
    "ndex": "479",
    "species": "Rotom",
    "forme": "Rotom (Heat Rotom)",
    "type1": "Electric",
    "type2": "Fire",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "65",
    "defense": "107",
    "spattack": "105",
    "spdefense": "107",
    "speed": "86",
    "total": "520",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Plasma Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "918",
    "ndex": "479",
    "species": "Rotom",
    "forme": "Rotom (Wash Rotom)",
    "type1": "Electric",
    "type2": "Water",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "65",
    "defense": "107",
    "spattack": "105",
    "spdefense": "107",
    "speed": "86",
    "total": "520",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Plasma Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "919",
    "ndex": "479",
    "species": "Rotom",
    "forme": "Rotom (Frost Rotom)",
    "type1": "Electric",
    "type2": "Ice",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "65",
    "defense": "107",
    "spattack": "105",
    "spdefense": "107",
    "speed": "86",
    "total": "520",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Plasma Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "920",
    "ndex": "479",
    "species": "Rotom",
    "forme": "Rotom (Fan Rotom)",
    "type1": "Electric",
    "type2": "Flying",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "65",
    "defense": "107",
    "spattack": "105",
    "spdefense": "107",
    "speed": "86",
    "total": "520",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Plasma Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "921",
    "ndex": "479",
    "species": "Rotom",
    "forme": "Rotom (Mow Rotom)",
    "type1": "Electric",
    "type2": "Grass",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "65",
    "defense": "107",
    "spattack": "105",
    "spdefense": "107",
    "speed": "86",
    "total": "520",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Plasma Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "922",
    "ndex": "487",
    "species": "Giratina",
    "forme": "Giratina (Origin Forme)",
    "type1": "Ghost",
    "type2": "Dragon",
    "ability1": "Levitate",
    "ability2": "",
    "abilityH": "",
    "hp": "150",
    "attack": "120",
    "defense": "100",
    "spattack": "120",
    "spdefense": "100",
    "speed": "90",
    "total": "680",
    "weight": "1433.0 lbs.",
    "height": "22'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Renegade Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "923",
    "ndex": "492",
    "species": "Shaymin",
    "forme": "Shaymin (Sky Forme)",
    "type1": "Grass",
    "type2": "Flying",
    "ability1": "Serene Grace",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "103",
    "defense": "75",
    "spattack": "120",
    "spdefense": "75",
    "speed": "127",
    "total": "600",
    "weight": "11.5 lbs.",
    "height": "1'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Gratitude Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "924",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Fighting)",
    "type1": "Fighting",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "925",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Flying)",
    "type1": "Flying",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "926",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Poison)",
    "type1": "Poison",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "927",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Ground)",
    "type1": "Ground",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "928",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Rock)",
    "type1": "Rock",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "929",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Bug)",
    "type1": "Bug",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "930",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Ghost)",
    "type1": "Ghost",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "931",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Steel)",
    "type1": "Steel",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "932",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Fire)",
    "type1": "Fire",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "933",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Water)",
    "type1": "Water",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "934",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Grass)",
    "type1": "Grass",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "935",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Electric)",
    "type1": "Electric",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "936",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Psychic)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "937",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Ice)",
    "type1": "Ice",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "938",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Dragon)",
    "type1": "Dragon",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "939",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Dark)",
    "type1": "Dark",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "940",
    "ndex": "493",
    "species": "Arceus",
    "forme": "Arceus (Fairy)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Multitype",
    "ability2": "",
    "abilityH": "",
    "hp": "120",
    "attack": "120",
    "defense": "120",
    "spattack": "120",
    "spdefense": "120",
    "speed": "120",
    "total": "720",
    "weight": "705.5 lbs.",
    "height": "10'06\"",
    "dex1": "",
    "dex2": "",
    "class": "Alpha Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "941",
    "ndex": "531",
    "species": "Audino",
    "forme": "Audino (Mega Audino)",
    "type1": "Normal",
    "type2": "Fairy",
    "ability1": "Healer",
    "ability2": "",
    "abilityH": "",
    "hp": "103",
    "attack": "60",
    "defense": "126",
    "spattack": "80",
    "spdefense": "126",
    "speed": "50",
    "total": "545",
    "weight": "70.5 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Hearing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "942",
    "ndex": "550",
    "species": "Basculin",
    "forme": "Basculin (Blue-Striped Form)",
    "type1": "Water",
    "type2": "",
    "ability1": "Rock Head",
    "ability2": "Adaptability",
    "abilityH": "Mold Breaker",
    "hp": "70",
    "attack": "92",
    "defense": "65",
    "spattack": "80",
    "spdefense": "55",
    "speed": "98",
    "total": "460",
    "weight": "39.7 lbs.",
    "height": "3'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Hostile Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "943",
    "ndex": "555",
    "species": "Darmanitan",
    "forme": "Darmanitan (Zen Mode)",
    "type1": "Fire",
    "type2": "Psychic",
    "ability1": "Zen Mode",
    "ability2": "",
    "abilityH": "",
    "hp": "105",
    "attack": "30",
    "defense": "105",
    "spattack": "140",
    "spdefense": "105",
    "speed": "55",
    "total": "540",
    "weight": "204.8 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Blazing Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Darumaka",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "944",
    "ndex": "585",
    "species": "Deerling",
    "forme": "Deerling (Summer Form)",
    "type1": "Normal",
    "type2": "Grass",
    "ability1": "Chlorophyll",
    "ability2": "Sap Sipper",
    "abilityH": "Serene Grace",
    "hp": "60",
    "attack": "60",
    "defense": "50",
    "spattack": "40",
    "spdefense": "50",
    "speed": "75",
    "total": "335",
    "weight": "43.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Season Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "945",
    "ndex": "585",
    "species": "Deerling",
    "forme": "Deerling (Autumn Form)",
    "type1": "Normal",
    "type2": "Grass",
    "ability1": "Chlorophyll",
    "ability2": "Sap Sipper",
    "abilityH": "Serene Grace",
    "hp": "60",
    "attack": "60",
    "defense": "50",
    "spattack": "40",
    "spdefense": "50",
    "speed": "75",
    "total": "335",
    "weight": "43.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Season Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "946",
    "ndex": "585",
    "species": "Deerling",
    "forme": "Deerling (Winter Form)",
    "type1": "Normal",
    "type2": "Grass",
    "ability1": "Chlorophyll",
    "ability2": "Sap Sipper",
    "abilityH": "Serene Grace",
    "hp": "60",
    "attack": "60",
    "defense": "50",
    "spattack": "40",
    "spdefense": "50",
    "speed": "75",
    "total": "335",
    "weight": "43.0 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Season Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "947",
    "ndex": "586",
    "species": "Sawsbuck",
    "forme": "Sawsbuck (Summer Form)",
    "type1": "Normal",
    "type2": "Grass",
    "ability1": "Chlorophyll",
    "ability2": "Sap Sipper",
    "abilityH": "Serene Grace",
    "hp": "80",
    "attack": "100",
    "defense": "70",
    "spattack": "60",
    "spdefense": "70",
    "speed": "95",
    "total": "475",
    "weight": "203.9 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Season Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Deerling",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "948",
    "ndex": "586",
    "species": "Sawsbuck",
    "forme": "Sawsbuck (Autumn Form)",
    "type1": "Normal",
    "type2": "Grass",
    "ability1": "Chlorophyll",
    "ability2": "Sap Sipper",
    "abilityH": "Serene Grace",
    "hp": "80",
    "attack": "100",
    "defense": "70",
    "spattack": "60",
    "spdefense": "70",
    "speed": "95",
    "total": "475",
    "weight": "203.9 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Season Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Deerling",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "949",
    "ndex": "586",
    "species": "Sawsbuck",
    "forme": "Sawsbuck (Winter Form)",
    "type1": "Normal",
    "type2": "Grass",
    "ability1": "Chlorophyll",
    "ability2": "Sap Sipper",
    "abilityH": "Serene Grace",
    "hp": "80",
    "attack": "100",
    "defense": "70",
    "spattack": "60",
    "spdefense": "70",
    "speed": "95",
    "total": "475",
    "weight": "203.9 lbs.",
    "height": "6'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Season Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Deerling",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "950",
    "ndex": "641",
    "species": "Tornadus",
    "forme": "Tornadus (Therian Forme)",
    "type1": "Flying",
    "type2": "",
    "ability1": "Regenerator",
    "ability2": "",
    "abilityH": "",
    "hp": "79",
    "attack": "100",
    "defense": "80",
    "spattack": "110",
    "spdefense": "90",
    "speed": "121",
    "total": "580",
    "weight": "138.9 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Cyclone Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "951",
    "ndex": "642",
    "species": "Thundurus",
    "forme": "Thundurus (Therian Forme)",
    "type1": "Electric",
    "type2": "Flying",
    "ability1": "Volt Absorb",
    "ability2": "",
    "abilityH": "",
    "hp": "79",
    "attack": "105",
    "defense": "70",
    "spattack": "145",
    "spdefense": "80",
    "speed": "101",
    "total": "580",
    "weight": "134.5 lbs.",
    "height": "9'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Bolt Strike Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "952",
    "ndex": "645",
    "species": "Landorus",
    "forme": "Landorus (Therian Forme)",
    "type1": "Ground",
    "type2": "Flying",
    "ability1": "Intimidate",
    "ability2": "",
    "abilityH": "",
    "hp": "89",
    "attack": "145",
    "defense": "90",
    "spattack": "105",
    "spdefense": "80",
    "speed": "91",
    "total": "600",
    "weight": "149.9 lbs.",
    "height": "4'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Abundance Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "953",
    "ndex": "646",
    "species": "Kyurem",
    "forme": "Kyurem (White Kyurem)",
    "type1": "Dragon",
    "type2": "Ice",
    "ability1": "Turboblaze",
    "ability2": "",
    "abilityH": "",
    "hp": "125",
    "attack": "120",
    "defense": "90",
    "spattack": "170",
    "spdefense": "100",
    "speed": "95",
    "total": "700",
    "weight": "716.5 lbs.",
    "height": "11'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Boundary Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "954",
    "ndex": "646",
    "species": "Kyurem",
    "forme": "Kyurem (Black Kyurem)",
    "type1": "Dragon",
    "type2": "Ice",
    "ability1": "Teravolt",
    "ability2": "",
    "abilityH": "",
    "hp": "125",
    "attack": "170",
    "defense": "100",
    "spattack": "120",
    "spdefense": "90",
    "speed": "95",
    "total": "700",
    "weight": "716.5 lbs.",
    "height": "10'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Boundary Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "955",
    "ndex": "647",
    "species": "Keldeo",
    "forme": "Keldeo (Resolute Form)",
    "type1": "Water",
    "type2": "Fighting",
    "ability1": "Justified",
    "ability2": "",
    "abilityH": "",
    "hp": "91",
    "attack": "72",
    "defense": "90",
    "spattack": "129",
    "spdefense": "90",
    "speed": "108",
    "total": "580",
    "weight": "106.9 lbs.",
    "height": "4'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Colt Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "956",
    "ndex": "648",
    "species": "Meloetta",
    "forme": "Meloetta (Pirouette Forme)",
    "type1": "Normal",
    "type2": "Fighting",
    "ability1": "Serene Grace",
    "ability2": "",
    "abilityH": "",
    "hp": "100",
    "attack": "128",
    "defense": "90",
    "spattack": "77",
    "spdefense": "77",
    "speed": "128",
    "total": "600",
    "weight": "14.3 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Melody Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "957",
    "ndex": "649",
    "species": "Genesect",
    "forme": "Genesect (Genesect)",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Download",
    "ability2": "",
    "abilityH": "",
    "hp": "71",
    "attack": "120",
    "defense": "95",
    "spattack": "120",
    "spdefense": "95",
    "speed": "99",
    "total": "600",
    "weight": "181.9 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Paleozoic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "958",
    "ndex": "649",
    "species": "Genesect",
    "forme": "Genesect (Genesect)",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Download",
    "ability2": "",
    "abilityH": "",
    "hp": "71",
    "attack": "120",
    "defense": "95",
    "spattack": "120",
    "spdefense": "95",
    "speed": "99",
    "total": "600",
    "weight": "181.9 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Paleozoic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "959",
    "ndex": "649",
    "species": "Genesect",
    "forme": "Genesect (Genesect)",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Download",
    "ability2": "",
    "abilityH": "",
    "hp": "71",
    "attack": "120",
    "defense": "95",
    "spattack": "120",
    "spdefense": "95",
    "speed": "99",
    "total": "600",
    "weight": "181.9 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Paleozoic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "960",
    "ndex": "649",
    "species": "Genesect",
    "forme": "Genesect (Genesect)",
    "type1": "Bug",
    "type2": "Steel",
    "ability1": "Download",
    "ability2": "",
    "abilityH": "",
    "hp": "71",
    "attack": "120",
    "defense": "95",
    "spattack": "120",
    "spdefense": "95",
    "speed": "99",
    "total": "600",
    "weight": "181.9 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Paleozoic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "961",
    "ndex": "658",
    "species": "Greninja",
    "forme": "Greninja (Battle Bond)",
    "type1": "Water",
    "type2": "Dark",
    "ability1": "Battle Bond",
    "ability2": "Battle Bond",
    "abilityH": "Battle Bond",
    "hp": "72",
    "attack": "95",
    "defense": "67",
    "spattack": "103",
    "spdefense": "71",
    "speed": "122",
    "total": "530",
    "weight": "88.2 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Ninja Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "962",
    "ndex": "658",
    "species": "Greninja",
    "forme": "Greninja (Ash-Greninja)",
    "type1": "Water",
    "type2": "Dark",
    "ability1": "Battle Bond",
    "ability2": "Battle Bond",
    "abilityH": "Battle Bond",
    "hp": "72",
    "attack": "145",
    "defense": "67",
    "spattack": "153",
    "spdefense": "71",
    "speed": "132",
    "total": "640",
    "weight": "88.2 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Ninja Pokémon",
    "percent-male": "1",
    "percent-female": "0",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "963",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Polar Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "964",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Tundra Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "965",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Continental Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "966",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Garden Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "967",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Elegant Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "968",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Meadow Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "969",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Modern Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "970",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Marine Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "971",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Archipelago Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "972",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (High Plains Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "973",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Sandstorm Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "974",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (River Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "975",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Monsoon Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "976",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Savanna Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "977",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Sun Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "978",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Ocean Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "979",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Jungle Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "980",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Fancy Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "981",
    "ndex": "666",
    "species": "Vivillon",
    "forme": "Vivillon (Poké Ball Pattern)",
    "type1": "Bug",
    "type2": "Flying",
    "ability1": "Shield Dust",
    "ability2": "Compound Eyes",
    "abilityH": "Friend Guard",
    "hp": "80",
    "attack": "52",
    "defense": "50",
    "spattack": "90",
    "spdefense": "50",
    "speed": "89",
    "total": "411",
    "weight": "37.5 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Scale Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Spewpa",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "982",
    "ndex": "669",
    "species": "Flabébé",
    "forme": "Flabébé (Yellow Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "44",
    "attack": "38",
    "defense": "39",
    "spattack": "61",
    "spdefense": "79",
    "speed": "42",
    "total": "303",
    "weight": "0.2 lbs.",
    "height": "0'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "983",
    "ndex": "669",
    "species": "Flabébé",
    "forme": "Flabébé (Orange Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "44",
    "attack": "38",
    "defense": "39",
    "spattack": "61",
    "spdefense": "79",
    "speed": "42",
    "total": "303",
    "weight": "0.2 lbs.",
    "height": "0'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "984",
    "ndex": "669",
    "species": "Flabébé",
    "forme": "Flabébé (Blue Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "44",
    "attack": "38",
    "defense": "39",
    "spattack": "61",
    "spdefense": "79",
    "speed": "42",
    "total": "303",
    "weight": "0.2 lbs.",
    "height": "0'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "985",
    "ndex": "669",
    "species": "Flabébé",
    "forme": "Flabébé (White Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "44",
    "attack": "38",
    "defense": "39",
    "spattack": "61",
    "spdefense": "79",
    "speed": "42",
    "total": "303",
    "weight": "0.2 lbs.",
    "height": "0'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "986",
    "ndex": "670",
    "species": "Floette",
    "forme": "Floette (Yellow Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "54",
    "attack": "45",
    "defense": "47",
    "spattack": "75",
    "spdefense": "98",
    "speed": "52",
    "total": "371",
    "weight": "2.0 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Flabébé",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "987",
    "ndex": "670",
    "species": "Floette",
    "forme": "Floette (Orange Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "54",
    "attack": "45",
    "defense": "47",
    "spattack": "75",
    "spdefense": "98",
    "speed": "52",
    "total": "371",
    "weight": "2.0 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Flabébé",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "988",
    "ndex": "670",
    "species": "Floette",
    "forme": "Floette (Blue Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "54",
    "attack": "45",
    "defense": "47",
    "spattack": "75",
    "spdefense": "98",
    "speed": "52",
    "total": "371",
    "weight": "2.0 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Flabébé",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "989",
    "ndex": "670",
    "species": "Floette",
    "forme": "Floette (White Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "54",
    "attack": "45",
    "defense": "47",
    "spattack": "75",
    "spdefense": "98",
    "speed": "52",
    "total": "371",
    "weight": "2.0 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Flabébé",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "990",
    "ndex": "670",
    "species": "Floette",
    "forme": "Floette (Eternal Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "",
    "hp": "74",
    "attack": "65",
    "defense": "67",
    "spattack": "125",
    "spdefense": "128",
    "speed": "92",
    "total": "551",
    "weight": "2.0 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Single Bloom Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "991",
    "ndex": "671",
    "species": "Florges",
    "forme": "Florges (Yellow Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "78",
    "attack": "65",
    "defense": "68",
    "spattack": "112",
    "spdefense": "154",
    "speed": "75",
    "total": "552",
    "weight": "22.0 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Garden Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Floette",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "992",
    "ndex": "671",
    "species": "Florges",
    "forme": "Florges (Orange Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "78",
    "attack": "65",
    "defense": "68",
    "spattack": "112",
    "spdefense": "154",
    "speed": "75",
    "total": "552",
    "weight": "22.0 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Garden Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Floette",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "993",
    "ndex": "671",
    "species": "Florges",
    "forme": "Florges (Blue Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "78",
    "attack": "65",
    "defense": "68",
    "spattack": "112",
    "spdefense": "154",
    "speed": "75",
    "total": "552",
    "weight": "22.0 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Garden Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Floette",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "994",
    "ndex": "671",
    "species": "Florges",
    "forme": "Florges (White Flower)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Flower Veil",
    "ability2": "",
    "abilityH": "Symbiosis",
    "hp": "78",
    "attack": "65",
    "defense": "68",
    "spattack": "112",
    "spdefense": "154",
    "speed": "75",
    "total": "552",
    "weight": "22.0 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Garden Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Floette",
    "egg-group1": "Fairy",
    "egg-group2": ""
  },
  {
    "id": "995",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (Heart Trim)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "996",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (Star Trim)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "997",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (Diamond Trim)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "998",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (Debutante Trim)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "999",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (Matron Trim)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "1000",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (Dandy Trim)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "1001",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (La Reine Trim)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "1002",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (Kabuki Trim)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "1003",
    "ndex": "676",
    "species": "Furfrou",
    "forme": "Furfrou (Pharaoh Trim)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Fur Coat",
    "ability2": "",
    "abilityH": "",
    "hp": "75",
    "attack": "80",
    "defense": "60",
    "spattack": "65",
    "spdefense": "90",
    "speed": "102",
    "total": "472",
    "weight": "61.7 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Poodle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "1004",
    "ndex": "678",
    "species": "Meowstic",
    "forme": "Meowstic (Female)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "Keen Eye",
    "ability2": "Infiltrator",
    "abilityH": "Competitive",
    "hp": "74",
    "attack": "48",
    "defense": "76",
    "spattack": "83",
    "spdefense": "81",
    "speed": "104",
    "total": "466",
    "weight": "18.7 lbs.",
    "height": "2'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Constraint Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "Espurr",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "1005",
    "ndex": "681",
    "species": "Aegislash",
    "forme": "Aegislash (Blade Forme)",
    "type1": "Steel",
    "type2": "Ghost",
    "ability1": "Stance Change",
    "ability2": "",
    "abilityH": "",
    "hp": "60",
    "attack": "150",
    "defense": "50",
    "spattack": "150",
    "spdefense": "50",
    "speed": "60",
    "total": "520",
    "weight": "116.8 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Royal Sword Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Doublade",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1006",
    "ndex": "710",
    "species": "Pumpkaboo",
    "forme": "Pumpkaboo (Small Size)",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Pickup",
    "ability2": "Frisk",
    "abilityH": "Insomnia",
    "hp": "44",
    "attack": "66",
    "defense": "70",
    "spattack": "44",
    "spdefense": "55",
    "speed": "56",
    "total": "335",
    "weight": "7.7 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Pumpkin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "1007",
    "ndex": "710",
    "species": "Pumpkaboo",
    "forme": "Pumpkaboo (Large Size)",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Pickup",
    "ability2": "Frisk",
    "abilityH": "Insomnia",
    "hp": "54",
    "attack": "66",
    "defense": "70",
    "spattack": "44",
    "spdefense": "55",
    "speed": "46",
    "total": "335",
    "weight": "16.5 lbs.",
    "height": "1'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Pumpkin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "1008",
    "ndex": "710",
    "species": "Pumpkaboo",
    "forme": "Pumpkaboo (Super Size)",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Pickup",
    "ability2": "Frisk",
    "abilityH": "Insomnia",
    "hp": "59",
    "attack": "66",
    "defense": "70",
    "spattack": "44",
    "spdefense": "55",
    "speed": "41",
    "total": "335",
    "weight": "33.1 lbs.",
    "height": "2'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Pumpkin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "1009",
    "ndex": "711",
    "species": "Gourgeist",
    "forme": "Gourgeist (Small Size)",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Pickup",
    "ability2": "Frisk",
    "abilityH": "Insomnia",
    "hp": "55",
    "attack": "85",
    "defense": "122",
    "spattack": "58",
    "spdefense": "75",
    "speed": "99",
    "total": "494",
    "weight": "20.9 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Pumpkin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pumpkaboo (Small Size)",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "1010",
    "ndex": "711",
    "species": "Gourgeist",
    "forme": "Gourgeist (Large Size)",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Pickup",
    "ability2": "Frisk",
    "abilityH": "Insomnia",
    "hp": "75",
    "attack": "95",
    "defense": "122",
    "spattack": "58",
    "spdefense": "75",
    "speed": "69",
    "total": "494",
    "weight": "30.9 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Pumpkin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pumpkaboo (Large Size)",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "1011",
    "ndex": "711",
    "species": "Gourgeist",
    "forme": "Gourgeist (Super Size)",
    "type1": "Ghost",
    "type2": "Grass",
    "ability1": "Pickup",
    "ability2": "Frisk",
    "abilityH": "Insomnia",
    "hp": "85",
    "attack": "100",
    "defense": "122",
    "spattack": "58",
    "spdefense": "75",
    "speed": "54",
    "total": "494",
    "weight": "86.0 lbs.",
    "height": "5'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Pumpkin Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Pumpkaboo (Super Size)",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "1012",
    "ndex": "716",
    "species": "Xerneas",
    "forme": "Xerneas (Active Mode)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "Fairy Aura",
    "ability2": "",
    "abilityH": "",
    "hp": "126",
    "attack": "131",
    "defense": "95",
    "spattack": "131",
    "spdefense": "98",
    "speed": "99",
    "total": "680",
    "weight": "474.0 lbs.",
    "height": "9'10\"",
    "dex1": "",
    "dex2": "",
    "class": "Life Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1013",
    "ndex": "718",
    "species": "Zygarde",
    "forme": "Zygarde (10% Forme)",
    "type1": "Dragon",
    "type2": "Ground",
    "ability1": "Power Construct",
    "ability2": "Power Construct",
    "abilityH": "Power Construct",
    "hp": "54",
    "attack": "100",
    "defense": "71",
    "spattack": "61",
    "spdefense": "85",
    "speed": "115",
    "total": "486",
    "weight": "73.9 lbs.",
    "height": "3'11\"",
    "dex1": "Its sharp fangs make short work of finishing off its enemies, but it’s unable to maintain this body indefinitely. After a period of time, it falls apart.",
    "dex2": "This is Zygarde’s form when about 10% of its cells have been gathered. It runs across the land at speeds greater than 60 mph.",
    "class": "Order Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1014",
    "ndex": "718",
    "species": "Zygarde",
    "forme": "Zygarde (10% Forme)",
    "type1": "Dragon",
    "type2": "Ground",
    "ability1": "",
    "ability2": "",
    "abilityH": "",
    "hp": "54",
    "attack": "100",
    "defense": "71",
    "spattack": "61",
    "spdefense": "85",
    "speed": "115",
    "total": "486",
    "weight": "73.9 lbs.",
    "height": "3'11\"",
    "dex1": "Its sharp fangs make short work of finishing off its enemies, but it’s unable to maintain this body indefinitely. After a period of time, it falls apart.",
    "dex2": "This is Zygarde’s form when about 10% of its cells have been gathered. It runs across the land at speeds greater than 60 mph.",
    "class": "Order Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1015",
    "ndex": "718",
    "species": "Zygarde",
    "forme": "Zygarde (50% Forme)",
    "type1": "Dragon",
    "type2": "Ground",
    "ability1": "",
    "ability2": "",
    "abilityH": "",
    "hp": "108",
    "attack": "100",
    "defense": "121",
    "spattack": "81",
    "spdefense": "95",
    "speed": "95",
    "total": "600",
    "weight": "672.4 lbs.",
    "height": "16'05\"",
    "dex1": "This is Zygarde’s form when it has gathered 50% of its cells. It wipes out all those who oppose it, showing not a shred of mercy.",
    "dex2": "It’s thought to be monitoring the ecosystem. There are rumors that even greater power lies hidden within it.",
    "class": "Order Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1016",
    "ndex": "718",
    "species": "Zygarde",
    "forme": "Zygarde (Complete Forme)",
    "type1": "Dragon",
    "type2": "Ground",
    "ability1": "Power Construct",
    "ability2": "Power Construct",
    "abilityH": "Power Construct",
    "hp": "216",
    "attack": "100",
    "defense": "121",
    "spattack": "91",
    "spdefense": "95",
    "speed": "85",
    "total": "708",
    "weight": "1344.8 lbs.",
    "height": "14'09\"",
    "dex1": "This is Zygarde’s form at times when it uses its overwhelming power to suppress those who endanger the ecosystem.",
    "dex2": "This is Zygarde’s 100% form. It has enough power to overwhelm even Xerneas or Yveltal.",
    "class": "Order Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1017",
    "ndex": "719",
    "species": "Diancie",
    "forme": "Diancie (Mega Diancie)",
    "type1": "Rock",
    "type2": "Fairy",
    "ability1": "Magic Bounce",
    "ability2": "",
    "abilityH": "",
    "hp": "50",
    "attack": "160",
    "defense": "110",
    "spattack": "160",
    "spdefense": "110",
    "speed": "110",
    "total": "700",
    "weight": "61.3 lbs.",
    "height": "3'07\"",
    "dex1": "",
    "dex2": "",
    "class": "Jewel Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1018",
    "ndex": "720",
    "species": "Hoopa",
    "forme": "Hoopa (Hoopa Unbound)",
    "type1": "Psychic",
    "type2": "Dark",
    "ability1": "Magician",
    "ability2": "",
    "abilityH": "",
    "hp": "80",
    "attack": "160",
    "defense": "60",
    "spattack": "170",
    "spdefense": "130",
    "speed": "80",
    "total": "680",
    "weight": "1080.3 lbs.",
    "height": "21'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Djinn Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1019",
    "ndex": "735",
    "species": "Gumshoos",
    "forme": "Gumshoos (1)",
    "type1": "Normal",
    "type2": "",
    "ability1": "Stakeout",
    "ability2": "Strong Jaw",
    "abilityH": "Adaptability",
    "hp": "88",
    "attack": "110",
    "defense": "60",
    "spattack": "55",
    "spdefense": "60",
    "speed": "45",
    "total": "418",
    "weight": "31.3 lbs.",
    "height": "2'04\"",
    "dex1": "",
    "dex2": "",
    "class": "Stakeout Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "1020",
    "ndex": "738",
    "species": "Vikavolt",
    "forme": "Vikavolt (1)",
    "type1": "Bug",
    "type2": "Electric",
    "ability1": "Levitate",
    "ability2": "Levitate",
    "abilityH": "Levitate",
    "hp": "77",
    "attack": "70",
    "defense": "90",
    "spattack": "145",
    "spdefense": "75",
    "speed": "43",
    "total": "500",
    "weight": "99.2 lbs.",
    "height": "4'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Stag Beetle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Bug",
    "egg-group2": ""
  },
  {
    "id": "1021",
    "ndex": "741",
    "species": "Oricorio",
    "forme": "Oricorio (Pom-Pom Style)",
    "type1": "Electric",
    "type2": "Flying",
    "ability1": "Dancer",
    "ability2": "Dancer",
    "abilityH": "Dancer",
    "hp": "75",
    "attack": "70",
    "defense": "70",
    "spattack": "98",
    "spdefense": "70",
    "speed": "93",
    "total": "476",
    "weight": "7.5 lbs.",
    "height": "2'00\"",
    "dex1": "This Oricorio has sipped bright yellow nectar. Its bright, cheerful dance melts the hearts of its enemies.",
    "dex2": "It creates an electric charge by rubbing its feathers together. It dances over to its enemies and delivers shocking electrical punches.",
    "class": "Dancing Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "1022",
    "ndex": "741",
    "species": "Oricorio",
    "forme": "Oricorio (Pa’u Style)",
    "type1": "Psychic",
    "type2": "Flying",
    "ability1": "Dancer",
    "ability2": "Dancer",
    "abilityH": "Dancer",
    "hp": "75",
    "attack": "70",
    "defense": "70",
    "spattack": "98",
    "spdefense": "70",
    "speed": "93",
    "total": "476",
    "weight": "7.5 lbs.",
    "height": "2'00\"",
    "dex1": "This Oricorio relaxes by swaying gently. This increases its psychic energy, which it then fires at its enemies.",
    "dex2": "This Oricorio has sipped pink nectar. Its enemies’ hearts melt at the sight of its gently swaying hips.",
    "class": "Dancing Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "1023",
    "ndex": "741",
    "species": "Oricorio",
    "forme": "Oricorio (Sensu Style)",
    "type1": "Ghost",
    "type2": "Flying",
    "ability1": "Dancer",
    "ability2": "Dancer",
    "abilityH": "Dancer",
    "hp": "75",
    "attack": "70",
    "defense": "70",
    "spattack": "98",
    "spdefense": "70",
    "speed": "93",
    "total": "476",
    "weight": "7.5 lbs.",
    "height": "2'00\"",
    "dex1": "This Oricorio has sipped purple nectar. Its elegant, attractive dance will send the minds and hearts of its enemies to another world.",
    "dex2": "It summons the dead with its dreamy dancing. From their malice, it draws power with which to curse its enemies.",
    "class": "Dancing Pokémon",
    "percent-male": "0.25",
    "percent-female": "0.75",
    "pre-evolution": "",
    "egg-group1": "Flying",
    "egg-group2": ""
  },
  {
    "id": "1024",
    "ndex": "745",
    "species": "Lycanroc",
    "forme": "Lycanroc (Midnight Form)",
    "type1": "Rock",
    "type2": "",
    "ability1": "Keen Eye",
    "ability2": "Vital Spirit",
    "abilityH": "No Guard",
    "hp": "85",
    "attack": "115",
    "defense": "75",
    "spattack": "55",
    "spdefense": "75",
    "speed": "82",
    "total": "487",
    "weight": "55.1 lbs.",
    "height": "3'07\"",
    "dex1": "The more intimidating the opponent it faces, the more this Pokémon’s blood boils. It will attack with no regard for its own safety.",
    "dex2": "It goads its enemies into attacking, withstands the hits, and in return, delivers a headbutt, crushing their bones with its rocky mane.",
    "class": "Wolf Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "Rockruff",
    "egg-group1": "Field",
    "egg-group2": ""
  },
  {
    "id": "1025",
    "ndex": "746",
    "species": "Wishiwashi",
    "forme": "Wishiwashi (School Form)",
    "type1": "Water",
    "type2": "",
    "ability1": "Schooling",
    "ability2": "Schooling",
    "abilityH": "Schooling",
    "hp": "45",
    "attack": "140",
    "defense": "130",
    "spattack": "140",
    "spdefense": "135",
    "speed": "30",
    "total": "620",
    "weight": "173.3 lbs.",
    "height": "26'11\"",
    "dex1": "Weak Wishiwashi school together to concentrate their power. Their united force makes them the demon of the sea, feared near and far.",
    "dex2": "At their appearance, even Gyarados will flee. When they team up to use Water Gun, its power exceeds that of Hydro Pump.",
    "class": "Small Fry Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Water 2",
    "egg-group2": ""
  },
  {
    "id": "1026",
    "ndex": "754",
    "species": "Lurantis",
    "forme": "Lurantis (1)",
    "type1": "Grass",
    "type2": "",
    "ability1": "Leaf Guard",
    "ability2": "Leaf Guard",
    "abilityH": "Contrary",
    "hp": "70",
    "attack": "105",
    "defense": "90",
    "spattack": "80",
    "spdefense": "90",
    "speed": "45",
    "total": "480",
    "weight": "40.8 lbs.",
    "height": "2'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Bloom Sickle Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Grass",
    "egg-group2": ""
  },
  {
    "id": "1027",
    "ndex": "758",
    "species": "Salazzle",
    "forme": "Salazzle (1)",
    "type1": "Poison",
    "type2": "Fire",
    "ability1": "Corrosion",
    "ability2": "Corrosion",
    "abilityH": "Oblivious",
    "hp": "68",
    "attack": "64",
    "defense": "60",
    "spattack": "111",
    "spdefense": "60",
    "speed": "117",
    "total": "480",
    "weight": "48.9 lbs.",
    "height": "3'11\"",
    "dex1": "",
    "dex2": "",
    "class": "Toxic Lizard Pokémon",
    "percent-male": "0",
    "percent-female": "1",
    "pre-evolution": "",
    "egg-group1": "Monster",
    "egg-group2": "Dragon"
  },
  {
    "id": "1028",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Fighting)",
    "type1": "Fighting",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1029",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Flying)",
    "type1": "Flying",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1030",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Poison)",
    "type1": "Poison",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1031",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Ground)",
    "type1": "Ground",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1032",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Rock)",
    "type1": "Rock",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1033",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Bug)",
    "type1": "Bug",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1034",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Ghost)",
    "type1": "Ghost",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1035",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Steel)",
    "type1": "Steel",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1036",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Fire)",
    "type1": "Fire",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1037",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Water)",
    "type1": "Water",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1038",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Grass)",
    "type1": "Grass",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1039",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Electric)",
    "type1": "Electric",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1040",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Psychic)",
    "type1": "Psychic",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1041",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Ice)",
    "type1": "Ice",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1042",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Dragon)",
    "type1": "Dragon",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1043",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Dark)",
    "type1": "Dark",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1044",
    "ndex": "773",
    "species": "Silvally",
    "forme": "Silvally (Type: Fairy)",
    "type1": "Fairy",
    "type2": "",
    "ability1": "RKS System",
    "ability2": "RKS System",
    "abilityH": "RKS System",
    "hp": "95",
    "attack": "95",
    "defense": "95",
    "spattack": "95",
    "spdefense": "95",
    "speed": "95",
    "total": "570",
    "weight": "221.6 lbs.",
    "height": "7'07\"",
    "dex1": "It destroyed its own control mask. It has become capable of changing its type by equipping special memories.",
    "dex2": "Upon awakening, its RKS System is activated. By employing specific memories, this Pokémon can adapt its type to confound its enemies.",
    "class": "Synthetic Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "Type: Null",
    "egg-group1": "Undiscovered",
    "egg-group2": ""
  },
  {
    "id": "1045",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Meteor Form)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "60",
    "defense": "100",
    "spattack": "60",
    "spdefense": "100",
    "speed": "60",
    "total": "440",
    "weight": "88.2 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1046",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Meteor Form)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "60",
    "defense": "100",
    "spattack": "60",
    "spdefense": "100",
    "speed": "60",
    "total": "440",
    "weight": "88.2 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1047",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Meteor Form)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "60",
    "defense": "100",
    "spattack": "60",
    "spdefense": "100",
    "speed": "60",
    "total": "440",
    "weight": "88.2 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1048",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Meteor Form)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "60",
    "defense": "100",
    "spattack": "60",
    "spdefense": "100",
    "speed": "60",
    "total": "440",
    "weight": "88.2 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1049",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Meteor Form)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "60",
    "defense": "100",
    "spattack": "60",
    "spdefense": "100",
    "speed": "60",
    "total": "440",
    "weight": "88.2 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1050",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Meteor Form)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "60",
    "defense": "100",
    "spattack": "60",
    "spdefense": "100",
    "speed": "60",
    "total": "440",
    "weight": "88.2 lbs.",
    "height": "1'00\"",
    "dex1": "",
    "dex2": "",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1051",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Red Core)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "It eats dust in the atmosphere. The composition of the dust determines the color of its core.",
    "dex2": "If its core stays exposed, it will soon die off. It’s possible that it may survive if it’s put into a Poké Ball quickly enough.",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1052",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Orange Core)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "It eats dust in the atmosphere. The composition of the dust determines the color of its core.",
    "dex2": "If its core stays exposed, it will soon die off. It’s possible that it may survive if it’s put into a Poké Ball quickly enough.",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1053",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Yellow Core)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "It eats dust in the atmosphere. The composition of the dust determines the color of its core.",
    "dex2": "If its core stays exposed, it will soon die off. It’s possible that it may survive if it’s put into a Poké Ball quickly enough.",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1054",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Green Core)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "It eats dust in the atmosphere. The composition of the dust determines the color of its core.",
    "dex2": "If its core stays exposed, it will soon die off. It’s possible that it may survive if it’s put into a Poké Ball quickly enough.",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1055",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Blue Core)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "It eats dust in the atmosphere. The composition of the dust determines the color of its core.",
    "dex2": "If its core stays exposed, it will soon die off. It’s possible that it may survive if it’s put into a Poké Ball quickly enough.",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1056",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Indigo Core)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "It eats dust in the atmosphere. The composition of the dust determines the color of its core.",
    "dex2": "If its core stays exposed, it will soon die off. It’s possible that it may survive if it’s put into a Poké Ball quickly enough.",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1057",
    "ndex": "774",
    "species": "Minior",
    "forme": "Minior (Violet Core)",
    "type1": "Rock",
    "type2": "Flying",
    "ability1": "Shields Down",
    "ability2": "Shields Down",
    "abilityH": "Shields Down",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "0.7 lbs.",
    "height": "1'00\"",
    "dex1": "It eats dust in the atmosphere. The composition of the dust determines the color of its core.",
    "dex2": "If its core stays exposed, it will soon die off. It’s possible that it may survive if it’s put into a Poké Ball quickly enough.",
    "class": "Meteor Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Mineral",
    "egg-group2": ""
  },
  {
    "id": "1058",
    "ndex": "778",
    "species": "Mimikyu",
    "forme": "Mimikyu (Busted Form)",
    "type1": "Ghost",
    "type2": "Fairy",
    "ability1": "Disguise",
    "ability2": "Disguise",
    "abilityH": "Disguise",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "1.5 lbs.",
    "height": "0'08\"",
    "dex1": "After going to all the effort of disguising itself, its neck was broken. Whatever is inside is probably unharmed, but it’s still feeling sad.",
    "dex2": "If its neck is broken or its rag torn during an attack, it works through the night to patch it.",
    "class": "Disguise Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "1059",
    "ndex": "778",
    "species": "Mimikyu",
    "forme": "Mimikyu (2)",
    "type1": "Ghost",
    "type2": "Fairy",
    "ability1": "Disguise",
    "ability2": "Disguise",
    "abilityH": "Disguise",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "1.5 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Disguise Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "1060",
    "ndex": "778",
    "species": "Mimikyu",
    "forme": "Mimikyu (3)",
    "type1": "Ghost",
    "type2": "Fairy",
    "ability1": "Disguise",
    "ability2": "Disguise",
    "abilityH": "Disguise",
    "hp": "60",
    "attack": "100",
    "defense": "60",
    "spattack": "100",
    "spdefense": "60",
    "speed": "120",
    "total": "500",
    "weight": "1.5 lbs.",
    "height": "0'08\"",
    "dex1": "",
    "dex2": "",
    "class": "Disguise Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Amorphous",
    "egg-group2": ""
  },
  {
    "id": "1061",
    "ndex": "784",
    "species": "Kommo-o",
    "forme": "Kommo-o (1)",
    "type1": "Dragon",
    "type2": "Fighting",
    "ability1": "Bulletproof",
    "ability2": "Soundproof",
    "abilityH": "Overcoat",
    "hp": "75",
    "attack": "110",
    "defense": "125",
    "spattack": "100",
    "spdefense": "105",
    "speed": "85",
    "total": "600",
    "weight": "172.4 lbs.",
    "height": "5'03\"",
    "dex1": "",
    "dex2": "",
    "class": "Scaly Pokémon",
    "percent-male": "0.5",
    "percent-female": "0.5",
    "pre-evolution": "",
    "egg-group1": "Dragon",
    "egg-group2": ""
  },
  {
    "id": "1062",
    "ndex": "801",
    "species": "Magearna",
    "forme": "Magearna (Original Color)",
    "type1": "Steel",
    "type2": "Fairy",
    "ability1": "Soul-Heart",
    "ability2": "Soul-Heart",
    "abilityH": "Soul-Heart",
    "hp": "80",
    "attack": "95",
    "defense": "115",
    "spattack": "130",
    "spdefense": "115",
    "speed": "65",
    "total": "600",
    "weight": "177.5 lbs.",
    "height": "3'03\"",
    "dex1": "This beautiful form reflects Magearna’s appearance when first presented to a king’s daughter 500 years ago.",
    "dex2": "This gorgeous Magearna looks as it did at the time of its invention. Its luxurious decoration pleased the king’s daughter.",
    "class": "Artificial Pokémon",
    "percent-male": "",
    "percent-female": "",
    "pre-evolution": "",
    "egg-group1": "Undiscovered"
  }
];